
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lVF98", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kA6Zo = parcelRequire("kA6Zo");


var $buxP3 = parcelRequire("buxP3");


var $3izAL = parcelRequire("3izAL");


var $8Iwqw = parcelRequire("8Iwqw");


var $8lt1a = parcelRequire("8lt1a");


var $b9k8w = parcelRequire("b9k8w");


var $1sCHt = parcelRequire("1sCHt");


var $5YDZX = parcelRequire("5YDZX");


var $7sJoX = parcelRequire("7sJoX");


var $j6vyT = parcelRequire("j6vyT");


var $lpNn5 = parcelRequire("lpNn5");


var $lTECB = parcelRequire("lTECB");


var $1eD4P = parcelRequire("1eD4P");


var $93Gae = parcelRequire("93Gae");


var $dPoYT = parcelRequire("dPoYT");


var $JTIzG = parcelRequire("JTIzG");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $hU34N = parcelRequire("hU34N");

/* AIFloatingContextMenu.tsx generated by @compiled/babel-plugin v2.0.0 */ /** @jsxFrag React.Fragment */ 









var $3ricL = parcelRequire("3ricL");


var $9DHhW = parcelRequire("9DHhW");


var $4n1IT = parcelRequire("4n1IT");








var $ExetK = parcelRequire("ExetK");


var $9wGTI = parcelRequire("9wGTI");


var $1ytiN = parcelRequire("1ytiN");


var $euL71 = parcelRequire("euL71");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $3Am3T = parcelRequire("3Am3T");


var $NomII = parcelRequire("NomII");


var $bQm3c = parcelRequire("bQm3c");


var $7mpOv = parcelRequire("7mpOv");


var $8zMP3 = parcelRequire("8zMP3");














var $9ivsj = parcelRequire("9ivsj");

const $af25143620373faf$var$baseShadow = `0 0 0 2px ${"var(--ds-border-brand, #1868DB)"}`;
const $af25143620373faf$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $af25143620373faf$var$pulseKeyframes = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $af25143620373faf$var$SinglePulse = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2fBhteXHPU",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2fBhteXHPU",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $af25143620373faf$var$DoublePulse = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2fBhte0qPK",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2fBhte0qPK",
            __cmplp.className
        ])
    });
});
const $af25143620373faf$var$defaultBorderRadius = null;
const $af25143620373faf$var$isInObjectSideBarBorderRadius = null;
const $af25143620373faf$export$cd20eff28c3c2c7f = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { children: children, pulseCount: t1, isInObjectSideBar: t2 } = t0;
    const pulseCount = t1 === undefined ? 0 : t1;
    const isInObjectSideBar = t2 === undefined ? false : t2;
    const isReducedMotion = (0, $9ivsj.useIsReducedMotion)();
    if (isReducedMotion) {
        let t3;
        if ($[0] !== children) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "data-testid": "contextual-pulse-none"
            }, children);
            $[0] = children;
            $[1] = t3;
        } else t3 = $[1];
        return t3;
    }
    switch(pulseCount){
        case 1:
            {
                const t3 = isInObjectSideBar && "_0bjKvDS5Zs";
                let t4;
                if ($[2] !== t3) {
                    t4 = (0, $hekY6.default)([
                        "_0bjKvDyzSk",
                        t3
                    ]);
                    $[2] = t3;
                    $[3] = t4;
                } else t4 = $[3];
                let t5;
                if ($[4] !== children || $[5] !== t4) {
                    t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($af25143620373faf$var$SinglePulse, {
                        "data-testid": "contextual-pulse-single",
                        className: t4
                    }, children);
                    $[4] = children;
                    $[5] = t4;
                    $[6] = t5;
                } else t5 = $[6];
                return t5;
            }
        case 2:
            {
                const t3 = isInObjectSideBar && "_0bjKvDS5Zs";
                let t4;
                if ($[7] !== t3) {
                    t4 = (0, $hekY6.default)([
                        "_0bjKvDyzSk",
                        t3
                    ]);
                    $[7] = t3;
                    $[8] = t4;
                } else t4 = $[8];
                let t5;
                if ($[9] !== children || $[10] !== t4) {
                    t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($af25143620373faf$var$DoublePulse, {
                        "data-testid": "contextual-pulse-double",
                        className: t4
                    }, children);
                    $[9] = children;
                    $[10] = t4;
                    $[11] = t5;
                } else t5 = $[11];
                return t5;
            }
    }
    let t3;
    if ($[12] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "contextual-pulse-none"
        }, children);
        $[12] = children;
        $[13] = t3;
    } else t3 = $[13];
    return t3;
} : ({ children: children, pulseCount: pulseCount = 0, isInObjectSideBar: isInObjectSideBar = false })=>{
    const isReducedMotion = (0, $9ivsj.useIsReducedMotion)();
    if (isReducedMotion) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "contextual-pulse-none"
    }, children);
    switch(pulseCount){
        case 1:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($af25143620373faf$var$SinglePulse, {
                "data-testid": "contextual-pulse-single",
                className: (0, $hekY6.default)([
                    "_0bjKvDyzSk",
                    isInObjectSideBar && "_0bjKvDS5Zs"
                ])
            }, children);
        case 2:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($af25143620373faf$var$DoublePulse, {
                "data-testid": "contextual-pulse-double",
                className: (0, $hekY6.default)([
                    "_0bjKvDyzSk",
                    isInObjectSideBar && "_0bjKvDS5Zs"
                ])
            }, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "contextual-pulse-none"
    }, children);
};















var $41KFX = parcelRequire("41KFX");








var $55fM8 = parcelRequire("55fM8");

const $5d003355575f53c0$export$cbb5dd4e54f3bea9 = (isLivePage = false)=>{
    {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const newViewPageContainer = document.getElementById('AkMainContent');
        const [scrollHeightAttributes, setScrollHeightAttributes] = // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $cozmU.useState)({
            scrollY: 0
        });
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const handleScroll = (0, $cozmU.useCallback)(()=>{
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const livePageContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
            const viewPageScrollY = newViewPageContainer ? newViewPageContainer.scrollTop : window.scrollY;
            setScrollHeightAttributes({
                scrollY: isLivePage ? livePageContainer && livePageContainer.scrollTop : viewPageScrollY
            });
        }, [
            setScrollHeightAttributes,
            isLivePage,
            newViewPageContainer
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $cozmU.useEffect)(()=>{
            const livePageContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
            const debounceScroll = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(handleScroll, 250);
            if (isLivePage) livePageContainer?.addEventListener('scroll', debounceScroll);
            else newViewPageContainer ? newViewPageContainer?.addEventListener('scroll', debounceScroll) : document.addEventListener('scroll', debounceScroll);
            return ()=>{
                if (isLivePage) livePageContainer?.removeEventListener('scroll', debounceScroll);
                else newViewPageContainer ? newViewPageContainer?.removeEventListener('scroll', debounceScroll) : document.removeEventListener('scroll', debounceScroll);
            };
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        return scrollHeightAttributes;
    }
};



var $72md5 = parcelRequire("72md5");

var $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf = /*#__PURE__*/ function(FeatureStates) {
    FeatureStates["QuickSummary"] = "quick-summary";
    FeatureStates["Comments"] = "comments";
    FeatureStates["PageCatchup"] = "page-catchup";
    FeatureStates["BulkIssueCreate"] = "bulk-issue-create";
    FeatureStates["QuickSummaryAudio"] = "quick-summary-audio";
    return FeatureStates;
}({});
var $2c4fc9e48b4f3b02$export$a913d22899a46b83 = /*#__PURE__*/ function(NonFeatureStates) {
    NonFeatureStates["Menu"] = "menu";
    NonFeatureStates["OptIn"] = "opt-in";
    NonFeatureStates["Upsell"] = "upsell";
    return NonFeatureStates;
}({});
const $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c = {
    ...$2c4fc9e48b4f3b02$export$881f3bfeb53afdcf,
    ...$2c4fc9e48b4f3b02$export$a913d22899a46b83
};
function $2c4fc9e48b4f3b02$export$4940a8f6968b63(popupState) {
    return Object.values($2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).includes(popupState);
}



var $i1vUz = parcelRequire("i1vUz");

const $83cf8da53844c2d7$export$7571cdd921b49cc0 = (0, $3u0dr.isReactCompilerActiveV2)() ? (contentId, contentType, pageCommentsSectionInView, isLivePage, contentIdFromQuery, contentBodyDynamic)=>{
    const $ = (0, $bDgLe.c)(9);
    const { scrollY: scrollY } = (0, $5d003355575f53c0$export$cbb5dd4e54f3bea9)(isLivePage);
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount, footerCommentsCount: footerCommentsCount } = (0, $cozmU.useContext)((0, $3Am3T.CommentCountsContext));
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const contentTypeEnum = contentType === "page" ? "PAGE" : "BLOGPOST";
    const { showCatchupAsDefault: showCatchupAsDefault, queryError: queryError } = (0, $i1vUz.useDynamicSplitButton)(contentId, contentTypeEnum);
    const { navStyle: navStyle } = (0, $41KFX.useSimplifiedNavNewUsers)();
    const isSimplifiedNavExperimentVariant = navStyle === "default-templates" || navStyle === "pin-templates";
    const hasContentToSummarize = isSimplifiedNavExperimentVariant ? (0, $72md5.docHasContent)(contentBodyDynamic) : true;
    if (!isAdminHubAIEnabled) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                dynamicActionTarget: null
            };
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    if (pageCommentsSectionInView && (unresolvedInlineCommentsCount > 0 || footerCommentsCount > 0)) {
        let t0;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                dynamicActionTarget: (0, $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).Comments
            };
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    if (showCatchupAsDefault && scrollY !== null && scrollY < 400) {
        let t0;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                dynamicActionTarget: (0, $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).PageCatchup
            };
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    }
    if (scrollY !== null && scrollY < 400) {
        if (isSimplifiedNavExperimentVariant) {
            const canUseSyncBlankCheck = contentIdFromQuery != null && contentBodyDynamic !== undefined && contentId === contentIdFromQuery;
            if (canUseSyncBlankCheck && !hasContentToSummarize) {
                let t0;
                if ($[3] !== queryError) {
                    t0 = {
                        dynamicActionTarget: null,
                        queryError: queryError
                    };
                    $[3] = queryError;
                    $[4] = t0;
                } else t0 = $[4];
                return t0;
            }
        }
        let t0;
        if ($[5] !== queryError) {
            t0 = {
                dynamicActionTarget: (0, $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).QuickSummary,
                queryError: queryError
            };
            $[5] = queryError;
            $[6] = t0;
        } else t0 = $[6];
        return t0;
    }
    let t0;
    if ($[7] !== queryError) {
        t0 = {
            dynamicActionTarget: null,
            queryError: queryError
        };
        $[7] = queryError;
        $[8] = t0;
    } else t0 = $[8];
    return t0;
} : (contentId, contentType, pageCommentsSectionInView, isLivePage, contentIdFromQuery, contentBodyDynamic)=>{
    const { scrollY: scrollY } = (0, $5d003355575f53c0$export$cbb5dd4e54f3bea9)(isLivePage);
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount, footerCommentsCount: footerCommentsCount } = (0, $cozmU.useContext)((0, $3Am3T.CommentCountsContext));
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const contentTypeEnum = contentType === 'page' ? 'PAGE' : 'BLOGPOST';
    const { showCatchupAsDefault: showCatchupAsDefault, queryError: queryError } = (0, $i1vUz.useDynamicSplitButton)(contentId, contentTypeEnum);
    const { navStyle: navStyle } = (0, $41KFX.useSimplifiedNavNewUsers)();
    const isSimplifiedNavExperimentVariant = navStyle === 'default-templates' || navStyle === 'pin-templates';
    // contentBodyDynamic is passed through from the view-page query (same ref when data unchanged), so this memo is stable.
    const hasContentToSummarize = (0, $cozmU.useMemo)(()=>isSimplifiedNavExperimentVariant ? (0, $72md5.docHasContent)(contentBodyDynamic) : true, [
        isSimplifiedNavExperimentVariant,
        contentBodyDynamic
    ]);
    if (!isAdminHubAIEnabled) return {
        dynamicActionTarget: null
    };
    if (pageCommentsSectionInView && (unresolvedInlineCommentsCount > 0 || footerCommentsCount > 0)) return {
        dynamicActionTarget: (0, $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).Comments
    };
    if (showCatchupAsDefault && scrollY !== null && scrollY < 400) return {
        dynamicActionTarget: (0, $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).PageCatchup
    };
    if (scrollY !== null && scrollY < 400) {
        if (isSimplifiedNavExperimentVariant) {
            const canUseSyncBlankCheck = contentIdFromQuery != null && contentBodyDynamic !== undefined && contentId === contentIdFromQuery;
            if (canUseSyncBlankCheck && !hasContentToSummarize) return {
                dynamicActionTarget: null,
                queryError: queryError
            };
        }
        return {
            dynamicActionTarget: (0, $2c4fc9e48b4f3b02$export$881f3bfeb53afdcf).QuickSummary,
            queryError: queryError
        };
    }
    return {
        dynamicActionTarget: null,
        queryError: queryError
    };
};












var $ivb8S = parcelRequire("ivb8S");


var $d282Z = parcelRequire("d282Z");







const $874fd8abb2c90fe4$export$b938e63de8ec6cb1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (contentId, contentType)=>{
    const $ = (0, $bDgLe.c)(10);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const [pulseCount, setPulseCount] = (0, $cozmU.useState)(0);
    const hasLoaded = (0, $cozmU.useRef)(false);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const contentTypeEnum = contentType === "page" ? "PAGE" : "BLOGPOST";
    const { showCatchupAsDefault: showCatchupAsDefault, queryLoading: dynamicSplitButtonLoading } = (0, $i1vUz.useDynamicSplitButton)(contentId, contentTypeEnum);
    const { data: onboardingStateData, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)((0, $d282Z.ONBOARDING_INSIGHTS).CONTEXTUAL_FLOATING_BUTTON_NUDGE, !isAdminHubAIEnabled);
    let t0;
    let t1;
    if ($[0] !== dynamicSplitButtonLoading || $[1] !== isAdminHubAIEnabled || $[2] !== onboardingStateData || $[3] !== onboardingStateLoading || $[4] !== setOnboardingState || $[5] !== showCatchupAsDefault) {
        t0 = ()=>{
            if (!dynamicSplitButtonLoading && !onboardingStateLoading && !hasLoaded.current && isAdminHubAIEnabled) {
                hasLoaded.current = true;
                const { hasContextualFloatingButtonBeenSeen: hasContextualFloatingButtonBeenSeen } = (0, $ivb8S.deserializeState)(onboardingStateData);
                if (onboardingStateData != null && !hasContextualFloatingButtonBeenSeen) {
                    setOnboardingState({
                        key: (0, $d282Z.ONBOARDING_INSIGHTS).CONTEXTUAL_FLOATING_BUTTON_NUDGE,
                        value: "true"
                    });
                    setPulseCount(2);
                } else if (showCatchupAsDefault) setPulseCount(1);
            }
        };
        t1 = [
            dynamicSplitButtonLoading,
            onboardingStateData,
            onboardingStateLoading,
            setPulseCount,
            setOnboardingState,
            showCatchupAsDefault,
            isAdminHubAIEnabled
        ];
        $[0] = dynamicSplitButtonLoading;
        $[1] = isAdminHubAIEnabled;
        $[2] = onboardingStateData;
        $[3] = onboardingStateLoading;
        $[4] = setOnboardingState;
        $[5] = showCatchupAsDefault;
        $[6] = t0;
        $[7] = t1;
    } else {
        t0 = $[6];
        t1 = $[7];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[8] !== pulseCount) {
        t2 = {
            pulseCount: pulseCount
        };
        $[8] = pulseCount;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
} : (contentId, contentType)=>{
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const [pulseCount, setPulseCount] = (0, $cozmU.useState)(0);
    const hasLoaded = (0, $cozmU.useRef)(false);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const contentTypeEnum = contentType === 'page' ? 'PAGE' : 'BLOGPOST';
    const { showCatchupAsDefault: showCatchupAsDefault, queryLoading: dynamicSplitButtonLoading } = (0, $i1vUz.useDynamicSplitButton)(contentId, contentTypeEnum);
    // Ignoring error state as we will just not show a pulse if this errors
    const { data: onboardingStateData, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)((0, $d282Z.ONBOARDING_INSIGHTS).CONTEXTUAL_FLOATING_BUTTON_NUDGE, !isAdminHubAIEnabled);
    (0, $cozmU.useEffect)(()=>{
        if (!dynamicSplitButtonLoading && !onboardingStateLoading && !hasLoaded.current && isAdminHubAIEnabled) {
            // We only want this to execute once and only once when both hooks are finished loading
            hasLoaded.current = true;
            const { hasContextualFloatingButtonBeenSeen: hasContextualFloatingButtonBeenSeen } = (0, $ivb8S.deserializeState)(onboardingStateData);
            if (onboardingStateData != null && !hasContextualFloatingButtonBeenSeen) {
                setOnboardingState({
                    key: (0, $d282Z.ONBOARDING_INSIGHTS).CONTEXTUAL_FLOATING_BUTTON_NUDGE,
                    value: 'true'
                });
                setPulseCount(2);
            } else if (showCatchupAsDefault) setPulseCount(1);
        }
    }, [
        dynamicSplitButtonLoading,
        onboardingStateData,
        onboardingStateLoading,
        setPulseCount,
        setOnboardingState,
        showCatchupAsDefault,
        isAdminHubAIEnabled
    ]);
    return {
        pulseCount: pulseCount
    };
};
























var $kz1Yj = parcelRequire("kz1Yj");





var $kh0hi = parcelRequire("kh0hi");


var $iODl6 = parcelRequire("iODl6");


var $57p4j = parcelRequire("57p4j");

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ 



var $320o0 = parcelRequire("320o0");

const $e926aed382b01d25$export$2c6a5235f6e9fe39 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($320o0))), {
        color: "var(--ds-icon, #292A2E)",
        ...props
    });






var $e4o8D = parcelRequire("e4o8D");

const $7b40fa145aa0c9d8$var$i18n = (0, $kSwu1.defineMessages)({
    logoAltText: {
        id: "ai-floating-context-menu.floating-context-menu-button.logo-alt-text",
        defaultMessage: "Atlassian Intelligence"
    }
});
const $7b40fa145aa0c9d8$var$aiFloatingContextMenuStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.xlarge',
    padding: 'space.075',
    boxShadow: 'elevation.shadow.overlay',
    backgroundColor: 'elevation.surface.raised'
});
const $7b40fa145aa0c9d8$var$aiFloatingContextMenuStylesInObjectSidebar = (0, $buxP3.xcss)({
    padding: 'space.100',
    boxShadow: 'elevation.shadow.raised',
    backgroundColor: 'elevation.surface.raised',
    borderRadius: 'radius.full'
});
const $7b40fa145aa0c9d8$var$dividerStyles = (0, $buxP3.xcss)({
    height: '100%',
    width: '1px',
    backgroundColor: 'color.background.neutral'
});
const $7b40fa145aa0c9d8$var$dividerStylesInObjectSidebar = (0, $buxP3.xcss)({
    height: '24px',
    width: '1px',
    backgroundColor: 'color.background.neutral'
});
const $7b40fa145aa0c9d8$var$defaultPressableStyles = (0, $buxP3.xcss)({
    display: 'inline-flex',
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: 'color.text.subtle',
    width: 'auto',
    maxWidth: '100%',
    boxSizing: 'border-box',
    position: 'relative',
    flexShrink: 0,
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    paddingBlock: 'space.025',
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    verticalAlign: 'middle',
    borderRadius: 'radius.small',
    transition: `background ${"var(--ds-duration-xshort, 100ms)"} ${"var(--ds-easing-out-practical, cubic-bezier(0.4, 1, 0.6, 1))"}`,
    whiteSpace: 'nowrap',
    '::after': {
        borderRadius: 'inherit',
        inset: 'space.0',
        borderStyle: 'solid',
        borderWidth: 'border.width',
        pointerEvents: 'none',
        position: 'absolute'
    },
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    }
});
const $7b40fa145aa0c9d8$var$selectedPressableStyles = (0, $buxP3.xcss)({
    background: "var(--ds-background-selected, #E9F2FE)",
    color: 'color.text.selected',
    '::after': {
        content: '""',
        borderColor: 'color.border.selected',
        borderStyle: 'solid'
    },
    ':visited': {
        color: 'color.text.selected'
    },
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-text-selected, #1868DB)",
        background: "var(--ds-background-selected-hovered, #CFE1FD)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-text-selected, #1868DB)",
        background: "var(--ds-background-selected-pressed, #8FB8F6)"
    }
});
const $7b40fa145aa0c9d8$var$pressableMotionStyles = (0, $buxP3.xcss)({
    transition: "var(--ds-button-hovered, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))",
    ':hover': {
        transition: "var(--ds-button-hovered, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"
    },
    ':active': {
        transition: "var(--ds-button-pressed, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"
    }
});
const $7b40fa145aa0c9d8$var$sideBarPressableStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.full',
    paddingBlock: 'space.075'
});
const $7b40fa145aa0c9d8$export$c226a072142c15e9 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { dynamicActionText: dynamicActionText, isDynamicActionSelected: t1, onDynamicActionClick: onDynamicActionClick, onMenuButtonClick: onMenuButtonClick, triggerProps: triggerProps, isMenuOpen: isMenuOpen, isInObjectSideBar: t2 } = t0;
    const isDynamicActionSelected = t1 === undefined ? false : t1;
    const isInObjectSideBar = t2 === undefined ? false : t2;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const t3 = !isInObjectSideBar && $7b40fa145aa0c9d8$var$aiFloatingContextMenuStyles;
    const t4 = isInObjectSideBar && $7b40fa145aa0c9d8$var$aiFloatingContextMenuStylesInObjectSidebar;
    let t5;
    if ($[0] !== t3 || $[1] !== t4) {
        t5 = [
            t3,
            t4
        ];
        $[0] = t3;
        $[1] = t4;
        $[2] = t5;
    } else t5 = $[2];
    const t6 = !renderServerPlaceholder;
    let t7;
    if ($[3] !== dynamicActionText || $[4] !== isDynamicActionSelected || $[5] !== isInObjectSideBar || $[6] !== onDynamicActionClick) {
        t7 = dynamicActionText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            entranceDirection: "right",
            exitDirection: "right",
            duration: "medium"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                ...props,
                "data-vc": "ai-floating-dynamic-action"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
                onClick: ()=>onDynamicActionClick?.(),
                xcss: [
                    $7b40fa145aa0c9d8$var$defaultPressableStyles,
                    isDynamicActionSelected && $7b40fa145aa0c9d8$var$selectedPressableStyles,
                    isInObjectSideBar && $7b40fa145aa0c9d8$var$sideBarPressableStyles,
                    (0, $9wGTI.fg)("platform-dst-motion-uplift-custom-button") && $7b40fa145aa0c9d8$var$pressableMotionStyles
                ]
            }, dynamicActionText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: [
                !isInObjectSideBar && $7b40fa145aa0c9d8$var$dividerStyles,
                isInObjectSideBar && $7b40fa145aa0c9d8$var$dividerStylesInObjectSidebar
            ]
        }));
        $[3] = dynamicActionText;
        $[4] = isDynamicActionSelected;
        $[5] = isInObjectSideBar;
        $[6] = onDynamicActionClick;
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== t6 || $[9] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
            appear: t6,
            exitThenEnter: true
        }, t7);
        $[8] = t6;
        $[9] = t7;
        $[10] = t8;
    } else t8 = $[10];
    let t9;
    if ($[11] !== formatMessage) {
        t9 = formatMessage($7b40fa145aa0c9d8$var$i18n.logoAltText);
        $[11] = formatMessage;
        $[12] = t9;
    } else t9 = $[12];
    let t10;
    if ($[13] !== onMenuButtonClick) {
        t10 = ()=>onMenuButtonClick?.();
        $[13] = onMenuButtonClick;
        $[14] = t10;
    } else t10 = $[14];
    const t11 = isInObjectSideBar ? "circle" : "default";
    let t12;
    if ($[15] !== isMenuOpen || $[16] !== t10 || $[17] !== t11 || $[18] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: (0, $e926aed382b01d25$export$2c6a5235f6e9fe39),
            label: t9,
            onClick: t10,
            appearance: "subtle",
            isSelected: isMenuOpen,
            shape: t11
        });
        $[15] = isMenuOpen;
        $[16] = t10;
        $[17] = t11;
        $[18] = t9;
        $[19] = t12;
    } else t12 = $[19];
    let t13;
    if ($[20] !== t12 || $[21] !== t5 || $[22] !== t8) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            xcss: t5,
            grow: "hug",
            space: "space.050",
            alignBlock: "center"
        }, t8, t12);
        $[20] = t12;
        $[21] = t5;
        $[22] = t8;
        $[23] = t13;
    } else t13 = $[23];
    let t14;
    if ($[24] !== t13 || $[25] !== triggerProps) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), triggerProps, t13);
        $[24] = t13;
        $[25] = triggerProps;
        $[26] = t14;
    } else t14 = $[26];
    return t14;
} : ({ dynamicActionText: dynamicActionText, isDynamicActionSelected: isDynamicActionSelected = false, onDynamicActionClick: onDynamicActionClick, onMenuButtonClick: onMenuButtonClick, triggerProps: triggerProps, isMenuOpen: isMenuOpen, isInObjectSideBar: isInObjectSideBar = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), triggerProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        xcss: [
            !isInObjectSideBar && $7b40fa145aa0c9d8$var$aiFloatingContextMenuStyles,
            isInObjectSideBar && $7b40fa145aa0c9d8$var$aiFloatingContextMenuStylesInObjectSidebar
        ],
        grow: "hug",
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
        appear: !renderServerPlaceholder,
        exitThenEnter: true
    }, dynamicActionText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
        entranceDirection: "right",
        exitDirection: "right",
        duration: "medium"
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ...props,
            "data-vc": "ai-floating-dynamic-action"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
            onClick: ()=>onDynamicActionClick?.(),
            xcss: [
                $7b40fa145aa0c9d8$var$defaultPressableStyles,
                isDynamicActionSelected && $7b40fa145aa0c9d8$var$selectedPressableStyles,
                isInObjectSideBar && $7b40fa145aa0c9d8$var$sideBarPressableStyles,
                (0, $9wGTI.fg)('platform-dst-motion-uplift-custom-button') && $7b40fa145aa0c9d8$var$pressableMotionStyles
            ]
        }, dynamicActionText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            !isInObjectSideBar && $7b40fa145aa0c9d8$var$dividerStyles,
            isInObjectSideBar && $7b40fa145aa0c9d8$var$dividerStylesInObjectSidebar
        ]
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, $e926aed382b01d25$export$2c6a5235f6e9fe39),
        label: formatMessage($7b40fa145aa0c9d8$var$i18n.logoAltText),
        onClick: ()=>onMenuButtonClick?.(),
        appearance: "subtle",
        isSelected: isMenuOpen,
        shape: isInObjectSideBar ? 'circle' : 'default'
    })));
};














// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $44548221e1617185$var$PopupWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_30huDK5FKZ _0bjKvDyzSk _0KLXruqi9L _2OUyjtGk8v _39xV02nd2U _1zr6Dc98eZ _0htemXYbGa _067LceT6kp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_30huDK5FKZ _0bjKvDyzSk _0KLXruqi9L _2OUyjtGk8v _39xV02nd2U _1zr6Dc98eZ _0htemXYbGa _067LceT6kp",
            __cmplp.className
        ])
    });
});
const $44548221e1617185$export$2593be7073434b2d = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(7);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== children || $[4] !== props || $[5] !== ref) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($44548221e1617185$var$PopupWrapper, {
            ...props,
            ref: ref,
            role: "dialog"
        }, children);
        $[3] = children;
        $[4] = props;
        $[5] = ref;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : ({ children: children, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($44548221e1617185$var$PopupWrapper, {
        ...props,
        ref: ref,
        role: "dialog"
    }, children);
});















var $9d7Pd = parcelRequire("9d7Pd");


var $6IL1T = parcelRequire("6IL1T");


var $8FgJC = parcelRequire("8FgJC");


var $1l0kj = parcelRequire("1l0kj");


var $9KSWX = parcelRequire("9KSWX");


var $3fO5l = parcelRequire("3fO5l");


var $gFEZF = parcelRequire("gFEZF");


var $eDtFr = parcelRequire("eDtFr");


var $5ZtfK = parcelRequire("5ZtfK");











var $aUTn5 = parcelRequire("aUTn5");


var $hq2Sz = parcelRequire("hq2Sz");


var $1mDVg = parcelRequire("1mDVg");


var $1Q0l6 = parcelRequire("1Q0l6");


var $UNr39 = parcelRequire("UNr39");


var $jln20 = parcelRequire("jln20");


var $cAdj8 = parcelRequire("cAdj8");

const $c8e282bfad3727e4$export$ddc739fc0aea988a = ({ contentId: contentId, content: content, useRovoWidth: useRovoWidth = false })=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const setIsCreatedWithAi = (0, $hq2Sz.useSetIsCreatedWithAi)();
    const setIsCreatedFromTable = (0, $hq2Sz.useSetIsCreatedFromTable)();
    const setIsRovoPanelWidth = (0, $hq2Sz.useSetIsRovoPanelWidth)();
    const setInsertStorageFragmentRequestPayload = (0, $hq2Sz.useSetInsertStorageFragmentRequestPayload)();
    const contentLastModifiedTimestamp = (0, $hq2Sz.useGetContentLastModifiedTimestamp)();
    // eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
    const [, issueCreateSidePanelActions] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { pageInfo: pageInfo } = (0, $cAdj8.usePageInfo)({
        fetchPolicy: 'cache-first'
    });
    const hasEditPermission = (0, $cozmU.useMemo)(()=>pageInfo?.operations?.some((op)=>op?.operation === 'update' && op?.targetType === pageInfo.type) || false, [
        pageInfo
    ]);
    return (0, $cozmU.useCallback)(()=>{
        setIsCreatedWithAi(true);
        setIsCreatedFromTable(false);
        setIsRovoPanelWidth(useRovoWidth);
        if (content.current) {
            const range = (0, $1Q0l6.getValidRange)((0, $1Q0l6.getPageContentRange)());
            const payload = (0, $1Q0l6.constructInsertStorageFragmentRequestPayload)(contentId, (0, $aUTn5.convertSelectionToLegacyFormat), range, content.current, contentLastModifiedTimestamp);
            setInsertStorageFragmentRequestPayload(payload);
        }
        issueCreateSidePanelActions.setHasEditPermission(hasEditPermission);
        rightSidebarContext.open((0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_ID), useRovoWidth ? (0, $UNr39.ROVO_BULK_CREATE_SIDE_PANEL_WIDTH) : (0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH));
    }, [
        setIsCreatedWithAi,
        setIsCreatedFromTable,
        setIsRovoPanelWidth,
        useRovoWidth,
        contentId,
        content,
        contentLastModifiedTimestamp,
        setInsertStorageFragmentRequestPayload,
        issueCreateSidePanelActions,
        hasEditPermission,
        rightSidebarContext
    ]);
};












var $4aiCO = parcelRequire("4aiCO");





const $790b3996dfce6541$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    inlineCommentsMenuItemLabel: {
        id: "ai-floating-context-menu.menu.item.label.inline-comments",
        defaultMessage: "Summarize comments"
    },
    pageCatchupMenuItemLabel: {
        id: "ai-floating-context-menu.menu.item.label.page-catchup",
        defaultMessage: "Summarize changes"
    },
    audioSummarySectionLabel: {
        id: "ai-floating-context-menu.menu.item.label.audio-summary",
        defaultMessage: "Listen to Page Summary"
    },
    bulkIssueCreateMenuItemLabel: {
        id: "ai-floating-context-menu.menu.item.label.bulk-issue-create",
        defaultMessage: "Create Jira issues"
    },
    bulkWorkItemsCreateMenuItemLabel: {
        id: "ai-floating-context-menu.menu.item.label.bulk-work-items-create",
        defaultMessage: "Create Jira work items"
    },
    betaLabel: {
        id: "ai-floating-context-menu.menu.item.lozenge.beta",
        defaultMessage: "Beta"
    },
    summarizeSectionLabel: {
        id: "ai-floating-context-menu.summarize.section.label",
        defaultMessage: "Summarize page"
    },
    createSectionLabel: {
        id: "ai-floating-context-menu.create.section.label",
        defaultMessage: "Create"
    }
});
var $790b3996dfce6541$var$ContentActionsMenuSectionKey = /*#__PURE__*/ function(ContentActionsMenuSectionKey) {
    ContentActionsMenuSectionKey["Summarize"] = "Summarize";
    ContentActionsMenuSectionKey["Create"] = "Create";
    return ContentActionsMenuSectionKey;
}($790b3996dfce6541$var$ContentActionsMenuSectionKey || {});
const $790b3996dfce6541$export$2b7899a440558a80 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { contentId: contentId, isLivePage: t1, setIsOpen: setIsOpen, setPopupState: setPopupState } = t0;
    const isLivePage = t1 === undefined ? false : t1;
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount, footerCommentsCount: footerCommentsCount } = (0, $cozmU.useContext)((0, $3Am3T.CommentCountsContext));
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { showWarningDialog: showWarningDialog } = (0, $4aiCO.useWarningDialogStateActions)();
    let t2;
    if ($[0] !== rightSidebarContext) {
        t2 = rightSidebarContext.getCurrent()?.panelId;
        $[0] = rightSidebarContext;
        $[1] = t2;
    } else t2 = $[1];
    const isSidePanelOpen = t2 === (0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_ID);
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = typeof document !== "undefined" ? document.querySelector("div#content") : null;
        $[2] = t3;
    } else t3 = $[2];
    const content = (0, $cozmU.useRef)(t3);
    let t4;
    if ($[3] !== contentId) {
        t4 = {
            contentId: contentId,
            content: content
        };
        $[3] = contentId;
        $[4] = t4;
    } else t4 = $[4];
    const handleBulkIssueCreate = (0, $c8e282bfad3727e4$export$ddc739fc0aea988a)(t4);
    let t5;
    if ($[5] !== contentId || $[6] !== createAnalyticsEvent || $[7] !== edition || $[8] !== footerCommentsCount || $[9] !== handleBulkIssueCreate || $[10] !== intl || $[11] !== isLivePage || $[12] !== isSidePanelOpen || $[13] !== setIsOpen || $[14] !== setPopupState || $[15] !== showWarningDialog || $[16] !== unresolvedInlineCommentsCount) {
        const menuItems = [
            {
                key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).QuickSummary,
                label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.summarizeSectionLabel),
                showMenuItem: true,
                isDisabled: false,
                beta: false,
                section: "Summarize",
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), {
                    label: ""
                })
            },
            {
                key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).PageCatchup,
                label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.pageCatchupMenuItemLabel),
                showMenuItem: true,
                isDisabled: false,
                beta: false,
                section: "Summarize",
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
                    label: ""
                })
            },
            {
                key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments,
                label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.inlineCommentsMenuItemLabel),
                showMenuItem: true,
                isDisabled: isLivePage ? unresolvedInlineCommentsCount === 0 : unresolvedInlineCommentsCount === 0 && footerCommentsCount === 0,
                beta: false,
                section: "Summarize",
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
                    label: ""
                })
            },
            {
                key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).BulkIssueCreate,
                label: intl.formatMessage((0, $9wGTI.fg)("confluence-issue-terminology-refresh") ? $790b3996dfce6541$export$a7357cdd1f0b0168.bulkWorkItemsCreateMenuItemLabel : $790b3996dfce6541$export$a7357cdd1f0b0168.bulkIssueCreateMenuItemLabel),
                showMenuItem: (0, $9wGTI.fg)("confluence_ai_bulk_issue_creation"),
                isDisabled: false,
                beta: false,
                section: "Create",
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
                    label: ""
                })
            }
        ];
        const sectionItems = [
            {
                key: "Summarize",
                label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.summarizeSectionLabel),
                showSection: menuItems.some($790b3996dfce6541$var$_temp)
            },
            {
                key: "Create",
                label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.createSectionLabel),
                showSection: !isLivePage && menuItems.some($790b3996dfce6541$var$_temp2)
            }
        ];
        const onMenuItemSelection = (key)=>{
            let additionalAnalyticsAttributes = {};
            if (key === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments) additionalAnalyticsAttributes = {
                numPageCommentsSummarized: footerCommentsCount,
                numInlineCommentsSummarized: unresolvedInlineCommentsCount
            };
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "page",
                    action: "clicked",
                    actionSubject: "menuItem",
                    actionSubjectId: `aiActionsMenuItem-${key}`,
                    attributes: {
                        contentId: contentId,
                        edition: edition,
                        ...additionalAnalyticsAttributes,
                        isLivePage: isLivePage
                    }
                }
            }).fire();
            if (key === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).BulkIssueCreate && (0, $9wGTI.fg)("confluence_ai_bulk_issue_creation")) {
                if (isSidePanelOpen) showWarningDialog((0, $4aiCO.WarningDialog).FLOATING);
                else {
                    setIsOpen(false);
                    handleBulkIssueCreate();
                }
            } else setPopupState(key);
        };
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), {
            testId: "ai-uber-button-menu-group"
        }, sectionItems.map((section)=>section.showSection ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
                key: section.key,
                title: section.label
            }, menuItems.map((item_1)=>item_1.showMenuItem && item_1.section === section.key ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                    iconBefore: item_1.icon,
                    key: item_1.key,
                    isDisabled: item_1.isDisabled,
                    onClick: ()=>{
                        onMenuItemSelection(item_1.key);
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    spread: "space-between",
                    alignBlock: "center"
                }, item_1.label, item_1.beta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), null, intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.betaLabel)))) : null)) : null));
        $[5] = contentId;
        $[6] = createAnalyticsEvent;
        $[7] = edition;
        $[8] = footerCommentsCount;
        $[9] = handleBulkIssueCreate;
        $[10] = intl;
        $[11] = isLivePage;
        $[12] = isSidePanelOpen;
        $[13] = setIsOpen;
        $[14] = setPopupState;
        $[15] = showWarningDialog;
        $[16] = unresolvedInlineCommentsCount;
        $[17] = t5;
    } else t5 = $[17];
    return t5;
} : ({ contentId: contentId, isLivePage: isLivePage = false, setIsOpen: setIsOpen, setPopupState: setPopupState })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount, footerCommentsCount: footerCommentsCount } = (0, $cozmU.useContext)((0, $3Am3T.CommentCountsContext));
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { showWarningDialog: showWarningDialog } = (0, $4aiCO.useWarningDialogStateActions)();
    const isSidePanelOpen = rightSidebarContext.getCurrent()?.panelId === (0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_ID);
    const content = (0, $cozmU.useRef)(typeof document !== 'undefined' ? document.querySelector('div#content') : null);
    const handleBulkIssueCreate = (0, $c8e282bfad3727e4$export$ddc739fc0aea988a)({
        contentId: contentId,
        content: content
    });
    const menuItems = [
        {
            key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).QuickSummary,
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.summarizeSectionLabel),
            showMenuItem: true,
            isDisabled: false,
            beta: false,
            section: "Summarize",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), {
                label: ""
            })
        },
        {
            key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).PageCatchup,
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.pageCatchupMenuItemLabel),
            showMenuItem: true,
            isDisabled: false,
            beta: false,
            section: "Summarize",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
                label: ""
            })
        },
        {
            key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments,
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.inlineCommentsMenuItemLabel),
            showMenuItem: true,
            isDisabled: isLivePage ? unresolvedInlineCommentsCount === 0 : unresolvedInlineCommentsCount === 0 && footerCommentsCount === 0,
            beta: false,
            section: "Summarize",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
                label: ""
            })
        },
        {
            key: (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).BulkIssueCreate,
            label: intl.formatMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? $790b3996dfce6541$export$a7357cdd1f0b0168.bulkWorkItemsCreateMenuItemLabel : $790b3996dfce6541$export$a7357cdd1f0b0168.bulkIssueCreateMenuItemLabel),
            showMenuItem: (0, $9wGTI.fg)('confluence_ai_bulk_issue_creation'),
            isDisabled: false,
            beta: false,
            section: "Create",
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
                label: ""
            })
        }
    ];
    const sectionItems = [
        {
            key: "Summarize",
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.summarizeSectionLabel),
            showSection: menuItems.some((item)=>item.section === 'Summarize' && item.showMenuItem)
        },
        {
            key: "Create",
            label: intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.createSectionLabel),
            showSection: !isLivePage && menuItems.some((item_0)=>item_0.section === 'Create' && item_0.showMenuItem)
        }
    ];
    const onMenuItemSelection = (key)=>{
        let additionalAnalyticsAttributes = {};
        if (key === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments) additionalAnalyticsAttributes = {
            numPageCommentsSummarized: footerCommentsCount,
            numInlineCommentsSummarized: unresolvedInlineCommentsCount
        };
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'page',
                action: 'clicked',
                actionSubject: 'menuItem',
                actionSubjectId: `aiActionsMenuItem-${key}`,
                attributes: {
                    contentId: contentId,
                    edition: edition,
                    ...additionalAnalyticsAttributes,
                    isLivePage: isLivePage
                }
            }
        }).fire();
        if (key === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).BulkIssueCreate && (0, $9wGTI.fg)('confluence_ai_bulk_issue_creation')) {
            if (isSidePanelOpen) showWarningDialog((0, $4aiCO.WarningDialog).FLOATING);
            else {
                setIsOpen(false);
                handleBulkIssueCreate();
            }
        } else setPopupState(key);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), {
        testId: "ai-uber-button-menu-group"
    }, sectionItems.map((section)=>section.showSection ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
            key: section.key,
            title: section.label
        }, menuItems.map((item_1)=>item_1.showMenuItem && item_1.section === section.key ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                iconBefore: item_1.icon,
                key: item_1.key,
                isDisabled: item_1.isDisabled,
                onClick: ()=>{
                    onMenuItemSelection(item_1.key);
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                spread: "space-between",
                alignBlock: "center"
            }, item_1.label, item_1.beta && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), null, intl.formatMessage($790b3996dfce6541$export$a7357cdd1f0b0168.betaLabel)))) : null)) : null));
};
function $790b3996dfce6541$var$_temp(item) {
    return item.section === "Summarize" && item.showMenuItem;
}
function $790b3996dfce6541$var$_temp2(item_0) {
    return item_0.section === "Create" && item_0.showMenuItem;
}















var $i1t43 = parcelRequire("i1t43");








var $5oPgz = parcelRequire("5oPgz");


var $jmjWc = parcelRequire("jmjWc");


const $6654dd6aa1f8b471$export$33b519b7db786337 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "9WcCJ",
    name: "FooterCommentsSummaryCombined",
    loader: async ()=>(await (parcelRequire("cGlMo"))).FooterCommentsSummaryCombinedWithErrorBoundary
});



var $9VC5k = parcelRequire("9VC5k");


var $auLW1 = parcelRequire("auLW1");


var $eN3MW = parcelRequire("eN3MW");


var $brrvF = parcelRequire("brrvF");






const $0eb3a6f6be084bf0$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    aiFloatingContextMenuOptInDialogHeaderText: {
        id: "ai-floating-context-menu.opt-in.dialog.header.text",
        defaultMessage: "Work smarter, not harder"
    },
    aiFloatingContextMenuAdminOptInDialogBodyText: {
        id: "ai-floating-context-menu.admin.opt-in.dialog.body.text",
        defaultMessage: "Save your team time by reading an Al-generated summary instead of an entire page with <a>Atlassian Intelligence</a>. <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration."
    }
});
const $0eb3a6f6be084bf0$var$ATLASSIAN_INTELLIGENCE_LEARN_MORE_LINK = 'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products';
const $0eb3a6f6be084bf0$var$FeatureContentWidthStyles = (0, $buxP3.xcss)({
    width: '500px'
});
const $0eb3a6f6be084bf0$export$a5bda9e80ae7b12a = /*#__PURE__*/ (0, $cozmU.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { popupState: popupState, contentId: contentId, contentType: contentType, spaceKey: spaceKey, lastModifiedDate: lastModifiedDate, source: source, onClose: onClose, setIsOpen: setIsOpen, setPopupState: setPopupState, isLivePage: t1 } = t0;
    const isLivePage = t1 === undefined ? false : t1;
    const intl = (0, $kSwu1.useIntl)();
    const { orgId: orgId } = (0, $bQm3c.useSessionData)();
    const adminLink = `https://admin.atlassian.com/o/${orgId}/atlassian-intelligence`;
    let t2;
    if ($[0] !== adminLink || $[1] !== contentId || $[2] !== contentType || $[3] !== intl || $[4] !== isLivePage || $[5] !== lastModifiedDate || $[6] !== onClose || $[7] !== popupState || $[8] !== setIsOpen || $[9] !== setPopupState || $[10] !== source || $[11] !== spaceKey) {
        const formatOptInMessageValues = {
            a: $0eb3a6f6be084bf0$var$_temp,
            br: $0eb3a6f6be084bf0$var$_temp2
        };
        const renderContent = ()=>{
            switch(popupState){
                case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6654dd6aa1f8b471$export$33b519b7db786337), {
                        contentId: contentId,
                        contentType: contentType,
                        source: (0, $9VC5k.CommentsSummarySource).Header,
                        spaceKey: spaceKey
                    });
                case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).PageCatchup:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $auLW1.PageCatchupComponent), {
                        contentId: contentId,
                        contentType: contentType,
                        spaceKey: spaceKey,
                        setIsOpen: onClose,
                        contentPath: window.location.pathname
                    });
                case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).QuickSummary:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eN3MW.QuickSummaryStreamingComponent), {
                        contentId: contentId,
                        spaceKey: spaceKey,
                        contentType: contentType,
                        lastModifiedDate: lastModifiedDate,
                        setIsOpen: onClose,
                        source: source,
                        contentPath: window.location.pathname
                    });
                case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Upsell:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $brrvF.QuickSummaryUpsell), null);
                case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).OptIn:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5oPgz.default), {
                        source: "quickSummary",
                        product: "confluence",
                        isOrgAdmin: true,
                        headerText: intl.formatMessage($0eb3a6f6be084bf0$export$a7357cdd1f0b0168.aiFloatingContextMenuOptInDialogHeaderText),
                        adminBodyText: intl.formatMessage($0eb3a6f6be084bf0$export$a7357cdd1f0b0168.aiFloatingContextMenuAdminOptInDialogBodyText, formatOptInMessageValues),
                        adminLink: adminLink,
                        onAdminClose: ()=>setIsOpen(false)
                    });
                default:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $790b3996dfce6541$export$2b7899a440558a80), {
                        contentId: contentId,
                        setPopupState: setPopupState,
                        setIsOpen: setIsOpen,
                        isLivePage: isLivePage
                    });
            }
        };
        let t3;
        if ($[13] !== popupState) {
            t3 = (0, $2c4fc9e48b4f3b02$export$4940a8f6968b63)(popupState) && $0eb3a6f6be084bf0$var$FeatureContentWidthStyles;
            $[13] = popupState;
            $[14] = t3;
        } else t3 = $[14];
        let t4;
        if ($[15] !== t3) {
            t4 = [
                t3
            ];
            $[15] = t3;
            $[16] = t4;
        } else t4 = $[16];
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: t4
        }, renderContent());
        $[0] = adminLink;
        $[1] = contentId;
        $[2] = contentType;
        $[3] = intl;
        $[4] = isLivePage;
        $[5] = lastModifiedDate;
        $[6] = onClose;
        $[7] = popupState;
        $[8] = setIsOpen;
        $[9] = setPopupState;
        $[10] = source;
        $[11] = spaceKey;
        $[12] = t2;
    } else t2 = $[12];
    return t2;
} : ({ popupState: popupState, contentId: contentId, contentType: contentType, spaceKey: spaceKey, lastModifiedDate: lastModifiedDate, source: source, onClose: onClose, setIsOpen: setIsOpen, setPopupState: setPopupState, isLivePage: isLivePage = false })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { orgId: orgId } = (0, $bQm3c.useSessionData)();
    const adminLink = `https://admin.atlassian.com/o/${orgId}/atlassian-intelligence`;
    const formatOptInMessageValues = {
        a: (s)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                href: $0eb3a6f6be084bf0$var$ATLASSIAN_INTELLIGENCE_LEARN_MORE_LINK,
                target: "_blank"
            }, s),
        br: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("br", null)
    };
    const renderContent = ()=>{
        switch(popupState){
            case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6654dd6aa1f8b471$export$33b519b7db786337), {
                    contentId: contentId,
                    contentType: contentType,
                    source: (0, $9VC5k.CommentsSummarySource).Header,
                    spaceKey: spaceKey
                });
            case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).PageCatchup:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $auLW1.PageCatchupComponent), {
                    contentId: contentId,
                    contentType: contentType,
                    spaceKey: spaceKey,
                    setIsOpen: onClose,
                    contentPath: window.location.pathname
                });
            case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).QuickSummary:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eN3MW.QuickSummaryStreamingComponent), {
                    contentId: contentId,
                    spaceKey: spaceKey,
                    contentType: contentType,
                    lastModifiedDate: lastModifiedDate,
                    setIsOpen: onClose,
                    source: source,
                    contentPath: window.location.pathname
                });
            case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Upsell:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $brrvF.QuickSummaryUpsell), null);
            case (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).OptIn:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5oPgz.default), {
                    source: "quickSummary",
                    product: "confluence",
                    isOrgAdmin: true,
                    headerText: intl.formatMessage($0eb3a6f6be084bf0$export$a7357cdd1f0b0168.aiFloatingContextMenuOptInDialogHeaderText),
                    adminBodyText: intl.formatMessage($0eb3a6f6be084bf0$export$a7357cdd1f0b0168.aiFloatingContextMenuAdminOptInDialogBodyText, formatOptInMessageValues),
                    adminLink: adminLink,
                    onAdminClose: ()=>setIsOpen(false)
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $790b3996dfce6541$export$2b7899a440558a80), {
                    contentId: contentId,
                    setPopupState: setPopupState,
                    setIsOpen: setIsOpen,
                    isLivePage: isLivePage
                });
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            (0, $2c4fc9e48b4f3b02$export$4940a8f6968b63)(popupState) && $0eb3a6f6be084bf0$var$FeatureContentWidthStyles
        ]
    }, renderContent());
});
function $0eb3a6f6be084bf0$var$_temp(s) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: $0eb3a6f6be084bf0$var$ATLASSIAN_INTELLIGENCE_LEARN_MORE_LINK,
        target: "_blank"
    }, s);
}
function $0eb3a6f6be084bf0$var$_temp2() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("br", null);
}



const $b3acdd5624bc36ae$var$absoluteWrapperStyles = (0, $buxP3.xcss)({
    display: 'flex',
    position: 'absolute',
    right: 'space.150',
    bottom: 'space.0'
});
const $b3acdd5624bc36ae$var$FloatingContextMenuStyles = null;
const $b3acdd5624bc36ae$var$dynamicActionTextMap = {
    [(0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).QuickSummary]: (0, $790b3996dfce6541$export$a7357cdd1f0b0168).summarizeSectionLabel,
    [(0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Comments]: (0, $790b3996dfce6541$export$a7357cdd1f0b0168).inlineCommentsMenuItemLabel,
    [(0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).PageCatchup]: (0, $790b3996dfce6541$export$a7357cdd1f0b0168).pageCatchupMenuItemLabel,
    [(0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).BulkIssueCreate]: (0, $790b3996dfce6541$export$a7357cdd1f0b0168).bulkIssueCreateMenuItemLabel
};
const $b3acdd5624bc36ae$var$AIFloatingContextMenuWrapped = ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, lastModifiedDate: lastModifiedDate = '', pageCommentsSectionInView: pageCommentsSectionInView = false, isLivePage: isLivePage = false, isInObjectSideBar: isInObjectSideBar = false, contentIdFromQuery: contentIdFromQuery, contentBodyDynamic: contentBodyDynamic })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const { edition: edition, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [popupState, setPopupState] = (0, $cozmU.useState)((0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu);
    const { dynamicActionTarget: dynamicActionTarget, queryError: queryError } = (0, $83cf8da53844c2d7$export$7571cdd921b49cc0)(contentId, contentType, pageCommentsSectionInView && !isLivePage, isLivePage, contentIdFromQuery, contentBodyDynamic);
    const { pulseCount: pulseCount } = (0, $874fd8abb2c90fe4$export$b938e63de8ec6cb1)(contentId, contentType);
    const { isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const { isAIEnabledForContent: isAIEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const isDynamicActionSelected = isOpen && popupState !== (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu; // environment-aware enablement via feature encoding
    const isAIFeatureEnabled = (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-ai');
    const isEnabled = isAIFeatureEnabled && (isAIEnabledForContent || isSiteAdmin && !isAdminHubAIEnabled || edition !== (0, $euL71.ConfluenceEdition).PREMIUM && !isAdminHubAIEnabled);
    const getDynamicActionText = ()=>{
        if (dynamicActionTarget && !isOpen) return intl.formatMessage($b3acdd5624bc36ae$var$dynamicActionTextMap[dynamicActionTarget]);
        else if (isOpen && (0, $2c4fc9e48b4f3b02$export$4940a8f6968b63)(popupState)) return intl.formatMessage($b3acdd5624bc36ae$var$dynamicActionTextMap[popupState]);
        else return undefined;
    };
    const [prevDynamicActionTarget, setPrevDynamicActionTarget] = (0, $cozmU.useState)(null);
    if (dynamicActionTarget !== prevDynamicActionTarget) {
        setPrevDynamicActionTarget(dynamicActionTarget);
        if (dynamicActionTarget) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'shown',
                actionSubject: 'button',
                actionSubjectId: 'aiDynamicActionButton',
                source: 'page',
                attributes: {
                    contentId: contentId,
                    dynamicActionTarget: dynamicActionTarget,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }
    const onClose = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
        setPopupState((0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu);
    }, []);
    const onDynamicActionClick = (0, $cozmU.useCallback)(()=>{
        if (isOpen) onClose();
        else if (dynamicActionTarget) {
            setIsOpen(true);
            setPopupState(dynamicActionTarget);
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'page',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiDynamicActionButton',
                attributes: {
                    contentId: contentId,
                    dynamicActionTarget: dynamicActionTarget,
                    toggleClose: isOpen,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        contentId,
        createAnalyticsEvent,
        isOpen,
        onClose,
        dynamicActionTarget,
        isLivePage
    ]);
    const onMenuButtonClick = (0, $cozmU.useCallback)(()=>{
        if (isOpen && popupState !== (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu && isAdminHubAIEnabled) setPopupState((0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu);
        else if (isOpen) onClose();
        else if (!isAdminHubAIEnabled && edition !== (0, $euL71.ConfluenceEdition).PREMIUM) {
            setIsOpen(true);
            setPopupState((0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Upsell);
        } else if (!isAdminHubAIEnabled && isSiteAdmin) {
            setIsOpen(true);
            setPopupState((0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).OptIn);
        } else setIsOpen(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'page',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiActionMenuButton',
                attributes: {
                    contentId: contentId,
                    edition: edition,
                    toggleClose: isOpen,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        contentId,
        createAnalyticsEvent,
        edition,
        isOpen,
        onClose,
        popupState,
        isAdminHubAIEnabled,
        isSiteAdmin,
        isLivePage
    ]);
    const popupComponent = ()=>{
        if (popupState === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu) return 0, $44548221e1617185$export$2593be7073434b2d;
        return 0, $NomII.CustomPopupContainer;
    };
    if (!isEnabled) return null;
    if (isAdminHubAIEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, queryError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: queryError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        isOpen: isOpen,
        onClose: onClose,
        offset: [
            0,
            6
        ],
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0eb3a6f6be084bf0$export$a5bda9e80ae7b12a), {
                popupState: popupState,
                contentId: contentId,
                contentType: contentType,
                spaceKey: spaceKey,
                lastModifiedDate: lastModifiedDate ?? '',
                source: "view-page",
                onClose: onClose,
                setPopupState: setPopupState,
                setIsOpen: setIsOpen,
                isLivePage: isLivePage
            }),
        shouldRenderToParent: true,
        placement: "top-end",
        popupComponent: popupComponent(),
        zIndex: popupState !== (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu && (0, $9wGTI.fg)('platform-dst-motion-uplift-popup') ? 1 : undefined,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $af25143620373faf$export$cd20eff28c3c2c7f), {
                pulseCount: pulseCount,
                isInObjectSideBar: isInObjectSideBar
            }, !isAdminHubAIEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ExetK.AIButton), {
                ...triggerProps,
                onClick: onMenuButtonClick
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7b40fa145aa0c9d8$export$c226a072142c15e9), {
                isDynamicActionSelected: isDynamicActionSelected,
                triggerProps: triggerProps,
                onMenuButtonClick: onMenuButtonClick,
                onDynamicActionClick: onDynamicActionClick,
                dynamicActionText: getDynamicActionText(),
                isMenuOpen: isOpen && popupState === (0, $2c4fc9e48b4f3b02$export$fae4a75c52a0e30c).Menu,
                isInObjectSideBar: isInObjectSideBar
            }))
    }));
};
const $b3acdd5624bc36ae$export$71951c424ee8d4c2 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
        dataFetcherName: "ai-floating-context-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Am3T.CommentCountsProvider), {
        contentId: props.contentId
    }, props.isInObjectSideBar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b3acdd5624bc36ae$var$AIFloatingContextMenuWrapped, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $b3acdd5624bc36ae$var$absoluteWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1mT5xdy1CL _0Bm75Gp0Oa _42Yu6B3p0A _1VJPcaIt9z"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b3acdd5624bc36ae$var$AIFloatingContextMenuWrapped, props))))));
};



var $3jwuS = parcelRequire("3jwuS");





var $D7PHQ = parcelRequire("D7PHQ");


var $kM55L = parcelRequire("kM55L");


var $6mKj3 = parcelRequire("6mKj3");


var $efvKr = parcelRequire("efvKr");


var $aWwYt = parcelRequire("aWwYt");


var $eNjW4 = parcelRequire("eNjW4");








var $kvJHJ = parcelRequire("kvJHJ");


var $8uM2K = parcelRequire("8uM2K");


var $bj5fB = parcelRequire("bj5fB");


var $c4wtI = parcelRequire("c4wtI");


var $dppWL = parcelRequire("dppWL");


var $3tUdX = parcelRequire("3tUdX");





var $amW67 = parcelRequire("amW67");

const $b6f192cd6e2c63ff$export$b9c46d9495de208d = ({ setConfiguration: setConfiguration })=>{
    const { actionsToRender: actionsToRender } = (0, $amW67.useRovoConfigProviderProps)();
    const config = (0, $cozmU.useMemo)(()=>({
            getActions: async ()=>actionsToRender
        }), [
        actionsToRender
    ]);
    (0, $cozmU.useEffect)(()=>{
        setConfiguration(config);
    }, [
        config,
        setConfiguration
    ]);
    return null;
};






var $bXh4X = parcelRequire("bXh4X");


var $k9SyR = parcelRequire("k9SyR");





























var $f1iv3 = parcelRequire("f1iv3");


var $gC2EJ = parcelRequire("gC2EJ");


var $58cpY = parcelRequire("58cpY");


var $dQeg1 = parcelRequire("dQeg1");


var $6iWVH = parcelRequire("6iWVH");








var $bqcqm = parcelRequire("bqcqm");






var $2bR8c = parcelRequire("2bR8c");


var $dWpd3 = parcelRequire("dWpd3");






































const $7dab2f8a87f7b6ba$var$PROJECT_TITLE_KEYWORDS = [
    'project',
    'overview',
    'poster',
    'brief',
    'scope',
    'plan',
    'launch',
    'strategy'
];
const $7dab2f8a87f7b6ba$var$titleContainsProjectKeyword = (contentTitle)=>{
    const lowerTitle = contentTitle.toLowerCase();
    return $7dab2f8a87f7b6ba$var$PROJECT_TITLE_KEYWORDS.some((keyword)=>lowerTitle.includes(keyword));
};
const $7dab2f8a87f7b6ba$export$f2eec944fba9428e = ({ contentType: contentType, contentTitle: contentTitle })=>{
    if (contentType !== 'page') return false;
    return Boolean(contentTitle && $7dab2f8a87f7b6ba$var$titleContainsProjectKeyword(contentTitle));
};


const $a6bade25d3c467cc$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    inlineCommentsMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.inline-comments",
        defaultMessage: "Summarize comments"
    },
    pageCatchupMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.page-catchup",
        defaultMessage: "Summarize changes"
    },
    pageCatchupMenuItemSubheaderLabel: {
        id: "page-rovo-config-common.menu.item.label.page-catchup-subheader",
        defaultMessage: "See what's changed since your last visit"
    },
    summarizeSectionLabel: {
        id: "page-rovo-config-common.summarize.section.label",
        defaultMessage: "Summarize page"
    },
    bulkIssueCreateMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.bulk-issue-create",
        defaultMessage: "Create Jira issues"
    },
    bulkWorkItemsCreateMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.bulk-work-items-create",
        defaultMessage: "Create Jira work items"
    },
    audioBriefingMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.audio-briefing",
        defaultMessage: "Listen to page"
    },
    audioBriefingMenuItemLabelWithContentType: {
        id: "page-rovo-config-common.menu.item.label.audio-briefing-with-content-type",
        defaultMessage: "Listen to {contentType}"
    },
    audioBriefingContentTypePage: {
        id: "page-rovo-config-common.menu.item.label.audio-briefing-content-type-page",
        defaultMessage: "page"
    },
    audioBriefingContentTypeBlogPost: {
        id: "page-rovo-config-common.menu.item.label.audio-briefing-content-type-blogpost",
        defaultMessage: "blogpost"
    },
    audioBriefingContentTypeLiveDoc: {
        id: "page-rovo-config-common.menu.item.label.audio-briefing-content-type-live-doc",
        defaultMessage: "live doc"
    },
    audioBriefingMenuItemSubheaderLabel: {
        id: "page-rovo-config-common.menu.item.label.audio-briefing-subheader",
        defaultMessage: "Get a brief audio summary"
    },
    getProjectOverviewMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.get-project-overview",
        defaultMessage: "Get Project Overview"
    },
    draftCommentsMenuItemLabel: {
        id: "page-rovo-config-common.menu.item.label.draft-comments",
        defaultMessage: "Draft a comment"
    },
    draftCommentsPrompt: {
        id: "page-rovo-config-common.menu.item.prompt.draft-comments",
        defaultMessage: "Suggest a few comments I could leave on this page, then offer to post my chosen one."
    }
});
const $a6bade25d3c467cc$var$AUDIO_BRIEFING_CONTENT_TYPE_MESSAGES = {
    live: $a6bade25d3c467cc$export$defe85febe8b728c.audioBriefingContentTypeLiveDoc,
    page: $a6bade25d3c467cc$export$defe85febe8b728c.audioBriefingContentTypePage,
    blogpost: $a6bade25d3c467cc$export$defe85febe8b728c.audioBriefingContentTypeBlogPost
};
const $a6bade25d3c467cc$var$isValidAudioContentTye = (key)=>key in $a6bade25d3c467cc$var$AUDIO_BRIEFING_CONTENT_TYPE_MESSAGES;
const $a6bade25d3c467cc$export$e0c34800d984dab2 = ()=>{
    const { contentId: contentId, contentType: contentType, contentTitle: contentTitle, spaceKey: spaceKey, lastModifiedDate: lastModifiedDate, isUnpublishedDraft: isUnpublishedDraft, isEditorEmpty: isEditorEmpty } = (0, $amW67.useRovoConfigProviderProps)();
    const { mode: rovoUiMode, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode } = (0, $93Gae.useRovoExperienceAPIStore)();
    const intl = (0, $kSwu1.useIntl)();
    const { formatMessage: formatMessage } = intl;
    const { unresolvedInlineCommentsCount: unresolvedInlineCommentsCount, footerCommentsCount: footerCommentsCount } = (0, $cozmU.useContext)((0, $3Am3T.CommentCountsContext));
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { showWarningDialog: showWarningDialog } = (0, $4aiCO.useWarningDialogStateActions)();
    const isSidePanelOpen = rightSidebarContext.getCurrent()?.panelId === (0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_ID);
    const content = (0, $cozmU.useRef)(typeof document !== 'undefined' ? document.querySelector('div#content') : null);
    // Page Catchup action
    const pageCatchupAction = (0, $cozmU.useCallback)(()=>({
            id: 'summarize-changes-ai-action',
            title: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.pageCatchupMenuItemLabel),
            secondaryTitle: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.pageCatchupMenuItemSubheaderLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
                    label: "",
                    testId: "summarize-changes-ai-action.icon"
                }),
            viewConfig: {
                render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $auLW1.PageCatchupComponent), {
                        contentId: contentId,
                        contentType: contentType,
                        spaceKey: spaceKey,
                        setIsOpen: ()=>{},
                        contentPath: window.location.pathname,
                        isInObjectSidebar: true,
                        showAIDisclaimer: false,
                        allowCustomFollowUp: true
                    })
            },
            type: 'ai-action',
            handleType: (0, $6iWVH.HandleActionType).Base,
            customFollowUpContext: {
                available: false,
                fetch: ()=>Promise.resolve([])
            },
            nudgeContext: {
                id: 'content-catchup'
            }
        }), [
        formatMessage,
        contentId,
        contentType,
        spaceKey
    ]);
    // Summarize page action
    const quickSummaryAction = (0, $cozmU.useCallback)(()=>{
        if ((0, $6mKj3.expValEquals)('confluence_quick_summary_as_a_skill', 'isEnabled', true)) return {
            id: 'summarize-page-ai-action',
            title: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.summarizeSectionLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), {
                    label: "",
                    testId: "summarize-page-ai-action.icon"
                }),
            type: 'skill-action',
            handleType: (0, $6iWVH.HandleActionType).Skill,
            staticPrompt: '/quick-summary',
            nudgeContext: {
                id: 'page-summaries'
            }
        };
        return {
            id: 'summarize-page-ai-action',
            title: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.summarizeSectionLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), {
                    label: "",
                    testId: "summarize-page-ai-action.icon"
                }),
            viewConfig: {
                render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eN3MW.QuickSummaryStreamingComponent), {
                        contentId: contentId,
                        spaceKey: spaceKey,
                        contentType: contentType,
                        lastModifiedDate: lastModifiedDate ?? '',
                        source: "view-page",
                        setIsOpen: ()=>{},
                        contentPath: window.location.pathname,
                        isInObjectSidebar: true,
                        showAIDisclaimer: false,
                        allowCustomFollowUp: true
                    })
            },
            type: 'ai-action',
            handleType: (0, $6iWVH.HandleActionType).Base,
            customFollowUpContext: {
                available: false,
                fetch: ()=>Promise.resolve([])
            },
            nudgeContext: {
                id: 'page-summaries'
            }
        };
    }, [
        formatMessage,
        contentId,
        contentType,
        spaceKey,
        lastModifiedDate
    ]);
    // Summarize comments action
    const commentSummaryAction = (0, $cozmU.useCallback)(()=>({
            id: 'summarize-comments-ai-action',
            title: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.inlineCommentsMenuItemLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
                    label: ""
                }),
            viewConfig: {
                render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Am3T.CommentCountsProvider), {
                        contentId: contentId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6654dd6aa1f8b471$export$33b519b7db786337), {
                        contentId: contentId,
                        contentType: contentType,
                        source: (0, $9VC5k.CommentsSummarySource).Footer,
                        spaceKey: spaceKey,
                        isInObjectSidebar: true,
                        showAIDisclaimer: false
                    }))
            },
            type: 'ai-action',
            handleType: (0, $6iWVH.HandleActionType).Base
        }), [
        formatMessage,
        contentId,
        contentType,
        spaceKey
    ]);
    // Create Jira bulk issues action
    const handleBulkIssueCreate = (0, $c8e282bfad3727e4$export$ddc739fc0aea988a)({
        contentId: contentId,
        content: content,
        useRovoWidth: true
    });
    const onBulkIssueCreate = (0, $cozmU.useCallback)(()=>{
        if (isSidePanelOpen) showWarningDialog((0, $4aiCO.WarningDialog).FLOATING);
        else handleBulkIssueCreate();
    }, [
        isSidePanelOpen,
        showWarningDialog,
        handleBulkIssueCreate
    ]);
    const bulkIssueCreateAction = (0, $cozmU.useCallback)(()=>({
            id: 'bulk-issue-create-ai-action',
            title: formatMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? $a6bade25d3c467cc$export$defe85febe8b728c.bulkWorkItemsCreateMenuItemLabel : $a6bade25d3c467cc$export$defe85febe8b728c.bulkIssueCreateMenuItemLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f1iv3))), {
                    label: ""
                }),
            onClick: onBulkIssueCreate,
            type: 'ai-action',
            handleType: (0, $6iWVH.HandleActionType).Base
        }), [
        formatMessage,
        onBulkIssueCreate
    ]);
    // Audio briefing action
    const { openAudioPlayer: openAudioPlayer } = (0, $bqcqm.useAudioPlayerStore)();
    const sidebarApi = (0, $2bR8c.useCreateRovoExperienceSidebarController)();
    const { activeContent: activeContent } = (0, $dWpd3.useAudioButtonWrapperStore)();
    const { audioBriefingNudgeExperimentState: audioBriefingNudgeExperimentState } = (0, $JTIzG.useAudioFeatureFlags)();
    const playBriefingImmediately = audioBriefingNudgeExperimentState === (0, $JTIzG.BriefingNudgeExperimentState).NUDGE_AUTOPLAY;
    const onAudioBriefingAction = (0, $cozmU.useCallback)(()=>{
        if (!!activeContent) {
            openAudioPlayer(activeContent, {
                playImmediately: playBriefingImmediately
            });
            // Close the Rovo popup or sidebar after clicking
            const isSidebarOrMiniModalOpen = rovoUiMode === (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR || rovoUiMode === (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL;
            if (isSidebarOrMiniModalOpen) // Close sidebar
            toggleConversationAssistantUIMode({
                targetMode: undefined,
                sidebarApi: sidebarApi
            });
        }
    }, [
        activeContent,
        openAudioPlayer,
        playBriefingImmediately,
        rovoUiMode,
        toggleConversationAssistantUIMode,
        sidebarApi
    ]);
    const audioBriefingAction = (0, $cozmU.useCallback)(()=>{
        const key = activeContent?.subType || activeContent?.contentType;
        const contentTypeMessage = key && $a6bade25d3c467cc$var$isValidAudioContentTye(key) ? $a6bade25d3c467cc$var$AUDIO_BRIEFING_CONTENT_TYPE_MESSAGES[key] : undefined;
        const contentTypeLabel = contentTypeMessage ? formatMessage(contentTypeMessage) : '';
        const title = contentTypeLabel ? formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.audioBriefingMenuItemLabelWithContentType, {
            contentType: contentTypeLabel
        }) : formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.audioBriefingMenuItemLabel);
        return {
            id: 'audio-briefing-ai-action',
            title: title,
            secondaryTitle: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.audioBriefingMenuItemSubheaderLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($58cpY))), {
                    label: ""
                }),
            onClick: onAudioBriefingAction,
            type: 'ai-action',
            handleType: (0, $6iWVH.HandleActionType).Base,
            nudgeContext: {
                id: 'proactive-audio-briefing',
                // PROACTIVE_AI_AUDIO_BRIEFING in convo-ai
                suppressionKey: activeContent?.contentId
            }
        };
    }, [
        formatMessage,
        onAudioBriefingAction,
        activeContent
    ]);
    const shouldShowAudioBriefingAction = (0, $cozmU.useMemo)(()=>!!activeContent && audioBriefingNudgeExperimentState !== (0, $JTIzG.BriefingNudgeExperimentState).CONTROL, [
        activeContent,
        audioBriefingNudgeExperimentState
    ]);
    // Get Project Overview skill action
    const getProjectOverviewAction = (0, $cozmU.useCallback)(()=>({
            id: 'get-project-overview-ai-action',
            title: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.getProjectOverviewMenuItemLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dQeg1))), {
                    label: ""
                }),
            handleType: (0, $6iWVH.HandleActionType).Skill,
            type: 'skill-action',
            staticPrompt: '/get-project-details'
        }), [
        formatMessage
    ]);
    // Draft comment action
    const draftCommentAction = (0, $cozmU.useCallback)(()=>({
            id: 'draft-comment-ai-action',
            title: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.draftCommentsMenuItemLabel),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
                    label: ""
                }),
            handleType: (0, $6iWVH.HandleActionType).Chat,
            staticPrompt: formatMessage($a6bade25d3c467cc$export$defe85febe8b728c.draftCommentsPrompt)
        }), [
        formatMessage
    ]);
    // Final actions list
    const getViewPageRovoActions = (0, $cozmU.useCallback)(()=>{
        const actions = [];
        const isPageOrBlogpost = contentType === 'page' || contentType === 'blogpost';
        // Remove this const and use isEditorEmpty directly on experiment cleanup
        const isGatedEditorEmpty = isEditorEmpty && (0, $6mKj3.expValEquals)('platform_editor_remove_summarise_from_empty_doc', 'isEnabled', true);
        // needed for space overview since it doesn't have content type
        // also skip for unpublished drafts and empty live docs)
        if (!isPageOrBlogpost || isUnpublishedDraft || isGatedEditorEmpty) return actions;
        // Get Project Overview action (top of the list for published pages with project-related title)
        if ((0, $7dab2f8a87f7b6ba$export$f2eec944fba9428e)({
            contentType: contentType,
            contentTitle: contentTitle
        }) && (0, $6mKj3.expVal)('rovo_connie_empty_state_get_project_details_skill', 'isEnabled', false)) actions.push({
            actionId: 'get-project-overview',
            action: getProjectOverviewAction()
        });
        actions.push({
            actionId: 'page-catchup',
            action: pageCatchupAction()
        }, {
            actionId: 'quick-summary',
            action: quickSummaryAction()
        });
        if ((0, $6mKj3.expValEquals)('confluence_rovo_draft_comments', 'isEnabled', true)) actions.push({
            actionId: 'draft-comment',
            action: draftCommentAction()
        });
        if (shouldShowAudioBriefingAction) actions.push({
            actionId: 'audio-briefing',
            action: audioBriefingAction()
        });
        // Only show comment summary in Rovo button when proactive_comment_summary experiment is disabled
        if ((unresolvedInlineCommentsCount > 0 || footerCommentsCount > 0) && !(0, $6mKj3.expValEquals)('proactive_comment_summary', 'isEnabled', true)) actions.push({
            actionId: 'comment-summary',
            action: commentSummaryAction()
        });
        if (pageMode === (0, $cD1qu.PageMode).VIEW && (0, $9wGTI.fg)('confluence_ai_bulk_issue_creation')) actions.push({
            actionId: 'bulk-issue-create',
            action: bulkIssueCreateAction()
        });
        return actions;
    }, [
        contentType,
        contentTitle,
        bulkIssueCreateAction,
        commentSummaryAction,
        draftCommentAction,
        footerCommentsCount,
        getProjectOverviewAction,
        isUnpublishedDraft,
        isEditorEmpty,
        pageCatchupAction,
        pageMode,
        quickSummaryAction,
        unresolvedInlineCommentsCount,
        audioBriefingAction,
        shouldShowAudioBriefingAction
    ]);
    const actions = (0, $cozmU.useMemo)(()=>getViewPageRovoActions(), [
        getViewPageRovoActions
    ]);
    return actions;
};





/**
 * @generated SignedSource<<b4310f301c256ea95275f5723888b05a>>
 * @relayHash dea9c3cbfe29b9c92cdeb224b8f076c7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3535a366980d7daaf35b172ee45b177da449ae9442b6943bdb0c465be89ae8b7
const $e82e32b99e59f54f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentContributors",
            "kind": "LinkedField",
            "name": "contentContributors",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isCurrentUserContributor"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useNudgeContributorFilterQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useNudgeContributorFilterQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "dea9c3cbfe29b9c92cdeb224b8f076c7",
            "id": "3535a366980d7daaf35b172ee45b177da449ae9442b6943bdb0c465be89ae8b7",
            "metadata": {},
            "name": "useNudgeContributorFilterQuery",
            "operationKind": "query",
            "text": "query useNudgeContributorFilterQuery($contentId:ID!){contentContributors(id:$contentId){isCurrentUserContributor}}"
        }
    };
}();
$e82e32b99e59f54f$var$node.hash = "427fb0db9de3e615035eab567b67ccf0";
var $e82e32b99e59f54f$export$2e2bcd8739ae039 = $e82e32b99e59f54f$var$node;






var $jMyy4 = parcelRequire("jMyy4");

const $fc07d009da21f8b9$var$useNudgeContributorFilterQuery = (0, $e82e32b99e59f54f$export$2e2bcd8739ae039);
function $fc07d009da21f8b9$export$cb9bdc967aae1b21(contentId, skip) {
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($fc07d009da21f8b9$var$useNudgeContributorFilterQuery, {
        variables: {
            contentId: contentId
        },
        skip: !contentId || skip,
        errorPolicy: 'all',
        __callerPackage__: "page-rovo-config-common"
    });
    const isCurrentUserContributor = data?.contentContributors?.isCurrentUserContributor ?? false;
    return (0, $cozmU.useMemo)(()=>({
            isCurrentUserContributor: isCurrentUserContributor,
            loading: loading
        }), [
        isCurrentUserContributor,
        loading
    ]);
}


/**
 * @generated SignedSource<<7aa3d54126f9597e716056a7eefea026>>
 * @relayHash a0dc0a296d152cfbd6c0ca2a59e55c8b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 80126f44d9591dcee6cb6f9d63eb77d74968d56d29dd33c4a3e52973ee97507e
const $d9c45cee0d598413$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentType"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                }
            ],
            "concreteType": "CatchupLastViewedTimeResponse",
            "kind": "LinkedField",
            "name": "catchupGetLastViewedTime",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "lastViewedTimeISO"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useNudgeFirstVisitFilterQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useNudgeFirstVisitFilterQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "a0dc0a296d152cfbd6c0ca2a59e55c8b",
            "id": "80126f44d9591dcee6cb6f9d63eb77d74968d56d29dd33c4a3e52973ee97507e",
            "metadata": {},
            "name": "useNudgeFirstVisitFilterQuery",
            "operationKind": "query",
            "text": "query useNudgeFirstVisitFilterQuery($contentId:ID!,$contentType:CatchupContentType!){catchupGetLastViewedTime(contentId:$contentId,contentType:$contentType){lastViewedTimeISO}}"
        }
    };
}();
$d9c45cee0d598413$var$node.hash = "1e734053e31505b911fcc40be543fe6e";
var $d9c45cee0d598413$export$2e2bcd8739ae039 = $d9c45cee0d598413$var$node;








const $4a8709f90f4edadd$var$useNudgeFirstVisitFilterQuery = (0, $d9c45cee0d598413$export$2e2bcd8739ae039);
function $4a8709f90f4edadd$export$628206ea1fe1b0f7(lastViewedTimeISO) {
    if (!lastViewedTimeISO) return true;
    // Strip timezone bracket suffixes (e.g. "[America/New_York]") that cause NaN on Date.parse
    const cleaned = lastViewedTimeISO.replace(/\[.*?\]$/, '');
    return !cleaned || Number.isNaN(Date.parse(cleaned));
}
function $4a8709f90f4edadd$export$2e8f1aa0f8ab1526(contentId, skip) {
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($4a8709f90f4edadd$var$useNudgeFirstVisitFilterQuery, {
        variables: {
            contentId: contentId,
            contentType: 'PAGE'
        },
        skip: !contentId || skip,
        errorPolicy: 'all',
        __callerPackage__: "page-rovo-config-common"
    });
    const lastViewedTimeISO = data?.catchupGetLastViewedTime?.lastViewedTimeISO ?? '';
    const isFirstVisit = $4a8709f90f4edadd$export$628206ea1fe1b0f7(lastViewedTimeISO);
    return (0, $cozmU.useMemo)(()=>({
            isFirstVisit: isFirstVisit,
            loading: loading
        }), [
        isFirstVisit,
        loading
    ]);
}









var $gXKuh = parcelRequire("gXKuh");

function $97654e51bdd5d39b$export$5985165b88d806e9() {
    const sidebarApi = (0, $2bR8c.useCreateRovoExperienceSidebarController)();
    const handleAgentMentionSaved = (0, $cozmU.useCallback)((event)=>{
        const detail = event.detail;
        if (!detail) return;
        sidebarApi.openSidebar();
    }, [
        sidebarApi
    ]);
    (0, $cozmU.useEffect)(()=>{
        window.addEventListener((0, $gXKuh.AGENT_MENTION_COMMENT_SAVED_EVENT), handleAgentMentionSaved);
        return ()=>{
            window.removeEventListener((0, $gXKuh.AGENT_MENTION_COMMENT_SAVED_EVENT), handleAgentMentionSaved);
        };
    }, [
        handleAgentMentionSaved
    ]);
}


















var $h2uld = parcelRequire("h2uld");

const $e4cd8876e4f83d2e$export$b68936138edb7d6e = (contentType, contentId)=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { readTime: readTime, loading: readTimeLoading } = (0, $h2uld.useReadTime)(contentId, !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT);
    const readTimeMinutes = readTimeLoading ? null : Number(readTime);
    const minReadTimeMinutes = (0, $9wGTI.fg)('rovo_button_proactive_nudge_min_read_time_increase') ? 1.0 : 0.5;
    /**
   * Base eligibility checks (page-level, shared across all nudges):
   * 1. Rovo Button must be enabled
   * 2. Content type must be 'page' (TODO: extend to 'blogpost' when backend 500s are fixed)
   * 3. Page must not be in edit mode
   * 4. Read time query must be completed
   * 5. Read time must exceed the minimum threshold (1 min with gate on, 30s with gate off)
   */ const isBaseEligible = isRovoButtonEnabled && contentType === 'page' && pageMode !== (0, $cD1qu.PageMode).EDIT && readTimeMinutes !== null && readTimeMinutes > minReadTimeMinutes;
    return {
        isBaseEligible: isBaseEligible,
        readTimeMinutes: readTimeMinutes
    };
};






















var $jXbuX = parcelRequire("jXbuX");


var $hdBxM = parcelRequire("hdBxM");




const $b985b864a3dfeb42$export$560e3a8567843c82 = 'daily-brief-nudge';
const $b985b864a3dfeb42$export$98808fd4b2dc119e = 300000;
const $b985b864a3dfeb42$var$messages = (0, $kSwu1.defineMessages)({
    dailyBriefNudgeTitle: {
        id: "page-rovo-config-common.daily-brief-nudge-title",
        defaultMessage: "Review your daily brief"
    },
    dailyBriefNudgeSubtitle: {
        id: "page-rovo-config-common.daily-brief-nudge-subtitle",
        defaultMessage: "See today's highlights at a glance"
    },
    dailyBriefNudgeIconLabel: {
        id: "page-rovo-config-common.daily-brief-nudge-icon-label",
        defaultMessage: "Daily brief"
    }
});
function $b985b864a3dfeb42$export$9c69eb1d10bb0a06(conversationId) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const onClick = (0, $cozmU.useCallback)(()=>{
        if (conversationId) publish({
            type: 'chat-open',
            data: {
                channelId: conversationId
            },
            openChatMode: 'mini-modal',
            source: 'daily-brief-nudge'
        });
    }, [
        conversationId,
        publish
    ]);
    return (0, $cozmU.useMemo)(()=>({
            id: $b985b864a3dfeb42$export$560e3a8567843c82,
            title: formatMessage($b985b864a3dfeb42$var$messages.dailyBriefNudgeTitle),
            secondaryTitle: formatMessage($b985b864a3dfeb42$var$messages.dailyBriefNudgeSubtitle),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jXbuX))), {
                    size: "small",
                    label: formatMessage($b985b864a3dfeb42$var$messages.dailyBriefNudgeIconLabel)
                }),
            onClick: onClick,
            type: 'ai-action',
            handleType: (0, $6iWVH.HandleActionType).Base,
            nudgeContext: {
                id: $b985b864a3dfeb42$export$560e3a8567843c82,
                selfEligible: true,
                suppressionKey: conversationId ?? undefined
            }
        }), [
        onClick,
        formatMessage,
        conversationId
    ]);
}









var $9Ke0t = parcelRequire("9Ke0t");


var $bGNkz = parcelRequire("bGNkz");





var $1AJi3 = parcelRequire("1AJi3");

const $c3e3eb1b5def3766$var$messages = (0, $kSwu1.defineMessages)({
    insightsNudgeTitle: {
        id: "page-rovo-config-common.digest-nudge-title.v2",
        defaultMessage: "Explore your Rovo digest"
    },
    insightsNudgeIconLabel: {
        id: "page-rovo-config-common.digest-nudge-icon-label",
        defaultMessage: "Digest icon"
    },
    insightsNudgeSecondaryTitle: {
        id: "page-rovo-config-common.digest-nudge-secondary-title",
        defaultMessage: "See this week's highlights at a glance"
    }
});
function $c3e3eb1b5def3766$export$efd7aeb42217b406() {
    const { setActiveMenu: setActiveMenu } = (0, $bGNkz.useUIStore)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { mode: mode, toggleConversationAssistant: toggleConversationAssistant } = (0, $1AJi3.useToggleConversationAssistant)();
    const onClick = (0, $cozmU.useCallback)(()=>{
        if (!mode) toggleConversationAssistant();
        setActiveMenu('pulse');
    }, [
        mode,
        toggleConversationAssistant,
        setActiveMenu
    ]);
    return (0, $cozmU.useMemo)(()=>({
            id: 'rovo-insights-nudge',
            title: formatMessage($c3e3eb1b5def3766$var$messages.insightsNudgeTitle),
            secondaryTitle: formatMessage($c3e3eb1b5def3766$var$messages.insightsNudgeSecondaryTitle),
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9Ke0t))), {
                    size: "small",
                    label: formatMessage($c3e3eb1b5def3766$var$messages.insightsNudgeIconLabel)
                }),
            onClick: onClick,
            type: 'ai-action',
            handleType: (0, $6iWVH.HandleActionType).Base,
            nudgeContext: {
                id: 'rovo-insights'
            }
        }), [
        onClick,
        formatMessage
    ]);
}









var $4nhQC = parcelRequire("4nhQC");


var $TTB05 = parcelRequire("TTB05");




const $c07f2db40a5a574b$var$CONVO_STARTER_NUDGE_ID = 'convo-starter';
/**
 * Checks whether the user has consented to Functional storage.
 * The convo starter nudge uses sessionStorage for suppression, which requires
 * Functional cookie consent per Atlassian policy.
 * Returns null while pending, true if granted, false if denied.
 */ function $c07f2db40a5a574b$var$useCanShowConvoStarterNudge() {
    const [hasFunctionalConsent, setHasFunctionalConsent] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('rovo_button_convostarter_nudge_cookie_policy_check')) {
            setHasFunctionalConsent(true);
            return;
        }
        (0, $4nhQC.getPreferences)().then((preferences)=>{
            setHasFunctionalConsent(Boolean(preferences?.[(0, $TTB05.PreferenceCategory).Functional]));
        }).catch(()=>{
            setHasFunctionalConsent(false);
        });
    }, []);
    return hasFunctionalConsent;
}
function $c07f2db40a5a574b$export$26385239543be8d2() {
    const hasFunctionalConsent = $c07f2db40a5a574b$var$useCanShowConvoStarterNudge();
    return (0, $cozmU.useMemo)(()=>{
        if (!(0, $9wGTI.fg)('aix_convo_starter_nudge_enabled')) return null;
        if (hasFunctionalConsent !== true) return null;
        return {
            id: $c07f2db40a5a574b$var$CONVO_STARTER_NUDGE_ID,
            title: '',
            type: 'convo-starter-action',
            handleType: (0, $6iWVH.HandleActionType).Chat,
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null),
            staticPrompt: '',
            starterType: 'static'
        };
    }, [
        hasFunctionalConsent
    ]);
}


const $fa24c3761347e030$export$5d0421d6a355c531 = (entry)=>'action' in entry;


/** Minimum read time (in minutes) required for the convo starter nudge. */ const $8bdd9ea855fe08b8$var$CONVO_STARTER_MIN_READ_TIME_MINUTES = 2;
function $8bdd9ea855fe08b8$export$730669e74cd8a0c9(isBaseEligible, readTimeMinutes, isCurrentUserContributor, isFirstVisit, dailyBriefStatus) {
    const viewPageRovoActions = (0, $a6bade25d3c467cc$export$e0c34800d984dab2)();
    const dailyBriefNudgeAction = (0, $b985b864a3dfeb42$export$9c69eb1d10bb0a06)(dailyBriefStatus?.conversationId ?? null);
    const insightsNudgeAction = (0, $c3e3eb1b5def3766$export$efd7aeb42217b406)();
    const convoStartersNudgeAction = (0, $c07f2db40a5a574b$export$26385239543be8d2)();
    const { eligibleForChangeboarding: eligibleForChangeboarding } = (0, $dWpd3.useAudioButtonWrapperStore)();
    const actionsById = (0, $cozmU.useMemo)(()=>new Map(viewPageRovoActions.map((registeredAction)=>[
                registeredAction.actionId,
                registeredAction.action
            ])), [
        viewPageRovoActions
    ]);
    return (0, $cozmU.useMemo)(()=>{
        if (!isBaseEligible) return [];
        const nudgeEntries = [
            {
                actionId: 'page-catchup',
                enabled: true
            },
            {
                actionId: 'audio-briefing',
                enabled: !eligibleForChangeboarding
            },
            {
                action: dailyBriefNudgeAction,
                enabled: !!dailyBriefStatus?.conversationId && !!dailyBriefStatus?.completedAt && Date.now() - new Date(dailyBriefStatus.completedAt).getTime() < (0, $b985b864a3dfeb42$export$98808fd4b2dc119e) && (0, $9wGTI.fg)('rovo_button_daily_brief_nudge')
            },
            // Insights nudge — 1 min read time threshold covered by isBaseEligible
            {
                action: insightsNudgeAction,
                enabled: (0, $6mKj3.expVal)('rovo_growth_chat_pulse', 'isEnabled', false)
            },
            // Convo starter nudge — requires higher read time than the base threshold
            // Excluded for contributors and first-time visitors
            {
                action: convoStartersNudgeAction,
                enabled: !isCurrentUserContributor && !isFirstVisit && readTimeMinutes !== null && readTimeMinutes > $8bdd9ea855fe08b8$var$CONVO_STARTER_MIN_READ_TIME_MINUTES && (0, $9wGTI.fg)('aix_convo_starter_nudge_enabled')
            },
            // Action items nudge — eligibility gated in useViewPageRovoActions
            {
                actionId: 'action-items-nudge',
                enabled: true
            }
        ];
        return nudgeEntries.reduce((acc, nudgeEntry)=>{
            if (!nudgeEntry.enabled) return acc;
            const action = (0, $fa24c3761347e030$export$5d0421d6a355c531)(nudgeEntry) ? nudgeEntry.action : actionsById.get(nudgeEntry.actionId);
            if (action) acc.push(action);
            return acc;
        }, []);
    }, [
        isBaseEligible,
        readTimeMinutes,
        eligibleForChangeboarding,
        isCurrentUserContributor,
        isFirstVisit,
        dailyBriefStatus,
        dailyBriefNudgeAction,
        insightsNudgeAction,
        convoStartersNudgeAction,
        actionsById
    ]);
}


const $2b7ed8ae830eb95a$var$AgentMentionSidebarListener = ()=>{
    (0, $97654e51bdd5d39b$export$5985165b88d806e9)();
    return null;
};
const $2b7ed8ae830eb95a$var$ViewPageConfigProviderInner = ({ setConfiguration: setConfiguration })=>{
    const { contentType: contentType, contentId: contentId } = (0, $amW67.useRovoConfigProviderProps)();
    const { isLoggedIn: isLoggedIn, isLicensed: isLicensed, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const isSessionReady = isLoggedIn && isLicensed && !!cloudId;
    const viewPageRovoActions = (0, $a6bade25d3c467cc$export$e0c34800d984dab2)();
    const { isBaseEligible: isBaseEligible, readTimeMinutes: readTimeMinutes } = (0, $e4cd8876e4f83d2e$export$b68936138edb7d6e)(contentType, contentId);
    const { isCurrentUserContributor: isCurrentUserContributor } = (0, $fc07d009da21f8b9$export$cb9bdc967aae1b21)(contentId, !isBaseEligible || !isSessionReady || !(0, $9wGTI.fg)('aix_convo_starter_nudge_enabled'));
    const { isFirstVisit: isFirstVisit } = (0, $4a8709f90f4edadd$export$2e8f1aa0f8ab1526)(contentId, !isBaseEligible || !isSessionReady || !(0, $9wGTI.fg)('aix_convo_starter_nudge_enabled'));
    const dailyBriefStatus = (0, $k9SyR.useDailyBriefUnread)();
    const nudges = (0, $8bdd9ea855fe08b8$export$730669e74cd8a0c9)(isBaseEligible, readTimeMinutes, isCurrentUserContributor, isFirstVisit, dailyBriefStatus);
    const { setNudges: setNudges } = (0, $bXh4X.useAISmartButtonActions)();
    const rovoConfiguration = (0, $cozmU.useMemo)(()=>{
        return {
            getActions: async ()=>{
                const actions = viewPageRovoActions.map((action)=>action.action);
                return Promise.resolve(actions);
            }
        };
    }, [
        viewPageRovoActions
    ]);
    (0, $cozmU.useEffect)(()=>{
        setConfiguration(rovoConfiguration);
        setNudges(nudges);
    }, [
        rovoConfiguration,
        setConfiguration,
        nudges,
        setNudges
    ]);
    return (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2b7ed8ae830eb95a$var$AgentMentionSidebarListener, null) : null;
};
const $2b7ed8ae830eb95a$export$299010de885adda = (props)=>{
    const { contentId: contentId } = (0, $amW67.useRovoConfigProviderProps)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Am3T.CommentCountsProvider), {
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2b7ed8ae830eb95a$var$ViewPageConfigProviderInner, props));
};









var $4u3xL = parcelRequire("4u3xL");








var $as9lu = parcelRequire("as9lu");


var $bm4Et = parcelRequire("bm4Et");


var $eDWhq = parcelRequire("eDWhq");


var $9lHB9 = parcelRequire("9lHB9");




var $ZKswU = parcelRequire("ZKswU");






















var $mfdwv = parcelRequire("mfdwv");


var $6gGPb = parcelRequire("6gGPb");



















const $8732973ed376fa07$var$messages = (0, $kSwu1.defineMessages)({
    agentMentionNudgeTitle: {
        id: "page-rovo-config-common.agent-mention-nudge-title",
        defaultMessage: "Start chatting with agent"
    },
    agentMentionNudgeTitleWithAgentName: {
        id: "page-rovo-config-common.agent-mention-nudge-title-with-agent-name.ai-non-final",
        defaultMessage: "Start chatting with {agentName}"
    },
    agentMentionNudgeTitle2: {
        id: "page-rovo-config-common.agent-mention-nudge-title-2",
        defaultMessage: "Give agent a task?"
    },
    agentMentionNudgeTitleWithAgentName2: {
        id: "page-rovo-config-common.agent-mention-nudge-title-with-agent-name.ai-non-final-2",
        defaultMessage: "Give {agentName} a task?"
    },
    agentMentionNudgeIconLabel: {
        id: "page-rovo-config-common.agent-mention-nudge-icon-label",
        defaultMessage: "Agent icon"
    },
    agentMentionNudgeSecondaryTitle: {
        id: "page-rovo-config-common.agent-mention-nudge-secondary-title",
        defaultMessage: "Start a conversation using this agent"
    }
});
const $8732973ed376fa07$export$d8e8e9b085d2396e = 'agent-mention-nudge';
const $8732973ed376fa07$export$969a8c78a138b693 = 'taskItem';
/** Defined outside the hook so React keeps the same DOM node across re-renders. */ const $8732973ed376fa07$var$AgentMentionIcon = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
        size: "small",
        label: label
    });
/**
 * Avatar for the mentioned agent, rendered in the nudge's leading slot. Keyed by the agent's
 * Atlassian account id (AAID), from which AgentAvatar derives a stable image with no avatar URL
 * fetch. Decorative: the nudge title already names the agent, so the avatar is not separately
 * labelled (a label would put aria-label on a role-less element). Defined outside the hook for a
 * stable component identity.
 */ const $8732973ed376fa07$var$AgentMentionAvatar = ({ agentIdentityAccountId: agentIdentityAccountId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
        agentIdentityAccountId: agentIdentityAccountId,
        size: "small",
        showBorder: false
    });
/**
 * Returns true only when the active element is inside the main page editor,
 * excluding comment editors, AI modals and the Rovo prompt screen.
 *
 * Mirrors isMainEditorContent from @confluence/editor-presets — kept local to
 * avoid adding editor-presets as a dependency of this package.
 */ const $8732973ed376fa07$var$isMainEditorContent = (target)=>{
    if (!(target instanceof HTMLElement)) return false;
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') return false;
    if (target.closest('[data-testid="ak-editor-plugin-ai-modal"]')) return false;
    if (target.closest('[data-testid^="ak-editor-ai"]')) return false;
    if (target.closest('[data-testid="rovo-prompt-session-screen"]')) return false;
    if (target.closest('[data-testid="chromeless-editor"]')) return false;
    return target.closest('.ProseMirror') !== null;
};
function $8732973ed376fa07$export$3e06c63ab8775ee2(agentId, agentMentionContext, agentMentionPrompt, agentMentionParentNodeType, agentMentionInsertionCount, agentMentionName, agentIdentityAccountId, invokedByNodeLocalId) {
    const resolvedAgentId = agentId ?? null;
    // Convert bare AAID to full IdentityUserAri
    const resolvedAgentIdentityAccountId = agentIdentityAccountId ? (0, $as9lu.IdentityUserAri).create({
        userId: agentIdentityAccountId
    }).toString() : null;
    const resolvedPrompt = agentMentionPrompt ?? '';
    const resolvedPromptAdf = agentMentionContext ?? null;
    const resolvedAgentMentionName = agentMentionName?.trim() || null;
    // With platform_editor_agent_mentions_no_task_autofire on, task-item mentions reach this nudge
    // and draft like every other block (auto-send/seeded-conversation behaviour removed), so treat
    // them as non-task here.
    const isTaskItem = agentMentionParentNodeType === $8732973ed376fa07$export$969a8c78a138b693 && !(0, $9wGTI.fg)('platform_editor_agent_mentions_no_task_autofire');
    const nudgeId = agentMentionInsertionCount && agentMentionInsertionCount > 0 ? `${$8732973ed376fa07$export$d8e8e9b085d2396e}-${agentMentionInsertionCount}` : $8732973ed376fa07$export$d8e8e9b085d2396e;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const { setEditorHadFocusBeforeChatOpen: setEditorHadFocusBeforeChatOpen } = (0, $93Gae.useRovoExperienceAPIStore)();
    // Keep a ref to the latest prompt so onClick doesn't need it as a dep.
    // agentMentionContext changes on every keystroke; without this, onClick would
    // recreate on each keystroke → cascading memo invalidations → setNudges on every keystroke.
    const resolvedPromptRef = (0, $cozmU.useRef)(resolvedPrompt);
    resolvedPromptRef.current = resolvedPrompt;
    const resolvedPromptAdfRef = (0, $cozmU.useRef)(resolvedPromptAdf);
    resolvedPromptAdfRef.current = resolvedPromptAdf;
    // Keep a ref to the latest agentId so onClick doesn't capture a stale null.
    // agentId resolves asynchronously; without this, the callback created before
    // resolution would permanently close over null.
    const resolvedAgentIdRef = (0, $cozmU.useRef)(resolvedAgentId);
    resolvedAgentIdRef.current = resolvedAgentId;
    const resolvedAgentIdentityAccountIdRef = (0, $cozmU.useRef)(resolvedAgentIdentityAccountId);
    resolvedAgentIdentityAccountIdRef.current = resolvedAgentIdentityAccountId;
    const invokedByNodeLocalIdRef = (0, $cozmU.useRef)(invokedByNodeLocalId ?? null);
    invokedByNodeLocalIdRef.current = invokedByNodeLocalId ?? null;
    const iconLabel = formatMessage($8732973ed376fa07$var$messages.agentMentionNudgeIconLabel);
    // We capture focus on mousedown so we have the correct pre-click value.
    // The handler is bound directly to the nudge button via the action's onMouseDown prop
    const editorHadFocusAtMouseDownRef = (0, $cozmU.useRef)(false);
    const onMouseDown = (0, $cozmU.useCallback)(()=>{
        if (!(0, $9wGTI.fg)('platform_editor_agent_mentions_drop_one_fixes')) return;
        editorHadFocusAtMouseDownRef.current = typeof document !== 'undefined' && $8732973ed376fa07$var$isMainEditorContent(document.activeElement);
    }, []);
    const onClick = (0, $cozmU.useCallback)(()=>{
        // Use the mousedown snapshot — focus has already moved to the nudge button
        // by the time this click handler runs.
        if ((0, $9wGTI.fg)('platform_editor_agent_mentions_drop_one_fixes')) {
            const editorHadFocus = editorHadFocusAtMouseDownRef.current;
            setEditorHadFocusBeforeChatOpen?.(editorHadFocus);
        }
        publish({
            type: 'chat-new',
            source: 'agentMentionEditorNudge',
            openChatMode: 'mini-modal',
            data: {
                prompt: resolvedPromptAdfRef.current ?? resolvedPromptRef.current,
                // Non-task blocks pre-fill as a draft and skip creating a seeded conversation, so
                // the manual send creates and names the conversation instead of leaving a
                // date-named one. With platform_editor_agent_mentions_no_task_autofire off, task-item
                // mentions never reach this nudge (their presence is gated off in
                // EditPageRovoConfigProvider, so they use the auto-fire path instead). With it on,
                // isTaskItem is false so they draft like every other block.
                // This nudge is only surfaced under the platform_editor_agent_mentions experiment
                // (EditPageRovoConfigProvider gates its presence), so the gate below is effectively
                // double-gated without preconditioning it on the experiment here.
                ...isTaskItem ? {} : {
                    overrideAutoSend: true
                },
                ...!isTaskItem && (0, $9wGTI.fg)('platform_editor_agent_mentions_drop_one_fixes') ? {
                    skipCreatingSeededConversation: true
                } : {},
                dialogues: [],
                mode: {
                    useCurrentPageContext: true
                },
                ...resolvedAgentIdRef.current ? {
                    agentId: resolvedAgentIdRef.current
                } : {},
                ...resolvedAgentIdentityAccountIdRef.current ? {
                    agentIdentityAccountId: resolvedAgentIdentityAccountIdRef.current
                } : {},
                // Seed the agent-run-state bridge with the invoking node, behind its experiment.
                // Consumed on the manual send via the stash in the pubsub listener.
                ...invokedByNodeLocalIdRef.current && (0, $6mKj3.expValEquals)('platform_editor_agent_state_bridge', 'isEnabled', true) ? {
                    invokedByNodeLocalId: invokedByNodeLocalIdRef.current
                } : {}
            }
        });
    }, [
        publish,
        isTaskItem,
        setEditorHadFocusBeforeChatOpen
    ]);
    return (0, $cozmU.useMemo)(()=>{
        const title = resolvedAgentMentionName ? formatMessage($8732973ed376fa07$var$messages.agentMentionNudgeTitleWithAgentName, {
            agentName: resolvedAgentMentionName
        }) : formatMessage($8732973ed376fa07$var$messages.agentMentionNudgeTitle);
        const title2 = resolvedAgentMentionName ? formatMessage($8732973ed376fa07$var$messages.agentMentionNudgeTitleWithAgentName2, {
            agentName: resolvedAgentMentionName
        }) : formatMessage($8732973ed376fa07$var$messages.agentMentionNudgeTitle2);
        // The mentioned agent's avatar replaces the chat icon in the leading slot. When off the nudge
        // renders as before.
        return {
            id: nudgeId,
            title: (0, $9wGTI.fg)('platform_editor_agent_mentions_drop_one_fixes') ? title2 : title,
            secondaryTitle: formatMessage($8732973ed376fa07$var$messages.agentMentionNudgeSecondaryTitle),
            icon: (0, $9wGTI.fg)('platform_editor_agent_mentions_cta_redesign') ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8732973ed376fa07$var$AgentMentionAvatar, {
                    agentIdentityAccountId: agentIdentityAccountId
                }) : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8732973ed376fa07$var$AgentMentionIcon, {
                    label: iconLabel
                }),
            onClick: onClick,
            onMouseDown: onMouseDown,
            type: 'ai-action',
            handleType: (0, $6iWVH.HandleActionType).Base,
            nudgeContext: {
                id: $8732973ed376fa07$export$d8e8e9b085d2396e,
                selfEligible: true,
                experimentName: 'platform_editor_agent_mentions'
            }
        };
    }, [
        formatMessage,
        iconLabel,
        nudgeId,
        onClick,
        onMouseDown,
        resolvedAgentMentionName,
        agentIdentityAccountId
    ]);
}
















var $3z1p5 = parcelRequire("3z1p5");




const $5f4baace2595030e$export$eab6f356b10dc881 = 'content_reviewer_agent';
/** Identifies this touchpoint to the assistance service for the agent lookup. */ const $5f4baace2595030e$var$TOUCHPOINT_SOURCE = 'confluence-edit-page-rovo-chat';
const $5f4baace2595030e$export$38f8263f72e6f3e7 = ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { getAndStoreAgentByExternalConfigReference: getAndStoreAgentByExternalConfigReference } = (0, $3z1p5.usePaginatedAgentByConfigReference)({
        assistanceServiceParams: {
            experienceId: 'ai-mate',
            product: 'confluence',
            siteId: cloudId,
            touchpointSource: $5f4baace2595030e$var$TOUCHPOINT_SOURCE
        }
    });
    const [agent, setAgent] = (0, $cozmU.useState)(undefined);
    // Resolver returns undefined (never rejects) on failure; depend on it to reflect the latest config.
    (0, $cozmU.useEffect)(()=>{
        getAndStoreAgentByExternalConfigReference({
            externalConfigReference: $5f4baace2595030e$export$eab6f356b10dc881
        }).then((resolvedAgent)=>{
            setAgent(resolvedAgent ?? undefined);
        });
    }, [
        getAndStoreAgentByExternalConfigReference
    ]);
    return agent;
};

















const $23e0c73c9feee0cc$export$5569745b4d0a5343 = (contentType)=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const isLiveDoc = pageMode === (0, $cD1qu.PageMode).LIVE;
    /**
	 * Filters to prevent high request volume checking for nudge recommendations on live docs
	 * 1. Feature gate 'confluence_rovo_live_doc_nudges' must be enabled
	 * 2. Page must be a live doc
	 * 3. Rovo Button must be enabled
	 * 4. Content type must be 'page'
	 */ return isLiveDoc && isRovoButtonEnabled && contentType === 'page' && isAdminHubAIEnabled && (0, $9wGTI.fg)('confluence_rovo_live_doc_nudges');
};








const $1dc1702d58bb7989$var$AUDIO_BRIEFING_MIN_READ_TIME_MINUTES = 5;
function $1dc1702d58bb7989$export$60835107d4b45e85(enableLiveDocNudges, eligibleForChangeboarding, isFirstVisit, isCurrentUserContributor, isEligibilityLoading, readTimeMinutes, /**
	 * controls nudge *presence* (truthy = mention exists). Presence also requires
	 * `resolvedAgentMentionId` below, so the nudge never renders (and can't be clicked) before
	 * the Agent Studio UUID has resolved — clicking before resolution would fire `chat-new`
	 * without a routable agentId.
	 */ agentMentionId, /** control nudge *presence* (see above) and *payload* (forwarded to useAgentMentionNudgeAction). */ resolvedAgentMentionId, /** control nudge *payload* (forwarded to useAgentMentionNudgeAction). */ agentMentionContext, /** control nudge fallback prompt (forwarded to useAgentMentionNudgeAction). */ agentMentionPrompt, /** control nudge *payload* (forwarded to useAgentMentionNudgeAction). */ agentMentionParentNodeType, /** controls the nudge action id so each inserted mention is treated as a new nudge. */ agentMentionInsertionCount, /** control nudge title (forwarded to useAgentMentionNudgeAction). */ agentMentionName, /** invoking mention node localId (forwarded to seed the agent-run-state bridge). */ invokedByNodeLocalId) {
    const viewPageRovoActions = (0, $a6bade25d3c467cc$export$e0c34800d984dab2)();
    const agentMentionNudgeAction = (0, $8732973ed376fa07$export$3e06c63ab8775ee2)(resolvedAgentMentionId, agentMentionContext, agentMentionPrompt, agentMentionParentNodeType, agentMentionInsertionCount, agentMentionName, agentMentionId, invokedByNodeLocalId);
    const actionsById = (0, $cozmU.useMemo)(()=>new Map(viewPageRovoActions.map((registeredAction)=>[
                registeredAction.actionId,
                registeredAction.action
            ])), [
        viewPageRovoActions
    ]);
    return (0, $cozmU.useMemo)(()=>{
        // Require resolvedAgentMentionId too: without it, a click fired before the AAID→UUID
        // resolution completes would publish `chat-new` with no agentId, silently routing to
        // the default/current conversation agent instead of the mentioned one.
        const alwaysOnNudges = agentMentionId && resolvedAgentMentionId ? [
            agentMentionNudgeAction
        ] : [];
        if (!enableLiveDocNudges) return alwaysOnNudges;
        const isAudioBriefingEligible = !isEligibilityLoading && !eligibleForChangeboarding && isFirstVisit && !isCurrentUserContributor && readTimeMinutes !== null && readTimeMinutes >= $1dc1702d58bb7989$var$AUDIO_BRIEFING_MIN_READ_TIME_MINUTES;
        const nudgeEntries = [
            {
                actionId: 'audio-briefing',
                enabled: isAudioBriefingEligible
            }
        ];
        const liveDocNudges = nudgeEntries.reduce((acc, nudgeEntry)=>{
            if (!nudgeEntry.enabled) return acc;
            const action = (0, $fa24c3761347e030$export$5d0421d6a355c531)(nudgeEntry) ? nudgeEntry.action : actionsById.get(nudgeEntry.actionId);
            if (action) acc.push(action);
            return acc;
        }, []);
        return [
            ...alwaysOnNudges,
            ...liveDocNudges
        ];
    }, [
        agentMentionId,
        // resolvedAgentMentionId now also gates presence (see above), so it must be a dep.
        // agentMentionContext/agentMentionParentNodeType/agentMentionName remain payload-only:
        // agentMentionNudgeAction already invalidates on those values.
        resolvedAgentMentionId,
        agentMentionNudgeAction,
        enableLiveDocNudges,
        isEligibilityLoading,
        eligibleForChangeboarding,
        isFirstVisit,
        isCurrentUserContributor,
        readTimeMinutes,
        actionsById
    ]);
}



var $02cx8 = parcelRequire("02cx8");

/* getEmptyPageCreationActions.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $4ez2K = parcelRequire("4ez2K");


var $jQDPt = parcelRequire("jQDPt");




const $efb362169c233167$export$4b8c4c333cdd165d = [
    'create-product-requirements-document',
    'create-customer-onboarding-strategy',
    'create-background-research-plan'
]; /* istanbul ignore next */ 
const $efb362169c233167$var$styles = {
    iconContainer: "_4FKVYEgVvo"
};
const $efb362169c233167$export$4e5c71902381581b = (promptCards)=>{
    const promptCardsById = new Map(promptCards.map((card)=>[
            card.id,
            card
        ]));
    return $efb362169c233167$export$4b8c4c333cdd165d.reduce((actions, targetId)=>{
        const card = promptCardsById.get(targetId);
        if (card) actions.push({
            handleType: (0, $6iWVH.HandleActionType).Chat,
            id: card.id,
            title: card.title,
            dynamicPrompt: card.prompt,
            icon: ()=>{
                const Icon = (0, $jQDPt.getUseCaseIcon)(card.useCase);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
                    alignItems: "center",
                    justifyContent: "center",
                    xcss: $efb362169c233167$var$styles.iconContainer
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, null));
            }
        });
        return actions;
    }, []);
};


var $4c762b6d974e46d5$exports = {};
$4c762b6d974e46d5$exports = new URL("empty-page-greeting-icon.9a2c7bfb.svg", import.meta.url).toString();


const $7e583ad86f1e8aa8$var$messages = (0, $kSwu1.defineMessages)({
    emptyPageGreetingTitle: {
        id: "edit-page-rovo-config-provider.empty-page-greeting-title",
        defaultMessage: "Start your doc with a prompt"
    },
    copiedPageGreetingTitle: {
        id: "edit-page-rovo-config-provider.copied-page-greeting-title",
        defaultMessage: "Need help editing your copied page?"
    },
    suggestEditsMenuItemLabel: {
        id: "edit-page-rovo-config-provider.menu.item.label.suggest-edits",
        defaultMessage: "Review with suggestions"
    },
    suggestEditsMenuItemPrompt: {
        id: "edit-page-rovo-config-provider.menu.item.prompt.suggest-edits-agent",
        defaultMessage: "Review my content and suggest improvements"
    }
});
/** Max length for the prompt-derived chat history title (matches other Rovo chat channels). */ const $7e583ad86f1e8aa8$var$AGENT_MENTION_CHAT_TITLE_MAX_LENGTH = 30;
const $7e583ad86f1e8aa8$var$AGENT_MENTION_BRIDGE_CLIENT_PREFIX = 'confluence-editor-agent-mention-';
const $7e583ad86f1e8aa8$var$EditPageConfigProviderInner = ({ setConfiguration: setConfiguration })=>{
    const viewPageRovoActions = (0, $a6bade25d3c467cc$export$e0c34800d984dab2)();
    const editorActions = (0, $02cx8.useEditorRovoButtonActionsActions)();
    const editorActionsContext = (0, $02cx8.useEditorRovoButtonActionsContext)();
    const rovoConfigProviderProps = (0, $amW67.useRovoConfigProviderProps)();
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    // Resolve the OOTB Content Reviewer agent that backs the "Review with suggestions" entry point.
    // Existence check only (no provisioning); if the agent isn't provisioned the entry point is
    // hidden.
    const contentReviewerAgent = (0, $5f4baace2595030e$export$38f8263f72e6f3e7)();
    const isEditorEmpty = (0, $dppWL.isPageRovoConfigProviderProps)(rovoConfigProviderProps) && rovoConfigProviderProps.isEditorEmpty;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { promptCards: promptCards } = (0, $ZKswU.usePromptCards)();
    const isEmptyPageWithPromptCards = isEditorEmpty && Array.isArray(promptCards);
    const pageProps = (0, $dppWL.isPageRovoConfigProviderProps)(rovoConfigProviderProps) ? rovoConfigProviderProps : null;
    const contentType = pageProps?.contentType ?? '';
    const contentId = pageProps?.contentId ?? '';
    const readTimeMinutes = pageProps?.readTime ?? null;
    const readTimeLoading = pageProps?.readTimeLoading ?? false;
    const suggestEditsActionIcon = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4u3xL))), {
            label: ""
        }), []);
    const enableLiveDocNudges = (0, $23e0c73c9feee0cc$export$5569745b4d0a5343)(contentType);
    const { eligibleForChangeboarding: eligibleForChangeboarding } = (0, $dWpd3.useAudioButtonWrapperStore)();
    const { isFirstVisit: isFirstVisit, loading: isFirstVisitLoading } = (0, $4a8709f90f4edadd$export$2e8f1aa0f8ab1526)(contentId, !enableLiveDocNudges);
    const { isCurrentUserContributor: isCurrentUserContributor, loading: isContributorLoading } = (0, $fc07d009da21f8b9$export$cb9bdc967aae1b21)(contentId, !enableLiveDocNudges);
    const isEligibilityLoading = isFirstVisitLoading || isContributorLoading || readTimeLoading;
    const agentMentionId = (0, $02cx8.useEditorRovoButtonAgentMentionId)();
    const agentMentionInsertionCount = (0, $02cx8.useEditorRovoButtonAgentMentionInsertionCount)();
    const resolvedAgentMentionId = (0, $02cx8.useEditorRovoButtonResolvedAgentMentionId)();
    const agentMentionContext = (0, $02cx8.useEditorRovoButtonAgentMentionContext)();
    const agentMentionPrompt = (0, $02cx8.useEditorRovoButtonAgentMentionPrompt)();
    const agentMentionName = (0, $02cx8.useEditorRovoButtonAgentMentionName)();
    const agentMentionParentNodeType = (0, $02cx8.useEditorRovoButtonAgentMentionParentNodeType)();
    const agentMentionNodeLocalId = (0, $02cx8.useEditorRovoButtonAgentMentionNodeLocalId)();
    // When platform_editor_agent_mentions_no_task_autofire is on, task-item mentions drop their
    // auto-fire special case and follow the same nudge path as every other block, so treat them as
    // non-task items here. This one flag flips both the nudge-presence arg below and the (now
    // legacy) auto-fire effect.
    const isTaskItemMention = agentMentionParentNodeType === (0, $8732973ed376fa07$export$969a8c78a138b693) && !(0, $9wGTI.fg)('platform_editor_agent_mentions_no_task_autofire');
    const nudges = (0, $1dc1702d58bb7989$export$60835107d4b45e85)(enableLiveDocNudges, eligibleForChangeboarding, isFirstVisit, isCurrentUserContributor, isEligibilityLoading, readTimeMinutes, // Legacy task-item auto-fire keeps them out of the nudge. With
    // platform_editor_agent_mentions_no_task_autofire on, isTaskItemMention is false so task
    // items show the nudge like any block. expValEquals last ensures exposure is tracked.
    !isTaskItemMention && (0, $6mKj3.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) ? agentMentionId : null, resolvedAgentMentionId, agentMentionContext, agentMentionPrompt, agentMentionParentNodeType, agentMentionInsertionCount, agentMentionName, agentMentionNodeLocalId);
    const { setNudges: setNudges } = (0, $bXh4X.useAISmartButtonActions)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const agentMentionBridgeClientId = (0, $cozmU.useMemo)(()=>(0, $bm4Et.client)(`${$7e583ad86f1e8aa8$var$AGENT_MENTION_BRIDGE_CLIENT_PREFIX}${contentId || 'fallback'}`), [
        contentId
    ]);
    const { send: sendBridgeMessage, ready: readyBridgeClient } = (0, $eDWhq.useRovoContentBridgeAPI)(agentMentionBridgeClientId);
    const hasCalledBridgeReadyRef = (0, $cozmU.useRef)(false);
    // Keep refs so the auto-fire effect can read the latest agent mention prompt/context without
    // them being reactive dependencies. Adding them to the dep array would cause the effect to
    // re-fire on every keystroke in the task item without agentMentionInsertionCount changing.
    const agentMentionPromptRef = (0, $cozmU.useRef)(agentMentionPrompt);
    agentMentionPromptRef.current = agentMentionPrompt;
    const agentMentionContextRef = (0, $cozmU.useRef)(agentMentionContext);
    agentMentionContextRef.current = agentMentionContext;
    // Keep the invoking node localId in a ref so the auto-fire effect can read the latest value
    // without it being a reactive dependency (matching the prompt/context refs above).
    const agentMentionNodeLocalIdRef = (0, $cozmU.useRef)(agentMentionNodeLocalId);
    agentMentionNodeLocalIdRef.current = agentMentionNodeLocalId;
    // Legacy auto-fire when an agent is @mentioned inside a task item. The inline-Rovo treatment
    // runs through the content bridge without opening chat, and the control retains the existing
    // mini-modal flow. Both remain gated by platform_editor_agent_mentions. This whole effect is
    // disabled once platform_editor_agent_mentions_no_task_autofire is on: isTaskItemMention is
    // false, so the guard below returns early and task items fall back to the shared nudge path.
    (0, $cozmU.useEffect)(()=>{
        if (!isTaskItemMention || !resolvedAgentMentionId || !agentMentionInsertionCount || !(0, $6mKj3.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true)) return;
        const promptText = agentMentionPromptRef.current?.trim();
        if ((0, $6mKj3.expValEquals)('platform_editor_agent_mentions_nudge_indication', 'isEnabled', true)) {
            if (!contentId || !promptText) return;
            if (!hasCalledBridgeReadyRef.current) {
                readyBridgeClient();
                hasCalledBridgeReadyRef.current = true;
            }
            sendBridgeMessage((0, $9lHB9.InlineInputBoxSendMessageCommand), {
                receiverId: (0, $9lHB9.ROVO_CHAT_CLIENT_ID),
                prompt: promptText,
                source: 'agentMentionTaskItemAutoFire',
                productKey: 'confluence',
                contentId: contentId,
                agentId: resolvedAgentMentionId,
                ...agentMentionName ? {
                    agentName: agentMentionName
                } : {},
                ...agentMentionId ? {
                    agentIdentityAccountId: (0, $as9lu.IdentityUserAri).create({
                        userId: agentMentionId
                    }).toString()
                } : {},
                deepResearchEnabled: false,
                webSearchEnabled: false,
                openChat: false,
                openChatOnError: false,
                addCurrentPageAsContextUserPreference: true,
                contentContext: 'global'
            });
            return;
        }
        const prompt = agentMentionContextRef.current ?? agentMentionPromptRef.current;
        // Plain-text title for the chat history entry, derived from the task text. Inline-atom
        // nodes (the agent mention, custom/reaction emoji, etc.) are dropped by ProseMirror's
        // textContent; plain typed text is kept. Truncate by code point rather than UTF-16 unit
        // so an astral character (e.g. a typed Unicode emoji) on the boundary isn't split into an
        // unpaired surrogate. Without a title the auto-sent, seeded conversation shows only a date.
        const conversationName = promptText ? Array.from(promptText).slice(0, $7e583ad86f1e8aa8$var$AGENT_MENTION_CHAT_TITLE_MAX_LENGTH).join('') : undefined;
        publish({
            type: 'chat-new',
            source: 'agentMentionTaskItemAutoFire',
            openChatMode: 'mini-modal',
            autoFocusInput: false,
            data: {
                ...prompt ? {
                    prompt: prompt
                } : {},
                ...conversationName && (0, $9wGTI.fg)('platform_editor_agent_mentions_drop_one_fixes') ? {
                    name: conversationName
                } : {},
                isPromptPlaceholder: false,
                dialogues: [],
                mode: {
                    useCurrentPageContext: true
                },
                agentId: resolvedAgentMentionId,
                ...agentMentionName ? {
                    agentName: agentMentionName
                } : {},
                // Reconstruct the full identity ARI from the bare accountId stored in the ADF mention node.
                // agentMentionId is "712020:..." (bare), but downstream consumers (TelepointerAvatar,
                // sendMessageActionProvider) expect the full "ari:cloud:identity::user/712020:..." ARI.
                ...agentMentionId ? {
                    agentIdentityAccountId: (0, $as9lu.IdentityUserAri).create({
                        userId: agentMentionId
                    }).toString()
                } : {},
                // Seed the agent-run-state bridge with the invoking node, behind its experiment.
                ...agentMentionNodeLocalIdRef.current && (0, $6mKj3.expValEquals)('platform_editor_agent_state_bridge', 'isEnabled', true) ? {
                    invokedByNodeLocalId: agentMentionNodeLocalIdRef.current
                } : {}
            }
        });
    }, [
        agentMentionId,
        agentMentionInsertionCount,
        agentMentionName,
        contentId,
        readyBridgeClient,
        resolvedAgentMentionId,
        sendBridgeMessage,
        isTaskItemMention,
        // agentMentionPrompt/agentMentionContext intentionally omitted — read via refs above to avoid
        // re-firing on every keystroke after the mention is inserted.
        publish
    ]);
    const config = (0, $cozmU.useMemo)(()=>{
        // A recently-copied page in the `rovoChat` cohort injects the "Remove content, keep structure"
        // action into the editor-actions store (via CopyWithRovo → setActions) without a selection
        // `context.reference`. CopyWithRovo only injects it for a page that actually came through the
        // copy flow (`?copiedPage=<sourceId>`), and the selection-based editor-actions flow always sets
        // `reference`, so `rovoChat cohort + editor actions present + no reference` identifies the
        // copied-page injection. In that case we pin the injected action(s) as the sole, prioritized
        // actions so the copy-with-rovo action is the top option rather than being interleaved with /
        // buried under the prompt-of-day and dynamic conversation starters downstream. This is also the
        // single signal behind the copied-page greeting below — do not gate that on the cohort alone,
        // or every edit page in the cohort shows the copied-page title.
        // Evaluate the experiment last so exposure is only tracked once the copied-page signal
        // (injected editor actions, no selection reference) is present.
        const isCopiedPageRovoChat = editorActions.length > 0 && !editorActionsContext?.reference && (0, $6mKj3.expValEquals)('cc_fd_copy_with_rovo', 'cohort', 'rovoChat');
        const getCustomGreeting = ()=>{
            if (isEmptyPageWithPromptCards && !isCopiedPageRovoChat) return {
                iconSrc: (0, (/*@__PURE__*/$parcel$interopDefault($4c762b6d974e46d5$exports))),
                title: formatMessage($7e583ad86f1e8aa8$var$messages.emptyPageGreetingTitle)
            };
            if (isCopiedPageRovoChat) return {
                title: formatMessage($7e583ad86f1e8aa8$var$messages.copiedPageGreetingTitle)
            };
            return undefined;
        };
        const customGreeting = getCustomGreeting();
        const suggestEditsAction = {
            id: 'suggest-edits-ai-action',
            title: formatMessage($7e583ad86f1e8aa8$var$messages.suggestEditsMenuItemLabel),
            icon: suggestEditsActionIcon,
            handleType: (0, $6iWVH.HandleActionType).Chat,
            staticPrompt: formatMessage($7e583ad86f1e8aa8$var$messages.suggestEditsMenuItemPrompt),
            agent: contentReviewerAgent
        };
        // Show the suggest-edits action (chat with the OOTB Content Reviewer agent) only when the
        // gate is on and the agent is provisioned — no skill fallback, no provisioning on click.
        // The experiment is evaluated in its own statement (not chained with the gate) to satisfy
        // the no-preconditioning rule; the agent is only resolved when the gate is on.
        const isSuggestEditsExperimentEnabled = isRovoLLMEnabled && !!contentReviewerAgent && (0, $6mKj3.expValEquals)('platform_editor_ai_content_suggested_edits', 'isEnabled', true);
        const isSuggestEditsActionEnabled = isSuggestEditsExperimentEnabled && (0, $9wGTI.fg)('content_reviewer_agent');
        const combinedEditorActions = isSuggestEditsActionEnabled ? [
            suggestEditsAction,
            ...editorActions
        ] : editorActions;
        const baseConfig = {
            getActions: async ()=>{
                // Copied-page rovoChat cohort: return only the injected editor action(s) so
                // copy-with-rovo ("Remove content, keep structure") is the top option. Use
                // `editorActions` (not `combinedEditorActions`) so the optional suggest-edits action
                // cannot sit above it. Paired with `prioritizeCustomActionResults` below.
                if (isCopiedPageRovoChat) return Promise.resolve(editorActions);
                if (isEmptyPageWithPromptCards) return Promise.resolve((0, $efb362169c233167$export$4e5c71902381581b)(promptCards));
                if (editorActionsContext?.reference) return Promise.resolve(combinedEditorActions);
                const viewPageActions = viewPageRovoActions.map((action)=>action.action);
                return Promise.resolve([
                    ...combinedEditorActions,
                    ...viewPageActions
                ]);
            },
            customGreeting: customGreeting,
            shouldShowGreeting: customGreeting !== undefined || undefined,
            prioritizeCustomActionResults: isCopiedPageRovoChat || isEmptyPageWithPromptCards ? true : undefined
        };
        return baseConfig;
    }, [
        editorActions,
        editorActionsContext,
        viewPageRovoActions,
        isEmptyPageWithPromptCards,
        isRovoLLMEnabled,
        contentReviewerAgent,
        promptCards,
        formatMessage,
        suggestEditsActionIcon
    ]);
    (0, $cozmU.useEffect)(()=>{
        setConfiguration(config);
        setNudges(nudges);
    }, [
        config,
        setConfiguration,
        nudges,
        setNudges
    ]);
    return null;
};
const $7e583ad86f1e8aa8$export$d95c465cd9bfae9f = (props)=>{
    const { contentId: contentId } = (0, $amW67.useRovoConfigProviderProps)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Am3T.CommentCountsProvider), {
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7e583ad86f1e8aa8$var$EditPageConfigProviderInner, props));
};
























var $gIaMn = parcelRequire("gIaMn");




var $5Abqh = parcelRequire("5Abqh");


const $8a4bdd953279ff48$export$75b705e7e413826a = (0, $jmjWc.LoadableActivatable)({
    __loadable_id__: "h5GrM",
    name: "AudioButtonLoaderActivatable",
    loader: async ()=>(await (parcelRequire("3guYO"))).AudioButton,
    triggers: [
        {
            type: (0, $gIaMn.ActivationTriggerType).HOVER
        }
    ],
    ssrSuccessCheckName: (0, $5Abqh.SSR_PARTIAL_COMPONENT).AudioButton
});

const $8a4bdd953279ff48$export$2cf028d3aae3c5f9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "IJrya",
    name: "AudioButtonLoaderAfterPaint",
    loader: async ()=>(await (parcelRequire("3guYO"))).AudioButton
});


const $46bbba5af56c1c8e$export$6210e0bba7c89213 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(8);
    const { isView: isView, contentId: contentId, contentType: contentType, spaceKey: spaceKey, contentTitle: contentTitle, isDisabled: isDisabled } = props;
    if (isView && (0, $6mKj3.expVal)("confluence_selective_hydration_audio_button", "isEnabled", false)) {
        let t0;
        if ($[0] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($46bbba5af56c1c8e$var$AudioButtonSelectiveHydrationWrapper, props);
            $[0] = props;
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    let t0;
    if ($[2] !== contentId || $[3] !== contentTitle || $[4] !== contentType || $[5] !== isDisabled || $[6] !== spaceKey) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8a4bdd953279ff48$export$2cf028d3aae3c5f9), {
            contentId: contentId,
            contentType: contentType,
            spaceKey: spaceKey,
            contentTitle: contentTitle,
            isDisabled: isDisabled
        });
        $[2] = contentId;
        $[3] = contentTitle;
        $[4] = contentType;
        $[5] = isDisabled;
        $[6] = spaceKey;
        $[7] = t0;
    } else t0 = $[7];
    return t0;
} : (props)=>{
    const { isView: isView, contentId: contentId, contentType: contentType, spaceKey: spaceKey, contentTitle: contentTitle, isDisabled: isDisabled } = props;
    if (isView && (0, $6mKj3.expVal)('confluence_selective_hydration_audio_button', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($46bbba5af56c1c8e$var$AudioButtonSelectiveHydrationWrapper, props);
    // functionality is unchanged, AudioButton is only wrapped in a Loadable
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8a4bdd953279ff48$export$2cf028d3aae3c5f9), {
        contentId: contentId,
        contentType: contentType,
        spaceKey: spaceKey,
        contentTitle: contentTitle,
        isDisabled: isDisabled
    });
};
/**
 * Internal component used only when selective hydration is enabled.
 * Contains all SH-specific logic (browser support, keyboard focus unlock).
 *
 * JS for AudioButton is delayed until user hovers (currently for View Page and Space Overviews)
 * Cases for immediate unlock (bypassing selective hydration) include:
 *
 * Disabled browser (Firefox)
 * User activation via keyboard (tab)
 *
 */ const $46bbba5af56c1c8e$var$AudioButtonSelectiveHydrationWrapper = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { contentId: contentId, contentType: contentType, spaceKey: spaceKey, contentTitle: contentTitle, isDisabled: isDisabled } = t0;
    const wrapperRef = (0, $cozmU.useRef)(null);
    const [audioSupportedByBrowser, setAudioSupportedByBrowser] = (0, $cozmU.useState)(true);
    const [isFocusActivated, setIsFocusActivated] = (0, $cozmU.useState)(false);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            const isAudioSupportedByBrowser = typeof MediaSource !== "undefined" && MediaSource.isTypeSupported("audio/mpeg");
            if (!isAudioSupportedByBrowser) (0, $cozmU.startTransition)(()=>{
                setAudioSupportedByBrowser(false);
            });
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const wrapper = wrapperRef.current;
            if (!wrapper) return;
            const handleFocus = (event)=>{
                const target = event.target;
                if (!target || !target.matches("button, [role=\"button\"]")) return;
                const isKeyboardFocus = target.matches(":focus-visible");
                if (!isKeyboardFocus) return;
                (0, $cozmU.startTransition)(()=>{
                    setIsFocusActivated(true);
                });
            };
            wrapper.addEventListener("focus", handleFocus, true);
            return ()=>{
                wrapper.removeEventListener("focus", handleFocus, true);
            };
        };
        t4 = [];
        $[2] = t3;
        $[3] = t4;
    } else {
        t3 = $[2];
        t4 = $[3];
    }
    (0, $cozmU.useEffect)(t3, t4);
    const immediateActivationCondition = audioSupportedByBrowser === false || isFocusActivated;
    let t5;
    if ($[4] !== audioSupportedByBrowser || $[5] !== isDisabled || $[6] !== renderServerPlaceholder) {
        t5 = isDisabled && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false) || !renderServerPlaceholder && !audioSupportedByBrowser;
        $[4] = audioSupportedByBrowser;
        $[5] = isDisabled;
        $[6] = renderServerPlaceholder;
        $[7] = t5;
    } else t5 = $[7];
    const isButtonDisabled = t5;
    const t6 = audioSupportedByBrowser ?? true;
    let t7;
    if ($[8] !== t6) {
        t7 = {
            audioSupportedByBrowserFromWrapper: t6
        };
        $[8] = t6;
        $[9] = t7;
    } else t7 = $[9];
    const wrapperProps = t7;
    let t8;
    if ($[10] !== contentId || $[11] !== contentTitle || $[12] !== contentType || $[13] !== immediateActivationCondition || $[14] !== isButtonDisabled || $[15] !== spaceKey || $[16] !== wrapperProps) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: wrapperRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8a4bdd953279ff48$export$75b705e7e413826a), {
            contentId: contentId,
            contentType: contentType,
            spaceKey: spaceKey,
            contentTitle: contentTitle,
            isDisabled: isButtonDisabled,
            immediateActivationCondition: immediateActivationCondition,
            selectiveHydrationEnabled: true,
            ...wrapperProps
        }));
        $[10] = contentId;
        $[11] = contentTitle;
        $[12] = contentType;
        $[13] = immediateActivationCondition;
        $[14] = isButtonDisabled;
        $[15] = spaceKey;
        $[16] = wrapperProps;
        $[17] = t8;
    } else t8 = $[17];
    return t8;
} : ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, contentTitle: contentTitle, isDisabled: isDisabled })=>{
    const wrapperRef = (0, $cozmU.useRef)(null);
    // Assume audio is enabled for SSR until client-side useEffect checks browser support
    const [audioSupportedByBrowser, setAudioSupportedByBrowser] = (0, $cozmU.useState)(true);
    const [isFocusActivated, setIsFocusActivated] = (0, $cozmU.useState)(false);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    (0, $cozmU.useEffect)(()=>{
        // Only check audio support when selective hydration is enabled.
        // For FG-OFF we rely on the browser check within AudioButton.
        const isAudioSupportedByBrowser = typeof MediaSource !== 'undefined' && MediaSource.isTypeSupported('audio/mpeg');
        if (!isAudioSupportedByBrowser) (0, $cozmU.startTransition)(()=>{
            setAudioSupportedByBrowser(false);
        });
    }, []);
    (0, $cozmU.useEffect)(()=>{
        // Focus listener to determine if a user has tabbed to the button via keyboard, in which case
        // the component is immediately hydrated. This listener must live outside AudioButton code and hydrate if button is activated.
        const wrapper = wrapperRef.current;
        if (!wrapper) return;
        const handleFocus = (event)=>{
            const target = event.target;
            if (!target || !target.matches('button, [role="button"]')) return;
            const isKeyboardFocus = target.matches(':focus-visible');
            if (!isKeyboardFocus) return;
            (0, $cozmU.startTransition)(()=>{
                setIsFocusActivated(true);
            });
        };
        wrapper.addEventListener('focus', handleFocus, true);
        return ()=>{
            wrapper.removeEventListener('focus', handleFocus, true);
        };
    }, []);
    // Only immediately hydrate if:
    // 1) audio button is not supported by browser (firefox) and component needs to hydrate to show as disabled on page load
    // 2) user activates the button via keyboard focus
    const immediateActivationCondition = audioSupportedByBrowser === false || isFocusActivated;
    const isButtonDisabled = isDisabled && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false) || !renderServerPlaceholder && !audioSupportedByBrowser;
    const wrapperProps = {
        audioSupportedByBrowserFromWrapper: audioSupportedByBrowser ?? true
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: wrapperRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8a4bdd953279ff48$export$75b705e7e413826a), {
        contentId: contentId,
        contentType: contentType,
        spaceKey: spaceKey,
        contentTitle: contentTitle,
        isDisabled: isButtonDisabled,
        immediateActivationCondition: immediateActivationCondition,
        selectiveHydrationEnabled: true,
        ...wrapperProps
    }));
};





















var $gRv41 = parcelRequire("gRv41");

/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 


const $b249d3a6d47f5309$export$dfb24f670bfd5854 = ()=>{
    const width = 24;
    const height = 24;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        viewBox: "0 0 156 156"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        filter: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#b)",
        "data-figma-skip-parse": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("foreignObject", {
        width: 1789.03,
        height: 1789.03,
        x: -894.514,
        y: -894.514,
        transform: "matrix(.05 -.06262 .06262 .05 74 74)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            background: // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            'conic-gradient(from 90deg,#fca700 0deg,#fca700 72.6913deg,#6a9922 72.7273deg,#6a9922 167.895deg,#1868db 167.931deg,#1868db 252.667deg,#af59e0 252.703deg,#af59e0 360deg)',
            height: '100%',
            width: '100%',
            opacity: 1
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M24 24h100v100H24z",
        "data-figma-gradient-fill": '{"type":"GRADIENT_ANGULAR","stops":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"stopsVar":[{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.0},{"color":{"r":0.98823529481887817,"g":0.65490198135375977,"b":0.0,"a":1.0},"position":0.20192027091979980},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.20202027261257172},{"color":{"r":0.41662007570266724,"g":0.60310000181198120,"b":0.13690000772476196,"a":1.0},"position":0.46637400984764099},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.46647399663925171},{"color":{"r":0.094117648899555206,"g":0.40784314274787903,"b":0.85882353782653809,"a":1.0},"position":0.70185315608978271},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":0.70195317268371582},{"color":{"r":0.68627452850341797,"g":0.34901961684226990,"b":0.87843137979507446,"a":1.0},"position":1.0}],"transform":{"m00":100.00002288818359,"m01":125.23040008544922,"m02":-38.615222930908203,"m10":-125.23040008544922,"m11":100.00002288818359,"m12":86.615180969238281},"opacity":1.0,"blendMode":"NORMAL","visible":true}'
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "b"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M24 24h100v100H24z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("filter", {
        id: "a",
        width: 164,
        height: 164,
        x: -8,
        y: -8,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
        result: "effect1_foregroundBlur_3077_178",
        stdDeviation: 16
    }))));
};


function $31e30a93afdc1384$export$eca6b6ab857179f1({ contentId: contentId, cloudId: cloudId, contentType: contentType }) {
    const { isHerActive: isHerActive, toggleHer: toggleHer } = (0, $gRv41.useHerStore)();
    const handleClick = (0, $cozmU.useCallback)(()=>{
        toggleHer(contentId, cloudId, contentType);
    }, [
        toggleHer,
        contentId,
        cloudId,
        contentType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: "Enterprise HER",
        position: "left"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b249d3a6d47f5309$export$dfb24f670bfd5854), null),
        label: "Enterprise HER",
        shape: "circle",
        isSelected: isHerActive,
        onClick: handleClick,
        testId: "enterprise-her-button"
    }));
}





const $d34346cf549a725a$export$2501aa4690daf770 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { contentId: contentId, contentType: contentType } = t0;
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t1;
    if ($[0] !== cloudId || $[1] !== contentId || $[2] !== contentType) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $31e30a93afdc1384$export$eca6b6ab857179f1), {
            contentId: contentId,
            contentType: contentType,
            cloudId: cloudId
        });
        $[0] = cloudId;
        $[1] = contentId;
        $[2] = contentType;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ contentId: contentId, contentType: contentType })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $31e30a93afdc1384$export$eca6b6ab857179f1), {
        contentId: contentId,
        contentType: contentType,
        cloudId: cloudId
    });
};



var $4ZXww = parcelRequire("4ZXww");


var $fgdVB = parcelRequire("fgdVB");


var $8jXZv = parcelRequire("8jXZv");


var $9Zall = parcelRequire("9Zall");

const $3265ee1fae39f7d6$var$hoistedNav4RightSlotWidthVar = [
    '--right',
    'PanelWidth'
].join('');

const $3265ee1fae39f7d6$var$CommentPanelButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "R3F99",
    name: "CommentPanelButton",
    loader: async ()=>(await (parcelRequire("kONYb"))).CommentPanelButton
});

const $3265ee1fae39f7d6$var$DetailsPanelButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "wgj5o",
    name: "DetailsPanelButton",
    loader: async ()=>(await (parcelRequire("gN62b"))).DetailsPanelButton
});

const $3265ee1fae39f7d6$var$AgentReceiptPanelButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "R8yoa",
    name: "AgentReceiptPanelButton",
    loader: async ()=>(await (parcelRequire("2sYsz"))).AgentReceiptPanelButton
});

const $3265ee1fae39f7d6$var$EditorAIActions = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "gSc9d",
    name: "EditorAIActions",
    loader: async ()=>(await (parcelRequire("cv9SU"))).EditorAIActions
});

const $3265ee1fae39f7d6$var$UndoButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KP43A",
    name: "UndoButton",
    loader: async ()=>(await (parcelRequire("3zDXO"))).UndoButton
});

const $3265ee1fae39f7d6$var$RedoButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "jZ8ML",
    name: "RedoButton",
    loader: async ()=>(await (parcelRequire("3zDXO"))).RedoButton
});

const $3265ee1fae39f7d6$var$ShowDiffButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "41USm",
    name: "ShowDiffButton",
    loader: async ()=>(await (parcelRequire("jyQuB"))).ShowDiffButton
});

const $3265ee1fae39f7d6$var$RemixPanelButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CmH6Z",
    name: "RemixPanelButton",
    loader: async ()=>(await (parcelRequire("a3pDb"))).RemixPanelButton
});

const $3265ee1fae39f7d6$var$AgentsPanelButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "RyToS",
    name: "AgentsPanelButton",
    loader: async ()=>(await (parcelRequire("fmz8s"))).AgentsPanelButton
});

const $3265ee1fae39f7d6$var$TableOfContentsPopupButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "mLzZJ",
    name: "TableOfContentsPopupButton",
    loader: async ()=>(await (parcelRequire("2E3RW"))).TableOfContentsPopupButton
});

const $3265ee1fae39f7d6$var$ReviewButton = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Vn9T7",
    name: "ReviewButton",
    loader: async ()=>(await (parcelRequire("5Uf3U"))).ReviewButton
});

const $3265ee1fae39f7d6$var$AudioListenButtonWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "bAx22",
    name: "AudioListenButtonWrapper",
    loader: async ()=>(await (parcelRequire("jzzzm"))).AudioListenButtonWrapper
});

const $3265ee1fae39f7d6$var$ObjectSidebarSpotlightTour = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "hFsXW",
    name: "ObjectSidebarSpotlightTour",
    loader: async ()=>(await (parcelRequire("3R9tJ"))).ObjectSidebarSpotlightTour
});
const $3265ee1fae39f7d6$var$objectSidebarStyles = null;
const $3265ee1fae39f7d6$var$markdownModeObjectSidebarStyles = null;
const $3265ee1fae39f7d6$var$objectSidebarPaddingStyles = null;
const $3265ee1fae39f7d6$var$databaseObjectSidebarPaddingStyles = null;
const $3265ee1fae39f7d6$var$largeBottomPaddingStyles = null;
const $3265ee1fae39f7d6$var$viewModeStyles = null;
const $3265ee1fae39f7d6$var$miniModalModeStyles = null;
const $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles = (0, $buxP3.xcss)({
    padding: 'space.100',
    boxShadow: 'elevation.shadow.raised',
    backgroundColor: 'elevation.surface.raised',
    borderRadius: 'radius.xlarge'
});
const $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerOverlayStyles = (0, $buxP3.xcss)({
    padding: 'space.100',
    boxShadow: 'elevation.shadow.overlay',
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: 'radius.xlarge'
});
const $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles = (0, $buxP3.xcss)({
    padding: 'space.100',
    boxShadow: 'elevation.shadow.raised',
    backgroundColor: 'elevation.surface.raised',
    borderRadius: 'radius.xlarge'
});
const $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerOverlayStyles = (0, $buxP3.xcss)({
    padding: 'space.100',
    boxShadow: 'elevation.shadow.overlay',
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: 'radius.xlarge'
});
const $3265ee1fae39f7d6$var$collapsibleContainerStyles = null;
const $3265ee1fae39f7d6$var$collapsibleBottomSidebarStyles = (0, $buxP3.xcss)({
    paddingTop: 'space.100',
    marginBottom: 'space.050'
});
const $3265ee1fae39f7d6$var$rovoButtonCollapsibleBottomSidebarStyles = null;
const $3265ee1fae39f7d6$var$collapsibleToggleStyles = null;
const $3265ee1fae39f7d6$var$dividerStyle = (0, $buxP3.xcss)({
    borderBottom: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    display: 'inline-block',
    width: '16px',
    height: '1px'
});
const $3265ee1fae39f7d6$var$hiddenStyles = null;
const $3265ee1fae39f7d6$var$i18n = (0, $kSwu1.defineMessages)({
    expandToggleLabel: {
        id: "object-sidebar-components.expand-toggle-label",
        defaultMessage: "Expand action bar"
    },
    collapseToggleLabel: {
        id: "object-sidebar-components.collapse-toggle-label",
        defaultMessage: "Collapse action bar"
    }
});
const $3265ee1fae39f7d6$export$3fab07431350539e = /*#__PURE__*/ (0, $cozmU.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(213);
    const { hasCommentsButton: hasCommentsButton, hasDetailsButton: hasDetailsButton, hasAgentReceiptButton: hasAgentReceiptButton, hasLoomButton: hasLoomButton, hasAiButton: hasAiButton, hasRemixButton: hasRemixButton, undoRedoButtonActions: undoRedoButtonActions, hasUndoRedoButton: hasUndoRedoButton, showDiffButtonActions: showDiffButtonActions, aiSuggestionsButtonActions: aiSuggestionsButtonActions, hasAudioButton: hasAudioButton, agentTrustReceipt: agentTrustReceipt, contentId: contentId, spaceKey: spaceKey, contentType: contentType, contentTitle: contentTitle, lastModifiedDate: lastModifiedDate, aiIsStreaming: t1, pageCommentsSectionInView: pageCommentsSectionInView, contentIdFromQuery: contentIdFromQuery, contentBodyDynamic: contentBodyDynamic, editorApi: editorApi, scrollToEditorHeading: scrollToEditorHeading, getAdfDocument: getAdfDocument, isUnpublishedDraft: isUnpublishedDraft, largeBottomPadding: largeBottomPadding, editorAIActions: editorAIActions, shouldDisableUndoRedo: t2, isDatabasesStagingArea: t3, disabled: disabled, isEditorEmpty: isEditorEmpty, isMarkdownMode: isMarkdownMode, isMarkdownModeSyntaxViewToggled: isMarkdownModeSyntaxViewToggled, actionsToRender: actionsToRender, preloadedCanAddComments: preloadedCanAddComments } = t0;
    const aiIsStreaming = t1 === undefined ? false : t1;
    const shouldDisableUndoRedo = t2 === undefined ? false : t2;
    const isDatabasesStagingArea = t3 === undefined ? false : t3;
    const [t4] = (0, $kM55L.useCollabNetworkStatus)();
    const { isCollabOffline: isCollabOffline } = t4;
    let t5;
    if ($[0] !== isCollabOffline) {
        t5 = isCollabOffline && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false) && !(0, $9wGTI.fg)("platform_editor_offline_editing_wrapper_override");
        $[0] = isCollabOffline;
        $[1] = t5;
    } else t5 = $[1];
    const isNetworkDisabled = t5;
    const { isFullScreenEmbedView: isFullScreenEmbedView } = (0, $1eD4P.useReactProps_DO_NOT_USE)() || {};
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [actionBarIsHovered, setActionBarIsHovered] = (0, $cozmU.useState)(false);
    const objectSidebarControlRef = (0, $cozmU.useRef)(null);
    const sidebarControlState = (0, $aWwYt.useSidebarControlState)();
    const sidebarControlExpandCollapsedState = (0, $aWwYt.useSidebarControlExpandCollapsedState)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { setSidebarControlState: setSidebarControlState, toggleObjectSidebarControl: toggleObjectSidebarControl, setSidebarControlExpandCollapsedState: setSidebarControlExpandCollapsedState } = (0, $aWwYt.useObjectSidebarActions)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const { mode: rovoExperienceMode } = (0, $93Gae.useRovoExperienceAPIStore)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    let t6;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = {
            selector: $3265ee1fae39f7d6$var$_temp
        };
        $[2] = t6;
    } else t6 = $[2];
    const isOnPDFExportPageRouteArgs = t6;
    const isOnPDFExportPageRoute = (0, $dPJCf.useRouteName)(isOnPDFExportPageRouteArgs);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [t7] = (0, $efvKr.useLivePageMode)();
    const { isViewMode: isLiveViewMode } = t7;
    let t8;
    if ($[3] !== isAdminHubAIEnabled || $[4] !== isLiveViewMode || $[5] !== isRovoButtonEnabled || $[6] !== pageMode) {
        t8 = !isAdminHubAIEnabled || !isRovoButtonEnabled || pageMode !== (0, $cD1qu.PageMode).LIVE || isLiveViewMode || !(0, $9wGTI.fg)("confluence_rovo_live_doc_nudges");
        $[3] = isAdminHubAIEnabled;
        $[4] = isLiveViewMode;
        $[5] = isRovoButtonEnabled;
        $[6] = pageMode;
        $[7] = t8;
    } else t8 = $[7];
    const skipReadTime = t8;
    const { readTime: readTime, loading: readTimeLoading } = (0, $h2uld.useReadTime)(contentId, skipReadTime);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { isAudioV3Enabled: isAudioV3Enabled } = (0, $JTIzG.useAudioFeatureFlags)();
    let t9;
    if ($[8] !== setSidebarControlExpandCollapsedState) {
        t9 = ()=>{
            setSidebarControlExpandCollapsedState("expanded");
        };
        $[8] = setSidebarControlExpandCollapsedState;
        $[9] = t9;
    } else t9 = $[9];
    let t10;
    if ($[10] !== contentId || $[11] !== setSidebarControlExpandCollapsedState) {
        t10 = [
            contentId,
            setSidebarControlExpandCollapsedState
        ];
        $[10] = contentId;
        $[11] = setSidebarControlExpandCollapsedState;
        $[12] = t10;
    } else t10 = $[12];
    (0, $cozmU.useEffect)(t9, t10);
    let t11;
    let t12;
    if ($[13] !== isObjectSidebarShown || $[14] !== setSidebarControlExpandCollapsedState || $[15] !== setSidebarControlState) {
        t11 = ()=>{
            if (!isObjectSidebarShown) setSidebarControlState("shown");
            setSidebarControlExpandCollapsedState("expanded");
            return ()=>{
                setSidebarControlExpandCollapsedState("collapsed");
            };
        };
        t12 = [
            setSidebarControlState,
            setSidebarControlExpandCollapsedState,
            isObjectSidebarShown
        ];
        $[13] = isObjectSidebarShown;
        $[14] = setSidebarControlExpandCollapsedState;
        $[15] = setSidebarControlState;
        $[16] = t11;
        $[17] = t12;
    } else {
        t11 = $[16];
        t12 = $[17];
    }
    (0, $cozmU.useEffect)(t11, t12);
    const sidebarIsExpanded = sidebarControlExpandCollapsedState === "expanded" || renderServerPlaceholder;
    let collapsedActions;
    let primaryActions;
    let secondaryActionsTeam25;
    let shouldRenderFloatingTableOfContents;
    if ($[18] !== agentTrustReceipt || $[19] !== aiIsStreaming || $[20] !== aiSuggestionsButtonActions || $[21] !== contentBodyDynamic?.value || $[22] !== contentId || $[23] !== contentTitle || $[24] !== contentType || $[25] !== disabled || $[26] !== editorAIActions || $[27] !== editorApi || $[28] !== getAdfDocument || $[29] !== hasAgentReceiptButton || $[30] !== hasAudioButton || $[31] !== hasCommentsButton || $[32] !== hasDetailsButton || $[33] !== hasLoomButton || $[34] !== hasRemixButton || $[35] !== hasUndoRedoButton || $[36] !== isAudioV3Enabled || $[37] !== isDatabasesStagingArea || $[38] !== isEditorEmpty || $[39] !== isLivePage || $[40] !== isLiveViewMode || $[41] !== isLoomDisabled || $[42] !== isNetworkDisabled || $[43] !== isRovoButtonEnabled || $[44] !== pageMode || $[45] !== preloadedCanAddComments || $[46] !== scrollToEditorHeading || $[47] !== shouldDisableUndoRedo || $[48] !== showDiffButtonActions || $[49] !== sidebarIsExpanded || $[50] !== spaceKey || $[51] !== undoRedoButtonActions) {
        collapsedActions = [];
        if ($[56] !== aiIsStreaming || $[57] !== hasUndoRedoButton || $[58] !== isDatabasesStagingArea || $[59] !== isLiveViewMode || $[60] !== shouldDisableUndoRedo || $[61] !== showDiffButtonActions || $[62] !== undoRedoButtonActions) {
            primaryActions = [];
            if (hasUndoRedoButton && undoRedoButtonActions && !isLiveViewMode && isDatabasesStagingArea) {
                const { canUndo: canUndo, undo: undo, canRedo: canRedo, redo: redo } = undoRedoButtonActions;
                if (undo && canUndo !== undefined) {
                    const t13 = aiIsStreaming || shouldDisableUndoRedo;
                    let t14;
                    if ($[64] !== canUndo || $[65] !== t13 || $[66] !== undo) {
                        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$UndoButton, {
                            canUndo: canUndo,
                            undo: undo,
                            isDisabled: t13
                        });
                        $[64] = canUndo;
                        $[65] = t13;
                        $[66] = undo;
                        $[67] = t14;
                    } else t14 = $[67];
                    primaryActions.push(t14);
                }
                if (redo && canRedo !== undefined) {
                    const t13 = aiIsStreaming || shouldDisableUndoRedo;
                    let t14;
                    if ($[68] !== canRedo || $[69] !== redo || $[70] !== t13) {
                        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$RedoButton, {
                            canRedo: canRedo,
                            redo: redo,
                            isDisabled: t13
                        });
                        $[68] = canRedo;
                        $[69] = redo;
                        $[70] = t13;
                        $[71] = t14;
                    } else t14 = $[71];
                    primaryActions.push(t14);
                }
            }
            if (showDiffButtonActions && !isLiveViewMode && isDatabasesStagingArea) {
                const { onShowDiff: onShowDiff, isShowDiffEnabled: isShowDiffEnabled, isShowDiffSelected: isShowDiffSelected } = showDiffButtonActions;
                const t13 = isShowDiffEnabled && !aiIsStreaming;
                let t14;
                if ($[72] !== isShowDiffSelected || $[73] !== onShowDiff || $[74] !== t13) {
                    t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$ShowDiffButton, {
                        isShowDiffSelected: isShowDiffSelected,
                        isShowDiffEnabled: t13,
                        onShowDiff: onShowDiff
                    });
                    $[72] = isShowDiffSelected;
                    $[73] = onShowDiff;
                    $[74] = t13;
                    $[75] = t14;
                } else t14 = $[75];
                primaryActions.push(t14);
            }
            $[56] = aiIsStreaming;
            $[57] = hasUndoRedoButton;
            $[58] = isDatabasesStagingArea;
            $[59] = isLiveViewMode;
            $[60] = shouldDisableUndoRedo;
            $[61] = showDiffButtonActions;
            $[62] = undoRedoButtonActions;
            $[63] = primaryActions;
        } else primaryActions = $[63];
        secondaryActionsTeam25 = [];
        if (hasCommentsButton) {
            let t13;
            if ($[76] !== contentId || $[77] !== isNetworkDisabled || $[78] !== preloadedCanAddComments) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
                    key: "comment-panel-button",
                    contentId: contentId,
                    isDisabled: isNetworkDisabled,
                    preloadedCanAddComments: preloadedCanAddComments
                });
                $[76] = contentId;
                $[77] = isNetworkDisabled;
                $[78] = preloadedCanAddComments;
                $[79] = t13;
            } else t13 = $[79];
            secondaryActionsTeam25.push(t13);
            if (!sidebarIsExpanded) {
                let t14;
                if ($[80] !== contentId || $[81] !== isNetworkDisabled || $[82] !== preloadedCanAddComments) {
                    t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
                        key: "comment-panel-button-collapsed",
                        contentId: contentId,
                        collapsed: true,
                        isDisabled: isNetworkDisabled,
                        preloadedCanAddComments: preloadedCanAddComments
                    });
                    $[80] = contentId;
                    $[81] = isNetworkDisabled;
                    $[82] = preloadedCanAddComments;
                    $[83] = t14;
                } else t14 = $[83];
                collapsedActions.push(t14);
            }
        }
        if (hasDetailsButton) {
            let t13;
            if ($[84] !== contentId || $[85] !== isNetworkDisabled) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
                    key: "details-panel-button",
                    contentId: contentId,
                    isDisabled: isNetworkDisabled
                });
                $[84] = contentId;
                $[85] = isNetworkDisabled;
                $[86] = t13;
            } else t13 = $[86];
            secondaryActionsTeam25.push(t13);
            if (!sidebarIsExpanded) {
                let t14;
                if ($[87] !== contentId || $[88] !== isNetworkDisabled) {
                    t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
                        key: "details-panel-button-collapsed",
                        contentId: contentId,
                        collapsed: true,
                        isDisabled: isNetworkDisabled
                    });
                    $[87] = contentId;
                    $[88] = isNetworkDisabled;
                    $[89] = t14;
                } else t14 = $[89];
                collapsedActions.push(t14);
            }
        }
        if (hasAgentReceiptButton && agentTrustReceipt) {
            let t13;
            if ($[90] !== agentTrustReceipt || $[91] !== isNetworkDisabled) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$AgentReceiptPanelButton, {
                    key: "agent-receipt-panel-button",
                    receipt: agentTrustReceipt,
                    isDisabled: isNetworkDisabled
                });
                $[90] = agentTrustReceipt;
                $[91] = isNetworkDisabled;
                $[92] = t13;
            } else t13 = $[92];
            secondaryActionsTeam25.push(t13);
        }
        if ((0, $6mKj3.isExperimentEnabled)("enterprise_her")) {
            const t13 = contentType ?? "";
            let t14;
            if ($[93] !== contentId || $[94] !== t13) {
                t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d34346cf549a725a$export$2501aa4690daf770), {
                    key: "enterprise-her-button-wrapper",
                    contentId: contentId,
                    contentType: t13
                });
                $[93] = contentId;
                $[94] = t13;
                $[95] = t14;
            } else t14 = $[95];
            secondaryActionsTeam25.push(t14);
        }
        if (hasAudioButton) {
            if (isAudioV3Enabled) {
                const t13 = contentType ?? "";
                const t14 = spaceKey ?? "";
                const t15 = contentTitle ?? "";
                let t16;
                if ($[96] !== contentId || $[97] !== disabled || $[98] !== isLivePage || $[99] !== isRovoButtonEnabled || $[100] !== t13 || $[101] !== t14 || $[102] !== t15) {
                    t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$AudioListenButtonWrapper, {
                        key: "audio-listen-button-wrapper",
                        isRovoButtonEnabled: isRovoButtonEnabled,
                        contentId: contentId,
                        contentType: t13,
                        isLivePage: isLivePage,
                        spaceKey: t14,
                        title: t15,
                        isAutoOpenDisabled: disabled
                    });
                    $[96] = contentId;
                    $[97] = disabled;
                    $[98] = isLivePage;
                    $[99] = isRovoButtonEnabled;
                    $[100] = t13;
                    $[101] = t14;
                    $[102] = t15;
                    $[103] = t16;
                } else t16 = $[103];
                secondaryActionsTeam25.push(t16);
            } else {
                const t13 = pageMode === (0, $cD1qu.PageMode).VIEW;
                let t14;
                if ($[104] !== contentId || $[105] !== contentTitle || $[106] !== contentType || $[107] !== isNetworkDisabled || $[108] !== spaceKey || $[109] !== t13) {
                    t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $46bbba5af56c1c8e$export$6210e0bba7c89213), {
                        key: "audio-button-loader-wrapper",
                        contentId: contentId,
                        contentType: contentType,
                        spaceKey: spaceKey,
                        contentTitle: contentTitle,
                        isDisabled: isNetworkDisabled,
                        isView: t13
                    });
                    $[104] = contentId;
                    $[105] = contentTitle;
                    $[106] = contentType;
                    $[107] = isNetworkDisabled;
                    $[108] = spaceKey;
                    $[109] = t13;
                    $[110] = t14;
                } else t14 = $[110];
                secondaryActionsTeam25.push(t14);
            }
        }
        if (hasLoomButton && !isLoomDisabled) {
            const t13 = spaceKey ?? "";
            const t14 = contentType ?? "";
            const t15 = !isRovoButtonEnabled;
            let t16;
            if ($[111] !== contentId || $[112] !== isNetworkDisabled || $[113] !== t13 || $[114] !== t14 || $[115] !== t15) {
                t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $D7PHQ.PageHeaderLoomEntryPoint), {
                    key: "page-header-loom-entry-point",
                    contentId: contentId,
                    crossSellPopupPlacement: "left-end",
                    crossSellSpotlightPlacement: "left-start",
                    spaceKey: t13,
                    contentType: t14,
                    isCircle: t15,
                    testId: "sidebar-loom-button",
                    source: "contentWrapper",
                    isDisabled: isNetworkDisabled
                });
                $[111] = contentId;
                $[112] = isNetworkDisabled;
                $[113] = t13;
                $[114] = t14;
                $[115] = t15;
                $[116] = t16;
            } else t16 = $[116];
            secondaryActionsTeam25.push(t16);
        }
        if (editorAIActions) {
            let t13;
            if ($[117] !== aiIsStreaming || $[118] !== editorAIActions) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$EditorAIActions, {
                    key: "editor-ai-actions",
                    editorAIActions: editorAIActions,
                    isDisabled: aiIsStreaming
                });
                $[117] = aiIsStreaming;
                $[118] = editorAIActions;
                $[119] = t13;
            } else t13 = $[119];
            secondaryActionsTeam25.push(t13);
        }
        if (hasRemixButton && !(0, $c4wtI.isRemixOptedOut)() && (0, $6mKj3.expValEquals)("cc-maui-object-level-remix-experiment", "isEnabled", true)) {
            const t13 = contentBodyDynamic?.value;
            let t14;
            if ($[120] !== getAdfDocument || $[121] !== isEditorEmpty || $[122] !== isNetworkDisabled || $[123] !== t13) {
                t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$RemixPanelButton, {
                    key: "remix-panel-button",
                    contentBodyValue: t13,
                    getAdfDocument: getAdfDocument,
                    isEditorEmpty: isEditorEmpty,
                    isDisabled: isNetworkDisabled
                });
                $[120] = getAdfDocument;
                $[121] = isEditorEmpty;
                $[122] = isNetworkDisabled;
                $[123] = t13;
                $[124] = t14;
            } else t14 = $[124];
            const remixButton = t14;
            secondaryActionsTeam25.push(remixButton);
        }
        let t13;
        if ($[125] !== contentType || $[126] !== editorApi || $[127] !== pageMode) {
            t13 = contentType !== "folder" && (pageMode === (0, $cD1qu.PageMode).VIEW || editorApi) && (0, $6mKj3.expValEquals)("platform_editor_floating_toc", "isEnabled", true);
            $[125] = contentType;
            $[126] = editorApi;
            $[127] = pageMode;
            $[128] = t13;
        } else t13 = $[128];
        shouldRenderFloatingTableOfContents = t13;
        if (shouldRenderFloatingTableOfContents) {
            const t14 = contentBodyDynamic?.value;
            let t15;
            if ($[129] !== contentType || $[130] !== editorApi || $[131] !== pageMode || $[132] !== scrollToEditorHeading || $[133] !== t14) {
                t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$TableOfContentsPopupButton, {
                    key: "table-of-contents-popup-button",
                    contentBodyValue: t14,
                    contentType: contentType,
                    editorApi: editorApi,
                    pageMode: pageMode,
                    popupPositioningRef: objectSidebarControlRef,
                    scrollToEditorHeading: scrollToEditorHeading
                });
                $[129] = contentType;
                $[130] = editorApi;
                $[131] = pageMode;
                $[132] = scrollToEditorHeading;
                $[133] = t14;
                $[134] = t15;
            } else t15 = $[134];
            secondaryActionsTeam25.unshift(t15);
        }
        const isEditingPage = pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE && !isLiveViewMode;
        if (aiSuggestionsButtonActions && isEditingPage && (0, $6mKj3.expValEquals)("platform_editor_ai_content_suggested_edits", "isEnabled", true)) {
            const t14 = aiSuggestionsButtonActions.isThinking || isNetworkDisabled;
            let t15;
            if ($[135] !== aiSuggestionsButtonActions.onStartThinking || $[136] !== t14) {
                t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$ReviewButton, {
                    key: "review-button",
                    onStartThinking: aiSuggestionsButtonActions.onStartThinking,
                    isDisabled: t14
                });
                $[135] = aiSuggestionsButtonActions.onStartThinking;
                $[136] = t14;
                $[137] = t15;
            } else t15 = $[137];
            secondaryActionsTeam25.push(t15);
        }
        if ((0, $9wGTI.fg)("confluence_ai_agents_sidebar_button")) {
            let t14;
            if ($[138] !== contentId || $[139] !== isNetworkDisabled) {
                t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$AgentsPanelButton, {
                    key: "agents-panel-button",
                    contentId: contentId,
                    isDisabled: isNetworkDisabled
                });
                $[138] = contentId;
                $[139] = isNetworkDisabled;
                $[140] = t14;
            } else t14 = $[140];
            secondaryActionsTeam25.push(t14);
        }
        $[18] = agentTrustReceipt;
        $[19] = aiIsStreaming;
        $[20] = aiSuggestionsButtonActions;
        $[21] = contentBodyDynamic?.value;
        $[22] = contentId;
        $[23] = contentTitle;
        $[24] = contentType;
        $[25] = disabled;
        $[26] = editorAIActions;
        $[27] = editorApi;
        $[28] = getAdfDocument;
        $[29] = hasAgentReceiptButton;
        $[30] = hasAudioButton;
        $[31] = hasCommentsButton;
        $[32] = hasDetailsButton;
        $[33] = hasLoomButton;
        $[34] = hasRemixButton;
        $[35] = hasUndoRedoButton;
        $[36] = isAudioV3Enabled;
        $[37] = isDatabasesStagingArea;
        $[38] = isEditorEmpty;
        $[39] = isLivePage;
        $[40] = isLiveViewMode;
        $[41] = isLoomDisabled;
        $[42] = isNetworkDisabled;
        $[43] = isRovoButtonEnabled;
        $[44] = pageMode;
        $[45] = preloadedCanAddComments;
        $[46] = scrollToEditorHeading;
        $[47] = shouldDisableUndoRedo;
        $[48] = showDiffButtonActions;
        $[49] = sidebarIsExpanded;
        $[50] = spaceKey;
        $[51] = undoRedoButtonActions;
        $[52] = collapsedActions;
        $[53] = primaryActions;
        $[54] = secondaryActionsTeam25;
        $[55] = shouldRenderFloatingTableOfContents;
    } else {
        collapsedActions = $[52];
        primaryActions = $[53];
        secondaryActionsTeam25 = $[54];
        shouldRenderFloatingTableOfContents = $[55];
    }
    let t13;
    bb0: {
        if (contentType === "folder") {
            let t14;
            if ($[141] === Symbol.for("react.memo_cache_sentinel")) {
                t14 = {
                    experience: (0, $dppWL.RegisteredExperience).FOLDER,
                    provider: (0, $b6f192cd6e2c63ff$export$b9c46d9495de208d)
                };
                $[141] = t14;
            } else t14 = $[141];
            t13 = t14;
            break bb0;
        }
        if (pageMode === (0, $cD1qu.PageMode).VIEW || pageMode === (0, $cD1qu.PageMode).LIVE && isLiveViewMode) {
            let t14;
            if ($[142] === Symbol.for("react.memo_cache_sentinel")) {
                t14 = {
                    experience: (0, $dppWL.RegisteredExperience).VIEW_PAGE,
                    provider: (0, $2b7ed8ae830eb95a$export$299010de885adda)
                };
                $[142] = t14;
            } else t14 = $[142];
            t13 = t14;
            break bb0;
        }
        if (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE && !isLiveViewMode) {
            let t14;
            if ($[143] === Symbol.for("react.memo_cache_sentinel")) {
                t14 = {
                    experience: (0, $dppWL.RegisteredExperience).EDIT_PAGE,
                    provider: (0, $7e583ad86f1e8aa8$export$d95c465cd9bfae9f)
                };
                $[143] = t14;
            } else t14 = $[143];
            t13 = t14;
            break bb0;
        }
        t13 = undefined;
    }
    const rovoConfiguration = t13;
    if (isOnPDFExportPageRoute) return null;
    let t14;
    if ($[144] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
        $[144] = t14;
    } else t14 = $[144];
    const isEmbeddedConfluence = t14;
    const shouldRenderWhenEmbedded = isEmbeddedConfluence ? isDatabasesStagingArea || isFullScreenEmbedView : !isEmbeddedConfluence;
    const shouldRenderIntegratedExpandButton = !hasAiButton && !sidebarIsExpanded;
    const shouldDisplayHoverToggle = sidebarIsExpanded && actionBarIsHovered || hasAiButton && !sidebarIsExpanded;
    const shouldRenderAISmartButton = hasAiButton && shouldRenderWhenEmbedded && !isMobileApp;
    const isRovoMiniModalShown = shouldRenderAISmartButton && isRovoButtonEnabled && rovoExperienceMode === (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL;
    let t15;
    if ($[145] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = ()=>{
            setActionBarIsHovered(true);
        };
        $[145] = t15;
    } else t15 = $[145];
    const handleMouseEnter = t15;
    let t16;
    if ($[146] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = ()=>{
            setActionBarIsHovered(false);
        };
        $[146] = t16;
    } else t16 = $[146];
    const handleMouseLeave = t16;
    let t17;
    if ($[147] !== sidebarIsExpanded || $[148] !== toggleObjectSidebarControl) {
        t17 = ()=>{
            toggleObjectSidebarControl();
            setActionBarIsHovered(!sidebarIsExpanded);
        };
        $[147] = sidebarIsExpanded;
        $[148] = toggleObjectSidebarControl;
        $[149] = t17;
    } else t17 = $[149];
    const onToggleClick = t17;
    let t18;
    if ($[150] !== formatMessage || $[151] !== sidebarIsExpanded) {
        t18 = sidebarIsExpanded ? formatMessage($3265ee1fae39f7d6$var$i18n.collapseToggleLabel) : formatMessage($3265ee1fae39f7d6$var$i18n.expandToggleLabel);
        $[150] = formatMessage;
        $[151] = sidebarIsExpanded;
        $[152] = t18;
    } else t18 = $[152];
    const toggleLabel = t18;
    let t19;
    if ($[153] !== formatMessage) {
        t19 = formatMessage($3265ee1fae39f7d6$var$i18n.expandToggleLabel);
        $[153] = formatMessage;
        $[154] = t19;
    } else t19 = $[154];
    let t20;
    if ($[155] !== toggleLabel || $[156] !== toggleObjectSidebarControl) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            icon: $3265ee1fae39f7d6$var$_temp2,
            label: toggleLabel,
            onClick: toggleObjectSidebarControl,
            shape: "circle",
            testId: "integrated-expand-button"
        });
        $[155] = toggleLabel;
        $[156] = toggleObjectSidebarControl;
        $[157] = t20;
    } else t20 = $[157];
    let t21;
    if ($[158] !== t19 || $[159] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            position: "left",
            content: t19,
            hideTooltipOnClick: true
        }, t20);
        $[158] = t19;
        $[159] = t20;
        $[160] = t21;
    } else t21 = $[160];
    const integratedExpandButton = t21;
    let t22;
    if ($[161] === Symbol.for("react.memo_cache_sentinel")) {
        t22 = (0, $6mKj3.UNSAFE_expValNoExposure)("cc_maui_remix_button_hover_corridor", "isEnabled", false) ? (0, $5YDZX.blockControlsSuppressionProps) : {};
        $[161] = t22;
    } else t22 = $[161];
    const t23 = "object-sidebar-container";
    const t24 = "object-sidebar-container";
    const t25 = pageMode === (0, $cD1qu.PageMode).VIEW ? `calc(var(${$3265ee1fae39f7d6$var$hoistedNav4RightSlotWidthVar}, 0px))` : "0px";
    let t26;
    if ($[162] !== t25) {
        t26 = {
            right: t25,
            marginRight: 0
        };
        $[162] = t25;
        $[163] = t26;
    } else t26 = $[163];
    const t27 = (0, $hekY6.default)([
        "_23rrnH9JLe _1mT5xdy1CL _0Bm75GdnbC _42Yu6BPvK5 _1pp6NdYbGa _27asfwIZbP",
        isMarkdownMode && isMarkdownModeSyntaxViewToggled && "_0Bm75GS40j",
        (contentType === "page" || contentType === "blogpost" || pageMode === (0, $cD1qu.PageMode).VIEW) && "_1ZnuxbNHnM _1wydGW2ADO",
        (contentType === "database" || contentType === "slide") && "_1Znuxb2ADO _1wydGW2ADO",
        largeBottomPadding && "_1wydGWNHnM",
        isRovoMiniModalShown && "_42Yu6BFIQA",
        pageMode === (0, $cD1qu.PageMode).VIEW && !isRovoMiniModalShown && "_42Yu6BiZR3",
        !renderServerPlaceholder && sidebarControlState === "hidden" && "_3iDTPbYbGa"
    ]);
    let t28;
    if ($[164] !== collapsedActions || $[165] !== contentId || $[166] !== integratedExpandButton || $[167] !== isMobileApp || $[168] !== isRovoButtonEnabled || $[169] !== onToggleClick || $[170] !== primaryActions || $[171] !== renderServerPlaceholder || $[172] !== secondaryActionsTeam25 || $[173] !== shouldDisplayHoverToggle || $[174] !== shouldRenderFloatingTableOfContents || $[175] !== shouldRenderIntegratedExpandButton || $[176] !== shouldRenderWhenEmbedded || $[177] !== sidebarIsExpanded || $[178] !== toggleLabel) {
        t28 = primaryActions.length + secondaryActionsTeam25.length > 0 && shouldRenderWhenEmbedded && !isMobileApp && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b9k8w.default), null, (0, $9wGTI.fg)("confluence_frontend_spotlight_ads_migration") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_39xV02p0Oa _2XsHFMIZbP"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            position: "left",
            content: toggleLabel,
            hideTooltipOnClick: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                paddingBottom: sidebarIsExpanded ? "var(--ds-space-100, 8px)" : undefined,
                visibility: shouldDisplayHoverToggle ? "visible" : "hidden"
            },
            "data-testid": "collapsible-hover-toggle",
            className: (0, $hekY6.default)([
                "_313842IZbP _0adFHsIZbP _1DCdHiIZbP _2XsHFMIZbP _39xV02Va5s"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            icon: (iconProps_0)=>sidebarIsExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    ...iconProps_0,
                    size: "small"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                    ...iconProps_0,
                    size: "small"
                }),
            label: toggleLabel,
            onClick: onToggleClick,
            shape: "circle",
            testId: "collapsible-hover-button"
        })))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Iwqw.default), {
            name: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).OBJECT_SIDEBAR_CONTROL
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_39xV02p0Oa _2XsHFMIZbP"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            position: "left",
            content: toggleLabel,
            hideTooltipOnClick: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                paddingBottom: sidebarIsExpanded ? "var(--ds-space-100, 8px)" : undefined,
                visibility: shouldDisplayHoverToggle ? "visible" : "hidden"
            },
            "data-testid": "collapsible-hover-toggle",
            className: (0, $hekY6.default)([
                "_313842IZbP _0adFHsIZbP _1DCdHiIZbP _2XsHFMIZbP _39xV02Va5s"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            icon: (iconProps_1)=>sidebarIsExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    ...iconProps_1,
                    size: "small"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                    ...iconProps_1,
                    size: "small"
                }),
            label: toggleLabel,
            onClick: onToggleClick,
            shape: "circle",
            testId: "collapsible-hover-button"
        }))))), (0, $9wGTI.fg)("confluence_frontend_spotlight_ads_migration") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_39xV02p0Oa _2XsHFMIZbP"
            ])
        }, sidebarIsExpanded || renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            ref: shouldRenderFloatingTableOfContents ? objectSidebarControlRef : undefined,
            xcss: isRovoButtonEnabled ? (0, $6mKj3.expValEquals)("cwr_blank_object_experiment", "isEnabled", true) ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : (0, $6mKj3.expValEquals)("cwr_blank_object_experiment", "isEnabled", true) ? $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
            direction: "column",
            gap: "space.100",
            justifyContent: "center",
            alignItems: "center",
            testId: "object-sidebar-control"
        }, primaryActions, primaryActions.length > 0 && secondaryActionsTeam25.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $3265ee1fae39f7d6$var$dividerStyle
        }), secondaryActionsTeam25) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, collapsedActions))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_39xV02p0Oa _2XsHFMIZbP"
            ])
        }, sidebarIsExpanded || renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            ref: shouldRenderFloatingTableOfContents ? objectSidebarControlRef : undefined,
            xcss: isRovoButtonEnabled ? (0, $6mKj3.expValEquals)("cwr_blank_object_experiment", "isEnabled", true) ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : (0, $6mKj3.expValEquals)("cwr_blank_object_experiment", "isEnabled", true) ? $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
            direction: "column",
            gap: "space.100",
            justifyContent: "center",
            alignItems: "center",
            testId: "object-sidebar-control"
        }, primaryActions, primaryActions.length > 0 && secondaryActionsTeam25.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $3265ee1fae39f7d6$var$dividerStyle
        }), secondaryActionsTeam25) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, collapsedActions)), shouldRenderIntegratedExpandButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_39xV02p0Oa _2XsHFMIZbP"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            xcss: isRovoButtonEnabled ? (0, $6mKj3.expValEquals)("cwr_blank_object_experiment", "isEnabled", true) ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : (0, $6mKj3.expValEquals)("cwr_blank_object_experiment", "isEnabled", true) ? $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
            direction: "column",
            gap: "space.100",
            justifyContent: "center",
            alignItems: "center",
            testId: "object-sidebar-control"
        }, integratedExpandButton)) : null, (0, $9wGTI.fg)("confluence_frontend_spotlight_ads_migration") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$ObjectSidebarSpotlightTour, {
            contentId: contentId
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lt1a.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$ObjectSidebarSpotlightTour, {
            contentId: contentId
        })));
        $[164] = collapsedActions;
        $[165] = contentId;
        $[166] = integratedExpandButton;
        $[167] = isMobileApp;
        $[168] = isRovoButtonEnabled;
        $[169] = onToggleClick;
        $[170] = primaryActions;
        $[171] = renderServerPlaceholder;
        $[172] = secondaryActionsTeam25;
        $[173] = shouldDisplayHoverToggle;
        $[174] = shouldRenderFloatingTableOfContents;
        $[175] = shouldRenderIntegratedExpandButton;
        $[176] = shouldRenderWhenEmbedded;
        $[177] = sidebarIsExpanded;
        $[178] = toggleLabel;
        $[179] = t28;
    } else t28 = $[179];
    let t29;
    if ($[180] !== actionsToRender || $[181] !== contentBodyDynamic || $[182] !== contentId || $[183] !== contentIdFromQuery || $[184] !== contentTitle || $[185] !== contentType || $[186] !== isEditorEmpty || $[187] !== isEmbeddedConfluence || $[188] !== isLivePage || $[189] !== isNetworkDisabled || $[190] !== isRovoButtonEnabled || $[191] !== isUnpublishedDraft || $[192] !== lastModifiedDate || $[193] !== pageCommentsSectionInView || $[194] !== pageMode || $[195] !== readTime || $[196] !== readTimeLoading || $[197] !== rovoConfiguration?.experience || $[198] !== rovoConfiguration?.provider || $[199] !== shouldRenderAISmartButton || $[200] !== spaceKey) {
        t29 = shouldRenderAISmartButton && (isRovoButtonEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_0Of8r22ADO _1DCdHi5zaO _2XsHFMHZdu"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3tUdX.RovoConfigProvider), {
            experience: rovoConfiguration?.experience,
            provider: rovoConfiguration?.provider,
            contentId: contentId,
            contentType: contentType ?? "",
            spaceKey: spaceKey ?? "",
            contentTitle: contentTitle ?? "",
            lastModifiedDate: lastModifiedDate,
            isUnpublishedDraft: isUnpublishedDraft,
            isEditorEmpty: isEditorEmpty,
            readTime: readTime ?? undefined,
            readTimeLoading: readTimeLoading,
            actionsToRender: actionsToRender ?? []
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hU34N.AISmartButtonWrapper), {
            contentId: contentId,
            contentType: contentType ?? "",
            pageMode: pageMode,
            isDisabled: isNetworkDisabled,
            spaceKey: spaceKey,
            isSidebarAvailable: isEmbeddedConfluence ? false : undefined
        })) : contentType !== "database" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $3265ee1fae39f7d6$var$collapsibleBottomSidebarStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3acdd5624bc36ae$export$71951c424ee8d4c2), {
            spaceKey: spaceKey ?? "",
            contentId: contentId,
            contentType: contentType ?? "",
            lastModifiedDate: lastModifiedDate,
            pageCommentsSectionInView: pageCommentsSectionInView,
            isLivePage: isLivePage,
            isInObjectSideBar: true,
            contentIdFromQuery: contentIdFromQuery,
            contentBodyDynamic: contentBodyDynamic
        })));
        $[180] = actionsToRender;
        $[181] = contentBodyDynamic;
        $[182] = contentId;
        $[183] = contentIdFromQuery;
        $[184] = contentTitle;
        $[185] = contentType;
        $[186] = isEditorEmpty;
        $[187] = isEmbeddedConfluence;
        $[188] = isLivePage;
        $[189] = isNetworkDisabled;
        $[190] = isRovoButtonEnabled;
        $[191] = isUnpublishedDraft;
        $[192] = lastModifiedDate;
        $[193] = pageCommentsSectionInView;
        $[194] = pageMode;
        $[195] = readTime;
        $[196] = readTimeLoading;
        $[197] = rovoConfiguration?.experience;
        $[198] = rovoConfiguration?.provider;
        $[199] = shouldRenderAISmartButton;
        $[200] = spaceKey;
        $[201] = t29;
    } else t29 = $[201];
    let t30;
    if ($[202] !== handleMouseEnter || $[203] !== handleMouseLeave || $[204] !== t22 || $[205] !== t26 || $[206] !== t27 || $[207] !== t28 || $[208] !== t29) {
        t30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ...t22,
            "data-testid": t23,
            "data-vc": t24,
            style: t26,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            onFocus: handleMouseEnter,
            onBlur: handleMouseLeave,
            className: t27
        }, t28, t29);
        $[202] = handleMouseEnter;
        $[203] = handleMouseLeave;
        $[204] = t22;
        $[205] = t26;
        $[206] = t27;
        $[207] = t28;
        $[208] = t29;
        $[209] = t30;
    } else t30 = $[209];
    let t31;
    if ($[210] === Symbol.for("react.memo_cache_sentinel")) {
        t31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            metric: (0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC)
        });
        $[210] = t31;
    } else t31 = $[210];
    let t32;
    if ($[211] !== t30) {
        t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t30, t31);
        $[211] = t30;
        $[212] = t32;
    } else t32 = $[212];
    return t32;
} : ({ hasCommentsButton: hasCommentsButton, hasDetailsButton: hasDetailsButton, hasAgentReceiptButton: hasAgentReceiptButton, hasLoomButton: hasLoomButton, hasAiButton: hasAiButton, hasRemixButton: hasRemixButton, undoRedoButtonActions: undoRedoButtonActions, hasUndoRedoButton: hasUndoRedoButton, showDiffButtonActions: showDiffButtonActions, aiSuggestionsButtonActions: aiSuggestionsButtonActions, hasAudioButton: hasAudioButton, agentTrustReceipt: agentTrustReceipt, contentId: contentId, spaceKey: spaceKey, contentType: contentType, contentTitle: contentTitle, lastModifiedDate: lastModifiedDate, aiIsStreaming: aiIsStreaming = false, pageCommentsSectionInView: pageCommentsSectionInView, contentIdFromQuery: contentIdFromQuery, contentBodyDynamic: contentBodyDynamic, editorApi: editorApi, scrollToEditorHeading: scrollToEditorHeading, getAdfDocument: getAdfDocument, isUnpublishedDraft: isUnpublishedDraft, largeBottomPadding: largeBottomPadding, editorAIActions: editorAIActions, shouldDisableUndoRedo: shouldDisableUndoRedo = false, isDatabasesStagingArea: isDatabasesStagingArea = false, disabled: disabled, isEditorEmpty: isEditorEmpty, isMarkdownMode: isMarkdownMode, isMarkdownModeSyntaxViewToggled: isMarkdownModeSyntaxViewToggled, actionsToRender: actionsToRender, preloadedCanAddComments: preloadedCanAddComments })=>{
    const [{ isCollabOffline: isCollabOffline }] = (0, $kM55L.useCollabNetworkStatus)(); // Network status is used when:
    // - isCollabOffline: The collab provider has detected a network disconnection
    // - platform_editor_offline_editing_web: Parent experiment for offline editing experience (must be enabled)
    // - platform_editor_offline_editing_wrapper_override: Kill switch to disable this feature (must be disabled)
    const isNetworkDisabled = isCollabOffline && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false) && !(0, $9wGTI.fg)('platform_editor_offline_editing_wrapper_override');
    const { isFullScreenEmbedView: isFullScreenEmbedView } = (0, $1eD4P.useReactProps_DO_NOT_USE)() || {};
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [actionBarIsHovered, setActionBarIsHovered] = (0, $cozmU.useState)(false);
    const objectSidebarControlRef = (0, $cozmU.useRef)(null);
    const sidebarControlState = (0, $aWwYt.useSidebarControlState)();
    const sidebarControlExpandCollapsedState = (0, $aWwYt.useSidebarControlExpandCollapsedState)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { setSidebarControlState: setSidebarControlState, toggleObjectSidebarControl: toggleObjectSidebarControl, setSidebarControlExpandCollapsedState: setSidebarControlExpandCollapsedState } = (0, $aWwYt.useObjectSidebarActions)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const { mode: rovoExperienceMode } = (0, $93Gae.useRovoExperienceAPIStore)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    const isOnPDFExportPageRouteArgs = {
        selector: (routeName)=>{
            if (!routeName) return false;
            return routeName === (0, $1NBp8.PDF_EXPORT_PAGE).name;
        }
    };
    const isOnPDFExportPageRoute = (0, $dPJCf.useRouteName)(isOnPDFExportPageRouteArgs);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ isViewMode: isLiveViewMode }] = (0, $efvKr.useLivePageMode)();
    const skipReadTime = !isAdminHubAIEnabled || !isRovoButtonEnabled || pageMode !== (0, $cD1qu.PageMode).LIVE || isLiveViewMode || !(0, $9wGTI.fg)('confluence_rovo_live_doc_nudges');
    const { readTime: readTime, loading: readTimeLoading } = (0, $h2uld.useReadTime)(contentId, skipReadTime);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { isAudioV3Enabled: isAudioV3Enabled } = (0, $JTIzG.useAudioFeatureFlags)(); // whenever the contentID changes we needed to reset the action bar to be expanded
    (0, $cozmU.useEffect)(()=>{
        setSidebarControlExpandCollapsedState('expanded');
    }, [
        contentId,
        setSidebarControlExpandCollapsedState
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Only reset to 'shown' if no sidebar panel is currently open.
        // When a panel is open (e.g. via focusedCommentId deep-link), showObjectSidebar()
        // already set sidebarControlState to 'hidden' — we must not override that here.
        if (!isObjectSidebarShown) setSidebarControlState('shown');
        setSidebarControlExpandCollapsedState('expanded');
        return ()=>{
            setSidebarControlExpandCollapsedState('collapsed');
        };
    }, [
        setSidebarControlState,
        setSidebarControlExpandCollapsedState,
        isObjectSidebarShown
    ]);
    const sidebarIsExpanded = sidebarControlExpandCollapsedState === 'expanded' || renderServerPlaceholder; // Collapsed actions are rendered when collapsed. These can be used e.g. to enable keyboard shortcuts while collapsed.
    const collapsedActions = [];
    const primaryActions = [];
    if (hasUndoRedoButton && undoRedoButtonActions && !isLiveViewMode && isDatabasesStagingArea) {
        const { canUndo: canUndo, undo: undo, canRedo: canRedo, redo: redo } = undoRedoButtonActions;
        if (undo && canUndo !== undefined) primaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$UndoButton, {
            canUndo: canUndo,
            undo: undo,
            isDisabled: aiIsStreaming || shouldDisableUndoRedo
        }));
        if (redo && canRedo !== undefined) primaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$RedoButton, {
            canRedo: canRedo,
            redo: redo,
            isDisabled: aiIsStreaming || shouldDisableUndoRedo
        }));
    }
    if (showDiffButtonActions && !isLiveViewMode && isDatabasesStagingArea) {
        const { onShowDiff: onShowDiff, isShowDiffEnabled: isShowDiffEnabled, isShowDiffSelected: isShowDiffSelected } = showDiffButtonActions;
        primaryActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$ShowDiffButton, {
            isShowDiffSelected: isShowDiffSelected,
            isShowDiffEnabled: isShowDiffEnabled && !aiIsStreaming,
            onShowDiff: onShowDiff
        }));
    }
    const secondaryActionsTeam25 = [];
    if (hasCommentsButton) {
        secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
            key: "comment-panel-button",
            contentId: contentId,
            isDisabled: isNetworkDisabled,
            preloadedCanAddComments: preloadedCanAddComments
        }));
        if (!sidebarIsExpanded) collapsedActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$CommentPanelButton, {
            key: "comment-panel-button-collapsed",
            contentId: contentId,
            collapsed: true,
            isDisabled: isNetworkDisabled,
            preloadedCanAddComments: preloadedCanAddComments
        }));
    }
    if (hasDetailsButton) {
        secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
            key: "details-panel-button",
            contentId: contentId,
            isDisabled: isNetworkDisabled
        }));
        if (!sidebarIsExpanded) collapsedActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$DetailsPanelButton, {
            key: "details-panel-button-collapsed",
            contentId: contentId,
            collapsed: true,
            isDisabled: isNetworkDisabled
        }));
    }
    if (hasAgentReceiptButton && agentTrustReceipt) secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$AgentReceiptPanelButton, {
        key: "agent-receipt-panel-button",
        receipt: agentTrustReceipt,
        isDisabled: isNetworkDisabled
    }));
    if ((0, $6mKj3.isExperimentEnabled)('enterprise_her')) secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d34346cf549a725a$export$2501aa4690daf770), {
        key: "enterprise-her-button-wrapper",
        contentId: contentId,
        contentType: contentType ?? ''
    }));
    if (hasAudioButton) {
        if (isAudioV3Enabled) secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$AudioListenButtonWrapper, {
            key: "audio-listen-button-wrapper",
            isRovoButtonEnabled: isRovoButtonEnabled,
            contentId: contentId,
            contentType: contentType ?? '',
            isLivePage: isLivePage,
            spaceKey: spaceKey ?? '',
            title: contentTitle ?? '',
            isAutoOpenDisabled: disabled
        }));
        else secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $46bbba5af56c1c8e$export$6210e0bba7c89213), {
            key: "audio-button-loader-wrapper",
            contentId: contentId,
            contentType: contentType,
            spaceKey: spaceKey,
            contentTitle: contentTitle,
            isDisabled: isNetworkDisabled,
            isView: pageMode === (0, $cD1qu.PageMode).VIEW
        }));
    }
    if (hasLoomButton && !isLoomDisabled) secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $D7PHQ.PageHeaderLoomEntryPoint), {
        key: "page-header-loom-entry-point",
        contentId: contentId,
        crossSellPopupPlacement: "left-end",
        crossSellSpotlightPlacement: "left-start",
        spaceKey: spaceKey ?? '',
        contentType: contentType ?? '',
        isCircle: !isRovoButtonEnabled,
        testId: "sidebar-loom-button",
        source: "contentWrapper",
        isDisabled: isNetworkDisabled
    }));
    if (editorAIActions) secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$EditorAIActions, {
        key: "editor-ai-actions",
        editorAIActions: editorAIActions,
        isDisabled: aiIsStreaming
    }));
    if (hasRemixButton && !(0, $c4wtI.isRemixOptedOut)() && (0, $6mKj3.expValEquals)('cc-maui-object-level-remix-experiment', 'isEnabled', true)) {
        const remixButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$RemixPanelButton, {
            key: "remix-panel-button",
            contentBodyValue: contentBodyDynamic?.value,
            getAdfDocument: getAdfDocument,
            isEditorEmpty: isEditorEmpty,
            isDisabled: isNetworkDisabled
        });
        secondaryActionsTeam25.push(remixButton);
    }
    const shouldRenderFloatingTableOfContents = contentType !== 'folder' && (pageMode === (0, $cD1qu.PageMode).VIEW || editorApi) && (0, $6mKj3.expValEquals)('platform_editor_floating_toc', 'isEnabled', true);
    if (shouldRenderFloatingTableOfContents) secondaryActionsTeam25.unshift(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$TableOfContentsPopupButton, {
        key: "table-of-contents-popup-button",
        contentBodyValue: contentBodyDynamic?.value,
        contentType: contentType,
        editorApi: editorApi,
        pageMode: pageMode,
        popupPositioningRef: objectSidebarControlRef,
        scrollToEditorHeading: scrollToEditorHeading
    }));
    const isEditingPage = pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE && !isLiveViewMode;
    if (aiSuggestionsButtonActions && isEditingPage && (0, $6mKj3.expValEquals)('platform_editor_ai_content_suggested_edits', 'isEnabled', true)) secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$ReviewButton, {
        key: "review-button",
        onStartThinking: aiSuggestionsButtonActions.onStartThinking,
        isDisabled: aiSuggestionsButtonActions.isThinking || isNetworkDisabled
    }));
    if ((0, $9wGTI.fg)('confluence_ai_agents_sidebar_button')) secondaryActionsTeam25.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$AgentsPanelButton, {
        key: "agents-panel-button",
        contentId: contentId,
        isDisabled: isNetworkDisabled
    }));
    const rovoConfiguration = (0, $cozmU.useMemo)(()=>{
        if (contentType === 'folder') return {
            experience: (0, $dppWL.RegisteredExperience).FOLDER,
            provider: (0, $b6f192cd6e2c63ff$export$b9c46d9495de208d)
        };
        if (pageMode === (0, $cD1qu.PageMode).VIEW || pageMode === (0, $cD1qu.PageMode).LIVE && isLiveViewMode) return {
            experience: (0, $dppWL.RegisteredExperience).VIEW_PAGE,
            provider: (0, $2b7ed8ae830eb95a$export$299010de885adda)
        };
        if (pageMode === (0, $cD1qu.PageMode).EDIT || pageMode === (0, $cD1qu.PageMode).LIVE && !isLiveViewMode) return {
            experience: (0, $dppWL.RegisteredExperience).EDIT_PAGE,
            provider: (0, $7e583ad86f1e8aa8$export$d95c465cd9bfae9f)
        };
        return undefined;
    }, [
        contentType,
        pageMode,
        isLiveViewMode
    ]);
    if (isOnPDFExportPageRoute) return null;
    const isEmbeddedConfluence = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)(); // For databases in staging area, always allow rendering (isFullScreenEmbedView is typically undefined)
    const shouldRenderWhenEmbedded = isEmbeddedConfluence ? isDatabasesStagingArea || isFullScreenEmbedView : !isEmbeddedConfluence; // If there's no AI button, when we collapse the action bar, we need to render an expand icon within the
    // existing action bar container. If there is an AI button, hovering over it should render the expand icon
    const shouldRenderIntegratedExpandButton = !hasAiButton && !sidebarIsExpanded; // We always render the toggle component into the DOM, but we change its visibility based on:
    // If the action bar is expanded: show on hover (regardless of AI button)
    // If the action bar is collapsed: always show if AI button present, otherwise never show
    const shouldDisplayHoverToggle = sidebarIsExpanded && actionBarIsHovered || hasAiButton && !sidebarIsExpanded;
    const shouldRenderAISmartButton = hasAiButton && shouldRenderWhenEmbedded && !isMobileApp;
    const isRovoMiniModalShown = shouldRenderAISmartButton && isRovoButtonEnabled && rovoExperienceMode === (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL;
    const handleMouseEnter = ()=>{
        setActionBarIsHovered(true);
    };
    const handleMouseLeave = ()=>{
        setActionBarIsHovered(false);
    };
    const onToggleClick = ()=>{
        toggleObjectSidebarControl(); // need to make sure the hover (dis)appears after clicking it
        setActionBarIsHovered(!sidebarIsExpanded);
    };
    const toggleLabel = sidebarIsExpanded ? formatMessage($3265ee1fae39f7d6$var$i18n.collapseToggleLabel) : formatMessage($3265ee1fae39f7d6$var$i18n.expandToggleLabel);
    const integratedExpandButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        position: "left",
        content: formatMessage($3265ee1fae39f7d6$var$i18n.expandToggleLabel),
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                ...iconProps,
                size: "small"
            }),
        label: toggleLabel,
        onClick: toggleObjectSidebarControl,
        shape: "circle",
        testId: "integrated-expand-button"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ...(0, $6mKj3.UNSAFE_expValNoExposure)('cc_maui_remix_button_hover_corridor', 'isEnabled', false) ? (0, $5YDZX.blockControlsSuppressionProps) : {},
        "data-testid": "object-sidebar-container",
        "data-vc": "object-sidebar-container",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            right: pageMode === (0, $cD1qu.PageMode).VIEW ? `calc(var(${$3265ee1fae39f7d6$var$hoistedNav4RightSlotWidthVar}, 0px))` : '0px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            marginRight: 0
        },
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleMouseEnter,
        onBlur: handleMouseLeave,
        className: (0, $hekY6.default)([
            "_23rrnH9JLe _1mT5xdy1CL _0Bm75GdnbC _42Yu6BPvK5 _1pp6NdYbGa _27asfwIZbP",
            isMarkdownMode && isMarkdownModeSyntaxViewToggled && "_0Bm75GS40j",
            (contentType === 'page' || contentType === 'blogpost' || pageMode === (0, $cD1qu.PageMode).VIEW) && "_1ZnuxbNHnM _1wydGW2ADO",
            (contentType === 'database' || contentType === 'slide') && "_1Znuxb2ADO _1wydGW2ADO",
            largeBottomPadding && "_1wydGWNHnM",
            isRovoMiniModalShown && "_42Yu6BFIQA",
            pageMode === (0, $cD1qu.PageMode).VIEW && !isRovoMiniModalShown && "_42Yu6BiZR3",
            !renderServerPlaceholder && sidebarControlState === 'hidden' && "_3iDTPbYbGa"
        ])
    }, primaryActions.length + secondaryActionsTeam25.length > 0 && shouldRenderWhenEmbedded && !isMobileApp && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b9k8w.default), null, (0, $9wGTI.fg)('confluence_frontend_spotlight_ads_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_39xV02p0Oa _2XsHFMIZbP"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        position: "left",
        content: toggleLabel,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            paddingBottom: sidebarIsExpanded ? `${"var(--ds-space-100, 8px)"}` : undefined,
            visibility: shouldDisplayHoverToggle ? 'visible' : 'hidden'
        },
        "data-testid": "collapsible-hover-toggle",
        className: (0, $hekY6.default)([
            "_313842IZbP _0adFHsIZbP _1DCdHiIZbP _2XsHFMIZbP _39xV02Va5s"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (iconProps_0)=>sidebarIsExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                ...iconProps_0,
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                ...iconProps_0,
                size: "small"
            }),
        label: toggleLabel,
        onClick: onToggleClick,
        shape: "circle",
        testId: "collapsible-hover-button"
    })))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Iwqw.default), {
        name: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).OBJECT_SIDEBAR_CONTROL
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_39xV02p0Oa _2XsHFMIZbP"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        position: "left",
        content: toggleLabel,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            paddingBottom: sidebarIsExpanded ? `${"var(--ds-space-100, 8px)"}` : undefined,
            visibility: shouldDisplayHoverToggle ? 'visible' : 'hidden'
        },
        "data-testid": "collapsible-hover-toggle",
        className: (0, $hekY6.default)([
            "_313842IZbP _0adFHsIZbP _1DCdHiIZbP _2XsHFMIZbP _39xV02Va5s"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (iconProps_1)=>sidebarIsExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                ...iconProps_1,
                size: "small"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                ...iconProps_1,
                size: "small"
            }),
        label: toggleLabel,
        onClick: onToggleClick,
        shape: "circle",
        testId: "collapsible-hover-button"
    }))))), (0, $9wGTI.fg)('confluence_frontend_spotlight_ads_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_39xV02p0Oa _2XsHFMIZbP"
        ])
    }, sidebarIsExpanded || renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        ref: shouldRenderFloatingTableOfContents ? objectSidebarControlRef : undefined,
        xcss: isRovoButtonEnabled ? (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'isEnabled', true) ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'isEnabled', true) ? $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
        direction: "column",
        gap: "space.100",
        justifyContent: "center",
        alignItems: "center",
        testId: "object-sidebar-control"
    }, primaryActions, primaryActions.length > 0 && secondaryActionsTeam25.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $3265ee1fae39f7d6$var$dividerStyle
    }), secondaryActionsTeam25) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, collapsedActions))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_39xV02p0Oa _2XsHFMIZbP"
        ])
    }, sidebarIsExpanded || renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        ref: shouldRenderFloatingTableOfContents ? objectSidebarControlRef : undefined,
        xcss: isRovoButtonEnabled ? (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'isEnabled', true) ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'isEnabled', true) ? $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
        direction: "column",
        gap: "space.100",
        justifyContent: "center",
        alignItems: "center",
        testId: "object-sidebar-control"
    }, primaryActions, primaryActions.length > 0 && secondaryActionsTeam25.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $3265ee1fae39f7d6$var$dividerStyle
    }), secondaryActionsTeam25) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, collapsedActions)), shouldRenderIntegratedExpandButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_39xV02p0Oa _2XsHFMIZbP"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        xcss: isRovoButtonEnabled ? (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'isEnabled', true) ? $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleSquircleObjectSidebarContainerStyles : (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'isEnabled', true) ? $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerOverlayStyles : $3265ee1fae39f7d6$var$collapsibleObjectSidebarContainerStyles,
        direction: "column",
        gap: "space.100",
        justifyContent: "center",
        alignItems: "center",
        testId: "object-sidebar-control"
    }, integratedExpandButton)) : null, (0, $9wGTI.fg)('confluence_frontend_spotlight_ads_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$ObjectSidebarSpotlightTour, {
        contentId: contentId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lt1a.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3265ee1fae39f7d6$var$ObjectSidebarSpotlightTour, {
        contentId: contentId
    }))), shouldRenderAISmartButton && (isRovoButtonEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_0Of8r22ADO _1DCdHi5zaO _2XsHFMHZdu"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3tUdX.RovoConfigProvider), {
        experience: rovoConfiguration?.experience,
        provider: rovoConfiguration?.provider,
        contentId: contentId,
        contentType: contentType ?? '',
        spaceKey: spaceKey ?? '',
        contentTitle: contentTitle ?? '',
        lastModifiedDate: lastModifiedDate,
        isUnpublishedDraft: isUnpublishedDraft,
        isEditorEmpty: isEditorEmpty,
        readTime: readTime ?? undefined,
        readTimeLoading: readTimeLoading,
        actionsToRender: actionsToRender ?? []
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hU34N.AISmartButtonWrapper), {
        contentId: contentId,
        contentType: contentType ?? '',
        pageMode: pageMode,
        isDisabled: isNetworkDisabled,
        spaceKey: spaceKey,
        isSidebarAvailable: isEmbeddedConfluence ? false : undefined
    })) : contentType !== 'database' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $3265ee1fae39f7d6$var$collapsibleBottomSidebarStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3acdd5624bc36ae$export$71951c424ee8d4c2), {
        spaceKey: spaceKey ?? '',
        contentId: contentId,
        contentType: contentType ?? '',
        lastModifiedDate: lastModifiedDate,
        pageCommentsSectionInView: pageCommentsSectionInView,
        isLivePage: isLivePage,
        isInObjectSideBar: true,
        contentIdFromQuery: contentIdFromQuery,
        contentBodyDynamic: contentBodyDynamic
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
        metric: (0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC)
    }));
});
function $3265ee1fae39f7d6$var$_temp(routeName) {
    if (!routeName) return false;
    return routeName === (0, $1NBp8.PDF_EXPORT_PAGE).name;
}
function $3265ee1fae39f7d6$var$_temp2(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
        ...iconProps,
        size: "small"
    });
}
module.exports["ObjectSidebarControl"] = $3265ee1fae39f7d6$export$3fab07431350539e;

});

parcelRegister("5YDZX", function(module, exports) {
const $d9d643acafd25457$var$BLOCK_CONTROLS_SUPPRESSION_ATTRIBUTE = 'data-block-controls-suppression';
const $d9d643acafd25457$var$BLOCK_CONTROLS_SUPPRESSION_SELECTOR = `[${$d9d643acafd25457$var$BLOCK_CONTROLS_SUPPRESSION_ATTRIBUTE}]`;
const $d9d643acafd25457$export$7a4820babe675d08 = {
    [$d9d643acafd25457$var$BLOCK_CONTROLS_SUPPRESSION_ATTRIBUTE]: 'true'
};
const $d9d643acafd25457$export$8d5d08f345eecbf1 = (target)=>target instanceof Element && target.closest($d9d643acafd25457$var$BLOCK_CONTROLS_SUPPRESSION_SELECTOR) !== null;
module.exports["blockControlsSuppressionProps"] = $d9d643acafd25457$export$7a4820babe675d08;
module.exports["isBlockControlsSuppressionTarget"] = $d9d643acafd25457$export$8d5d08f345eecbf1;

});

parcelRegister("JTIzG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");

var $27a67c702eae1a5a$export$419c8aa8913e9327 = /*#__PURE__*/ function(BriefingNudgeExperimentState) {
    BriefingNudgeExperimentState["CONTROL"] = "control";
    BriefingNudgeExperimentState["NUDGE"] = "nudge";
    BriefingNudgeExperimentState["NUDGE_AUTOPLAY"] = "nudge_autoplay";
    return BriefingNudgeExperimentState;
}({});
const $27a67c702eae1a5a$export$df5bf03825b93c3d = ()=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isAIEarlyAccessEnabled: isAIEarlyAccessEnabled, isAtlassianHostedLLMOnlyEnabled: isAtlassianHostedLLMOnlyEnabled } = (0, $bQm3c.useSessionData)();
    // Deferred: MediaSource is unavailable during SSR
    const [audioSupportedByBrowser, setAudioSupportedByBrowser] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        setAudioSupportedByBrowser(typeof MediaSource !== 'undefined' && MediaSource.isTypeSupported('audio/mpeg'));
    }, []);
    const { isAIPolicyEnabled: isAIPolicyEnabled, isAudioV3EnabledForPolicy: isAudioV3EnabledForPolicy, isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled } = (0, $cozmU.useMemo)(()=>{
        const aiPolicyEnabled = !(isAtlassianHostedLLMOnlyEnabled && (0, $6mKj3.isExperimentEnabled)('confluence_audio_disable_if_ahm_enabled')) && isAdminHubAIEnabled && isAIEarlyAccessEnabled;
        const audioV3EnabledForPolicy = aiPolicyEnabled && (0, $6mKj3.isExperimentEnabled)('confluence_audio_v3');
        return {
            isAIPolicyEnabled: aiPolicyEnabled,
            isAudioV3EnabledForPolicy: audioV3EnabledForPolicy,
            // Keep byline visibility stable through SSR and hydration. ListenByline checks browser
            // support after hydration and disables its trigger when audio playback is unsupported.
            isAudioBylineEntrypointEnabled: audioV3EnabledForPolicy
        };
    }, [
        isAdminHubAIEnabled,
        isAIEarlyAccessEnabled,
        isAtlassianHostedLLMOnlyEnabled
    ]);
    const isAudioV3Enabled = isAudioV3EnabledForPolicy && audioSupportedByBrowser;
    const audioBriefingNudgeExperimentState = (0, $cozmU.useMemo)(()=>{
        if (!isAudioV3Enabled) return "control";
        if ((0, $6mKj3.expValEquals)('confluence_audio_v3_briefing_nudge', 'variant', 'nudge')) return "nudge";
        else if ((0, $6mKj3.expValEquals)('confluence_audio_v3_briefing_nudge', 'variant', 'nudge_autoplay')) return "nudge_autoplay";
        else return "control";
    }, [
        isAudioV3Enabled
    ]);
    return {
        isAIPolicyAndBrowserSupportEnabled: isAIPolicyEnabled && audioSupportedByBrowser,
        isAudioV3Enabled: isAudioV3Enabled,
        isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled,
        audioBriefingNudgeExperimentState: audioBriefingNudgeExperimentState
    };
};
module.exports["BriefingNudgeExperimentState"] = $27a67c702eae1a5a$export$419c8aa8913e9327;
module.exports["useAudioFeatureFlags"] = $27a67c702eae1a5a$export$df5bf03825b93c3d;

});

parcelRegister("NomII", function(module, exports) {
/* CustomPopupContainer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $dinVW = parcelRequire("dinVW");


var $bmowW = parcelRequire("bmowW");

const $7ecedb5cea5467d4$var$PopupWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvD8fU6 _2OUyjtGk8v _42Yu6B7dHp _1zr6Dc98eZ _0htemXYbGa _067LceT6kp",
            __cmplp.className
        ])
    });
});
const $7ecedb5cea5467d4$export$2db9b01e44994880 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, ...props }, ref)=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7ecedb5cea5467d4$var$PopupWrapper, {
        ...props,
        ref: ref,
        role: "dialog",
        "aria-label": intl.formatMessage((0, $bmowW.i18n).quickSummaryLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, children));
});
module.exports["CustomPopupContainer"] = $7ecedb5cea5467d4$export$2db9b01e44994880;

});

parcelRegister("bmowW", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $jhwJP = parcelRequire("jhwJP");

const $c2de17ff654b3217$var$i18nBase = (0, $kSwu1.defineMessages)({
    quickSummaryLabel: {
        id: "quick-summary.label.text",
        defaultMessage: "Quick summary"
    },
    quickSummaryToolTipText: {
        id: "quick-summary.tooltip.text",
        defaultMessage: "Summarize"
    },
    quickSummaryFeatureSpotlightText: {
        id: "quick-summary.feature-spotlight-one.text",
        defaultMessage: "This might be a longer read. Save time and read a quick summary from Atlassian Intelligence."
    },
    quickSummarySpotlightSummarizeText: {
        id: "quick-summary.spotlight.summarize.button.text",
        defaultMessage: "Summarize"
    },
    quickSummarySpotlightCloseButtonText: {
        id: "quick-summary.spotlight.close.button.text",
        defaultMessage: "Dismiss"
    },
    quickSummaryOptInDialogHeaderText: {
        id: "quick-summary.opt-in.dialog.header.text",
        defaultMessage: "Work smarter, not harder"
    },
    quickSummaryOptInDialogBodyText: {
        id: "quick-summary.opt-in.dialog.body.text",
        defaultMessage: "Save time by reading an Al-generated summary instead of an entire page or blog with <a>Atlassian Intelligence</a>. <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration."
    },
    quickSummaryAdminOptInDialogBodyText: {
        id: "quick-summary.admin.opt-in.dialog.body.text",
        defaultMessage: "Save your team time by reading an Al-generated summary instead of an entire page with <a>Atlassian Intelligence</a>. <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration."
    }
});
const $c2de17ff654b3217$var$i18nLiveDocs = (0, $kSwu1.defineMessages)({
    quickSummaryOptInDialogBodyText: {
        id: "quick-summary.opt-in.dialog.body.text.livedocs",
        defaultMessage: "Save time by reading an Al-generated summary instead of an entire page, live doc, or blog with <a>Atlassian Intelligence</a>. <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration."
    },
    quickSummaryAdminOptInDialogBodyText: {
        id: "quick-summary.admin.opt-in.dialog.body.text.livedocs",
        defaultMessage: "Save your team time by reading an Al-generated summary instead of an entire page or live doc with <a>Atlassian Intelligence</a>. <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration."
    }
});
const $c2de17ff654b3217$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($c2de17ff654b3217$var$i18nBase, $c2de17ff654b3217$var$i18nLiveDocs);
module.exports["i18n"] = $c2de17ff654b3217$export$a7357cdd1f0b0168;

});

parcelRegister("7mpOv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");

const $7ae32555811cd45f$export$cc5edac91cdebf9b = (_props = {})=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    return {
        isAIEnabledForContent: isAdminHubAIEnabled,
        isRovoEnabledForContent: isRovoLLMEnabled
    };
};
function $7ae32555811cd45f$export$fb975e2d7306f54a(WrappedComponent) {
    return function EnhancedComponent(props) {
        const [contentId] = (0, $ep3mz.usePageContentId)();
        const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = $7ae32555811cd45f$export$cc5edac91cdebf9b({
            contentId: contentId ?? ''
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
            ...props,
            isAIEnabledForContent: isAIEnabledForContent,
            isRovoEnabledForContent: isRovoEnabledForContent
        });
    };
}
module.exports["useIsAIEnabledForContent"] = $7ae32555811cd45f$export$cc5edac91cdebf9b;
module.exports["withIsAIEnabledForContent"] = $7ae32555811cd45f$export$fb975e2d7306f54a;

});

parcelRegister("41KFX", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $dBcar = parcelRequire("dBcar");


var $ivb8S = parcelRequire("ivb8S");


var $879OR = parcelRequire("879OR");

const $73d6907ec9f8e642$export$fce5991a3cbd7c5a = new Set([
    'default-templates',
    'pin-templates'
]);
const $73d6907ec9f8e642$var$DEFAULT_RESULT = {
    navStyle: 'control',
    isWithinD0: false,
    source: null
};
function $73d6907ec9f8e642$export$9e39472fc9788dd0() {
    if ((0, $9wGTI.fg)('cfind_5565_creation_focused_nav_xflow_preload')) return [
        ...(0, $dBcar.NAV_EXPERIMENT_ONBOARDING_KEYS),
        (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).CHECKED_ELIGIBLE,
        (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).START_AT
    ];
    return [
        ...(0, $dBcar.NAV_EXPERIMENT_ONBOARDING_KEYS)
    ];
}
const $73d6907ec9f8e642$export$aed714501b2c585 = (skip = false)=>{
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)($73d6907ec9f8e642$export$9e39472fc9788dd0(), skip);
    const { isEligible: isEligibleForSimplifyNavXflow, isLoading: isLoadingIsEligibleForSimplifyNavXflow, hasError: hasEligibleForSimplifyNavXflowError, isWithinD0Window: isWithinD0WindowForSimplifyNavXflow } = (0, $879OR.useIsEligibleForSimplifyNavXflow)({
        onboardingStateData: onboardingStateData,
        onboardingStateLoading: onboardingStateLoading,
        onboardingStateError: onboardingStateError,
        skip: skip || !(0, $9wGTI.fg)('cfind_5565_creation_focused_nav_xflow_preload')
    });
    if (onboardingStateLoading) return {
        navStyle: 'loading',
        isWithinD0: false,
        source: null
    };
    if (onboardingStateError) return $73d6907ec9f8e642$var$DEFAULT_RESULT;
    const entries = onboardingStateData?.onboardingState;
    if (!entries) return $73d6907ec9f8e642$var$DEFAULT_RESULT;
    const eligibleEntry = entries.find((s)=>s.key === (0, $dBcar.SIMPLIFY_NAV_NEW_USER).NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE);
    if (eligibleEntry?.value !== 'true') {
        // Not in the retired new-user state, but might be eligible for xflow.
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cfind_5565_creation_focused_nav_xflow_preload')) {
            if (isLoadingIsEligibleForSimplifyNavXflow) // This may happen if TAP traits are loading, although they should generally be preloaded.
            // Case of onboarding state loading is handled in previous conditionals.
            return {
                navStyle: 'loading',
                isWithinD0: false,
                source: null
            };
            if (hasEligibleForSimplifyNavXflowError) return $73d6907ec9f8e642$var$DEFAULT_RESULT;
            if (isEligibleForSimplifyNavXflow) {
                const navStyle = (0, $6mKj3.expVal)('cfind_5565_creation_focused_nav_xflow', 'cohort', 'control');
                if ($73d6907ec9f8e642$export$fce5991a3cbd7c5a.has(navStyle)) return {
                    navStyle: navStyle,
                    isWithinD0: isWithinD0WindowForSimplifyNavXflow,
                    source: 'xflow'
                };
            }
        }
        return $73d6907ec9f8e642$var$DEFAULT_RESULT;
    }
    return $73d6907ec9f8e642$var$DEFAULT_RESULT;
};
module.exports["TREATMENT_COHORTS"] = $73d6907ec9f8e642$export$fce5991a3cbd7c5a;
module.exports["useSimplifiedNavNewUsers"] = $73d6907ec9f8e642$export$aed714501b2c585;

});

parcelRegister("879OR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $kOUwv = parcelRequire("kOUwv");


var $dBcar = parcelRequire("dBcar");


var $ivb8S = parcelRequire("ivb8S");


var $1KHQh = parcelRequire("1KHQh");


var $6Dfc9 = parcelRequire("6Dfc9");

const $1f55678574e67c8a$var$FIRST_ACTIVATION_DATE_TRAIT = 'firstActivationDate';
// Use a module-level variable to ensure the effect only fires once per app lifecycle,
// even if the hook is called from multiple places simultaneously.
let $1f55678574e67c8a$var$hasRunEffect = false;
function $1f55678574e67c8a$export$5b324fbcfda94020() {
    $1f55678574e67c8a$var$hasRunEffect = false;
}
const $1f55678574e67c8a$export$bbe7d46982302b03 = ({ onboardingStateData: onboardingStateData, onboardingStateLoading: onboardingStateLoading, onboardingStateError: onboardingStateError, skip: skip })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    const { data: siteTraitsData, loading: siteTraitsDataLoading, error: siteTraitsDataError } = (0, $kOUwv.useSiteTraits)({
        skipBootstrap: skip
    });
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const entries = onboardingStateData?.onboardingState;
    const isInCfindLandCreationFocusedNavExperiment = !!entries?.find((s)=>s.key === (0, $dBcar.CREATION_FOCUSED_NAV_START_TIME))?.value;
    const isInActivationExperiment = entries?.find(({ key: key })=>key === (0, $dBcar.SIMPLIFY_NAV_NEW_USER).NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE)?.value === 'true';
    const isOnboardingStateForExperimentSet = entries?.find(({ key: key })=>key === (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).CHECKED_ELIGIBLE)?.value === 'true';
    const xflowStartAt = entries?.find(({ key: key })=>key === (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).START_AT)?.value;
    // We checked the user's eligibility at one point and determined they were not in treatment.
    const isReturningControlUser = isOnboardingStateForExperimentSet && !xflowStartAt;
    // A user who already has a START_AT recorded is a returning enrolled user and is always eligible.
    const isReturningEnrolledUser = !!xflowStartAt;
    const siteActivationDateTrait = siteTraitsData?.attributes?.find(({ name: name })=>name === $1f55678574e67c8a$var$FIRST_ACTIVATION_DATE_TRAIT)?.value;
    // TAP site traits data is only needed when the user might be a first-time eligible user.
    // If onboarding state alone can determine eligibility, don't wait for TAP data to load —
    // this avoids an unnecessary loading state that hides navigation items.
    const canDetermineWithoutTap = skip || !hasLicensedAccess || isInCfindLandCreationFocusedNavExperiment || isInActivationExperiment || isReturningControlUser || isReturningEnrolledUser;
    const isLoading = !!(onboardingStateLoading || !canDetermineWithoutTap && siteTraitsDataLoading);
    const hasError = !!(onboardingStateError || !canDetermineWithoutTap && siteTraitsDataError);
    // A new user is eligible if their site's firstActivationDate is non-null and
    // after the experiment start date. Returning enrolled users are always eligible.
    const isSiteActivationAfterExperimentStart = ()=>{
        if (!siteActivationDateTrait) return false;
        const experimentStartDate = (0, $1KHQh.getXflowExperimentStartDate)();
        if (!experimentStartDate) return false;
        try {
            return new Date(siteActivationDateTrait) >= experimentStartDate;
        } catch  {
            return false;
        }
    };
    const isEligible = !skip && !isLoading && !hasError && hasLicensedAccess && !isInCfindLandCreationFocusedNavExperiment && !isInActivationExperiment && !isReturningControlUser && (isReturningEnrolledUser || isSiteActivationAfterExperimentStart());
    (0, $cozmU.useEffect)(()=>{
        if (!isEligible || isOnboardingStateForExperimentSet || $1f55678574e67c8a$var$hasRunEffect) return;
        $1f55678574e67c8a$var$hasRunEffect = true;
        if ((0, $6mKj3.expValEquals)('cfind_5565_creation_focused_nav_xflow', 'cohort', 'pin-templates')) setOnboardingState([
            {
                key: (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).CHECKED_ELIGIBLE,
                value: 'true'
            },
            {
                key: (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).START_AT,
                value: new Date().toISOString()
            }
        ]);
        else setOnboardingState({
            key: (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).CHECKED_ELIGIBLE,
            value: 'true'
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'eligible',
                actionSubject: 'cfind-5565-simplify-nav-xflow',
                actionSubjectId: 'cfind-5565-simplify-nav-xflow',
                source: 'cfind-5565-simplify-nav-xflow',
                attributes: {
                    siteActivationDate: siteActivationDateTrait
                }
            }
        }).fire();
    }, [
        isEligible,
        isOnboardingStateForExperimentSet,
        setOnboardingState,
        siteActivationDateTrait,
        createAnalyticsEvent
    ]);
    return {
        isLoading: isLoading,
        hasError: hasError,
        isEligible: isEligible,
        // For returning enrolled users, use their START_AT timestamp to determine if they're
        // within the D0 window. For first-time users (no START_AT yet), they're implicitly
        // within their D0 window if and only if they're eligible.
        isWithinD0Window: xflowStartAt ? (0, $6Dfc9.isWithinD0Window)(xflowStartAt) : isEligible
    };
};
module.exports["useIsEligibleForSimplifyNavXflow"] = $1f55678574e67c8a$export$bbe7d46982302b03;

});

parcelRegister("1KHQh", function(module, exports) {
// eslint-disable-next-line confluence-feature-gating/unsafe-no-exposure

var $6mKj3 = parcelRequire("6mKj3");

/**
 * Reads the experimentStartDate param from the cfind_5565_creation_focused_nav_xflow
 * experiment config without firing an exposure. Falls back to 2026-05-07 (the gate
 * rollout date) if the param is missing. Returns null only if the value is not a valid date.
 */ // eslint-disable-next-line confluence-feature-gating/unsafe-no-exposure
const $47ca1d22622dd352$var$XFLOW_EXPERIMENT_START_DATE_FALLBACK = '2026-05-07';
const $47ca1d22622dd352$export$9aeee5d7687bf679 = ()=>{
    // eslint-disable-next-line confluence-feature-gating/unsafe-no-exposure
    const [expConfig] = (0, $6mKj3.UNSAFE_noExposureExp)('cfind_5565_creation_focused_nav_xflow'); // Experiment exposure is fired elsewhere
    const rawValue = expConfig.get('experimentStartDate', $47ca1d22622dd352$var$XFLOW_EXPERIMENT_START_DATE_FALLBACK);
    const date = new Date(rawValue);
    return isNaN(date.getTime()) ? null : date;
};
module.exports["getXflowExperimentStartDate"] = $47ca1d22622dd352$export$9aeee5d7687bf679;

});

parcelRegister("6Dfc9", function(module, exports) {

var $bg9GW = parcelRequire("bg9GW");

var $esV19 = parcelRequire("esV19");

var $k5sGX = parcelRequire("k5sGX");

function $e250b9cfd6dd2931$export$46cbbdfdd4d2fcb(isoTimestamp) {
    if (!isoTimestamp) return false;
    const parsed = (0, $k5sGX.default)(isoTimestamp);
    return (0, $esV19.default)(parsed) && (0, $bg9GW.default)(new Date(), parsed) < 24;
}
function $e250b9cfd6dd2931$export$193a557a4d23c9aa(epochMs) {
    const date = new Date(epochMs);
    return (0, $esV19.default)(date) && (0, $bg9GW.default)(new Date(), date) < 24;
}
module.exports["isWithinD0Window"] = $e250b9cfd6dd2931$export$46cbbdfdd4d2fcb;

});

parcelRegister("i1vUz", function(module, exports) {

var $4qmCZ = parcelRequire("4qmCZ");


var $8SLNj = parcelRequire("8SLNj");


var $8G3G6 = parcelRequire("8G3G6");


var $5L7V6 = parcelRequire("5L7V6");


var $8uM2K = parcelRequire("8uM2K");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $h2uld = parcelRequire("h2uld");

const $649e6d4fa880ffb0$export$308bf82a9a0ad7d = (0, $5L7V6.default);
const $649e6d4fa880ffb0$var$useDynamicSplitButtonCatchupLastViewedTimeQuery = (0, $8G3G6.default);
const $649e6d4fa880ffb0$var$useDynamicSplitButtonContentHistoryQuery = (0, $8SLNj.default);
const $649e6d4fa880ffb0$export$ca7c63318c849d7a = (contentId, contentType, isRefreshRovoButton = false)=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, userId: userId } = (0, $bQm3c.useSessionData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { readTime: readTime, loading: readTimeLoading } = (0, $h2uld.useReadTime)(contentId, !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT);
    const { data: data, loading: catchupLastViewedLoading, error: queryError } = (0, $jMyy4.useQueryInterop)($649e6d4fa880ffb0$var$useDynamicSplitButtonCatchupLastViewedTimeQuery, {
        variables: {
            contentId: contentId,
            contentType: contentType
        },
        skip: !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT,
        __callerPackage__: "ai-floating-context-menu"
    });
    const { data: lastModifiedDateData, loading: lastModifiedLoading } = (0, $jMyy4.useQueryInterop)((0, $4qmCZ.default), {
        variables: {
            contentId: contentId
        },
        skip: !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT,
        __callerPackage__: "ai-floating-context-menu"
    });
    const { data: contentHistoryData, loading: contentHistoryLoading } = (0, $jMyy4.useQueryInterop)($649e6d4fa880ffb0$var$useDynamicSplitButtonContentHistoryQuery, {
        variables: {
            contentId: contentId
        },
        skip: !isAdminHubAIEnabled || pageMode === (0, $cD1qu.PageMode).EDIT || !isRovoButtonEnabled,
        fetchPolicy: 'network-only',
        __callerPackage__: "ai-floating-context-menu"
    });
    const lastModifiedDate = lastModifiedDateData?.content?.nodes?.[0]?.metadata?.lastModifiedDate ?? '';
    const lastViewedTime = data?.catchupGetLastViewedTime?.lastViewedTimeISO ?? '';
    // Guard against cases where lastViewedTime would otherwise cause a NaN parse result
    const cleanedLastViewedTime = lastViewedTime.replace(/\[.*?\]$/, '');
    const parsedLastViewedTime = Date.parse(cleanedLastViewedTime);
    const parsedLastModifiedDate = Date.parse(lastModifiedDate);
    const lastEditedCollaborators = contentHistoryData?.contentHistory?.nodes?.[0]?.collaborators?.userAccountIds ?? [];
    const isCurrentUserARecentCollaborator = lastEditedCollaborators.some((collaborator)=>collaborator === userId);
    const isFirstTimeVisit = Number.isNaN(parsedLastViewedTime);
    const lastViewedDate = isFirstTimeVisit ? undefined : new Date(parsedLastViewedTime);
    const queryLoading = catchupLastViewedLoading || lastModifiedLoading || contentHistoryLoading || readTimeLoading;
    let showCatchupAsDefault = false;
    let showSummarizeAsDefault = true;
    if (!parsedLastViewedTime && !isFirstTimeVisit || !parsedLastModifiedDate || queryError) return {
        showCatchupAsDefault: showCatchupAsDefault,
        queryLoading: queryLoading,
        queryError: queryError
    };
    if (isRovoButtonEnabled && pageMode !== (0, $cD1qu.PageMode).EDIT && !queryLoading && isFirstTimeVisit && readTime && readTime >= 5 && !isCurrentUserARecentCollaborator) {
        if (isRefreshRovoButton) return {
            showCatchupAsDefault: showCatchupAsDefault,
            showSummarizeAsDefault: showSummarizeAsDefault,
            queryLoading: queryLoading
        };
    }
    showCatchupAsDefault = pageMode !== (0, $cD1qu.PageMode).EDIT && !queryLoading && parsedLastModifiedDate > parsedLastViewedTime && !isCurrentUserARecentCollaborator;
    showSummarizeAsDefault = false;
    return {
        showCatchupAsDefault: showCatchupAsDefault,
        showSummarizeAsDefault: showSummarizeAsDefault,
        queryLoading: queryLoading,
        lastViewedDate: lastViewedDate
    };
};
module.exports["useDynamicSplitButton"] = $649e6d4fa880ffb0$export$ca7c63318c849d7a;

});

parcelRegister("4qmCZ", function(module, exports) {
/**
 * @generated SignedSource<<b18880c95a88e91ee675a5ab3e7a2f6a>>
 * @relayHash 53828d84c0acb319d0f0762fbd51cfb9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3782297928019afae38deeb994658b9d2bfb75b3dd67df3051fac91d5ebf0e37
const $3f3bb2f2b7df90db$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "lastModifiedDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDynamicSplitButtonLastModifiedDateQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDynamicSplitButtonLastModifiedDateQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "53828d84c0acb319d0f0762fbd51cfb9",
            "id": "3782297928019afae38deeb994658b9d2bfb75b3dd67df3051fac91d5ebf0e37",
            "metadata": {},
            "name": "useDynamicSplitButtonLastModifiedDateQuery",
            "operationKind": "query",
            "text": "query useDynamicSplitButtonLastModifiedDateQuery($contentId:ID!){content(id:$contentId){nodes{id,metadata{lastModifiedDate}}}}"
        }
    };
}();
$3f3bb2f2b7df90db$var$node.hash = "cb78a829ad38a06c36dc9615c22411b7";
var $3f3bb2f2b7df90db$export$2e2bcd8739ae039 = $3f3bb2f2b7df90db$var$node;
module.exports["default"] = $3f3bb2f2b7df90db$export$2e2bcd8739ae039;

});

parcelRegister("8SLNj", function(module, exports) {
/**
 * @generated SignedSource<<6135257c8df94a440f547d327ee53e8c>>
 * @relayHash c82cedffd514ace9062cc5a7ea29b433
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7dd5a60846b03a6eacef04466d72dec90722d2cae751b0c9b97f555a408d7190
const $a7452eae54a23656$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                }
            ],
            "concreteType": "PaginatedContentHistoryList",
            "kind": "LinkedField",
            "name": "contentHistory",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ContentHistory",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "ContributorUsers",
                            "kind": "LinkedField",
                            "name": "collaborators",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "userAccountIds"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDynamicSplitButtonContentHistoryQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDynamicSplitButtonContentHistoryQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c82cedffd514ace9062cc5a7ea29b433",
            "id": "7dd5a60846b03a6eacef04466d72dec90722d2cae751b0c9b97f555a408d7190",
            "metadata": {},
            "name": "useDynamicSplitButtonContentHistoryQuery",
            "operationKind": "query",
            "text": "query useDynamicSplitButtonContentHistoryQuery($contentId:ID!){contentHistory(contentId:$contentId,first:1){nodes{collaborators{userAccountIds}}}}"
        }
    };
}();
$a7452eae54a23656$var$node.hash = "428e55c833e4f9ecc04af6435214d702";
var $a7452eae54a23656$export$2e2bcd8739ae039 = $a7452eae54a23656$var$node;
module.exports["default"] = $a7452eae54a23656$export$2e2bcd8739ae039;

});

parcelRegister("8G3G6", function(module, exports) {
/**
 * @generated SignedSource<<e1177a1d3670ae73598e531cc663b738>>
 * @relayHash 4454a52ea4ab532f76ee4e80586f3a56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b93f6dc06e9898ae5a96da49582122e7834ced458f11ee2b79ed14f9d9b3a87
const $3a0ab9c788e793cd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentType"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                }
            ],
            "concreteType": "CatchupLastViewedTimeResponse",
            "kind": "LinkedField",
            "name": "catchupGetLastViewedTime",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "lastViewedTimeISO"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "4454a52ea4ab532f76ee4e80586f3a56",
            "id": "1b93f6dc06e9898ae5a96da49582122e7834ced458f11ee2b79ed14f9d9b3a87",
            "metadata": {},
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "operationKind": "query",
            "text": "query useDynamicSplitButtonCatchupLastViewedTimeQuery($contentId:ID!,$contentType:CatchupContentType!){catchupGetLastViewedTime(contentId:$contentId,contentType:$contentType){lastViewedTimeISO}}"
        }
    };
}();
$3a0ab9c788e793cd$var$node.hash = "ca230a2a5e683b85178d392f9c872c98";
var $3a0ab9c788e793cd$export$2e2bcd8739ae039 = $3a0ab9c788e793cd$var$node;
module.exports["default"] = $3a0ab9c788e793cd$export$2e2bcd8739ae039;

});

parcelRegister("5L7V6", function(module, exports) {
/**
 * @generated SignedSource<<369f3309f8f6ec03427d92d39f832dab>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $923ef1fe064db781$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useDynamicSplitButton_catchupLastViewedTime",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "lastViewedTimeISO"
        }
    ],
    "type": "CatchupLastViewedTimeResponse"
};
$923ef1fe064db781$var$node.hash = "297588dba1b1d203b8ad0275eaa0e0a8";
var $923ef1fe064db781$export$2e2bcd8739ae039 = $923ef1fe064db781$var$node;
module.exports["default"] = $923ef1fe064db781$export$2e2bcd8739ae039;

});

parcelRegister("8uM2K", function(module, exports) {

var $3ricL = parcelRequire("3ricL");


var $bQm3c = parcelRequire("bQm3c");

const $214157f3efbb250b$export$dcc461521a57aee7 = ()=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    // environment-aware enablement via feature encoding
    const isAIFeatureEnabled = (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-ai');
    return isAIFeatureEnabled && isAdminHubAIEnabled && isRovoLLMEnabled;
};
module.exports["useAIRovoButtonEnablement"] = $214157f3efbb250b$export$dcc461521a57aee7;

});

parcelRegister("d282Z", function(module, exports) {
const $a18eeb1d05dccc62$export$fc9b2402bb5adac2 = {
    CONTEXTUAL_FLOATING_BUTTON_NUDGE: 'onboarding-insights:hasContextualFloatingButtonBeenSeen',
    AUDIO_BRIEFING: 'onboarding-insights:hasAudioBriefingChangeboardingBeenSeen',
    AUDIO_V3_CHANGEBOARDING: 'onboarding-insights:hasAudioV3ChangeboardingBeenSeen'
};
const $a18eeb1d05dccc62$export$fac0a92023e58acd = Object.values($a18eeb1d05dccc62$export$fc9b2402bb5adac2);
module.exports["ONBOARDING_INSIGHTS"] = $a18eeb1d05dccc62$export$fc9b2402bb5adac2;
module.exports["InsightsOnboardingKeys"] = $a18eeb1d05dccc62$export$fac0a92023e58acd;

});

parcelRegister("cAdj8", function(module, exports) {

var $69Jl3 = parcelRequire("69Jl3");


var $cozmU = parcelRequire("cozmU");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $1uFM6 = parcelRequire("1uFM6");


var $flE5X = parcelRequire("flE5X");


var $jMyy4 = parcelRequire("jMyy4");

const $a1394411ec7881e4$var$usePageInfoPageInfoQuery = (0, $69Jl3.default);
const $a1394411ec7881e4$export$e1b9843c9a40eb2 = {
    id: '',
    type: '',
    status: '',
    space: {
        id: '',
        operations: []
    },
    operations: [],
    version: {
        number: -1
    }
};
const $a1394411ec7881e4$export$7b2dac1793a2824 = ({ fetchPolicy: fetchPolicy = 'cache-and-network', onCompleted: onCompleted, onError: onError } = {})=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)($a1394411ec7881e4$var$usePageInfoPageInfoQuery, {
        variables: {
            pageId: contentId
        },
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted,
        __callerPackage__: "page-info"
    });
    return (0, $cozmU.useMemo)(()=>{
        // Handle error case first
        if (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error) || error instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(error);
            onError?.(error);
            return {
                pageInfo: null,
                loading: false,
                error: error,
                refetch: null
            };
        }
        // If we have data, use it even during loading
        if (data) {
            const pageInfoNode = data.content?.nodes?.[0] ?? null;
            if (pageInfoNode) return {
                pageInfo: pageInfoNode,
                loading: loading,
                error: undefined,
                refetch: refetch
            };
            return {
                pageInfo: {
                    ...$a1394411ec7881e4$export$e1b9843c9a40eb2
                },
                loading: loading,
                error: undefined,
                refetch: refetch
            };
        }
        // Only return null pageInfo if we have no data at all
        return {
            pageInfo: null,
            loading: loading,
            error: undefined,
            refetch: null
        };
    }, [
        data,
        loading,
        error,
        onError,
        refetch
    ]);
};
module.exports["usePageInfo"] = $a1394411ec7881e4$export$7b2dac1793a2824;

});

parcelRegister("69Jl3", function(module, exports) {
/**
 * @generated SignedSource<<a52aa17c9371e87ad68639adf48d413b>>
 * @relayHash ece963db192ceabc724d67f753bee503
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2811ac8ea0cd2136d716a0779dac023c092684c56d72b0b668fe85db77dee6d4
const $c7d0a8215908754e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "pageId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "current",
                        "archived",
                        "draft"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        },
                        v2 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "number"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePageInfoPageInfoQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePageInfoPageInfoQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "ece963db192ceabc724d67f753bee503",
            "id": "2811ac8ea0cd2136d716a0779dac023c092684c56d72b0b668fe85db77dee6d4",
            "metadata": {},
            "name": "usePageInfoPageInfoQuery",
            "operationKind": "query",
            "text": "query usePageInfoPageInfoQuery($pageId:ID){content(id:$pageId,status:[\"current\",\"archived\",\"draft\"]){nodes{id,type,status,space{id,operations{operation,targetType}},operations{operation,targetType},version{number}}}}"
        }
    };
}();
$c7d0a8215908754e$var$node.hash = "a5580c0bc26236652ac23ad7c3f4bf51";
var $c7d0a8215908754e$export$2e2bcd8739ae039 = $c7d0a8215908754e$var$node;
module.exports["default"] = $c7d0a8215908754e$export$2e2bcd8739ae039;

});

parcelRegister("cGlMo", function(module, exports) {

let $93ba4d3888fcc884$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $93ba4d3888fcc884$var$load("5lfr5").then(()=>parcelRequire('ebALC'));

});

parcelRegister("9VC5k", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $303LV = parcelRequire("303LV");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $2wCqQ = parcelRequire("2wCqQ");


var $buxP3 = parcelRequire("buxP3");


var $7akNQ = parcelRequire("7akNQ");


var $I7hWB = parcelRequire("I7hWB");


var $9DHhW = parcelRequire("9DHhW");


var $b8pma = parcelRequire("b8pma");


var $cFVPs = parcelRequire("cFVPs");















var $a9aSv = parcelRequire("a9aSv");

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 


const $96aaefbcbab4ea71$export$b58d43d92d088553 = ({ alt: alt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("title", null, alt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.4473 7.99998C11.4473 7.63179 11.7457 7.33331 12.1139 7.33331H13.3339C13.7021 7.33331 14.0006 7.63179 14.0006 7.99998C14.0006 8.36817 13.7021 8.66665 13.3339 8.66665H12.1139C11.7457 8.66665 11.4473 8.36817 11.4473 7.99998Z",
        fill: "url(#paint0_linear_2378_7139)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.00065 2C8.36884 2 8.66732 2.29848 8.66732 2.66667V3.88667C8.66732 4.25486 8.36884 4.55333 8.00065 4.55333C7.63246 4.55333 7.33398 4.25486 7.33398 3.88667V2.66667C7.33398 2.29848 7.63246 2 8.00065 2Z",
        fill: "url(#paint1_linear_2378_7139)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 7.99998C2 7.63179 2.29848 7.33331 2.66667 7.33331H3.88667C4.25486 7.33331 4.55333 7.63179 4.55333 7.99998C4.55333 8.36817 4.25486 8.66665 3.88667 8.66665H2.66667C2.29848 8.66665 2 8.36817 2 7.99998Z",
        fill: "url(#paint2_linear_2378_7139)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.00065 11.4467C8.36884 11.4467 8.66732 11.7451 8.66732 12.1133V13.3333C8.66732 13.7015 8.36884 14 8.00065 14C7.63246 14 7.33398 13.7015 7.33398 13.3333V12.1133C7.33398 11.7451 7.63246 11.4467 8.00065 11.4467Z",
        fill: "url(#paint3_linear_2378_7139)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.52925 9.52858C9.7896 9.26823 10.2117 9.26823 10.4721 9.52858L13.1387 12.1952C13.3991 12.4556 13.3991 12.8777 13.1387 13.1381C12.8784 13.3984 12.4563 13.3984 12.1959 13.1381L9.52925 10.4714C9.2689 10.211 9.2689 9.78892 9.52925 9.52858Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.1387 2.86195C13.3991 3.1223 13.3991 3.54441 13.1387 3.80476L10.4721 6.47142C10.2117 6.73177 9.7896 6.73177 9.52925 6.47142C9.2689 6.21108 9.2689 5.78897 9.52925 5.52862L12.1959 2.86195C12.4563 2.6016 12.8784 2.6016 13.1387 2.86195Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.86128 2.86195C3.12163 2.6016 3.54374 2.6016 3.80409 2.86195L6.47075 5.52862C6.7311 5.78897 6.7311 6.21108 6.47075 6.47142C6.2104 6.73177 5.78829 6.73177 5.52794 6.47142L2.86128 3.80476C2.60093 3.54441 2.60093 3.1223 2.86128 2.86195Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.47075 9.52858C6.7311 9.78892 6.7311 10.211 6.47075 10.4714L3.80409 13.1381C3.54374 13.3984 3.12163 13.3984 2.86128 13.1381C2.60093 12.8777 2.60093 12.4556 2.86128 12.1952L5.52794 9.52858C5.78829 9.26823 6.2104 9.26823 6.47075 9.52858Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint0_linear_2378_7139",
        x1: "14.0006",
        y1: "7.99998",
        x2: "11.6672",
        y2: "7.99998",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.270833",
        stopColor: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#0052CC"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint1_linear_2378_7139",
        x1: "8.33398",
        y1: "2",
        x2: "8.33398",
        y2: "4.33333",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.1875",
        stopColor: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#0052CC"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint2_linear_2378_7139",
        x1: "4.5533",
        y1: "7.99998",
        x2: "2.21997",
        y2: "7.99998",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.791667",
        stopColor: "#2684FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint3_linear_2378_7139",
        x1: "8.33398",
        y1: "11.3333",
        x2: "8.33398",
        y2: "14",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.802083",
        stopColor: "#2684FF"
    }))));


const $333270f2f5cd2de3$var$i18n = (0, $kSwu1.defineMessages)({
    generatingSummary: {
        id: "ai-skeleton-loading.title",
        defaultMessage: "Atlassian Intelligence is generating a summary..."
    },
    logoAltText: {
        id: "ai-skeleton-loading.logo-alt",
        defaultMessage: "Atlassian Intelligence Logo"
    }
});
const $333270f2f5cd2de3$var$loadingTextContainer = (0, $buxP3.xcss)({
    display: 'flex',
    alignItems: 'center',
    gap: 'space.050',
    marginBottom: 'space.200',
    font: 'font.body.small',
    color: 'color.text.subtle'
});
const $333270f2f5cd2de3$export$e93f99a4d30f6d75 = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        padding: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $333270f2f5cd2de3$var$loadingTextContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $96aaefbcbab4ea71$export$b58d43d92d088553), {
        alt: intl.formatMessage($333270f2f5cd2de3$var$i18n.logoAltText)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, intl.formatMessage($333270f2f5cd2de3$var$i18n.generatingSummary))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        height: 16,
        width: '100%',
        borderRadius: "var(--ds-radius-large, 8px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        height: 16,
        width: '100%',
        borderRadius: "var(--ds-radius-large, 8px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        height: 16,
        width: '100%',
        borderRadius: "var(--ds-radius-large, 8px)",
        isShimmering: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        height: 16,
        width: '100%',
        borderRadius: "var(--ds-radius-large, 8px)",
        isShimmering: true
    })));
};



var $lpJCW = parcelRequire("lpJCW");















var $7m1U4 = parcelRequire("7m1U4");

const $82345f9002994123$var$BoxStyles = (0, $buxP3.xcss)({
    color: 'color.text.subtlest',
    backgroundColor: 'elevation.surface.sunken',
    padding: 'space.150',
    borderRadius: 'radius.large',
    borderBottomLeftRadius: 'radius.small'
});
const $82345f9002994123$var$i18n = (0, $kSwu1.defineMessages)({
    generatingSummaryText: {
        id: "ai-summary-loading.title",
        defaultMessage: "Writing a summary"
    },
    generatingSummaryAnimationAlt: {
        id: "ai-stream-loading.generation-animation",
        defaultMessage: "Generating"
    }
});
const $82345f9002994123$export$dd8c26521b6a2fec = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $82345f9002994123$var$BoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $82345f9002994123$var$i18n.generatingSummaryText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7m1U4.GeneratingStreamAnimation), {
        alt: formatMessage($82345f9002994123$var$i18n.generatingSummaryAnimationAlt)
    })));
};



var $5GgqH = parcelRequire("5GgqH");


var $bQm3c = parcelRequire("bQm3c");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $3Am3T = parcelRequire("3Am3T");


var $8jP1I = parcelRequire("8jP1I");

var $161368acfff8028f$export$ec72d0267c37019f = /*#__PURE__*/ function(CommentsSummaryAnalyticsType) {
    CommentsSummaryAnalyticsType["FOOTER"] = "FOOTER";
    CommentsSummaryAnalyticsType["INLINE"] = "INLINE";
    return CommentsSummaryAnalyticsType;
}({});



var $dchHi = parcelRequire("dchHi");


var $bbNJt = parcelRequire("bbNJt");


var $jhwJP = parcelRequire("jhwJP");

/**
 * @generated SignedSource<<29553362f1cef877309db445c48df90d>>
 * @relayHash 53eb9fa8cec0a522c06e9697c10f440b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0e7f7022453c20fb771fa2185effa02f458d286aad7e6ce54aeb8f5bfb846a33
const $24226cfbd28917e5$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentsType"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentsType",
                    "variableName": "commentsType"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                }
            ],
            "concreteType": "SmartFeaturesCommentsSummary",
            "kind": "LinkedField",
            "name": "getCommentsSummary",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "contentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "summary"
                },
                {
                    "kind": "ScalarField",
                    "name": "summaryId"
                },
                {
                    "kind": "ScalarField",
                    "name": "language"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCombinedCommentsSummariesQueriesInlineCommentsSummaryQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCombinedCommentsSummariesQueriesInlineCommentsSummaryQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "53eb9fa8cec0a522c06e9697c10f440b",
            "id": "0e7f7022453c20fb771fa2185effa02f458d286aad7e6ce54aeb8f5bfb846a33",
            "metadata": {},
            "name": "useCombinedCommentsSummariesQueriesInlineCommentsSummaryQuery",
            "operationKind": "query",
            "text": "query useCombinedCommentsSummariesQueriesInlineCommentsSummaryQuery($contentId:ID!,$contentType:SummaryType!,$commentsType:CommentsType!){getCommentsSummary(contentId:$contentId,contentType:$contentType,commentsType:$commentsType){contentId,summary,summaryId,language}}"
        }
    };
}();
$24226cfbd28917e5$var$node.hash = "6db2d91039b90f64f08e4e052c0a32d7";
var $24226cfbd28917e5$export$2e2bcd8739ae039 = $24226cfbd28917e5$var$node;


/**
 * @generated SignedSource<<c4777a9cf5f8e5b40c54145fa6f43328>>
 * @relayHash dc798cc8cc74b72655c7a19090058c0e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 436e25f2aa1fdf30c756b274ef8ce2de7a4f4bec1699fe1e3c1dc074e47484bb
const $050fce5e42c00d97$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentsType"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentsType",
                    "variableName": "commentsType"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                }
            ],
            "concreteType": "SmartFeaturesCommentsSummary",
            "kind": "LinkedField",
            "name": "getCommentsSummary",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "contentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "summary"
                },
                {
                    "kind": "ScalarField",
                    "name": "summaryId"
                },
                {
                    "kind": "ScalarField",
                    "name": "language"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCombinedCommentsSummariesQueriesFooterCommentsSummaryQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCombinedCommentsSummariesQueriesFooterCommentsSummaryQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "dc798cc8cc74b72655c7a19090058c0e",
            "id": "436e25f2aa1fdf30c756b274ef8ce2de7a4f4bec1699fe1e3c1dc074e47484bb",
            "metadata": {},
            "name": "useCombinedCommentsSummariesQueriesFooterCommentsSummaryQuery",
            "operationKind": "query",
            "text": "query useCombinedCommentsSummariesQueriesFooterCommentsSummaryQuery($contentId:ID!,$contentType:SummaryType!,$commentsType:CommentsType!){getCommentsSummary(contentId:$contentId,contentType:$contentType,commentsType:$commentsType){contentId,summary,summaryId,language}}"
        }
    };
}();
$050fce5e42c00d97$var$node.hash = "ffce51d12c39ccd238d2cb848107c61a";
var $050fce5e42c00d97$export$2e2bcd8739ae039 = $050fce5e42c00d97$var$node;



var $jMyy4 = parcelRequire("jMyy4");

/**
 * @generated SignedSource<<1f05a50a15753c67b4b42e99a5cdfd85>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: cc
 *
 * @see https://go/typsy
 **/ var $ac5fc6262abb25ff$export$e9466e0faeadf399 = /*#__PURE__*/ function(CommentsType) {
    CommentsType["FOOTER"] = "FOOTER";
    CommentsType["INLINE"] = "INLINE";
    return CommentsType;
}({});
var $ac5fc6262abb25ff$export$5bf35143f8d5729a = /*#__PURE__*/ function(SummaryType) {
    SummaryType["PAGE"] = "PAGE";
    SummaryType["BLOGPOST"] = "BLOGPOST";
    return SummaryType;
}({});


const $0edd62bded09ab4f$export$7bdbf0c72871fa1f = ({ contentId: contentId, contentType: contentType, shouldSkipFooterCommentsQuery: shouldSkipFooterCommentsQuery = false, shouldSkipInlineCommentsQuery: shouldSkipInlineCommentsQuery = false })=>{
    const { data: footerCommentsSummaryData, loading: footerCommentsQueryLoading, error: footerCommentsSummaryError, refetch: footerCommentsRefetch } = (0, $jMyy4.useQueryInterop)((0, $050fce5e42c00d97$export$2e2bcd8739ae039), {
        variables: {
            contentId: contentId,
            contentType: contentType,
            commentsType: (0, $ac5fc6262abb25ff$export$e9466e0faeadf399).FOOTER
        },
        notifyOnNetworkStatusChange: true,
        skip: shouldSkipFooterCommentsQuery,
        __callerPackage__: "ai-comments-summary"
    });
    const { data: inlineCommentsSummaryData, loading: inlineCommentsQueryLoading, error: inlineCommentsSummaryError, refetch: inlineCommentsRefetch } = (0, $jMyy4.useQueryInterop)((0, $24226cfbd28917e5$export$2e2bcd8739ae039), {
        variables: {
            contentId: contentId,
            contentType: contentType,
            commentsType: (0, $ac5fc6262abb25ff$export$e9466e0faeadf399).INLINE
        },
        notifyOnNetworkStatusChange: true,
        skip: shouldSkipInlineCommentsQuery,
        __callerPackage__: "ai-comments-summary"
    });
    const refetch = ()=>{
        footerCommentsRefetch();
        inlineCommentsRefetch();
    };
    return {
        data: {
            footerCommentsSummaryData: footerCommentsSummaryData,
            inlineCommentsSummaryData: inlineCommentsSummaryData
        },
        loading: footerCommentsQueryLoading || inlineCommentsQueryLoading,
        errors: {
            footerCommentsSummaryError: footerCommentsSummaryError,
            inlineCommentsSummaryError: inlineCommentsSummaryError
        },
        refetch: refetch
    };
};


const $ea0c56ea9695a839$export$2f5736e19049ec78 = '775fa156-8bed-4310-af75-c6d1148b88fb';


/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $17fd4a0f0d6084c8$export$e9466e0faeadf399 = /*#__PURE__*/ function(CommentsType) {
    CommentsType["FOOTER"] = "FOOTER";
    CommentsType["INLINE"] = "INLINE";
    return CommentsType;
}({});
var $17fd4a0f0d6084c8$export$5bf35143f8d5729a = /*#__PURE__*/ function(SummaryType) {
    SummaryType["BLOGPOST"] = "BLOGPOST";
    SummaryType["PAGE"] = "PAGE";
    return SummaryType;
}({});



var $lSOAM = parcelRequire("lSOAM");


var $jIOyV = parcelRequire("jIOyV");

const $f6bfaf9677f19070$export$9ad53c330569860e = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.COMMENTS_SUMMARY_COMPONENT_INTERACTION)
});


// eslint-disable-next-line import/order







var $i1t43 = parcelRequire("i1t43");











var $6Pqow = parcelRequire("6Pqow");





var $b3j2Y = parcelRequire("b3j2Y");


var $dL3KX = parcelRequire("dL3KX");


var $53ZHq = parcelRequire("53ZHq");

















var $7Sm4c = parcelRequire("7Sm4c");








const $883f6dcc92761560$export$37675c48b66aa091 = (contentId, source, footerCommentsError, inlineCommentsError)=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { footerCommentsCount: footerCommentsCount, unresolvedInlineCommentsCount: unresolvedInlineCommentsCount } = (0, $cozmU.useContext)((0, $3Am3T.CommentCountsContext));
    const { errorType: footerCommentsErrorType, isExpectedError: footerCommentsIsExpectedError } = (0, $dL3KX.useSummaryErrorHelper)((0, $irVI7.COMMENTS_SUMMARY_EXPERIENCE), footerCommentsError);
    const { errorType: inlineCommentsErrorType, isExpectedError: inlineCommentsIsExpectedError } = (0, $dL3KX.useSummaryErrorHelper)((0, $irVI7.COMMENTS_SUMMARY_EXPERIENCE), inlineCommentsError);
    const { errorType: errorType, commentsType: commentsType } = (0, $cozmU.useMemo)(()=>{
        let memoErrorType;
        let memoCommentsType = [];
        if (footerCommentsError && inlineCommentsError) {
            if (footerCommentsErrorType === inlineCommentsErrorType) memoErrorType = footerCommentsErrorType;
            memoCommentsType = [
                (0, $17fd4a0f0d6084c8$export$e9466e0faeadf399).FOOTER,
                (0, $17fd4a0f0d6084c8$export$e9466e0faeadf399).INLINE
            ];
        } else if (footerCommentsError) {
            memoErrorType = footerCommentsErrorType;
            memoCommentsType = [
                (0, $17fd4a0f0d6084c8$export$e9466e0faeadf399).FOOTER
            ];
        } else if (inlineCommentsError) {
            memoErrorType = inlineCommentsErrorType;
            memoCommentsType = [
                (0, $17fd4a0f0d6084c8$export$e9466e0faeadf399).INLINE
            ];
        }
        return {
            errorType: memoErrorType || (0, $dL3KX.HandledErrorType).GeneralError,
            commentsType: memoCommentsType
        };
    }, [
        inlineCommentsError,
        inlineCommentsErrorType,
        footerCommentsError,
        footerCommentsErrorType
    ]);
    if (footerCommentsIsExpectedError) (0, $7Sm4c.markErrorAsHandled)(footerCommentsError);
    if (inlineCommentsIsExpectedError) (0, $7Sm4c.markErrorAsHandled)(inlineCommentsError);
    // Experience should only be a failure if both queries have erred
    // OR either query has failed when the other query was skipped due to 0 comments
    const isExperienceFailure = footerCommentsError && (inlineCommentsError || unresolvedInlineCommentsCount === 0) || inlineCommentsError && footerCommentsCount === 0;
    const isExpectedError = footerCommentsIsExpectedError && (inlineCommentsIsExpectedError || unresolvedInlineCommentsCount === 0) || inlineCommentsIsExpectedError && footerCommentsCount === 0;
    if (isExperienceFailure) {
        if (isExpectedError) experienceTracker.abort({
            name: (0, $irVI7.COMMENTS_SUMMARY_EXPERIENCE),
            reason: `Can not generate summary due to ${errorType}`,
            attributes: {
                contentId: contentId,
                source: source
            }
        });
        else // Experience tracker can only fail with a single error. Since both queries have failed we will use the footer
        // comments failure to end the experience and pass both types of failures as attributes for further debugging
        experienceTracker.fail({
            name: (0, $irVI7.COMMENTS_SUMMARY_EXPERIENCE),
            // TS does not interpret the isExperienceFailure logic above correctly. Letting the compiler know
            error: footerCommentsError || inlineCommentsError,
            attributes: {
                footerCommentsErrorType: footerCommentsErrorType,
                inlineCommentsErrorType: inlineCommentsErrorType
            }
        });
    }
    return {
        erredQueries: commentsType,
        errorType: errorType,
        shouldCallErrorDisplayForFooterComments: !!footerCommentsError && !footerCommentsIsExpectedError,
        shouldCallErrorDisplayForInlineComments: !!inlineCommentsError && !inlineCommentsIsExpectedError
    };
};


const $6a674942f4f35f24$var$textStyles = (0, $buxP3.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body'
});
const $6a674942f4f35f24$var$i18nBase = (0, $kSwu1.defineMessages)({
    combinedErrorGeneral: {
        id: "ai-comments-summary.comments-summaries-error.combined-error-general",
        defaultMessage: "Atlassian Intelligence can\u2019t provide a summary right now. You can try again later or read more <a>in our support documentation</a>."
    },
    combinedErrorTooMuchContent: {
        id: "ai-comments-summary.comments-summaries-error.combined-error-too-much-content",
        defaultMessage: "There are too many comments for Atlassian Intelligence (AI) to summarize. Try again on content with fewer comments."
    },
    combinedErrorNotEnoughContent: {
        id: "ai-comments-summary.comments-summaries-error.combined-error-too-little-content",
        defaultMessage: "There aren\u2019t enough comments for Atlassian Intelligence (AI) to summarize. Try again when more comments have been added."
    },
    combinedErrorRateLimit: {
        id: "ai-comments-summary.comments-summaries-error.combined-error-rate-limit",
        defaultMessage: "We\u2019ve received too many recent requests for Atlassian Intelligence (AI). Try again in a few minutes or <a>read about excessive use of AI</a>."
    },
    combinedErrorAUPViolation: {
        id: "ai-comments-summary.comments-summaries-error.combined-error-aup-violation",
        defaultMessage: "Atlassian Intelligence (AI) can\u2019t provide a summary of the comments on this content, as some comments may not comply with our <a>Acceptable Use Policy</a>."
    },
    footerCommentsErrorGeneral: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-general",
        defaultMessage: "There is no summary of page comments at this time. You can try again later or read more <a>in our support documentation</a>."
    },
    footerCommentsErrorTooMuchContent: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-too-much-content",
        defaultMessage: "This summary only includes inline comments, as there are too many page comments for Atlassian Intelligence (AI) to summarize."
    },
    footerCommentsErrorNotEnoughContent: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-too-little-content",
        defaultMessage: "This summary only includes inline comments, as there aren\u2019t enough page comments for Atlassian Intelligence (AI) to summarize."
    },
    footerCommentsErrorRateLimit: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-rate-limit",
        defaultMessage: "This summary only includes inline comments, as we\u2019ve received too many page comment summary requests for Atlassian Intelligence (AI). Try again in a few minutes or <a>read about excessive use of AI</a>."
    },
    footerCommentsErrorAUPViolation: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-aup-violation",
        defaultMessage: "This summary only includes inline comments, as some page comments may not comply with Atlassian\u2019s <a>Acceptable Use Policy</a>."
    },
    inlineCommentsErrorGeneral: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-general",
        defaultMessage: "There is no summary of inline comments at this time. You can try again later or read more <a>in our support documentation</a>."
    },
    inlineCommentsErrorTooMuchContent: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-too-much-content",
        defaultMessage: "This summary only includes page comments, as there are too many inline comments for Atlassian Intelligence (AI) to summarize."
    },
    inlineCommentsErrorNotEnoughContent: {
        id: "ai-comments-summary.comments-summaries-error.inline-error-too-little-content",
        defaultMessage: "This summary only includes page comments, as there aren\u2019t enough inline comments for Atlassian Intelligence (AI) to summarize."
    },
    inlineCommentsErrorRateLimit: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-rate-limit",
        defaultMessage: "This summary only includes page comments, as we\u2019ve received too many inline comment summary requests for Atlassian Intelligence (AI). Try again in a few minutes or <a>read about excessive use of AI</a>."
    },
    inlineCommentsErrorAUPViolation: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-aup-violation",
        defaultMessage: "This summary only includes page comments, as some inline comments may not comply with Atlassian\u2019s <a>Acceptable Use Policy</a>."
    }
});
const $6a674942f4f35f24$var$i18nLiveDocs = (0, $kSwu1.defineMessages)({
    footerCommentsErrorGeneral: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-general.livedocs",
        defaultMessage: "There is no summary of general comments at this time. You can try again later or read more <a>in our support documentation</a>."
    },
    footerCommentsErrorTooMuchContent: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-too-much-content.livedocs",
        defaultMessage: "This summary only includes inline comments, as there are too many general comments for Atlassian Intelligence (AI) to summarize."
    },
    footerCommentsErrorNotEnoughContent: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-too-little-content.livedocs",
        defaultMessage: "This summary only includes inline comments, as there aren\u2019t enough general comments for Atlassian Intelligence (AI) to summarize."
    },
    footerCommentsErrorRateLimit: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-rate-limit.livedocs",
        defaultMessage: "This summary only includes inline comments, as we\u2019ve received too many general comment summary requests for Atlassian Intelligence (AI). Try again in a few minutes or <a>read about excessive use of AI</a>."
    },
    footerCommentsErrorAUPViolation: {
        id: "ai-comments-summary.comments-summaries-error.footer-comments-error-aup-violation.livedocs",
        defaultMessage: "This summary only includes inline comments, as some general comments may not comply with Atlassian\u2019s <a>Acceptable Use Policy</a>."
    },
    inlineCommentsErrorTooMuchContent: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-too-much-content.livedocs",
        defaultMessage: "This summary only includes general comments, as there are too many inline comments for Atlassian Intelligence (AI) to summarize."
    },
    inlineCommentsErrorNotEnoughContent: {
        id: "ai-comments-summary.comments-summaries-error.inline-error-too-little-content.livedocs",
        defaultMessage: "This summary only includes general comments, as there aren\u2019t enough inline comments for Atlassian Intelligence (AI) to summarize."
    },
    inlineCommentsErrorRateLimit: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-rate-limit.livedocs",
        defaultMessage: "This summary only includes general comments, as we\u2019ve received too many inline comment summary requests for Atlassian Intelligence (AI). Try again in a few minutes or <a>read about excessive use of AI</a>."
    },
    inlineCommentsErrorAUPViolation: {
        id: "ai-comments-summary.comments-summaries-error.inline-comments-error-aup-violation.livedocs",
        defaultMessage: "This summary only includes general comments, as some inline comments may not comply with Atlassian\u2019s <a>Acceptable Use Policy</a>."
    }
});
const $6a674942f4f35f24$var$i18n = (0, $jhwJP.mergeLiveDocI18n)($6a674942f4f35f24$var$i18nBase, $6a674942f4f35f24$var$i18nLiveDocs);
const $6a674942f4f35f24$export$b0cd94004126f4ff = ({ contentId: contentId, footerCommentsError: footerCommentsError, inlineCommentsError: inlineCommentsError, source: source })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { trackAIResultError: trackAIResultError } = (0, $cFVPs.useAIEventsInstrumentation)();
    const { erredQueries: erredQueries, errorType: errorType, shouldCallErrorDisplayForFooterComments: shouldCallErrorDisplayForFooterComments, shouldCallErrorDisplayForInlineComments: shouldCallErrorDisplayForInlineComments } = (0, $883f6dcc92761560$export$37675c48b66aa091)(contentId, source, footerCommentsError, inlineCommentsError);
    const { footerCommentsCount: footerCommentsCount, unresolvedInlineCommentsCount: unresolvedInlineCommentsCount } = (0, $cozmU.useContext)((0, $3Am3T.CommentCountsContext));
    (0, $cozmU.useEffect)(()=>{
        trackAIResultError({
            aiErrorMessage: errorType,
            // TODO Ideally we should pass the real code from the response
            aiErrorCode: 400
        }, {
            attributes: {
                contentId: contentId,
                errorType: errorType,
                commentsType: erredQueries,
                source: source
            }
        });
    }, [
        erredQueries,
        contentId,
        trackAIResultError,
        errorType,
        source
    ]);
    const onDocsLinkClicked = (linkName)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'commentsSummaryError',
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: `atlassianIntelligence${linkName}DocsLink`,
                attributes: {
                    contentId: contentId,
                    errorType: errorType,
                    commentsType: erredQueries,
                    source: source
                }
            }
        }).fire();
    };
    const errorMessage = ()=>{
        let i18nPrefix = "combined";
        if (footerCommentsError && !inlineCommentsError && unresolvedInlineCommentsCount > 0) i18nPrefix = "footerComments";
        if (inlineCommentsError && !footerCommentsError && footerCommentsCount > 0) i18nPrefix = "inlineComments";
        switch(errorType){
            case (0, $dL3KX.HandledErrorType).TooMuchContent:
                return intl.formatMessage($6a674942f4f35f24$var$i18n[`${i18nPrefix}ErrorTooMuchContent`]);
            case (0, $dL3KX.HandledErrorType).NotEnoughContent:
                return intl.formatMessage($6a674942f4f35f24$var$i18n[`${i18nPrefix}ErrorNotEnoughContent`]);
            case (0, $dL3KX.HandledErrorType).AUPViolation:
                return intl.formatMessage($6a674942f4f35f24$var$i18n[`${i18nPrefix}ErrorAUPViolation`], {
                    a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                            href: (0, $53ZHq.ACCEPTABLE_USE_POLICY_URL),
                            target: "_blank",
                            onClick: ()=>onDocsLinkClicked('AupViolation')
                        }, chunks)
                });
            case (0, $dL3KX.HandledErrorType).RateLimit:
                return intl.formatMessage($6a674942f4f35f24$var$i18n[`${i18nPrefix}ErrorRateLimit`], {
                    a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                            href: (0, $53ZHq.USAGE_LIMITS_DOCS_URL),
                            target: "_blank",
                            onClick: ()=>onDocsLinkClicked('RateLimit')
                        }, chunks)
                });
            default:
                return intl.formatMessage($6a674942f4f35f24$var$i18n[`${i18nPrefix}ErrorGeneral`], {
                    a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                            href: (0, $53ZHq.TROUBLE_SHOOTING_DOCS_URL),
                            target: "_blank",
                            onClick: ()=>onDocsLinkClicked('Troubleshooting')
                        }, chunks)
                });
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $6a674942f4f35f24$var$textStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        as: "p"
    }, errorMessage()), footerCommentsError && shouldCallErrorDisplayForFooterComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: footerCommentsError
    }), inlineCommentsError && shouldCallErrorDisplayForInlineComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: inlineCommentsError
    }));
};


const $28602bba7ed7c957$var$styles = (0, $buxP3.xcss)({
    height: '100%',
    font: 'font.body.large'
});
const $28602bba7ed7c957$var$FooterObjectSidebarStyles = (0, $buxP3.xcss)({
    // Object sidebar padding is 16px, this ensures that the footer isn't cutoff by parent padding
    width: 'calc(100% + 32px)',
    marginLeft: 'space.negative.200'
});
const $28602bba7ed7c957$var$i18nBase = (0, $kSwu1.defineMessages)({
    pageCommentsHeader: {
        id: "ai-comments-summary.combined-comments-summary.page-comments-header",
        defaultMessage: "Page comments"
    },
    inlineCommentsHeader: {
        id: "ai-comments-summary.combined-comments-summary.inline-comments-header",
        defaultMessage: "Inline comments"
    }
});
const $28602bba7ed7c957$var$i18nLiveDocs = (0, $kSwu1.defineMessages)({
    pageCommentsHeader: {
        id: "ai-comments-summary.combined-comments-summary.page-comments-header.livedocs",
        defaultMessage: "General comments"
    }
});
const $28602bba7ed7c957$var$i18n = (0, $jhwJP.mergeLiveDocI18n)($28602bba7ed7c957$var$i18nBase, $28602bba7ed7c957$var$i18nLiveDocs);
var $28602bba7ed7c957$export$92985523ee81b88c = /*#__PURE__*/ function(CommentsSummarySource) {
    CommentsSummarySource["Footer"] = "footer";
    CommentsSummarySource["Header"] = "header";
    CommentsSummarySource["Feed"] = "feed";
    return CommentsSummarySource;
}({});
const $28602bba7ed7c957$export$dd076aaa63869f66 = ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, onRefresh: onRefresh, shouldRefetchCommentsSummary: shouldRefetchCommentsSummary = false, source: source, isInObjectSidebar: isInObjectSidebar, showAIDisclaimer: showAIDisclaimer = true })=>{
    const intl = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { footerCommentsCount: footerCommentsCount, unresolvedInlineCommentsCount: unresolvedInlineCommentsCount } = (0, $cozmU.useContext)((0, $3Am3T.CommentCountsContext));
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $cFVPs.useAIEventsInstrumentation)();
    const containerRef = (0, $cozmU.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $5GgqH.usePopupDwellTime)(containerRef);
    const contentTypeEnum = contentType === 'page' ? (0, $17fd4a0f0d6084c8$export$5bf35143f8d5729a).PAGE : (0, $17fd4a0f0d6084c8$export$5bf35143f8d5729a).BLOGPOST;
    const { data: data, errors: errors, loading: loading, refetch: refetch } = (0, $0edd62bded09ab4f$export$7bdbf0c72871fa1f)({
        contentId: contentId,
        contentType: contentTypeEnum,
        shouldSkipFooterCommentsQuery: footerCommentsCount === 0,
        shouldSkipInlineCommentsQuery: unresolvedInlineCommentsCount === 0
    });
    const refreshHandler = ()=>{
        if (!loading) {
            refetch();
            onRefresh?.();
        }
    };
    const startExperienceTracking = (0, $cozmU.useCallback)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.COMMENTS_SUMMARY_EXPERIENCE),
            attributes: {
                contentId: contentId,
                source: source
            }
        });
        (0, $f6bfaf9677f19070$export$9ad53c330569860e).start();
    }, [
        contentId,
        experienceTracker,
        source
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (loading) startExperienceTracking();
        if (!loading) (0, $f6bfaf9677f19070$export$9ad53c330569860e).stop();
    }, [
        loading,
        startExperienceTracking
    ]);
    const footerCommentsSummary = data.footerCommentsSummaryData?.getCommentsSummary?.summary ?? '';
    const inlineCommentsSummary = data.inlineCommentsSummaryData?.getCommentsSummary?.summary ?? '';
    const loadingRef = (0, $cozmU.useRef)(loading);
    (0, $cozmU.useEffect)(()=>{
        loadingRef.current = loading;
    }, [
        loading
    ]);
    (0, $cozmU.useEffect)(()=>{
        trackAIInteractionInit();
        if (shouldRefetchCommentsSummary) {
            refetch();
            onRefresh?.();
        }
        return ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'dwelled',
                    actionSubject: 'commentsSummary',
                    source: 'commentsSummary',
                    actionSubjectId: 'commentsSummaryDialog',
                    attributes: {
                        contentId: contentId,
                        contentType: contentType,
                        dwellTime: getDwellTime()
                    }
                }
            }).fire();
            if (loadingRef.current) trackAIInteractionDismiss();
        };
    // Only check auto refetch on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const summaryLocale = (0, $cozmU.useMemo)(()=>{
        // Ok to just choose first of whichever is available from data team
        return data.footerCommentsSummaryData?.getCommentsSummary?.language || data.inlineCommentsSummaryData?.getCommentsSummary?.language;
    }, [
        data.footerCommentsSummaryData,
        data.inlineCommentsSummaryData
    ]);
    const commentsType = (0, $cozmU.useMemo)(()=>{
        const commentsTypeCollection = [];
        if (data.footerCommentsSummaryData) commentsTypeCollection.push((0, $161368acfff8028f$export$ec72d0267c37019f).FOOTER);
        if (data.inlineCommentsSummaryData) commentsTypeCollection.push((0, $161368acfff8028f$export$ec72d0267c37019f).INLINE);
        return commentsTypeCollection;
    }, [
        data.footerCommentsSummaryData,
        data.inlineCommentsSummaryData
    ]);
    const feedbackContext = {
        commentsType: commentsType,
        source: source
    };
    const analyticsProperties = {
        source: 'commentsSummary',
        additionalAnalyticsAttributes: {
            commentsType: commentsType
        }
    };
    (0, $cozmU.useEffect)(()=>{
        if (!loading) {
            if (!errors.footerCommentsSummaryError || !errors.inlineCommentsSummaryError) {
                createAnalyticsEvent({
                    type: 'sendScreenEvent',
                    data: {
                        name: 'commentsSummaryContainer',
                        attributes: {
                            contentId: contentId,
                            edition: edition,
                            commentsType: commentsType,
                            summaryLocale: summaryLocale,
                            numPageCommentsSummarized: footerCommentsCount,
                            numInlineCommentsSummarized: unresolvedInlineCommentsCount
                        }
                    }
                }).fire();
                trackAIResultView();
            }
        }
    }, [
        createAnalyticsEvent,
        contentId,
        edition,
        loading,
        commentsType,
        summaryLocale,
        errors.footerCommentsSummaryError,
        errors.inlineCommentsSummaryError,
        footerCommentsCount,
        trackAIResultView,
        unresolvedInlineCommentsCount
    ]);
    const fullTextToCopy = ()=>{
        return `${footerCommentsSummary && `${intl.formatMessage($28602bba7ed7c957$var$i18n.pageCommentsHeader)}\n${footerCommentsSummary}`}\n\n${inlineCommentsSummary && `${intl.formatMessage($28602bba7ed7c957$var$i18n.inlineCommentsHeader)}\n${inlineCommentsSummary}`}`;
    };
    const renderContentBody = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            space: "space.200"
        }, inlineCommentsSummary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "small"
        }, intl.formatMessage($28602bba7ed7c957$var$i18n.inlineCommentsHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $303LV.default), {
            options: {
                disableParsingRawHTML: true
            }
        }, inlineCommentsSummary)), footerCommentsSummary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "small"
        }, intl.formatMessage($28602bba7ed7c957$var$i18n.pageCommentsHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $303LV.default), {
            options: {
                disableParsingRawHTML: true
            }
        }, footerCommentsSummary)), (!errors.footerCommentsSummaryError || !errors.inlineCommentsSummaryError) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.COMMENTS_SUMMARY_EXPERIENCE),
            attributes: {
                contentId: contentId,
                source: source
            }
        }), (errors.footerCommentsSummaryError || errors.inlineCommentsSummaryError) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6a674942f4f35f24$export$b0cd94004126f4ff), {
            contentId: contentId,
            footerCommentsError: errors.footerCommentsSummaryError,
            inlineCommentsError: errors.inlineCommentsSummaryError,
            source: source
        }));
    };
    const renderContent = ()=>{
        if (loading) return isInObjectSidebar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            paddingInline: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $82345f9002994123$export$dd8c26521b6a2fec), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $333270f2f5cd2de3$export$e93f99a4d30f6d75), null);
        const shouldShowFooterError = !!errors.footerCommentsSummaryError && !!errors.inlineCommentsSummaryError || !!errors.footerCommentsSummaryError && inlineCommentsSummary.length === 0 || !!errors.inlineCommentsSummaryError && footerCommentsSummary.length === 0;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            xcss: $28602bba7ed7c957$var$styles,
            spread: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            padding: isInObjectSidebar ? 'space.100' : 'space.250'
        }, source !== "footer" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bbNJt.SummaryPopupScrollableBody), {
            "data-testid": "scrollable-comments-summary"
        }, renderContentBody()) : renderContentBody()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: isInObjectSidebar && $28602bba7ed7c957$var$FooterObjectSidebarStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jP1I.AISummaryFooter), {
            analyticsProperties: analyticsProperties,
            contentId: contentId,
            contentType: contentType,
            spaceKey: spaceKey,
            error: shouldShowFooterError,
            summaryText: fullTextToCopy(),
            showBetaLozenge: true,
            shouldHighlightRefresh: shouldRefetchCommentsSummary,
            refreshHandler: refreshHandler,
            showAIDisclaimer: showAIDisclaimer
        })));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dchHi.FeedbackCollectorPropertiesProvider), {
        entrypointId: (0, $ea0c56ea9695a839$export$2f5736e19049ec78),
        feedbackContext: feedbackContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "comments-summary-content",
        hold: loading
    }), isInObjectSidebar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderContent()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpJCW.AIBorder), {
        loading: loading
    }, renderContent()))));
};
module.exports["CommentsSummarySource"] = $28602bba7ed7c957$export$92985523ee81b88c;
module.exports["CommentsSummaryContent"] = $28602bba7ed7c957$export$dd076aaa63869f66;

});

parcelRegister("lpJCW", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $9ivsj = parcelRequire("9ivsj");


var $8jQuQ = parcelRequire("8jQuQ");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5e4f95acdf8fc4d$var$GradientPropertyContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_39xV02N91d _1mT5xdRAKS _0NUa3rOLYo",
            __cmplp.className
        ])
    });
});
const $f5e4f95acdf8fc4d$var$outerContainerStyles = (0, $buxP3.xcss)({
    overflow: 'hidden',
    position: 'relative',
    background: `conic-gradient(
    from var(--gradient-angle, 45deg),
    #0065FF 10%,
    #0469FF 30%,
    #BF63F3 50%,
    #FFA900 70%,
    #0065FF 90%
  )`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ...(0, $8jQuQ.reduceMotionAsPerUserPreference),
    maxHeight: 'inherit'
});
const $f5e4f95acdf8fc4d$var$animationStyles = (0, $buxP3.xcss)({
    animation: 'rotationAnimation linear 2s infinite'
});
const $f5e4f95acdf8fc4d$var$baseGlowStyles = (0, $buxP3.xcss)({
    position: 'absolute',
    filter: 'blur(25px)',
    opacity: '0.5',
    height: '100%',
    width: '100%'
});
const $f5e4f95acdf8fc4d$var$defaultBorderRadiusStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.large'
});
const $f5e4f95acdf8fc4d$var$modalBorderRadiusStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.small'
});
const $f5e4f95acdf8fc4d$var$innerContainerStyles = (0, $buxP3.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    maxHeight: 'inherit',
    display: 'flex',
    flexDirection: 'column',
    backgroundClip: 'content-box'
});
const $f5e4f95acdf8fc4d$export$6ed1e39f4dbe0bbf = ({ loading: loading = false, children: children, useModalStyles: useModalStyles, hideGlow: hideGlow, customInnerContainerStyles: customInnerContainerStyles, customGlowStyles: customGlowStyles, ...props })=>{
    const isReducedMotion = (0, $9ivsj.useIsReducedMotion)();
    const shouldRotate = loading && !isReducedMotion;
    const containerStyles = shouldRotate ? [
        $f5e4f95acdf8fc4d$var$outerContainerStyles,
        $f5e4f95acdf8fc4d$var$animationStyles
    ] : [
        $f5e4f95acdf8fc4d$var$outerContainerStyles
    ];
    const glowStyles = customGlowStyles ? [
        $f5e4f95acdf8fc4d$var$baseGlowStyles,
        customGlowStyles
    ] : [
        $f5e4f95acdf8fc4d$var$baseGlowStyles
    ];
    const borderRadiusStyles = useModalStyles ? $f5e4f95acdf8fc4d$var$modalBorderRadiusStyles : $f5e4f95acdf8fc4d$var$defaultBorderRadiusStyles;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5e4f95acdf8fc4d$var$GradientPropertyContainer, {
        "data-testid": "ai-border-container",
        ...props
    }, shouldRotate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            ...containerStyles,
            borderRadiusStyles,
            ...hideGlow ? [] : glowStyles
        ],
        testId: "loading-glow"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            ...containerStyles,
            borderRadiusStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        padding: "space.025",
        xcss: [
            $f5e4f95acdf8fc4d$var$innerContainerStyles,
            borderRadiusStyles,
            customInnerContainerStyles
        ]
    }, children)));
};
module.exports["AIBorder"] = $f5e4f95acdf8fc4d$export$6ed1e39f4dbe0bbf;

});

parcelRegister("8jQuQ", function(module, exports) {
/**
 * Use for any CSS based motion (animation or transition).
 * Always put at the end of your declaration for correct use of the cascade.
 * Reduced motion preference is generally set through OS preferences/settings.
 *
 * @deprecated This is not fully compatible with Compiled CSS and will be removed in the future.
 * You should hardcode the `prefers-reduced-motion` media query in your file instead.
 */ const $cfd6e6a22c7a51c3$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
module.exports["reduceMotionAsPerUserPreference"] = $cfd6e6a22c7a51c3$export$f0f789643ba5a83c;

});

parcelRegister("8jP1I", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $fc609ae5f11b40a5$export$409c83e49353f3fb = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "0IK46",
    name: "AISummaryFooter",
    loader: async ()=>(await (parcelRequire("3lbVi"))).AISummaryFooter
});
module.exports["AISummaryFooter"] = $fc609ae5f11b40a5$export$409c83e49353f3fb;

});

parcelRegister("3lbVi", function(module, exports) {

let $26ec94f2c48c166a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $26ec94f2c48c166a$var$load("6wr18"),
    $26ec94f2c48c166a$var$load("i3R6S"),
    $26ec94f2c48c166a$var$load("ffEVr"),
    $26ec94f2c48c166a$var$load("kUbT8")
]).then(()=>parcelRequire('4KbgO'));

});

parcelRegister("dchHi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $bQm3c = parcelRequire("bQm3c");

const $e12d220a6c6e853e$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $e12d220a6c6e853e$export$5b0d1a23cf38988 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $e12d220a6c6e853e$export$eecedbc46bd36460 = ({ children: children, entrypointId: entrypointId, locale: locale, feedbackContextId: feedbackContextId = $e12d220a6c6e853e$var$FEEDBACK_CONTEXT_CF, feedbackContext: feedbackContext = {}, userId: userId, displayName: displayName })=>{
    const { displayName: sessionDisplayName, userId: sessionUserId } = (0, $bQm3c.useSessionData)();
    const { locale: intlLocale } = (0, $kSwu1.useIntl)();
    const feedbackContextString = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${JSON.stringify(value)}`).join(' ');
    const contextValue = (0, $cozmU.useMemo)(()=>({
            entrypointId: entrypointId,
            feedbackContextId: feedbackContextId,
            feedbackContext: feedbackContextString,
            locale: locale || intlLocale,
            userId: userId || sessionUserId || undefined,
            displayName: displayName || sessionDisplayName || undefined
        }), [
        entrypointId,
        feedbackContextId,
        feedbackContextString,
        locale,
        intlLocale,
        userId,
        sessionUserId,
        displayName,
        sessionDisplayName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e12d220a6c6e853e$export$5b0d1a23cf38988.Provider, {
        value: contextValue
    }, children);
};
const $e12d220a6c6e853e$export$e8f7cf9dc2b23528 = ()=>{
    const context = (0, $cozmU.useContext)($e12d220a6c6e853e$export$5b0d1a23cf38988);
    if (context === undefined) throw new Error('useFeedbackCollectorProperties must be used within a FeedbackCollectorPropertiesProvider');
    return context;
};
module.exports["FeedbackCollectorPropertiesProvider"] = $e12d220a6c6e853e$export$eecedbc46bd36460;
module.exports["useFeedbackCollectorProperties"] = $e12d220a6c6e853e$export$e8f7cf9dc2b23528;

});

parcelRegister("bbNJt", function(module, exports) {
/* SummaryPopupScrollableBody.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $d3be62f9dcca5536$export$8fdeb1797011aead = 358;
const $d3be62f9dcca5536$export$3b687fa050c6eb18 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { useMaxHeight: useMaxHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIg20Hp _2WAcuGIZbP _3zvHkHwPeg _1ANEUSzUZr _4ho0wCjOvk _3ILZpPRi7C _2Ins1S8fU6 _0Gam4UDMqu _3ZpBalKcZT",
            __cmplp.useMaxHeight ? "_0NUa3rO3MJ" : "_0NUa3rZqHV",
            __cmplp.className
        ])
    });
});
module.exports["MAX_SUMMARY_HEIGHT"] = $d3be62f9dcca5536$export$8fdeb1797011aead;
module.exports["SummaryPopupScrollableBody"] = $d3be62f9dcca5536$export$3b687fa050c6eb18;

});

parcelRegister("jIOyV", function(module, exports) {
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$eb06363d6ef3b8dd = 'restrictions-dialog';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';
const $4fa41f80373a2ebe$export$576b15c3bba51667 = 'ai-audio-briefing';
module.exports["MORE_ACTIONS_DROPDOWN_INTERACTION"] = $4fa41f80373a2ebe$export$f49429c67898bd15;
module.exports["MOVE_PAGE_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$daaf73616fe91ce9;
module.exports["CONTENT_ANALYTICS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$d4222bce9029f393;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION"] = $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c;
module.exports["RESTRICTIONS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$eb06363d6ef3b8dd;
module.exports["QUICK_SUMMARY_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$ef2fb65c026ab7d3;
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$8122cf0ca2968a7b;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$ea9696a28a6fbc61;
module.exports["COMMENTS_SUMMARY_COMPONENT_INTERACTION"] = $4fa41f80373a2ebe$export$e561726b92a6162d;
module.exports["CREATE_SPACE_DRAWER_INTERACTION"] = $4fa41f80373a2ebe$export$e348981755bdab67;
module.exports["AI_CONTENT_CATCHUP_INTERACTION"] = $4fa41f80373a2ebe$export$7f72b8ffbbbfef58;
module.exports["AI_AUDIO_BRIEFING_INTERACTION"] = $4fa41f80373a2ebe$export$576b15c3bba51667;

});

parcelRegister("dL3KX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6ahXt = parcelRequire("6ahXt");


var $1kHsc = parcelRequire("1kHsc");


var $7Sm4c = parcelRequire("7Sm4c");

const $926c216e16fb1b0c$export$64cc6b1b62510d3 = "Atlassian Intelligence can\u2019t generate a summary for you right now, as there is too much content to summarize.";
const $926c216e16fb1b0c$export$1403052b2e306597 = "Atlassian Intelligence can\u2019t generate a summary for you right now, as there is not enough content to summarize. You can try again later if more is added!";
var $926c216e16fb1b0c$export$6841b1da468d3071 = /*#__PURE__*/ function(HandledErrorType) {
    HandledErrorType["TooMuchContent"] = "tooMuchContent";
    HandledErrorType["NotEnoughContent"] = "notEnoughContent";
    HandledErrorType["RateLimit"] = "rateLimit";
    HandledErrorType["AUPViolation"] = "aupViolation";
    HandledErrorType["GeneralError"] = "generalError";
    return HandledErrorType;
}({});
const $926c216e16fb1b0c$var$ERROR_MAP = {
    [$926c216e16fb1b0c$export$64cc6b1b62510d3]: "tooMuchContent",
    [$926c216e16fb1b0c$export$1403052b2e306597]: "notEnoughContent",
    TOO_MANY_REQUEST: "rateLimit",
    AUP_VIOLATION: "aupViolation"
};
const $926c216e16fb1b0c$var$STREAM_ERROR_MAP = {
    [(0, $6ahXt.ConvoAIErrorMessage).ANSWER_UNAVAILABLE_FOR_CONTENT]: "notEnoughContent",
    [(0, $6ahXt.ConvoAIErrorMessage).NOT_ENOUGH_CONTENT_ERROR]: "notEnoughContent",
    [(0, $6ahXt.ConvoAIErrorMessage).RATE_LIMIT]: "rateLimit",
    [(0, $6ahXt.ConvoAIErrorMessage).ACCEPTABLE_USE_VIOLATIONS]: "aupViolation"
};
const $926c216e16fb1b0c$var$expectedErrorTypes = [
    "tooMuchContent",
    "notEnoughContent",
    "aupViolation"
];
const $926c216e16fb1b0c$export$628a9b3d5b2b9729 = (experienceName, errorFromApolloOrStream)=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { errorType: errorType, isExpectedError: isExpectedError, error: error } = (0, $cozmU.useMemo)(()=>{
        if (!errorFromApolloOrStream) return {
            isExpectedError: false,
            stopExperienceTracking: ()=>{},
            errorType: undefined,
            error: new Error('[useSummaryErrorHelper]: error instance is missing')
        };
        let errorMessageFromGQLorStream = '';
        let errorTypeFromGQLorStream = '';
        if ('graphQLErrors' in errorFromApolloOrStream) {
            // The BE only returns one error (the first that it encounters).
            // Therefore, we don't need to loop through the array, and can just rely on index 0
            errorMessageFromGQLorStream = errorFromApolloOrStream.graphQLErrors[0].message;
            errorTypeFromGQLorStream = $926c216e16fb1b0c$var$ERROR_MAP[errorMessageFromGQLorStream];
            return {
                isExpectedError: $926c216e16fb1b0c$var$expectedErrorTypes.includes(errorTypeFromGQLorStream),
                error: errorFromApolloOrStream,
                errorType: errorTypeFromGQLorStream
            };
        } else {
            errorMessageFromGQLorStream = errorFromApolloOrStream.message.message_template;
            errorTypeFromGQLorStream = $926c216e16fb1b0c$var$STREAM_ERROR_MAP[errorMessageFromGQLorStream];
            return {
                isExpectedError: $926c216e16fb1b0c$var$expectedErrorTypes.includes(errorTypeFromGQLorStream),
                error: new Error(errorFromApolloOrStream.message.content),
                errorType: errorTypeFromGQLorStream
            };
        }
    }, [
        errorFromApolloOrStream
    ]);
    const stopExperienceTracking = ()=>{
        if (isExpectedError) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            experienceTracker.abort({
                name: experienceName,
                reason: `Can not generate summary due to ${errorType}`
            });
        } else experienceTracker.fail({
            name: experienceName,
            error: error
        });
    };
    return {
        isExpectedError: isExpectedError,
        stopExperienceTracking: stopExperienceTracking,
        error: error,
        errorType: errorType
    };
};
module.exports["HandledErrorType"] = $926c216e16fb1b0c$export$6841b1da468d3071;
module.exports["useSummaryErrorHelper"] = $926c216e16fb1b0c$export$628a9b3d5b2b9729;

});

parcelRegister("53ZHq", function(module, exports) {
const $ddccf0ae2c3101d9$export$6c1f59b2f89fe4f1 = 'https://support.atlassian.com/organization-administration/docs/troubleshooting-for-atlassian-intelligence/';
const $ddccf0ae2c3101d9$export$b4fefae0b724683f = 'https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/';
const $ddccf0ae2c3101d9$export$2876254020381b5e = 'https://www.atlassian.com/legal/acceptable-use-policy';
module.exports["TROUBLE_SHOOTING_DOCS_URL"] = $ddccf0ae2c3101d9$export$6c1f59b2f89fe4f1;
module.exports["USAGE_LIMITS_DOCS_URL"] = $ddccf0ae2c3101d9$export$b4fefae0b724683f;
module.exports["ACCEPTABLE_USE_POLICY_URL"] = $ddccf0ae2c3101d9$export$2876254020381b5e;

});

parcelRegister("auLW1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $b253f08be2669ace$export$c463287b61deee24 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "wRZLE",
    name: "PageCatchupComponent",
    loader: async ()=>(await (parcelRequire("9wm9e"))).PageCatchupComponentWithErrorBoundary
});
module.exports["PageCatchupComponent"] = $b253f08be2669ace$export$c463287b61deee24;

});

parcelRegister("9wm9e", function(module, exports) {

let $6ee848573ed95052$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6ee848573ed95052$var$load("fEHF5"),
    $6ee848573ed95052$var$load("52ZTT"),
    $6ee848573ed95052$var$load("b0ARW"),
    $6ee848573ed95052$var$load("7EorR"),
    $6ee848573ed95052$var$load("hhss7"),
    $6ee848573ed95052$var$load("eN6nL")
]).then(()=>parcelRequire('4RbVT'));

});

parcelRegister("eN3MW", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $bee98af9586f2941$export$e6e415a985158eb3 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EZkxH",
    name: "QuickSummaryStreamingComponent",
    loader: async ()=>(await (parcelRequire("f5LuS"))).QuickSummaryStreamingEntryPoint
});
module.exports["QuickSummaryStreamingComponent"] = $bee98af9586f2941$export$e6e415a985158eb3;

});

parcelRegister("f5LuS", function(module, exports) {

let $afcc2a8cde8a61cd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $afcc2a8cde8a61cd$var$load("52ZTT"),
    $afcc2a8cde8a61cd$var$load("hcY7w"),
    $afcc2a8cde8a61cd$var$load("6wr18"),
    $afcc2a8cde8a61cd$var$load("i3R6S"),
    $afcc2a8cde8a61cd$var$load("kUbT8"),
    $afcc2a8cde8a61cd$var$load("b0ARW"),
    $afcc2a8cde8a61cd$var$load("4nZ85"),
    $afcc2a8cde8a61cd$var$load("ariuh"),
    $afcc2a8cde8a61cd$var$load("hhss7"),
    $afcc2a8cde8a61cd$var$load("kHXvF"),
    $afcc2a8cde8a61cd$var$load("ffEVr"),
    $afcc2a8cde8a61cd$var$load("jrchu")
]).then(()=>parcelRequire('9zqwo'));

});

parcelRegister("brrvF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1ytiN = parcelRequire("1ytiN");


var $42MJM = parcelRequire("42MJM");


var $ffOSw = parcelRequire("ffOSw");


var $fvOg5 = parcelRequire("fvOg5");

const $a68160926e693700$var$i18n = (0, $kSwu1.defineMessages)({
    headerText: {
        id: "quick-summary.upsell.header.text",
        defaultMessage: "Improve productivity with Rovo"
    },
    headerTextAdmin: {
        id: "quick-summary.upsell.header.text.admin",
        defaultMessage: "Improve team productivity with Rovo"
    },
    learnMoreLinkTextUser: {
        id: "quick-summary.upsell.learn-more.link.text.user",
        defaultMessage: "Learn more about Rovo"
    },
    bodyTextAdmin: {
        id: "quick-summary.upsell.body.text.admin",
        defaultMessage: "Save time with page summaries, create and organize ideas efficiently, and get smarter, relevant search results you can act on. Upgrade to Premium"
    },
    bodyTextUser: {
        id: "quick-summary.upsell.body.text.user",
        defaultMessage: "Save time with page summaries, create and organize ideas efficiently, and get smarter, relevant search results you can act on. Try Rovo today"
    }
});
const $a68160926e693700$export$37172947b8f9cb48 = 'https://www.atlassian.com/software/rovo/guides/end-user-guide/introduction';
const $a68160926e693700$export$9f5718677d288e24 = 'https://www.atlassian.com/software/rovo/guides/admin-guide/introduction';
const $a68160926e693700$export$f552fbd4bef744fa = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    const { isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const headerText = isSiteAdmin ? intl.formatMessage($a68160926e693700$var$i18n.headerTextAdmin) : intl.formatMessage($a68160926e693700$var$i18n.headerText);
    const bodyText = isSiteAdmin ? intl.formatMessage($a68160926e693700$var$i18n.bodyTextAdmin) : intl.formatMessage($a68160926e693700$var$i18n.bodyTextUser);
    const learnMoreLink = isSiteAdmin ? $a68160926e693700$export$9f5718677d288e24 : $a68160926e693700$export$37172947b8f9cb48;
    const learnMoreText = intl.formatMessage($a68160926e693700$var$i18n.learnMoreLinkTextUser);
    const learnMoreLinkProps = (0, $cozmU.useMemo)(()=>({
            href: learnMoreLink,
            message: learnMoreText
        }), [
        learnMoreLink,
        learnMoreText
    ]);
    const imageProps = (0, $cozmU.useMemo)(()=>({
            src: {
                default: (0, (/*@__PURE__*/$parcel$interopDefault($ffOSw))),
                dark: (0, (/*@__PURE__*/$parcel$interopDefault($fvOg5)))
            },
            alt: ''
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $42MJM.AIUpsell), {
        title: headerText,
        body: bodyText,
        feature: "quickSummary",
        learnMoreLink: learnMoreLinkProps,
        image: imageProps
    });
};
module.exports["QuickSummaryUpsell"] = $a68160926e693700$export$f552fbd4bef744fa;

});

parcelRegister("ffOSw", function(module, exports) {
module.exports = new URL("quickSummaryUpsellBannerLight.edcc3647.svg", import.meta.url).toString();

});

parcelRegister("fvOg5", function(module, exports) {
module.exports = new URL("quickSummaryUpsellBannerDark.e27429f6.svg", import.meta.url).toString();

});

parcelRegister("eNjW4", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $3ricL = parcelRequire("3ricL");


var $8dwdz = parcelRequire("8dwdz");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $a42f1b873e59961a$export$9cca7cb3443dfd1 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    const isLoomFeatureEnabled = (0, $3ricL.isFeatureEnabled)("confluence", "confluence-loom-integration");
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    if (!isLoomFeatureEnabled) return true;
    if (isMobile) return true;
    return false;
} : ()=>{
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    const isLoomFeatureEnabled = (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-loom-integration');
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    // Disable when feature is not enabled in current environment/evaluation
    if (!isLoomFeatureEnabled) return true;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    if (isMobile) return true;
    return false;
};
module.exports["useIsLoomDisabled"] = $a42f1b873e59961a$export$9cca7cb3443dfd1;

});

parcelRegister("dppWL", function(module, exports) {
/* eslint-disable @typescript-eslint/consistent-type-imports */ var $56fbda2769629a59$export$50526ee9b1846f6c = /*#__PURE__*/ function(RegisteredExperience) {
    RegisteredExperience["VIEW_PAGE"] = "view-page";
    RegisteredExperience["EDIT_PAGE"] = "edit-page";
    RegisteredExperience["WHITEBOARD"] = "whiteboard";
    RegisteredExperience["SEARCH_PAGE"] = "search-page";
    RegisteredExperience["HOME"] = "home";
    RegisteredExperience["FOLDER"] = "folder";
    return RegisteredExperience;
}({});
const $56fbda2769629a59$export$1e3f84bae31640f2 = (props)=>'actionsToRender' in props;
const $56fbda2769629a59$export$73c8d1f99070570a = (props)=>'actionsToRender' in props;
const $56fbda2769629a59$export$9fdd72360ade08c0 = (props)=>'contentType' in props;
const $56fbda2769629a59$export$b8a252bbcf90a2cb = (props)=>'getSearchQuery' in props;
module.exports["RegisteredExperience"] = $56fbda2769629a59$export$50526ee9b1846f6c;
module.exports["isWhiteboardRovoConfigProviderProps"] = $56fbda2769629a59$export$1e3f84bae31640f2;
module.exports["isFolderRovoConfigProviderProps"] = $56fbda2769629a59$export$73c8d1f99070570a;
module.exports["isPageRovoConfigProviderProps"] = $56fbda2769629a59$export$9fdd72360ade08c0;

});

parcelRegister("3tUdX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dppWL = parcelRequire("dppWL");


var $amW67 = parcelRequire("amW67");


var $8hjAS = parcelRequire("8hjAS");

const $f4bf02d66e85d52a$export$44a9046b553a8167 = (props)=>{
    if (props.experience === (0, $dppWL.RegisteredExperience).WHITEBOARD && !(0, $dppWL.isWhiteboardRovoConfigProviderProps)(props)) return null;
    if (props.experience === (0, $dppWL.RegisteredExperience).FOLDER && !(0, $dppWL.isFolderRovoConfigProviderProps)(props)) return null;
    if ((props.experience === (0, $dppWL.RegisteredExperience).VIEW_PAGE || props.experience === (0, $dppWL.RegisteredExperience).EDIT_PAGE) && !(0, $dppWL.isPageRovoConfigProviderProps)(props)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $amW67.RovoConfigProviderContextProvider), {
        value: props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8hjAS.RovoCurrentConfigProvider), {
        provider: props.provider
    }));
};
module.exports["RovoConfigProvider"] = $f4bf02d66e85d52a$export$44a9046b553a8167;

});

parcelRegister("amW67", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $23a8183fa434531d$var$RovoConfigProviderContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $23a8183fa434531d$export$3ae1f97e9390a638 = ()=>{
    const context = (0, $cozmU.useContext)($23a8183fa434531d$var$RovoConfigProviderContext);
    if (!context) throw new Error('useRovoConfigProviderProps must be used within an RovoConfigProviderContext.Provider');
    return context;
};
const $23a8183fa434531d$export$45b0916bb24b31be = ({ children: children, value: value })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($23a8183fa434531d$var$RovoConfigProviderContext.Provider, {
        value: value
    }, children);
};
module.exports["useRovoConfigProviderProps"] = $23a8183fa434531d$export$3ae1f97e9390a638;
module.exports["RovoConfigProviderContextProvider"] = $23a8183fa434531d$export$45b0916bb24b31be;

});

parcelRegister("8hjAS", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $cozmU = parcelRequire("cozmU");


var $a1L5E = parcelRequire("a1L5E");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $8MKuN = parcelRequire("8MKuN");


var $6mKj3 = parcelRequire("6mKj3");


var $5ruin = parcelRequire("5ruin");

const $4d3968fc98119c84$export$9ef355ca939f0be9 = ({ provider: provider })=>{
    const { resetConfiguration: resetConfiguration, setConfiguration: setConfiguration } = (0, $5ruin.useRovoCurrentConfigStoreActions)();
    (0, $cozmU.useEffect)(()=>{
        if (!provider) resetConfiguration();
        return ()=>{
            resetConfiguration();
        };
    }, [
        resetConfiguration,
        provider
    ]);
    if (!provider) return null;
    const ActiveProviderComponent = provider;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "rovo-current-configuration-provider"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ActiveProviderComponent, {
        setConfiguration: setConfiguration
    })));
    return (0, $6mKj3.expVal)('confluence_edit_page_conditional_ufohold_ignore', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8MKuN.ConditionalUfoHoldIgnore), null, content) : content;
};
module.exports["RovoCurrentConfigProvider"] = $4d3968fc98119c84$export$9ef355ca939f0be9;

});

parcelRegister("8MKuN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $a33Aa = parcelRequire("a33Aa");


var $jb2gB = parcelRequire("jb2gB");

const $88668855474bc367$export$27cee8d00af73bce = [
    'edit-page.page_load',
    'edit-page.transition',
    'space-overview-edit-page.page_load',
    'space-overview-edit-page.transition',
    'live-edit.page_load',
    'live-edit.transition'
];
function $88668855474bc367$export$2510d15b8c74a469({ children: children, excludedInteractions: excludedInteractions = $88668855474bc367$export$27cee8d00af73bce }) {
    // Capture the interaction once at mount time to ensure stable behavior for the
    // component's lifetime. getActiveInteraction() can return null mid-render cycle
    // if the UFO interaction ends, which would cause the ignore prop to toggle
    // between renders and effectively un-ignore the hold on a subsequent re-render.
    const ignoreHoldsRef = (0, $cozmU.useRef)(null);
    if (ignoreHoldsRef.current === null) {
        const interaction = (0, $a33Aa.getActiveInteraction)();
        if (interaction) {
            const { type: type, ufoName: ufoName } = interaction;
            ignoreHoldsRef.current = excludedInteractions.includes(`${ufoName}.${type}`);
        } else ignoreHoldsRef.current = false;
    }
    const ignoreHolds = ignoreHoldsRef.current ?? false;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jb2gB.default), {
        ignore: ignoreHolds
    }, children);
}
module.exports["ConditionalUfoHoldIgnore"] = $88668855474bc367$export$2510d15b8c74a469;

});

parcelRegister("5ruin", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $2b71e6bc29f732db$var$noopConfiguration = {
    getActions: async ()=>[]
};
const $2b71e6bc29f732db$var$initialState = {
    configuration: $2b71e6bc29f732db$var$noopConfiguration
};
const $2b71e6bc29f732db$var$actions = {
    setConfiguration: (configuration)=>({ setState: setState })=>{
            setState({
                configuration: configuration
            });
        },
    resetConfiguration: ()=>({ setState: setState })=>{
            setState({
                configuration: $2b71e6bc29f732db$var$noopConfiguration
            });
        },
    updateConfiguration: (configuration)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                configuration: {
                    ...state.configuration,
                    ...configuration
                }
            });
        }
};
const $2b71e6bc29f732db$export$e0afd2e658e4f7ce = (0, $8s9DV.createStore)({
    initialState: $2b71e6bc29f732db$var$initialState,
    actions: $2b71e6bc29f732db$var$actions,
    name: 'RovoCurrentConfigStore'
});
const $2b71e6bc29f732db$export$2cefdfe72db08be4 = (0, $kBr4q.createActionsHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce);
const $2b71e6bc29f732db$export$d7809b5c7bef1f6d = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration
});
const $2b71e6bc29f732db$export$897f16b7b08b0ac = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.getActions
});
const $2b71e6bc29f732db$export$1e0546f83460b30d = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.tags
});
const $2b71e6bc29f732db$export$2a73ca2333c94154 = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.customGreeting
});
const $2b71e6bc29f732db$export$9d0f592eafe765c0 = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.shouldShowGreeting
});
const $2b71e6bc29f732db$export$6745aa6ec6db525a = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.prioritizeCustomActionResults
});
const $2b71e6bc29f732db$export$77b1364ae13e9bf5 = (0, $kBr4q.createStateHook)($2b71e6bc29f732db$export$e0afd2e658e4f7ce, {
    selector: (state)=>state.configuration.numStartersToShow
});
module.exports["useRovoCurrentConfigStoreActions"] = $2b71e6bc29f732db$export$2cefdfe72db08be4;
module.exports["useRovoConfigGetActions"] = $2b71e6bc29f732db$export$897f16b7b08b0ac;
module.exports["useRovoConfigTags"] = $2b71e6bc29f732db$export$1e0546f83460b30d;
module.exports["useRovoConfigCustomGreeting"] = $2b71e6bc29f732db$export$2a73ca2333c94154;
module.exports["useRovoConfigShouldShowGreeting"] = $2b71e6bc29f732db$export$9d0f592eafe765c0;
module.exports["useRovoConfigPrioritizeCustomActionResults"] = $2b71e6bc29f732db$export$6745aa6ec6db525a;
module.exports["useRovoConfigNumStartersToShow"] = $2b71e6bc29f732db$export$77b1364ae13e9bf5;

});

parcelRegister("bXh4X", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $5251c9f91178493b$export$d4c72bab9d6cc13a = {
    nudges: [],
    dailyBriefUnread: null,
    isNudgeVisible: false
};
const $5251c9f91178493b$export$e324594224ef24da = {
    setNudges: (nudges)=>({ setState: setState })=>{
            setState({
                nudges: nudges
            });
        },
    setButtonClickedTimestamp: (buttonClickedTimestamp)=>({ setState: setState })=>{
            setState({
                buttonClickedTimestamp: buttonClickedTimestamp
            });
        },
    setDailyBriefUnread: (dailyBriefUnread)=>({ setState: setState })=>{
            setState({
                dailyBriefUnread: dailyBriefUnread
            });
        },
    setIsNudgeVisible: (isNudgeVisible)=>({ setState: setState })=>{
            setState({
                isNudgeVisible: isNudgeVisible
            });
        }
};
const $5251c9f91178493b$export$72552b26ebb37b2 = (0, $8s9DV.createStore)({
    initialState: $5251c9f91178493b$export$d4c72bab9d6cc13a,
    actions: $5251c9f91178493b$export$e324594224ef24da,
    name: 'AISmartButtonStore'
});
const $5251c9f91178493b$export$af36d029992e7a8c = (0, $kBr4q.createActionsHook)($5251c9f91178493b$export$72552b26ebb37b2);
module.exports["AISmartButtonStore"] = $5251c9f91178493b$export$72552b26ebb37b2;
module.exports["useAISmartButtonActions"] = $5251c9f91178493b$export$af36d029992e7a8c;

});

parcelRegister("k9SyR", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $bXh4X = parcelRequire("bXh4X");

const $4a243273df5696f3$export$b854997b7299d67f = (0, $kBr4q.createStateHook)((0, $bXh4X.AISmartButtonStore), {
    selector: (state)=>state.nudges
});
const $4a243273df5696f3$export$9af0fbebebbfec35 = (0, $kBr4q.createStateHook)((0, $bXh4X.AISmartButtonStore), {
    selector: (state)=>state.buttonClickedTimestamp
});
const $4a243273df5696f3$export$2d43c7fdbd36cd6c = (0, $kBr4q.createStateHook)((0, $bXh4X.AISmartButtonStore), {
    selector: (state)=>state.dailyBriefUnread
});
const $4a243273df5696f3$export$17170223ff11d032 = (0, $kBr4q.createStateHook)((0, $bXh4X.AISmartButtonStore), {
    selector: (state)=>state.isNudgeVisible
});
module.exports["useAINudges"] = $4a243273df5696f3$export$b854997b7299d67f;
module.exports["useDailyBriefUnread"] = $4a243273df5696f3$export$2d43c7fdbd36cd6c;
module.exports["useIsNudgeVisible"] = $4a243273df5696f3$export$17170223ff11d032;

});

parcelRegister("58cpY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::638903f1830b7e0883391ef492d7a343>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3bc7550dcb3a0996$var$_react = $3bc7550dcb3a0996$var$_interopRequireDefault((parcelRequire("cozmU")));

var $3bc7550dcb3a0996$var$_baseNew = $3bc7550dcb3a0996$var$_interopRequireDefault((parcelRequire("gElAV")));
function $3bc7550dcb3a0996$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeAudioBriefing".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-generative-audio-briefing
 * Usage guidance:
 * Reserved for Audio Briefings, a new feature launching within Confluence to help people develop an expanded awareness on a topic by generating AI-powered podcasts about their work.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3bc7550dcb3a0996$var$AiGenerativeAudioBriefingIcon = (props)=>/*#__PURE__*/ $3bc7550dcb3a0996$var$_react.default.createElement($3bc7550dcb3a0996$var$_baseNew.default, Object.assign({
        name: "AiGenerativeAudioBriefingIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0c.97 0 1.88.2 2.72.55l-.24.09c-.52.19-.93.56-1.19 1.02A5.5 5.5 0 0 0 2.5 7v.71A2.5 2.5 0 0 1 6 10v3.08A1.92 1.92 0 0 1 4.08 15 3.08 3.08 0 0 1 1 12V7a7 7 0 0 1 7-7M3.5 9a1 1 0 0 0-1 1v1.92c0 .87.71 1.58 1.58 1.58.23 0 .42-.19.42-.42V10a1 1 0 0 0-1-1m11.46-2.78Q15 6.6 15 7v5a3.08 3.08 0 0 1-3.08 3A1.92 1.92 0 0 1 10 13.08V10a2.5 2.5 0 0 1 3.5-2.29v-.73a2.25 2.25 0 0 0 1.46-.77M12.5 9a1 1 0 0 0-1 1v3.08c0 .23.19.42.42.42.87 0 1.58-.71 1.58-1.58V10a1 1 0 0 0-1-1" clip-rule="evenodd"/><path fill="currentcolor" d="M13.365.009a.75.75 0 0 1 .541.378l.05.106.334.92a.5.5 0 0 0 .298.297l.919.335a.75.75 0 0 1 0 1.41l-.92.335a.5.5 0 0 0-.297.298l-.335.919a.75.75 0 0 1-1.41 0l-.335-.92a.5.5 0 0 0-.298-.297l-.919-.335a.75.75 0 0 1-.484-.589L10.5 2.75l.009-.116a.75.75 0 0 1 .484-.59l.92-.334a.5.5 0 0 0 .297-.298l.335-.919A.75.75 0 0 1 13.249 0z"/>`
    }, props));
$3bc7550dcb3a0996$var$AiGenerativeAudioBriefingIcon.displayName = 'AiGenerativeAudioBriefingIcon';
var $3bc7550dcb3a0996$var$_default = module.exports.default = $3bc7550dcb3a0996$var$AiGenerativeAudioBriefingIcon;

});

parcelRegister("6iWVH", function(module, exports) {
var $b76a5cfcb2493fac$export$87497e63e164f4b3 = /*#__PURE__*/ function(HandleActionType) {
    HandleActionType["Base"] = "Base";
    HandleActionType["Chat"] = "Chat";
    HandleActionType["Nested"] = "Nested";
    HandleActionType["Skill"] = "Skill";
    return HandleActionType;
}({});
const $b76a5cfcb2493fac$export$c91e07269f22915a = new Set([
    'invite-users',
    'grant-app-access',
    'manage-user-access',
    'troubleshoot-invitation-errors',
    'troubleshoot-user-access',
    'troubleshoot-user-provisioning',
    'troubleshoot-single-sign-on',
    'review-api-security',
    'policy-assist'
]);
var $b76a5cfcb2493fac$export$7f7a6f1c2ab5127 = /*#__PURE__*/ function(PageContextType) {
    PageContextType["ADMIN_HUB"] = "admin-hub";
    PageContextType["BITBUCKET"] = "bitbucket";
    PageContextType["BITBUCKET_PULL_REQUEST"] = "bitbucket-pull-request";
    PageContextType["BITBUCKET_CREATE_PULL_REQUEST"] = "bitbucket-create-pull-request";
    PageContextType["BITBUCKET_PIPELINES"] = "bitbucket-pipelines";
    PageContextType["BITBUCKET_REPOSITORY_SOURCE"] = "bitbucket-repository-source";
    PageContextType["CONFLUENCE_HOME"] = "confluence-home";
    PageContextType["CONFLUENCE_PAGE_VIEW"] = "confluence-page-view";
    PageContextType["CONFLUENCE_PAGE_EDIT"] = "confluence-page-edit";
    PageContextType["CONFLUENCE_BLOG_VIEW"] = "confluence-blog-view";
    PageContextType["CONFLUENCE_BLOG_EDIT"] = "confluence-blog-edit";
    PageContextType["CONFLUENCE_WHITEBOARD"] = "confluence-whiteboard";
    PageContextType["JIRA_HOME"] = "jira-home";
    PageContextType["JIRA_FOR_YOU"] = "jira-for-you";
    PageContextType["JIRA_ISSUE_VIEW"] = "jira-issue-view";
    PageContextType["JIRA_PROJECT"] = "jira-project";
    PageContextType["JIRA_BOARD"] = "jira-board";
    PageContextType["JIRA_BACKLOG"] = "jira-backlog";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY"] = "jira-cmp-space-settings-people-legacy";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PERMISSIONS_LEGACY"] = "jira-cmp-space-settings-permissions-legacy";
    PageContextType["JIRA_TMP_SPACE_SETTINGS_ACCESS"] = "jira-tmp-space-settings-access";
    PageContextType["JSM_INCIDENT_VIEW"] = "jsm-incident-view";
    PageContextType["JSM_INCIDENT_LIST_VIEW"] = "jsm-incident-list-view";
    PageContextType["JSM_ALERT_VIEW"] = "jsm-alert-view";
    PageContextType["JSM_ALERT_LIST_VIEW"] = "jsm-alert-list-view";
    PageContextType["JSM_ALERT_GROUP_DETAIL_VIEW"] = "jsm-alert-group-detail-view";
    PageContextType["ATLAS_HOME"] = "atlas-home";
    PageContextType["ATLAS_HOME_MAIN"] = "atlas-home-main";
    PageContextType["ATLAS_HOME_DISCOVER"] = "atlas-home-discover";
    PageContextType["ATLAS_HOME_RECENTS"] = "atlas-home-recents";
    PageContextType["ATLAS_HOME_FULL_PAGE_NOTIFICATIONS"] = "atlas-home-full-page-notifications";
    PageContextType["ATLAS_HOME_PROJECT_UPDATES_LIST"] = "atlas-home-project-updates-list";
    PageContextType["ATLAS_HOME_GOAL_UPDATES_LIST"] = "atlas-home-goal-updates-list";
    PageContextType["ATLAS_HOME_TEAM_UPDATES_LIST"] = "atlas-home-team-updates-list";
    PageContextType["ATLAS_HOME_TAG_UPDATES_LIST"] = "atlas-home-tag-updates-list";
    PageContextType["FOCUS"] = "focus";
    PageContextType["FOCUS_FOR_YOU"] = "focus-for-you";
    PageContextType["FOCUS_FOCUS_AREA_PAGE"] = "focus-focus-area-page";
    PageContextType["FOCUS_FOCUS_AREA_GOAL_VIEW"] = "focus-focus-area-goal-view";
    PageContextType["FOCUS_FOCUS_AREA_WORK_VIEW"] = "focus-focus-area-work-view";
    PageContextType["FOCUS_FOCUS_AREA_FUNDS_VIEW"] = "focus-focus-area-funds-view";
    PageContextType["SAC"] = "sac";
    PageContextType["TRELLO_BOARD"] = "trello-board";
    PageContextType["TRELLO_CARD"] = "trello-card";
    PageContextType["STUDIO_AGENT_BUILDER"] = "studio-agent-builder";
    PageContextType["UNKNOWN"] = "unknown";
    return PageContextType;
}({});
const $b76a5cfcb2493fac$export$4f757e7d9540e8f9 = 'prompt-of-day';
module.exports["HandleActionType"] = $b76a5cfcb2493fac$export$87497e63e164f4b3;
module.exports["LEGACY_DYNAMIC_SKILL_IDS"] = $b76a5cfcb2493fac$export$c91e07269f22915a;
module.exports["PageContextType"] = $b76a5cfcb2493fac$export$7f7a6f1c2ab5127;

});

parcelRegister("dWpd3", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $eb4732679a1ccd43$var$initialState = {
    activeContent: null,
    eligibleForChangeboarding: false
};
const $eb4732679a1ccd43$var$actions = {
    setActiveContent: (activeContent)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            return setState({
                ...state,
                activeContent: activeContent
            });
        },
    setEligibleForChangeboarding: (eligibleForChangeboarding)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            return setState({
                ...state,
                eligibleForChangeboarding: eligibleForChangeboarding
            });
        }
};
const $eb4732679a1ccd43$var$AudioButtonWrapperStore = (0, $8s9DV.createStore)({
    name: 'AudioButtonWrapperStore',
    initialState: $eb4732679a1ccd43$var$initialState,
    actions: $eb4732679a1ccd43$var$actions
});
const $eb4732679a1ccd43$export$ab1ee966cd621cb0 = (0, $kBr4q.createStateHook)($eb4732679a1ccd43$var$AudioButtonWrapperStore, {
    selector: (state)=>({
            activeContent: state.activeContent,
            eligibleForChangeboarding: state.eligibleForChangeboarding
        })
});
const $eb4732679a1ccd43$export$9980b31ff728dec1 = (0, $kBr4q.createActionsHook)($eb4732679a1ccd43$var$AudioButtonWrapperStore);
module.exports["useAudioButtonWrapperStore"] = $eb4732679a1ccd43$export$ab1ee966cd621cb0;
module.exports["useAudioButtonWrapperActions"] = $eb4732679a1ccd43$export$9980b31ff728dec1;

});

parcelRegister("1AJi3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dPoYT = parcelRequire("dPoYT");


var $kQqCc = parcelRequire("kQqCc");


var $93Gae = parcelRequire("93Gae");


var $2bR8c = parcelRequire("2bR8c");


var $jln20 = parcelRequire("jln20");

const $ca70225f28efd254$export$a81c3fee0d63dde7 = ()=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { panelId: panelId } = rightSidebarContext.getCurrent() || {};
    const { mode: mode, isMiniModalAvailable: isMiniModalAvailable, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, openConversationAssistantUIMode: openConversationAssistantUIMode } = (0, $93Gae.useRovoExperienceAPIStore)();
    const isConversationAssistantSidebarActive = panelId === (0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_ID);
    const sidebarApi = (0, $2bR8c.useCreateRovoExperienceSidebarController)();
    const toggleConversationAssistant = (0, $cozmU.useCallback)((openChatMode = 'sidebar', autoFocusInput = true)=>{
        toggleConversationAssistantUIMode({
            targetMode: openChatMode === 'mini-modal' && isMiniModalAvailable ? (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL : (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR,
            sidebarApi: sidebarApi,
            autoFocusInput: autoFocusInput
        });
    }, [
        toggleConversationAssistantUIMode,
        sidebarApi,
        isMiniModalAvailable
    ]);
    const openConversationAssistant = (0, $cozmU.useCallback)((openChatMode = 'sidebar', autoFocusInput = true)=>{
        openConversationAssistantUIMode({
            targetMode: openChatMode === 'mini-modal' && isMiniModalAvailable ? (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL : (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR,
            sidebarApi: sidebarApi,
            autoFocusInput: autoFocusInput
        });
    }, [
        openConversationAssistantUIMode,
        sidebarApi,
        isMiniModalAvailable
    ]);
    return (0, $cozmU.useMemo)(()=>({
            mode: mode,
            toggleConversationAssistant: toggleConversationAssistant,
            openConversationAssistant: openConversationAssistant,
            isConversationAssistantSidebarActive: isConversationAssistantSidebarActive
        }), [
        mode,
        toggleConversationAssistant,
        openConversationAssistant,
        isConversationAssistantSidebarActive
    ]);
};
module.exports["useToggleConversationAssistant"] = $ca70225f28efd254$export$a81c3fee0d63dde7;

});

parcelRegister("eDWhq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $85mU8 = parcelRequire("85mU8");

const $d70864677eee19d7$export$a74fbbd6fb01001c = (clientId, setupHandlers, apiInstance = (0, $85mU8.getBrowserBridgeAPI)())=>{
    const refApi = (0, $cozmU.useRef)(apiInstance);
    const refReady = (0, $cozmU.useRef)(false);
    const refMount = (0, $cozmU.useRef)(setupHandlers);
    const api = refApi.current;
    const setup = (0, $cozmU.useCallback)(()=>{
        // register all handlers
        // devx: provide current `clientId`
        setupHandlers?.((command, handler)=>api.on(clientId, command, handler));
    }, [
        clientId,
        setupHandlers,
        api
    ]);
    const ready = (0, $cozmU.useCallback)(()=>{
        // setup all handlers
        setup();
        // mark client as ready
        api.ready(clientId);
        // now, the client can receive messages AND handle them
        refReady.current = true;
    }, [
        clientId,
        setup,
        api
    ]);
    const send = (0, $cozmU.useCallback)((command_0, params)=>{
        // devx: provide current `clientId`
        return api.send(command_0, {
            ...params,
            senderId: clientId
        });
    }, [
        clientId,
        api
    ]);
    const broadcast = (0, $cozmU.useCallback)((command_1, params_0, options)=>{
        api.broadcast(command_1, params_0, options);
    }, [
        api
    ]);
    const teardown = (0, $cozmU.useCallback)(()=>{
        // devx: provide current `clientId`
        return api.teardown(clientId);
    }, [
        clientId,
        api
    ]);
    (0, $cozmU.useEffect)(()=>{
        // teardown if component tree is being destroyed
        // note: will also tear down all command handlers on your behalf
        return ()=>api.teardown(clientId);
    }, [
        clientId,
        api
    ]);
    /**
   * If we have already mounted our handlers once and marked ourselves as ready, then this
   * bridge API client is already capable of receiving & handling commands. On subsequent renders
   * if our {@link setupHandlers} reference changes, we need to make sure we run our setup again.
   *
   * This will ensure the newest state of every handler is being used, with no stale references
   * in closures, as can often occur with initialise-only-once code in React.
   */ if (refReady.current && refMount.current !== setupHandlers) setup();
    // so we can compare on next render
    refMount.current = setupHandlers;
    return {
        id: api.id,
        ready: ready,
        send: send,
        teardown: teardown,
        broadcast: broadcast
    };
};
module.exports["useRovoContentBridgeAPI"] = $d70864677eee19d7$export$a74fbbd6fb01001c;

});

parcelRegister("02cx8", function(module, exports) {
/* eslint-disable object-shorthand */ 
var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $4c5988c837301b49$export$d4c72bab9d6cc13a = {
    actions: [],
    agentMentionId: null,
    agentMentionInsertionCount: 0,
    resolvedAgentMentionId: null,
    agentMentionContext: null,
    agentMentionPrompt: null,
    agentMentionName: null,
    agentMentionParentNodeType: null,
    agentMentionNodeLocalId: null
};
const $4c5988c837301b49$export$e324594224ef24da = {
    setActions: (actions)=>({ setState: setState })=>{
            setState({
                actions: actions
            });
        },
    setContext: (context)=>({ setState: setState })=>{
            setState({
                context: context
            });
        },
    removeContext: ()=>({ setState: setState })=>{
            setState({
                context: undefined
            });
        },
    removeActions: ()=>({ setState: setState })=>{
            setState({
                actions: []
            });
        },
    setAgentMentionState: (state)=>({ setState: setState, getState: getState })=>{
            // Only reset resolvedAgentMentionId when the agent itself changes — not when
            // agentMentionContext updates (user typing after the mention) — to prevent the nudge
            // from flashing on every keystroke while the resolved UUID is already available.
            const current = getState();
            // Reset resolvedAgentMentionId when the agent changes OR when a new insertion
            // is made for the same agent — the insertion count increase means a new fetch
            // is about to start, and the old resolved UUID should not persist if it fails.
            const shouldResetResolved = state.agentMentionId !== current.agentMentionId || state.agentMentionInsertionCount !== current.agentMentionInsertionCount;
            setState({
                ...state,
                ...shouldResetResolved ? {
                    resolvedAgentMentionId: null
                } : {}
            });
        },
    setResolvedAgentMentionId: (resolvedAgentMentionId)=>({ setState: setState })=>{
            setState({
                resolvedAgentMentionId: resolvedAgentMentionId
            });
        }
};
const $4c5988c837301b49$export$e72cf4a64160987e = (0, $8s9DV.createStore)({
    initialState: $4c5988c837301b49$export$d4c72bab9d6cc13a,
    actions: $4c5988c837301b49$export$e324594224ef24da,
    name: 'EditorRovoButtonActionsStore'
});
const $4c5988c837301b49$export$b95031893a3d9d63 = (0, $kBr4q.createActionsHook)($4c5988c837301b49$export$e72cf4a64160987e);
const $4c5988c837301b49$export$c693678b9cc11679 = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.actions
});
const $4c5988c837301b49$export$59213a5c9f9d59b8 = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.context
});
const $4c5988c837301b49$export$f47243b349b78626 = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionId
});
const $4c5988c837301b49$export$65c1c9c4f5245bef = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionInsertionCount
});
const $4c5988c837301b49$export$c4372fb8872a2f0b = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.resolvedAgentMentionId
});
const $4c5988c837301b49$export$5c060a79a26e7361 = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionContext
});
const $4c5988c837301b49$export$4f371676b9a398fe = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionPrompt
});
const $4c5988c837301b49$export$95a191dd4fa0d1fd = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionName
});
const $4c5988c837301b49$export$f79a54b315516f9f = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionParentNodeType
});
const $4c5988c837301b49$export$af8dd61c1ae633af = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionNodeLocalId ?? null
});
module.exports["useEditorRovoButtonActions"] = $4c5988c837301b49$export$b95031893a3d9d63;
module.exports["useEditorRovoButtonActionsActions"] = $4c5988c837301b49$export$c693678b9cc11679;
module.exports["useEditorRovoButtonActionsContext"] = $4c5988c837301b49$export$59213a5c9f9d59b8;
module.exports["useEditorRovoButtonAgentMentionId"] = $4c5988c837301b49$export$f47243b349b78626;
module.exports["useEditorRovoButtonAgentMentionInsertionCount"] = $4c5988c837301b49$export$65c1c9c4f5245bef;
module.exports["useEditorRovoButtonResolvedAgentMentionId"] = $4c5988c837301b49$export$c4372fb8872a2f0b;
module.exports["useEditorRovoButtonAgentMentionContext"] = $4c5988c837301b49$export$5c060a79a26e7361;
module.exports["useEditorRovoButtonAgentMentionPrompt"] = $4c5988c837301b49$export$4f371676b9a398fe;
module.exports["useEditorRovoButtonAgentMentionName"] = $4c5988c837301b49$export$95a191dd4fa0d1fd;
module.exports["useEditorRovoButtonAgentMentionParentNodeType"] = $4c5988c837301b49$export$f79a54b315516f9f;
module.exports["useEditorRovoButtonAgentMentionNodeLocalId"] = $4c5988c837301b49$export$af8dd61c1ae633af;

});

parcelRegister("3guYO", function(module, exports) {

let $260ae5acec926715$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $260ae5acec926715$var$load("6wr18"),
    $260ae5acec926715$var$load("j6yAY"),
    $260ae5acec926715$var$load("flgjz"),
    $260ae5acec926715$var$load("f3qSD"),
    $260ae5acec926715$var$load("do5z1"),
    $260ae5acec926715$var$load("lFmKr"),
    $260ae5acec926715$var$load("aOIZj"),
    $260ae5acec926715$var$load("7EorR"),
    $260ae5acec926715$var$load("ffEVr"),
    $260ae5acec926715$var$load("aEk9k")
]).then(()=>parcelRequire('e1z3L'));

});

parcelRegister("gRv41", function(module, exports) {

var $g4Rov = parcelRequire("g4Rov");


var $hq8YP = parcelRequire("hq8YP");

const $94124018bc78b0e0$export$9b1c009846eb666 = ()=>{
    const state = (0, $g4Rov.useAtom)((0, $hq8YP.herState));
    return {
        // State
        isHerActive: state.isHerActive,
        isExpanded: state.isExpanded,
        isAnimating: state.isAnimating,
        contentId: state.contentId,
        contentType: state.contentType,
        cloudID: state.cloudID,
        textPreview: state.textPreview,
        tasks: state.tasks,
        notifications: state.notifications,
        rovoMessage: state.rovoMessage,
        toggleHer: // Actions
        $hq8YP.toggleHer,
        openHer: $hq8YP.openHer,
        closeHer: $hq8YP.closeHer,
        setExpanded: $hq8YP.setExpanded,
        setAnimating: $hq8YP.setAnimating,
        appendTextPreview: $hq8YP.appendTextPreview,
        clearTextPreview: $hq8YP.clearTextPreview,
        addNotification: $hq8YP.addNotification,
        removeNotification: $hq8YP.removeNotification,
        setRovoMessage: $hq8YP.setRovoMessage,
        clearRovoMessage: $hq8YP.clearRovoMessage
    };
};
module.exports["useHerStore"] = $94124018bc78b0e0$export$9b1c009846eb666;

});

parcelRegister("hq8YP", function(module, exports) {

var $avHQ3 = parcelRequire("avHQ3");

const $b2100637eed5fa2c$var$initialState = {
    isHerActive: false,
    isExpanded: true,
    isAnimating: true,
    contentId: null,
    contentType: 'page',
    cloudID: '',
    textPreview: '',
    tasks: {},
    notifications: {},
    rovoMessage: null
};
const $b2100637eed5fa2c$export$b1d93e626697721f = (0, $avHQ3.e)($b2100637eed5fa2c$var$initialState);
const $b2100637eed5fa2c$export$780673425ffb59a7 = (contentId, cloudID, contentType)=>{
    $b2100637eed5fa2c$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            isHerActive: !prevState.isHerActive,
            // Reset to expanded when opening
            isExpanded: !prevState.isHerActive ? true : prevState.isExpanded,
            isAnimating: !prevState.isHerActive ? true : prevState.isAnimating,
            contentId: !prevState.isHerActive ? contentId ?? null : null,
            contentType: !prevState.isHerActive ? contentType ?? 'page' : 'page',
            cloudID: !prevState.isHerActive ? cloudID ?? prevState.cloudID : prevState.cloudID,
            textPreview: !prevState.isHerActive ? '' : prevState.textPreview,
            rovoMessage: null
        }));
};
const $b2100637eed5fa2c$export$cc30aca21148df52 = (contentId, cloudID, contentType)=>{
    $b2100637eed5fa2c$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            isHerActive: true,
            isExpanded: true,
            isAnimating: true,
            contentId: contentId ?? null,
            contentType: contentType ?? 'page',
            cloudID: cloudID ?? prevState.cloudID,
            rovoMessage: null
        }));
};
const $b2100637eed5fa2c$export$d1dd051dd158cf2a = ()=>{
    $b2100637eed5fa2c$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            isHerActive: false,
            contentId: null,
            contentType: 'page',
            textPreview: '',
            rovoMessage: null
        }));
};
const $b2100637eed5fa2c$export$daffe9b53f21fd39 = (expanded)=>{
    $b2100637eed5fa2c$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            isExpanded: expanded
        }));
};
const $b2100637eed5fa2c$export$3a38c3c547ba462b = (animating)=>{
    $b2100637eed5fa2c$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            isAnimating: animating
        }));
};
const $b2100637eed5fa2c$export$52a0cc4030ebe376 = (text)=>{
    $b2100637eed5fa2c$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            textPreview: prevState.textPreview + text
        }));
};
const $b2100637eed5fa2c$export$cd85393335c99d14 = ()=>{
    $b2100637eed5fa2c$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            textPreview: ''
        }));
};
const $b2100637eed5fa2c$export$38a248e5348a1dc = (task)=>{
    $b2100637eed5fa2c$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            tasks: {
                ...prevState.tasks,
                [task.task_id]: task
            }
        }));
};
const $b2100637eed5fa2c$export$e8e0154b7bb02be4 = (task)=>{
    $b2100637eed5fa2c$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            tasks: {
                ...prevState.tasks,
                [task.task_id]: task
            }
        }));
};
const $b2100637eed5fa2c$export$e0f6ca2291a97572 = (taskId)=>{
    $b2100637eed5fa2c$export$b1d93e626697721f.set((prevState)=>{
        const { [taskId]: _, ...rest } = prevState.tasks;
        return {
            ...prevState,
            tasks: rest
        };
    });
};
const $b2100637eed5fa2c$export$c7def531c087da85 = (notification)=>{
    $b2100637eed5fa2c$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            notifications: {
                ...prevState.notifications,
                [notification.id]: notification
            }
        }));
};
const $b2100637eed5fa2c$export$92eb0ea44f8c9242 = (notificationId)=>{
    $b2100637eed5fa2c$export$b1d93e626697721f.set((prevState)=>{
        const { [notificationId]: _, ...rest } = prevState.notifications;
        return {
            ...prevState,
            notifications: rest
        };
    });
};
const $b2100637eed5fa2c$export$2a6b13a8b8066c3f = (rovoMessage)=>{
    $b2100637eed5fa2c$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            rovoMessage: rovoMessage
        }));
};
const $b2100637eed5fa2c$export$aaa1dffe3c1b0b3c = ()=>{
    $b2100637eed5fa2c$export$b1d93e626697721f.set((prevState)=>({
            ...prevState,
            rovoMessage: null
        }));
};
module.exports["herState"] = $b2100637eed5fa2c$export$b1d93e626697721f;
module.exports["toggleHer"] = $b2100637eed5fa2c$export$780673425ffb59a7;
module.exports["openHer"] = $b2100637eed5fa2c$export$cc30aca21148df52;
module.exports["closeHer"] = $b2100637eed5fa2c$export$d1dd051dd158cf2a;
module.exports["setExpanded"] = $b2100637eed5fa2c$export$daffe9b53f21fd39;
module.exports["setAnimating"] = $b2100637eed5fa2c$export$3a38c3c547ba462b;
module.exports["appendTextPreview"] = $b2100637eed5fa2c$export$52a0cc4030ebe376;
module.exports["clearTextPreview"] = $b2100637eed5fa2c$export$cd85393335c99d14;
module.exports["addTask"] = $b2100637eed5fa2c$export$38a248e5348a1dc;
module.exports["updateTask"] = $b2100637eed5fa2c$export$e8e0154b7bb02be4;
module.exports["removeTask"] = $b2100637eed5fa2c$export$e0f6ca2291a97572;
module.exports["addNotification"] = $b2100637eed5fa2c$export$c7def531c087da85;
module.exports["removeNotification"] = $b2100637eed5fa2c$export$92eb0ea44f8c9242;
module.exports["setRovoMessage"] = $b2100637eed5fa2c$export$2a6b13a8b8066c3f;
module.exports["clearRovoMessage"] = $b2100637eed5fa2c$export$aaa1dffe3c1b0b3c;

});

parcelRegister("kONYb", function(module, exports) {

let $f27f3d1a111e48ff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f27f3d1a111e48ff$var$load("1jVx9").then(()=>parcelRequire('3D12W'));

});

parcelRegister("gN62b", function(module, exports) {

let $c395e738886479fa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c395e738886479fa$var$load("k3amn").then(()=>parcelRequire('5A18u'));

});

parcelRegister("2sYsz", function(module, exports) {

let $1cbd1856e38901ac$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1cbd1856e38901ac$var$load("2Hp35").then(()=>parcelRequire('dRspb'));

});

parcelRegister("cv9SU", function(module, exports) {

let $91a00c2ab4957bf9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $91a00c2ab4957bf9$var$load("1dIEH").then(()=>parcelRequire('1hCz7'));

});

parcelRegister("3zDXO", function(module, exports) {

let $29a3a3f56e45a9db$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $29a3a3f56e45a9db$var$load("6wr18"),
    $29a3a3f56e45a9db$var$load("ffEVr"),
    $29a3a3f56e45a9db$var$load("lX2ZR")
]).then(()=>parcelRequire('bl7WT'));

});

parcelRegister("jyQuB", function(module, exports) {

let $e3d9e936067b1c66$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e3d9e936067b1c66$var$load("4wPZ7").then(()=>parcelRequire('eQF4d'));

});

parcelRegister("a3pDb", function(module, exports) {

let $751e10fb2768e757$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $751e10fb2768e757$var$load("18viy"),
    $751e10fb2768e757$var$load("6wr18"),
    $751e10fb2768e757$var$load("ih3Pw"),
    $751e10fb2768e757$var$load("ggHb7"),
    $751e10fb2768e757$var$load("ffEVr"),
    $751e10fb2768e757$var$load("fjSG8")
]).then(()=>parcelRequire('gMGbk'));

});

parcelRegister("fmz8s", function(module, exports) {

let $b2f42a442b045b0c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b2f42a442b045b0c$var$load("fvcK2"),
    $b2f42a442b045b0c$var$load("cyTuQ"),
    $b2f42a442b045b0c$var$load("6e5Dd")
]).then(()=>parcelRequire('8woNY'));

});

parcelRegister("2E3RW", function(module, exports) {

let $1ed251861d0a6d97$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1ed251861d0a6d97$var$load("g81ly"),
    $1ed251861d0a6d97$var$load("e3LAK"),
    $1ed251861d0a6d97$var$load("l7Pap")
]).then(()=>parcelRequire('hMNzI'));

});

parcelRegister("5Uf3U", function(module, exports) {

let $44cdddb8a3ebe225$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $44cdddb8a3ebe225$var$load("glIEn").then(()=>parcelRequire('6pfrs'));

});

parcelRegister("jzzzm", function(module, exports) {

let $e3fce08b1c6fd2f4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e3fce08b1c6fd2f4$var$load("31msE").then(()=>parcelRequire('9POeP'));

});

parcelRegister("3R9tJ", function(module, exports) {

let $2cedac92278937c5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2cedac92278937c5$var$load("KSMZE").then(()=>parcelRequire('jFrMf'));

});

parcelRegister("8nle6", function(module, exports) {
$parcel$export(module.exports, "preloadSpaceDetail", () => (parcelRequire("5SzHz")).preloadSpaceDetail);
$parcel$export(module.exports, "preloadPersonalSpaceDetail", () => (parcelRequire("jLyos")).preloadPersonalSpaceDetail);
$parcel$export(module.exports, "preloadPersonalSpaceDetailsQuery", () => (parcelRequire("jLyos")).preloadPersonalSpaceDetailsQuery);
$parcel$export(module.exports, "ConfluenceSpaceType", () => (parcelRequire("bgmQP")).ConfluenceSpaceType);
/* eslint-disable check-multiple-entry-point-exports/check-multiple-entry-point-exports */ 
var $jmjWc = parcelRequire("jmjWc");


var $5SzHz = parcelRequire("5SzHz");


var $jLyos = parcelRequire("jLyos");


var $bgmQP = parcelRequire("bgmQP");


const $b92195a33e0fb686$export$f10aab7c26f92d55 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7NksR",
    name: "SpaceTargetSelect",
    loader: async ()=>(await Promise.resolve((parcelRequire("bgmQP")))).SpaceTargetSelect
});
module.exports["SpaceTargetSelect"] = $b92195a33e0fb686$export$f10aab7c26f92d55;

});

parcelRegister("5SzHz", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $4ZxLt = parcelRequire("4ZxLt");

const $01831239f93415a0$var$getEmptyResult = ()=>Promise.resolve({
        data: null,
        loading: false,
        error: null
    });
const $01831239f93415a0$export$ec3af86ec6a1dfc6 = async (spaceKey = '', { includeSpaceTypeSettings: includeSpaceTypeSettings = false } = {})=>{
    if (spaceKey) return (0, $dYU3e.query)({
        query: (0, $4ZxLt.default),
        variables: {
            spaceKey: spaceKey,
            includeSpaceTypeSettings: includeSpaceTypeSettings
        },
        __callerPackage__: "space-utils"
    });
    return $01831239f93415a0$var$getEmptyResult();
};
const $01831239f93415a0$export$2403e25f29f92c16 = async (spaceKey = '', options)=>{
    return $01831239f93415a0$export$ec3af86ec6a1dfc6(spaceKey, options);
};
module.exports["fetchSpaceDetail"] = $01831239f93415a0$export$ec3af86ec6a1dfc6;
module.exports["preloadSpaceDetail"] = $01831239f93415a0$export$2403e25f29f92c16;

});

parcelRegister("jLyos", function(module, exports) {

var $a2WOL = parcelRequire("a2WOL");


var $dYU3e = parcelRequire("dYU3e");

const $51133d1487ddd8f7$export$945871a9cdda3d0b = (0, $a2WOL.default);
const $51133d1487ddd8f7$export$88da34a67bdae7e0 = ()=>{
    return (0, $dYU3e.query)({
        query: $51133d1487ddd8f7$export$945871a9cdda3d0b,
        __callerPackage__: "space-utils"
    });
};
module.exports["preloadPersonalSpaceDetailsQuery"] = $51133d1487ddd8f7$export$945871a9cdda3d0b;
module.exports["preloadPersonalSpaceDetail"] = $51133d1487ddd8f7$export$88da34a67bdae7e0;

});

parcelRegister("a2WOL", function(module, exports) {
/**
 * @generated SignedSource<<99c90ef1034a28215bdf926b84b02699>>
 * @relayHash 0616a22c791eb8d27cd97c38dbbaaaed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fdab4f721e30e106cb6e937af7ef465a8e7ce5047eb501ede326a1f7618e0cbb
const $fb9284d373020379$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v0 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "dataClassificationTags"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "preloadPersonalSpaceDetailsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "preloadPersonalSpaceDetailsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0616a22c791eb8d27cd97c38dbbaaaed",
            "id": "fdab4f721e30e106cb6e937af7ef465a8e7ce5047eb501ede326a1f7618e0cbb",
            "metadata": {},
            "name": "preloadPersonalSpaceDetailsQuery",
            "operationKind": "query",
            "text": "query preloadPersonalSpaceDetailsQuery{user:confluence_atlassianUser(current:true){id,confluence{space{id,key,dataClassificationTags}}}}"
        }
    };
}();
$fb9284d373020379$var$node.hash = "a2cf47cae3a68d2f66118a725dfea818";
var $fb9284d373020379$export$2e2bcd8739ae039 = $fb9284d373020379$var$node;
module.exports["default"] = $fb9284d373020379$export$2e2bcd8739ae039;

});

parcelRegister("bgmQP", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6wGOF = parcelRequire("6wGOF");


var $l9ukq = parcelRequire("l9ukq");


var $iMnC5 = parcelRequire("iMnC5");


var $4aRua = parcelRequire("4aRua");


var $jp2Q3 = parcelRequire("jp2Q3");

var $c8b68f6ea32b0094$export$2fabe69f8125d5a7 = /*#__PURE__*/ function(ConfluenceSpaceType) {
    ConfluenceSpaceType["ALL"] = "ALL";
    ConfluenceSpaceType["ALL_EXCEPT_PERSONAL"] = "ALL_EXCEPT_PERSONAL";
    ConfluenceSpaceType["ALL_EXCEPT_SPECIFIC"] = "ALL_EXCEPT_SPECIFIC";
    ConfluenceSpaceType["PERSONAL"] = "PERSONAL";
    ConfluenceSpaceType["SPECIFIC"] = "SPECIFIC";
    return ConfluenceSpaceType;
}({});
const $c8b68f6ea32b0094$var$i18n = (0, $kSwu1.defineMessages)({
    ariaLabel: {
        id: "space-utils.permissions-export.form.space-target-select.aria-label",
        defaultMessage: "For which spaces"
    },
    all: {
        id: "space-utils.space-target-select.all",
        defaultMessage: "All"
    },
    allDescription: {
        id: "space-utils.space-target-select.allDescription",
        defaultMessage: "All spaces, regardless of type"
    },
    allExcludingPersonal: {
        id: "space-utils.space-target-select.allExcludingPersonal",
        defaultMessage: "All (excluding personal)"
    },
    allExcludingPersonalDescription: {
        id: "space-utils.space-target-select.allExcludingPersonalDescription",
        defaultMessage: "Don't include any personal spaces"
    },
    allExcludingSpecific: {
        id: "space-utils.space-target-select.allExcludingSpecific",
        defaultMessage: "All (excluding specific spaces)"
    },
    allExcludingSpecificDescription: {
        id: "space-utils.space-target-select.allExcludingSpecificDescription",
        defaultMessage: "Choose specific spaces to exclude"
    },
    personal: {
        id: "space-utils.space-target-select.personal",
        defaultMessage: "Only personal"
    },
    personalDescription: {
        id: "space-utils.space-target-select.personalDescription",
        defaultMessage: "All personal spaces"
    },
    specific: {
        id: "space-utils.space-target-select.specific",
        defaultMessage: "Only specific spaces"
    },
    specificDescription: {
        id: "space-utils.space-target-select.specificDescription",
        defaultMessage: "Choose specific spaces to include"
    }
});
const $c8b68f6ea32b0094$var$menuItemStyle = {
    style: "_2mHwu81Y8M _3iDTPbQ4SZ _0aFT5vbt8w"
};
const $c8b68f6ea32b0094$var$CustomOption = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((props)=>{
    const $ = (0, $bDgLe.c)(10);
    let t0;
    if ($[0] !== props.data.label) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, props.data.label);
        $[0] = props.data.label;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props.data.description) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtlest"
        }, props.data.description);
        $[2] = props.data.description;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $c8b68f6ea32b0094$var$menuItemStyle.style
        }, t0, t1);
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== props || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Option, props, t2);
        $[7] = props;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
});
const $c8b68f6ea32b0094$var$SELECT_STYLE_PROPS = {
    isSearchable: false,
    styles: {
        menu: (base)=>({
                ...base,
                width: '320px',
                padding: 0,
                margin: 0,
                zIndex: (0, $jp2Q3.layers).modal() + 1 // Higher than modal to appear above modal content
            }),
        menuPortal: (base)=>({
                ...base,
                zIndex: (0, $jp2Q3.layers).modal() + 1 // Higher than modal to appear above modal content
            }),
        control: (base)=>({
                ...base,
                width: '320px',
                padding: 0,
                margin: 0
            })
    }
};
const $c8b68f6ea32b0094$var$SPACE_TARGET_OPTIONS = [
    {
        label: 'all',
        value: "ALL",
        description: 'allDescription'
    },
    {
        label: 'allExcludingPersonal',
        value: "ALL_EXCEPT_PERSONAL",
        description: 'allExcludingPersonalDescription'
    },
    {
        label: 'allExcludingSpecific',
        value: "ALL_EXCEPT_SPECIFIC",
        description: 'allExcludingSpecificDescription'
    },
    {
        label: 'personal',
        value: "PERSONAL",
        description: 'personalDescription'
    },
    {
        label: 'specific',
        value: "SPECIFIC",
        description: 'specificDescription'
    }
];
const $c8b68f6ea32b0094$export$f10aab7c26f92d55 = (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { onChange: onChange, spaceTargetValue: spaceTargetValue, menuPortalTarget: menuPortalTarget } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let T0;
    let t1;
    let t2;
    let t3;
    if ($[0] !== formatMessage || $[1] !== onChange || $[2] !== spaceTargetValue) {
        let t4;
        if ($[7] !== formatMessage) {
            t4 = (option)=>({
                    label: formatMessage($c8b68f6ea32b0094$var$i18n[option.label]),
                    value: option.value,
                    description: formatMessage($c8b68f6ea32b0094$var$i18n[option.description])
                });
            $[7] = formatMessage;
            $[8] = t4;
        } else t4 = $[8];
        const options = $c8b68f6ea32b0094$var$SPACE_TARGET_OPTIONS.map(t4);
        T0 = (0, $6wGOF.default);
        t1 = options;
        if ($[9] !== onChange) {
            t2 = (newValue)=>onChange(newValue?.value);
            $[9] = onChange;
            $[10] = t2;
        } else t2 = $[10];
        let t5;
        if ($[11] !== spaceTargetValue) {
            t5 = (option_0)=>String(option_0.value) === String(spaceTargetValue);
            $[11] = spaceTargetValue;
            $[12] = t5;
        } else t5 = $[12];
        t3 = options.find(t5);
        $[0] = formatMessage;
        $[1] = onChange;
        $[2] = spaceTargetValue;
        $[3] = T0;
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else {
        T0 = $[3];
        t1 = $[4];
        t2 = $[5];
        t3 = $[6];
    }
    let t4;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            Option: $c8b68f6ea32b0094$var$CustomOption
        };
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[14] !== formatMessage) {
        t5 = formatMessage($c8b68f6ea32b0094$var$i18n.ariaLabel);
        $[14] = formatMessage;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== T0 || $[17] !== menuPortalTarget || $[18] !== t1 || $[19] !== t2 || $[20] !== t3 || $[21] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            options: t1,
            onChange: t2,
            value: t3,
            components: t4,
            menuPosition: "fixed",
            menuPortalTarget: menuPortalTarget,
            "aria-label": t5,
            ...$c8b68f6ea32b0094$var$SELECT_STYLE_PROPS
        });
        $[16] = T0;
        $[17] = menuPortalTarget;
        $[18] = t1;
        $[19] = t2;
        $[20] = t3;
        $[21] = t5;
        $[22] = t6;
    } else t6 = $[22];
    return t6;
};
module.exports["ConfluenceSpaceType"] = $c8b68f6ea32b0094$export$2fabe69f8125d5a7;
module.exports["SpaceTargetSelect"] = $c8b68f6ea32b0094$export$f10aab7c26f92d55;

});

parcelRegister("j25oo", function(module, exports) {
/**
 * @generated SignedSource<<b0ed3f943392beb78acd9d9ea9b42788>>
 * @relayHash 24201b9545ec89a2ece8511e9a2a8999
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b3c5854ab0548b89c651d5a1e8fc47a2aa65f94c49e96a88597856cd78fc203c
const $6b1bc0e8ad61af00$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "includeContentBody"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "condition": "includeContentBody",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "dynamic",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "representation"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useReadTimeQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useReadTimeQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "24201b9545ec89a2ece8511e9a2a8999",
            "id": "b3c5854ab0548b89c651d5a1e8fc47a2aa65f94c49e96a88597856cd78fc203c",
            "metadata": {},
            "name": "useReadTimeQuery",
            "operationKind": "query",
            "text": "query useReadTimeQuery($contentId:ID,$status:[String],$includeContentBody:Boolean=true){content(id:$contentId,status:$status){nodes{id,type,body@include(if:$includeContentBody){dynamic{value,representation}},operations{operation,targetType}}}}"
        }
    };
}();
$6b1bc0e8ad61af00$var$node.hash = "1de89fa5a6335c6c91c524557c055ef1";
var $6b1bc0e8ad61af00$export$2e2bcd8739ae039 = $6b1bc0e8ad61af00$var$node;
module.exports["default"] = $6b1bc0e8ad61af00$export$2e2bcd8739ae039;

});

parcelRegister("gkHoc", function(module, exports) {
$parcel$export(module.exports, "default", () => $be402bcc938fe0c2$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $be402bcc938fe0c2$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("lQXDC", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $emZLc = parcelRequire("emZLc");


var $66Bcq = parcelRequire("66Bcq");


var $gBjHb = parcelRequire("gBjHb");

const $71fb2a898293aa35$export$dc30f43798194b03 = (props)=>{
    const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($66Bcq)))({
        source: source,
        ...rest
    }, (0, (/*@__PURE__*/$parcel$interopDefault($emZLc))));
};
const $71fb2a898293aa35$export$34282a1f95511a11 = (props)=>{
    const data = $71fb2a898293aa35$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
        data: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, props.children));
};
module.exports["ContextWrapper"] = $71fb2a898293aa35$export$34282a1f95511a11;

});

parcelRegister("j1Rvl", function(module, exports) {
parcelRequire("cozmU");


var $92AHJ = parcelRequire("92AHJ");


var $7n3BL = parcelRequire("7n3BL");

const $878ccfcc8552aaa6$export$98e06fe7a6174253 = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).unknownUserError);
const $878ccfcc8552aaa6$export$58bd5a2057b6b855 = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).noAccessWarning);
const $878ccfcc8552aaa6$export$da9f8ce14593162f = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).noAccessLabel);
const $878ccfcc8552aaa6$export$4a258ffee7316766 = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).defaultHeadline);
const $878ccfcc8552aaa6$export$702321a50d74536e = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).defaultAdvisedAction);
const $878ccfcc8552aaa6$export$ed7f16088a93ae9d = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).loginAgain);
const $878ccfcc8552aaa6$export$3ab158df56460d1c = (0, $7n3BL.propFormatter)((0, $92AHJ.messages).differentText);
module.exports["UnknownUserError"] = $878ccfcc8552aaa6$export$98e06fe7a6174253;
module.exports["NoAccessWarning"] = $878ccfcc8552aaa6$export$58bd5a2057b6b855;
module.exports["NoAccessLabel"] = $878ccfcc8552aaa6$export$da9f8ce14593162f;
module.exports["DefaultHeadline"] = $878ccfcc8552aaa6$export$4a258ffee7316766;
module.exports["DefaultAdvisedAction"] = $878ccfcc8552aaa6$export$702321a50d74536e;
module.exports["LoginAgain"] = $878ccfcc8552aaa6$export$ed7f16088a93ae9d;
module.exports["DifferentText"] = $878ccfcc8552aaa6$export$3ab158df56460d1c;

});

parcelRegister("92AHJ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $fb7b952708721b37$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    unknownUserError: {
        id: "fabric.mention.unknow.user.error",
        defaultMessage: "Unknown user {userId}"
    },
    noAccessWarning: {
        id: "fabric.mention.noAccess.warning",
        defaultMessage: "{name} won't be notified as they have no access"
    },
    noAccessLabel: {
        id: "fabric.mention.noAccess.label",
        defaultMessage: "No access"
    },
    defaultHeadline: {
        id: "fabric.mention.error.defaultHeadline",
        defaultMessage: "Something went wrong"
    },
    defaultAdvisedAction: {
        id: "fabric.mention.error.defaultAction",
        defaultMessage: "Try again in a few seconds"
    },
    loginAgain: {
        id: "fabric.mention.error.loginAgain",
        defaultMessage: "Try logging out then in again"
    },
    differentText: {
        id: "fabric.mention.error.differentText",
        defaultMessage: "Try entering different text"
    },
    memberCountWithoutYou: {
        id: "fabric.elements.mentions.team.member.count",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}"
    },
    memberCountWithYou: {
        id: "fabric.elements.mentions.team.member.count.including.you",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you"
    },
    plus50MembersWithoutYou: {
        id: "fabric.elements.mentions.team.member.50plus",
        defaultMessage: "Team \u2022 50+ members"
    },
    plus50MembersWithYou: {
        id: "fabric.elements.mentions.team.member.50plus.including.you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    xProductMentionDescription: {
        id: "fabric.elements.mentions.xproduct.mention.description",
        defaultMessage: "Needs access to Confluence"
    },
    loadingPlaceholder: {
        id: "fabric.elements.mentions.loading.placeholder",
        defaultMessage: "Loading"
    }
});
module.exports["messages"] = $fb7b952708721b37$export$defe85febe8b728c;

});

parcelRegister("7n3BL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $bb06cdc27dbcd8cb$export$392a0c6a82ab0e50 = (messageDescriptor)=>({ values: values, children: children })=>{
        const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
        const message = formatMessage(messageDescriptor, values);
        if (typeof children === 'function') return children(message);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            values: values,
            ...messageDescriptor
        });
    };
module.exports["propFormatter"] = $bb06cdc27dbcd8cb$export$392a0c6a82ab0e50;

});

parcelRegister("21cx5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $hI76F = parcelRequire("hI76F");

const $f497c875f65a609f$var$EMPTY = {};
const $f497c875f65a609f$var$useI18n = (0, $gtMdU.isReactCompilerActivePlatform)() ? (locale)=>{
    const $ = (0, $bDgLe.c)(3);
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState($f497c875f65a609f$var$EMPTY);
    let t0;
    let t1;
    if ($[0] !== locale) {
        t0 = ()=>{
            let aborted = false;
            setMessages($f497c875f65a609f$var$EMPTY);
            (0, $hI76F.getMessagesForLocale)(locale).then((messages_0)=>{
                if (!aborted) setMessages(messages_0);
            }).catch($f497c875f65a609f$var$_temp);
            return ()=>{
                aborted = true;
            };
        };
        t1 = [
            locale
        ];
        $[0] = locale;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t0, t1);
    return messages;
} : (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState($f497c875f65a609f$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        let aborted = false;
        setMessages($f497c875f65a609f$var$EMPTY);
        (0, $hI76F.getMessagesForLocale)(locale).then((messages_0)=>{
            if (!aborted) setMessages(messages_0);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $f497c875f65a609f$var$MessagesIntlProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = props;
    const intl = (0, $kSwu1.useIntl)();
    const messages = $f497c875f65a609f$var$useI18n(intl.locale);
    let t0;
    if ($[0] !== children || $[1] !== intl || $[2] !== messages) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            ...intl,
            messages: messages
        }, children);
        $[0] = children;
        $[1] = intl;
        $[2] = messages;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props)=>{
    const { children: children } = props;
    const intl = (0, $kSwu1.useIntl)();
    const messages = $f497c875f65a609f$var$useI18n(intl.locale);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        ...intl,
        messages: messages
    }, children);
};
var $f497c875f65a609f$export$2e2bcd8739ae039 = $f497c875f65a609f$var$MessagesIntlProvider;
function $f497c875f65a609f$var$_temp(error) {
    console.error(error);
}
module.exports["default"] = $f497c875f65a609f$export$2e2bcd8739ae039;

});

parcelRegister("hI76F", function(module, exports) {
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 






























const $27fa02be5ce1169a$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("jX0rV")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("2tbWn")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("dOzBl")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("gpL0n")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("ePsdA")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("2GvIV")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("16HIv")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("WAFjY")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("474Ah")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("84VXz")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("fQ8BA")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("1lX2v")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("dDWYb")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("5XRxk")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("hMxVZ")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("58PuX")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("jglh9")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("iHOtt")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("d3k1V")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("6paIk")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("lXcxb")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("jK2My")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("cx1wp")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("ge9it")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("bMkyl")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("1O6Yy")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("486Xk")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("6bLNM")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("jNfyP")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("eL47t")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $27fa02be5ce1169a$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("gpL0n")).then((mod)=>mod.default);
            }
    }
};
module.exports["getMessagesForLocale"] = $27fa02be5ce1169a$export$d0a3169680473b6c;

});

parcelRegister("jX0rV", function(module, exports) {

let $e863e0441b14ec08$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e863e0441b14ec08$var$load("1JYrd"),
    $e863e0441b14ec08$var$load("cip6w"),
    $e863e0441b14ec08$var$load("gAG2n"),
    $e863e0441b14ec08$var$load("hFpP9"),
    $e863e0441b14ec08$var$load("3feYV"),
    $e863e0441b14ec08$var$load("cwjU2"),
    $e863e0441b14ec08$var$load("3Ff1R"),
    $e863e0441b14ec08$var$load("423Ga")
]).then(()=>parcelRequire('aIUTc'));

});

parcelRegister("2tbWn", function(module, exports) {

let $1cc78d5897d732a7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1cc78d5897d732a7$var$load("30242"),
    $1cc78d5897d732a7$var$load("3qBwQ"),
    $1cc78d5897d732a7$var$load("cYGDU"),
    $1cc78d5897d732a7$var$load("ddSTH"),
    $1cc78d5897d732a7$var$load("7Q1SM"),
    $1cc78d5897d732a7$var$load("33Iaa"),
    $1cc78d5897d732a7$var$load("blA7x"),
    $1cc78d5897d732a7$var$load("gJroP")
]).then(()=>parcelRequire('aK3gp'));

});

parcelRegister("dOzBl", function(module, exports) {

let $a0eb8f8a89644122$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a0eb8f8a89644122$var$load("15aAJ"),
    $a0eb8f8a89644122$var$load("8rREG"),
    $a0eb8f8a89644122$var$load("dgXJL"),
    $a0eb8f8a89644122$var$load("9d8JZ"),
    $a0eb8f8a89644122$var$load("7JdzX"),
    $a0eb8f8a89644122$var$load("6681T"),
    $a0eb8f8a89644122$var$load("3dn3H"),
    $a0eb8f8a89644122$var$load("cYXvt")
]).then(()=>parcelRequire('d43Vk'));

});

parcelRegister("gpL0n", function(module, exports) {

let $bf33715bc1c03891$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bf33715bc1c03891$var$load("hUbK8").then(()=>parcelRequire('6BJ6x'));

});

parcelRegister("ePsdA", function(module, exports) {

let $acbbb7a8f95cd6fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $acbbb7a8f95cd6fc$var$load("l5BBd"),
    $acbbb7a8f95cd6fc$var$load("93ASN"),
    $acbbb7a8f95cd6fc$var$load("htu5t"),
    $acbbb7a8f95cd6fc$var$load("1A450"),
    $acbbb7a8f95cd6fc$var$load("24LNf"),
    $acbbb7a8f95cd6fc$var$load("iYQCc"),
    $acbbb7a8f95cd6fc$var$load("nBJth")
]).then(()=>parcelRequire('9BUhf'));

});

parcelRegister("2GvIV", function(module, exports) {

let $1f481cafca2c7f01$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1f481cafca2c7f01$var$load("bbv9t"),
    $1f481cafca2c7f01$var$load("9fQoJ"),
    $1f481cafca2c7f01$var$load("lTboH"),
    $1f481cafca2c7f01$var$load("gBDXQ"),
    $1f481cafca2c7f01$var$load("cnlNg"),
    $1f481cafca2c7f01$var$load("d3Phe"),
    $1f481cafca2c7f01$var$load("lASLx"),
    $1f481cafca2c7f01$var$load("bIXgz")
]).then(()=>parcelRequire('3u3mj'));

});

parcelRegister("16HIv", function(module, exports) {

let $0ce8433c656a7df9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0ce8433c656a7df9$var$load("7p4je"),
    $0ce8433c656a7df9$var$load("8SZbD"),
    $0ce8433c656a7df9$var$load("iE05k"),
    $0ce8433c656a7df9$var$load("lv5aU"),
    $0ce8433c656a7df9$var$load("9Uf61"),
    $0ce8433c656a7df9$var$load("3Yk1e"),
    $0ce8433c656a7df9$var$load("5lJyy"),
    $0ce8433c656a7df9$var$load("9w9df")
]).then(()=>parcelRequire('dWF5g'));

});

parcelRegister("WAFjY", function(module, exports) {

let $0b01dbe497441ac5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0b01dbe497441ac5$var$load("5ZQnr"),
    $0b01dbe497441ac5$var$load("lJyww"),
    $0b01dbe497441ac5$var$load("gVfjY"),
    $0b01dbe497441ac5$var$load("2hqQb"),
    $0b01dbe497441ac5$var$load("8RVFi")
]).then(()=>parcelRequire('33aAd'));

});

parcelRegister("474Ah", function(module, exports) {

let $2feb5f3312640ee1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2feb5f3312640ee1$var$load("1jQRQ"),
    $2feb5f3312640ee1$var$load("5pOQA"),
    $2feb5f3312640ee1$var$load("5GSny"),
    $2feb5f3312640ee1$var$load("cQump"),
    $2feb5f3312640ee1$var$load("fJSEb"),
    $2feb5f3312640ee1$var$load("ajzkj"),
    $2feb5f3312640ee1$var$load("eyysG"),
    $2feb5f3312640ee1$var$load("27gvR")
]).then(()=>parcelRequire('hDeI8'));

});

parcelRegister("84VXz", function(module, exports) {

let $5e1ba813b36eb977$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5e1ba813b36eb977$var$load("km37l"),
    $5e1ba813b36eb977$var$load("gbksI"),
    $5e1ba813b36eb977$var$load("j2X7f"),
    $5e1ba813b36eb977$var$load("fE8pi"),
    $5e1ba813b36eb977$var$load("9TeWr"),
    $5e1ba813b36eb977$var$load("kUZ7k"),
    $5e1ba813b36eb977$var$load("dJQL7"),
    $5e1ba813b36eb977$var$load("czj6d")
]).then(()=>parcelRequire('dvQoK'));

});

parcelRegister("fQ8BA", function(module, exports) {

let $b882632b90032289$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b882632b90032289$var$load("lTbXI"),
    $b882632b90032289$var$load("a98cw"),
    $b882632b90032289$var$load("e40mE"),
    $b882632b90032289$var$load("btBGI"),
    $b882632b90032289$var$load("fOGnR"),
    $b882632b90032289$var$load("cDQOq"),
    $b882632b90032289$var$load("8upye"),
    $b882632b90032289$var$load("GlmUM")
]).then(()=>parcelRequire('cvpu0'));

});

parcelRegister("1lX2v", function(module, exports) {

let $0fc58c977e435e13$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0fc58c977e435e13$var$load("8wMQe").then(()=>parcelRequire('LjIsh'));

});

parcelRegister("dDWYb", function(module, exports) {

let $9eeca90420daddea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9eeca90420daddea$var$load("iUyZj"),
    $9eeca90420daddea$var$load("4PDaO"),
    $9eeca90420daddea$var$load("lMhbw"),
    $9eeca90420daddea$var$load("amTTV"),
    $9eeca90420daddea$var$load("8nEeY"),
    $9eeca90420daddea$var$load("kLZKK"),
    $9eeca90420daddea$var$load("c7GMc"),
    $9eeca90420daddea$var$load("bnhJ1")
]).then(()=>parcelRequire('e4VAB'));

});

parcelRegister("5XRxk", function(module, exports) {

let $457bfdb241591b32$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $457bfdb241591b32$var$load("kPlMQ"),
    $457bfdb241591b32$var$load("ervs7"),
    $457bfdb241591b32$var$load("8CX31"),
    $457bfdb241591b32$var$load("kYd4i"),
    $457bfdb241591b32$var$load("fzzMQ"),
    $457bfdb241591b32$var$load("33S6H"),
    $457bfdb241591b32$var$load("kFae4"),
    $457bfdb241591b32$var$load("iZWpE")
]).then(()=>parcelRequire('96CT4'));

});

parcelRegister("hMxVZ", function(module, exports) {

let $03573eef817c65ad$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $03573eef817c65ad$var$load("iT2sv"),
    $03573eef817c65ad$var$load("iMMtn"),
    $03573eef817c65ad$var$load("23VWs"),
    $03573eef817c65ad$var$load("e1KaU"),
    $03573eef817c65ad$var$load("3gNEO"),
    $03573eef817c65ad$var$load("93obY"),
    $03573eef817c65ad$var$load("6Y9jE"),
    $03573eef817c65ad$var$load("cUTaY")
]).then(()=>parcelRequire('2YvEH'));

});

parcelRegister("58PuX", function(module, exports) {

let $3be5a59a48a9e11b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3be5a59a48a9e11b$var$load("lyPpF"),
    $3be5a59a48a9e11b$var$load("eX5n7"),
    $3be5a59a48a9e11b$var$load("aiYuN"),
    $3be5a59a48a9e11b$var$load("gqMCT"),
    $3be5a59a48a9e11b$var$load("gvylW"),
    $3be5a59a48a9e11b$var$load("bxfRe"),
    $3be5a59a48a9e11b$var$load("ed6s8"),
    $3be5a59a48a9e11b$var$load("lAuJd")
]).then(()=>parcelRequire('6VUXz'));

});

parcelRegister("jglh9", function(module, exports) {

let $e06003d5e1220a42$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e06003d5e1220a42$var$load("iN3cj"),
    $e06003d5e1220a42$var$load("3nHdy"),
    $e06003d5e1220a42$var$load("gDEvm"),
    $e06003d5e1220a42$var$load("5MwHB"),
    $e06003d5e1220a42$var$load("80OLx"),
    $e06003d5e1220a42$var$load("1EVcg"),
    $e06003d5e1220a42$var$load("96q1k"),
    $e06003d5e1220a42$var$load("XQtfV")
]).then(()=>parcelRequire('4D1c2'));

});

parcelRegister("iHOtt", function(module, exports) {

let $d9e3654e24ebe721$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d9e3654e24ebe721$var$load("eC1OL"),
    $d9e3654e24ebe721$var$load("ilL9c"),
    $d9e3654e24ebe721$var$load("64nco"),
    $d9e3654e24ebe721$var$load("9cx6P"),
    $d9e3654e24ebe721$var$load("e4s0V"),
    $d9e3654e24ebe721$var$load("28EXy"),
    $d9e3654e24ebe721$var$load("7RZp5"),
    $d9e3654e24ebe721$var$load("leyTH")
]).then(()=>parcelRequire('htiZ2'));

});

parcelRegister("d3k1V", function(module, exports) {

let $980b17bc6670e7c7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $980b17bc6670e7c7$var$load("4NJ49"),
    $980b17bc6670e7c7$var$load("bfOZL"),
    $980b17bc6670e7c7$var$load("jLbRX"),
    $980b17bc6670e7c7$var$load("5g0HW"),
    $980b17bc6670e7c7$var$load("4dPO1"),
    $980b17bc6670e7c7$var$load("gg8tK"),
    $980b17bc6670e7c7$var$load("eF54W"),
    $980b17bc6670e7c7$var$load("3hnPt")
]).then(()=>parcelRequire('6FDlX'));

});

parcelRegister("6paIk", function(module, exports) {

let $4a9d6374e12b3eab$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a9d6374e12b3eab$var$load("3zH5p").then(()=>parcelRequire('9VK7h'));

});

parcelRegister("lXcxb", function(module, exports) {

let $ffb8d4b57da0499e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ffb8d4b57da0499e$var$load("fsCDU"),
    $ffb8d4b57da0499e$var$load("kuolm"),
    $ffb8d4b57da0499e$var$load("fvE7S"),
    $ffb8d4b57da0499e$var$load("apVmx"),
    $ffb8d4b57da0499e$var$load("5xPg2")
]).then(()=>parcelRequire('0aYYd'));

});

parcelRegister("jK2My", function(module, exports) {

let $e5f478a9b13e5070$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e5f478a9b13e5070$var$load("g9gkE"),
    $e5f478a9b13e5070$var$load("jYdbS"),
    $e5f478a9b13e5070$var$load("6ncWv"),
    $e5f478a9b13e5070$var$load("gFneG"),
    $e5f478a9b13e5070$var$load("ltrgi"),
    $e5f478a9b13e5070$var$load("fu25G"),
    $e5f478a9b13e5070$var$load("iQGcz"),
    $e5f478a9b13e5070$var$load("ar4uw")
]).then(()=>parcelRequire('fHwYp'));

});

parcelRegister("cx1wp", function(module, exports) {

let $91f9bf4454da4b7f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $91f9bf4454da4b7f$var$load("dKdA9").then(()=>parcelRequire('6IGZA'));

});

parcelRegister("ge9it", function(module, exports) {

let $bd052a544036c7c1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bd052a544036c7c1$var$load("jhikU"),
    $bd052a544036c7c1$var$load("f0i3H"),
    $bd052a544036c7c1$var$load("bvBAp"),
    $bd052a544036c7c1$var$load("9kqmW"),
    $bd052a544036c7c1$var$load("69YlM"),
    $bd052a544036c7c1$var$load("cyTsc"),
    $bd052a544036c7c1$var$load("kXCsp"),
    $bd052a544036c7c1$var$load("disCG")
]).then(()=>parcelRequire('cycD1'));

});

parcelRegister("bMkyl", function(module, exports) {

let $89341eca9b757efd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $89341eca9b757efd$var$load("52XP1").then(()=>parcelRequire('klwXC'));

});

parcelRegister("1O6Yy", function(module, exports) {

let $150fdf33bc578fed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $150fdf33bc578fed$var$load("fSsz4"),
    $150fdf33bc578fed$var$load("kWOpS"),
    $150fdf33bc578fed$var$load("9tUAi"),
    $150fdf33bc578fed$var$load("bS9pO"),
    $150fdf33bc578fed$var$load("kgHzZ"),
    $150fdf33bc578fed$var$load("j4ur8"),
    $150fdf33bc578fed$var$load("fF7Id")
]).then(()=>parcelRequire('9kSto'));

});

parcelRegister("486Xk", function(module, exports) {

let $301d4e1521a68fed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $301d4e1521a68fed$var$load("k3bMq").then(()=>parcelRequire('5pQz0'));

});

parcelRegister("6bLNM", function(module, exports) {

let $4818d99fabfc5b23$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4818d99fabfc5b23$var$load("lF2HI").then(()=>parcelRequire('dPXRL'));

});

parcelRegister("jNfyP", function(module, exports) {

let $e68ea9f4734869ef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e68ea9f4734869ef$var$load("d91RK"),
    $e68ea9f4734869ef$var$load("f7hfJ"),
    $e68ea9f4734869ef$var$load("QI1kr"),
    $e68ea9f4734869ef$var$load("5LvhC"),
    $e68ea9f4734869ef$var$load("brdRT"),
    $e68ea9f4734869ef$var$load("lWBlc"),
    $e68ea9f4734869ef$var$load("s2EmI"),
    $e68ea9f4734869ef$var$load("jc0YL")
]).then(()=>parcelRequire('AOOMd'));

});

parcelRegister("eL47t", function(module, exports) {

let $abe8a684a19ae877$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $abe8a684a19ae877$var$load("708J7"),
    $abe8a684a19ae877$var$load("kVqUf"),
    $abe8a684a19ae877$var$load("2IMxh"),
    $abe8a684a19ae877$var$load("98tcg"),
    $abe8a684a19ae877$var$load("j03Pa"),
    $abe8a684a19ae877$var$load("kke1I"),
    $abe8a684a19ae877$var$load("gOwMq"),
    $abe8a684a19ae877$var$load("6GfaN")
]).then(()=>parcelRequire('gMQJr'));

});

parcelRegister("iD1Wv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $70ab48cd50028ae1$var$AsyncNoAccessTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("bfi3l")).then((module)=>{
        return {
            default: module.NoAccessTooltip
        };
    }));
var $70ab48cd50028ae1$export$2e2bcd8739ae039 = $70ab48cd50028ae1$var$AsyncNoAccessTooltip;
module.exports["default"] = $70ab48cd50028ae1$export$2e2bcd8739ae039;

});

parcelRegister("bfi3l", function(module, exports) {

let $021ce3818119c131$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $021ce3818119c131$var$load("akbkC").then(()=>parcelRequire('d7Uen'));

});

parcelRegister("aJNFh", function(module, exports) {

var $f6VI9 = parcelRequire("f6VI9");

const $71f78acdff7635c4$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
/**
 * Unified GraphQL query — convoai_availableSkills.
 */ const $71f78acdff7635c4$var$UNIFIED_SKILLS_QUERY = `
  query ConvoAiAvailableSkillsQuery(
    $first: Int
    $cloudId: ID!
  ) {
    convoai_availableSkills(
      first: $first
      cloudId: $cloudId
    )
    @optIn(to: "ConvoAiAvailableSkills")
    {
      edges {
        node {
          __typename
          ... on ConvoAiSkill {
            id
            name
            description
            displayName
            slashCommand
						helpText
            iconUrl
            iconKey
            color
            source
            tags
            category
            integrationKeys
          }
        }
      }
      errors {
        message
      }
    }
  }
`;
/**
 * Session-level cache for fetched skills.
 * Keyed by `${cloudId}` to avoid redundant network requests.
 * Skills are cached for the lifetime of the page (matching Relay store behavior).
 * A page refresh will fetch fresh data.
 */ const $71f78acdff7635c4$var$skillsCache = new Map();
function $71f78acdff7635c4$export$e6cf70cf6554c856() {
    $71f78acdff7635c4$var$skillsCache.clear();
}
/**
 * Fetch skills using the new unified convoai_availableSkills endpoint.
 */ async function $71f78acdff7635c4$var$fetchSkillsUnified(cloudId) {
    const response = await fetch($71f78acdff7635c4$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({
            query: $71f78acdff7635c4$var$UNIFIED_SKILLS_QUERY,
            variables: {
                cloudId: cloudId,
                first: 150
            }
        })
    });
    if (!response.ok) return [];
    const json = await response.json();
    if (json.errors?.length || json.data?.convoai_availableSkills?.errors?.length) return [];
    const edges = json.data?.convoai_availableSkills?.edges;
    return (0, $f6VI9.parseConvoAiSkillEdges)(edges);
}
async function $71f78acdff7635c4$export$268d57ae88e7df66(cloudId) {
    const cacheKey = cloudId;
    const cached = $71f78acdff7635c4$var$skillsCache.get(cacheKey);
    if (cached) return cached;
    try {
        const skills = await $71f78acdff7635c4$var$fetchSkillsUnified(cloudId);
        $71f78acdff7635c4$var$skillsCache.set(cacheKey, skills);
        return skills;
    } catch  {
        // Silently fail — the insert menu will just not show skills
        return [];
    }
}
module.exports["clearSkillsCache"] = $71f78acdff7635c4$export$e6cf70cf6554c856;
module.exports["fetchSkills"] = $71f78acdff7635c4$export$268d57ae88e7df66;

});

parcelRegister("f6VI9", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

function $ae2233479ab8cd62$export$db36004670a5626e(node) {
    return node?.__typename === 'GraphIntegrationSkillDirectoryItem';
}
function $ae2233479ab8cd62$export$7d1ba2a7b9e1a07(node) {
    return node?.__typename === 'ConvoAiSkill';
}
function $ae2233479ab8cd62$export$74ea09dd5afceb60(node) {
    if (!node || node.__typename !== 'GraphIntegrationSkillDirectoryItem') return null;
    const displayName = node.integrationKey?.displayName ?? '';
    const tagDisplayNames = node.tags?.map((t)=>t.displayName) ?? [];
    const trimmedDescription = node.description && node.description?.length > 150 ? `${node.description?.slice(0, 147)}...` : node.description ?? '';
    return {
        id: node.id,
        slug: node.slashCommand?.split('/')?.[1] ?? '',
        name: node.name ?? '',
        description: trimmedDescription,
        iconName: node.iconUrl?.split('name/')?.[1],
        product: displayName ? displayName.charAt(0).toUpperCase() + displayName.slice(1) : '',
        productIconUrl: node.integrationKey?.iconUrl ?? '',
        ...node.color ? {
            color: node.color
        } : {},
        ...tagDisplayNames.length > 0 ? {
            tags: [
                ...tagDisplayNames
            ]
        } : {}
    };
}
function $ae2233479ab8cd62$export$fd76a94f4a001a14(node) {
    if (!node || node.__typename !== 'ConvoAiSkill') return null;
    const primaryIntegration = node.integrations?.[0];
    let productDisplayName = '';
    let productIconUrl = '';
    // If the skill has integrations, else use the legacy integrationKeys.
    if (primaryIntegration) {
        productDisplayName = primaryIntegration.displayName ?? '';
        productIconUrl = primaryIntegration.iconUrl ?? '';
    } else {
        const product = node.integrationKeys?.[0] ?? '';
        productDisplayName = product ? product.charAt(0).toUpperCase() + product.slice(1) : '';
    }
    return {
        id: node.id,
        slug: node.slashCommand?.split('/')?.[1] || ((0, $iDrrr.fg)('rovo_skill_tag_label_wrapping') ? node.name : '') || '',
        name: node.displayName ?? node.name ?? '',
        description: node.helpText ?? node.description ?? '',
        iconName: node.iconKey || node.iconUrl?.split('name/')?.[1],
        product: productDisplayName,
        productIconUrl: productIconUrl,
        ...node.color ? {
            color: node.color
        } : {},
        ...node.tags && node.tags.length > 0 ? {
            tags: [
                ...node.tags
            ]
        } : {}
    };
}
function $ae2233479ab8cd62$export$2cffb029ea623d71(edges) {
    if (!edges) return [];
    return edges.map((edge)=>$ae2233479ab8cd62$export$db36004670a5626e(edge?.node) ? $ae2233479ab8cd62$export$74ea09dd5afceb60(edge.node) : null).filter((skill)=>skill !== null);
}
function $ae2233479ab8cd62$export$554aac7da67453f5(edges) {
    if (!edges) return [];
    return edges.map((edge)=>$ae2233479ab8cd62$export$7d1ba2a7b9e1a07(edge?.node) ? $ae2233479ab8cd62$export$fd76a94f4a001a14(edge.node) : null).filter((skill)=>skill !== null);
}
function $ae2233479ab8cd62$export$faef8b68e529d4a7(edges) {
    if (!edges) return [];
    return edges.map((edge)=>{
        const node = edge?.node;
        if (!node || !node.__typename) return null;
        // Route to appropriate parser based on typename
        if ($ae2233479ab8cd62$export$db36004670a5626e(node)) return $ae2233479ab8cd62$export$74ea09dd5afceb60(node);
        if ($ae2233479ab8cd62$export$7d1ba2a7b9e1a07(node)) return $ae2233479ab8cd62$export$fd76a94f4a001a14(node);
        return null;
    }).filter((skill)=>skill !== null);
}
module.exports["parseSkillNode"] = $ae2233479ab8cd62$export$74ea09dd5afceb60;
module.exports["parseConvoAiSkillEdges"] = $ae2233479ab8cd62$export$554aac7da67453f5;
module.exports["parseUniversalSkillEdges"] = $ae2233479ab8cd62$export$faef8b68e529d4a7;

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $bDgLe.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("4R3wx", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $9wGTI = parcelRequire("9wGTI");


var $932VV = parcelRequire("932VV");


var $cYe4v = parcelRequire("cYe4v");


var $dpJII = parcelRequire("dpJII");


var $eNjW4 = parcelRequire("eNjW4");

const $c8aabf9b2e3d2d10$export$62184c98af916d7a = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(10);
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    let t0;
    if ($[0] !== isBetaEnabled || $[1] !== isLoomDisabled || $[2] !== isLoomEntryPointsEnabled) {
        t0 = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)("confluence_frontend_loom_cross_sell");
        $[0] = isBetaEnabled;
        $[1] = isLoomDisabled;
        $[2] = isLoomEntryPointsEnabled;
        $[3] = t0;
    } else t0 = $[3];
    const skipPermsCheck = t0;
    const t1 = skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__);
    let t2;
    if ($[4] !== t1) {
        t2 = {
            skip: t1
        };
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)(t2);
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) {
        let t3;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[6] = t3;
        } else t3 = $[6];
        return t3;
    }
    if (isBetaEnabled) {
        let t3;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "BETA"
            };
            $[7] = t3;
        } else t3 = $[7];
        return t3;
    }
    if (!(0, $9wGTI.fg)("confluence_frontend_loom_cross_sell")) {
        let t3;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[8] = t3;
        } else t3 = $[8];
        return t3;
    }
    if (loomEntryPointVariant.entryPointVariant === "CROSS_FLOW" && (0, $9wGTI.fg)("confluence_frontend_loom_cross_flow_ads_opt_out")) {
        let t3;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[9] = t3;
        } else t3 = $[9];
        return t3;
    }
    return loomEntryPointVariant;
} : ()=>{
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    // This can be replaced entirely by `isLoomDisabled` once Loom Beta is cleaned up
    const skipPermsCheck = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell');
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)({
        // If the entry point variant has been SSRd, use that result and skip the permissions check
        skip: skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__)
    });
    // If the entry point already exists via SSR, return that value in the hook here (no need to check anything else)
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) return {
        entryPointVariant: 'DISABLED'
    };
    if (isBetaEnabled) return {
        entryPointVariant: 'BETA'
    };
    // This should be moved into useIsLoomDisabled once Loom Beta is cleaned up.
    // For now, we have to do the Beta check first because `confluence_frontend_loom_cross_sell` is
    // not enabled on Beta sites
    if (!(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell')) return {
        entryPointVariant: 'DISABLED'
    };
    if (loomEntryPointVariant.entryPointVariant === 'CROSS_FLOW' && (0, $9wGTI.fg)('confluence_frontend_loom_cross_flow_ads_opt_out')) return {
        entryPointVariant: 'DISABLED'
    };
    return loomEntryPointVariant;
};
module.exports["useLoomEntryPointVariant"] = $c8aabf9b2e3d2d10$export$62184c98af916d7a;

});

parcelRegister("932VV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $dHiKK = parcelRequire("dHiKK");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $7Sm4c = parcelRequire("7Sm4c");


var $i8Ofl = parcelRequire("i8Ofl");


var $c5JFM = parcelRequire("c5JFM");

const $45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery = (0, $dHiKK.default);
const $45094daeb894a50e$export$5d821a9fc4b7faa = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(12);
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $c5JFM.isMeetingRecorderEligibilityEnabled)();
        $[0] = t0;
    } else t0 = $[0];
    const includeMeetingRecorderEligibility = t0;
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    let t1;
    if ($[1] !== cloudId) {
        t1 = {
            cloudId: cloudId,
            includeMeetingRecorderEligibility: includeMeetingRecorderEligibility
        };
        $[1] = cloudId;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== activationId || $[4] !== cloudId) {
        t2 = (0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId);
        $[3] = activationId;
        $[4] = cloudId;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = {
            headers: {
                ...t2
            }
        };
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    const t4 = shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__);
    let t5;
    if ($[8] !== t1 || $[9] !== t3 || $[10] !== t4) {
        t5 = {
            variables: t1,
            context: t3,
            skip: t4
        };
        $[8] = t1;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery, {
        ...t5,
        __callerPackage__: "loom-utils"
    });
    if (window.__SSR_LOOM_ENTRY_POINT__) return;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
} : ()=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const includeMeetingRecorderEligibility = (0, $c5JFM.isMeetingRecorderEligibilityEnabled)();
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery, {
        variables: {
            cloudId: cloudId,
            includeMeetingRecorderEligibility: includeMeetingRecorderEligibility
        },
        context: {
            headers: {
                ...(0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId)
            }
        },
        skip: shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__),
        __callerPackage__: "loom-utils"
    });
    if (window.__SSR_LOOM_ENTRY_POINT__) return undefined;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
};
module.exports["useIsLoomEntryPointsEnabled"] = $45094daeb894a50e$export$5d821a9fc4b7faa;

});

parcelRegister("dHiKK", function(module, exports) {
/**
 * @generated SignedSource<<6bffa4411017429251cce91466f25b2c>>
 * @relayHash f7bb335b70d26ad812bfb3643de03577
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f7ffa147cd1d4533462f1fb2c3c994f63b873577cc20f9e4875b94343191953c
const $dc96dcb71a986382$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeMeetingRecorderEligibility"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "siteId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceLoomEntryPoints",
            "kind": "LinkedField",
            "name": "confluence_loomEntryPoints",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isLoomEntryPointsEnabled"
                }
            ]
        },
        {
            "condition": "includeMeetingRecorderEligibility",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "LoomSettings",
                    "kind": "LinkedField",
                    "name": "loom_settings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "meetingRecordingsAvailable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "meetingNotesEligible"
                        }
                    ]
                },
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "LoomConnectedCalendar",
                    "kind": "LinkedField",
                    "name": "loom_connectedCalendars",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "guid"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "f7bb335b70d26ad812bfb3643de03577",
            "id": "f7ffa147cd1d4533462f1fb2c3c994f63b873577cc20f9e4875b94343191953c",
            "metadata": {},
            "name": "useIsLoomEntryPointsEnabledQuery",
            "operationKind": "query",
            "text": "query useIsLoomEntryPointsEnabledQuery($cloudId:ID!,$includeMeetingRecorderEligibility:Boolean!){confluence_loomEntryPoints(cloudId:$cloudId){isLoomEntryPointsEnabled},loom_settings(siteId:$cloudId)@include(if:$includeMeetingRecorderEligibility){meetingRecordingsAvailable,meetingNotesEligible}\n  loom_connectedCalendars(siteId:$cloudId)@include(if:$includeMeetingRecorderEligibility){guid}}"
        }
    };
}();
$dc96dcb71a986382$var$node.hash = "992c3639759f7aa3511f220e9547ecc6";
var $dc96dcb71a986382$export$2e2bcd8739ae039 = $dc96dcb71a986382$var$node;
module.exports["default"] = $dc96dcb71a986382$export$2e2bcd8739ae039;

});

parcelRegister("i8Ofl", function(module, exports) {
const $bde9a1914731baf3$var$PRODUCT = 'Confluence Cloud';
const $bde9a1914731baf3$var$buildWorkspaceId = (tenantId, activationId)=>{
    return `ari:cloud:confluence:${tenantId}:workspace/${activationId}`;
};
const $bde9a1914731baf3$export$14ef296862e3705e = (tenantId, activationId)=>{
    const atlAttributionHeader = {
        atlWorkspaceId: $bde9a1914731baf3$var$buildWorkspaceId(tenantId, activationId),
        tenantId: tenantId,
        product: $bde9a1914731baf3$var$PRODUCT,
        service: 'cc-fe-bifrost'
    };
    return {
        'atl-attribution': JSON.stringify(atlAttributionHeader)
    };
};
module.exports["createAtlAttributionHeader"] = $bde9a1914731baf3$export$14ef296862e3705e;

});

parcelRegister("c5JFM", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $c8d6014c9c636b97$export$7c5b1b3e3108671e = ()=>(0, $9wGTI.fg)('twcg-2202-loom-meeting-nudge-ht-gate') || (0, $9wGTI.fg)('twcg-2202-loom-meeting-nudge-lt-gate');
module.exports["isMeetingRecorderEligibilityEnabled"] = $c8d6014c9c636b97$export$7c5b1b3e3108671e;

});

parcelRegister("cYe4v", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $8dwdz = parcelRequire("8dwdz");

const $9ecfddb6136413dc$export$a3777efa0eef336c = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
        $[0] = t0;
    } else t0 = $[0];
    const isMobileDeviceOrMobileWeb = t0;
    let t1;
    if ($[1] !== isConfluenceLicensed) {
        t1 = isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)("confluence_loom_beta_enabled");
        $[1] = isConfluenceLicensed;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    const isMobileDeviceOrMobileWeb = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    return isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)('confluence_loom_beta_enabled');
};
module.exports["useIsLoomBetaEnabled"] = $9ecfddb6136413dc$export$a3777efa0eef336c;

});

parcelRegister("dpJII", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bQm3c = parcelRequire("bQm3c");


var $5CUwy = parcelRequire("5CUwy");

const $42c1694041a86183$export$da228976f78945fd = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { skip: t2 } = t1;
    const skip = t2 === undefined ? false : t2;
    const { cloudId: cloudId, userId: userId, environment: environment } = (0, $bQm3c.useSessionData)();
    const [t3, t4] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { loomEntryPointVariant: loomEntryPointVariant } = t3;
    const { initLoomEntryPointVariant: initLoomEntryPointVariant } = t4;
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    let t5;
    let t6;
    if ($[2] !== cloudId || $[3] !== entryPointVariant || $[4] !== environment || $[5] !== initLoomEntryPointVariant || $[6] !== loading || $[7] !== skip || $[8] !== userId) {
        t5 = ()=>{
            if (skip) return;
            if (entryPointVariant === "NONE" && !loading) initLoomEntryPointVariant(cloudId, userId, environment);
        };
        t6 = [
            cloudId,
            initLoomEntryPointVariant,
            loading,
            entryPointVariant,
            skip,
            userId,
            environment
        ];
        $[2] = cloudId;
        $[3] = entryPointVariant;
        $[4] = environment;
        $[5] = initLoomEntryPointVariant;
        $[6] = loading;
        $[7] = skip;
        $[8] = userId;
        $[9] = t5;
        $[10] = t6;
    } else {
        t5 = $[9];
        t6 = $[10];
    }
    (0, $cozmU.useEffect)(t5, t6);
    if (entryPointVariant === "NONE") {
        let t7;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = {
                entryPointVariant: "NONE",
                loading: true
            };
            $[11] = t7;
        } else t7 = $[11];
        return t7;
    }
    return loomEntryPointVariant;
} : ({ skip: skip = false } = {})=>{
    const { cloudId: cloudId, userId: userId, environment: environment } = (0, $bQm3c.useSessionData)();
    const [{ loomEntryPointVariant: loomEntryPointVariant }, { initLoomEntryPointVariant: initLoomEntryPointVariant }] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    (0, $cozmU.useEffect)(()=>{
        if (skip) return;
        if (entryPointVariant === 'NONE' && !loading) initLoomEntryPointVariant(cloudId, userId, environment);
    }, [
        cloudId,
        initLoomEntryPointVariant,
        loading,
        entryPointVariant,
        skip,
        userId,
        environment
    ]);
    if (entryPointVariant === 'NONE') return {
        entryPointVariant: 'NONE',
        loading: true
    };
    return loomEntryPointVariant;
};
module.exports["useLoomPermissionStatus"] = $42c1694041a86183$export$da228976f78945fd;

});

parcelRegister("5CUwy", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $gXfti = parcelRequire("gXfti");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");



var $6mKj3 = parcelRequire("6mKj3");


var $8999o = parcelRequire("8999o");


var $lnyJf = parcelRequire("lnyJf");


var $8J8QJ = parcelRequire("8J8QJ");


var $3uzFB = parcelRequire("3uzFB");


var $2gAEP = parcelRequire("2gAEP");

var $9633e2f0bea217d1$export$ebe749be4eb13ac4 = /*#__PURE__*/ function(LoomTenantProvisionStatus) {
    LoomTenantProvisionStatus["PROVISIONED"] = "provisioned";
    LoomTenantProvisionStatus["NOT_PROVISIONED"] = "not-provisioned";
    LoomTenantProvisionStatus["ERROR"] = "error,";
    return LoomTenantProvisionStatus;
}({});
var $9633e2f0bea217d1$export$7909e54672d1c423 = /*#__PURE__*/ function(LoomUserPermissionStatus) {
    LoomUserPermissionStatus["PERMITTED"] = "permitted";
    LoomUserPermissionStatus["NOT_PERMITTED"] = "not-permitted";
    LoomUserPermissionStatus["ERROR"] = "error,";
    return LoomUserPermissionStatus;
}({});
const $9633e2f0bea217d1$var$getLoomTenantProvisionStatus = async ()=>{
    try {
        const licensedProducts = await (0, $c0rhi.queryInterop)({
            query: (0, $2gAEP.default),
            __callerPackage__: "loom-utils"
        });
        const isTenantLicensed = licensedProducts.data.confluence_tenantContext?.licensedProducts.some((product)=>product.productKey === 'loom' && product.licenseStatus === 'ACTIVE');
        return isTenantLicensed ? "provisioned" : "not-provisioned";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$export$85de6c803181afa9 = async (cloudId, userId, environment)=>{
    if ((0, $6mKj3.isExperimentEnabled)('confluence_frontend_loom_agg_perm_check_exp')) return $9633e2f0bea217d1$var$getLoomUserAggPermissionStatus(cloudId, userId);
    return $9633e2f0bea217d1$export$4fb5a1b2348fe5c4(cloudId, userId, environment);
};
const $9633e2f0bea217d1$export$4fb5a1b2348fe5c4 = async (cloudId, userId, environment)=>{
    const resourceId = `ari:cloud:loom::site/${cloudId}`;
    try {
        let permitted;
        {
            const response = await (0, $8J8QJ.postJson)(`/gateway/api/permissions/permitted`, {
                permissionId: 'write',
                resourceId: resourceId,
                checkProductStatus: true
            });
            permitted = response?.permitted;
        }
        return !!permitted ? "permitted" : "not-permitted";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$var$getLoomUserAggPermissionStatus = async (cloudId, userId)=>{
    if (!userId) return "not-permitted";
    const variables = (0, $3uzFB.getLoomUserPermissionQueryVariables)(cloudId, userId);
    try {
        const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
            query: (0, $3uzFB.LoomUserPermissionQuery),
            variables: variables,
            errorPolicy: 'all',
            interopApolloAggClient: true,
            __callerPackage__: "loom-utils"
        });
        if (error) throw error;
        return (0, $3uzFB.hasExactLoomUserPermission)(data, variables) ? "permitted" : "not-permitted";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$var$initialState = {
    loomEntryPointVariant: window.__SSR_LOOM_ENTRY_POINT__ ? window.__SSR_LOOM_ENTRY_POINT__ : {
        entryPointVariant: 'NONE'
    }
};
const $9633e2f0bea217d1$export$cbb01c57ec9c933e = {
    initLoomEntryPointVariant: (cloudId, userId, environment)=>async ({ getState: getState, setState: setState })=>{
            const state = getState();
            if (state.loomEntryPointVariant.entryPointVariant !== 'NONE') return;
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_FLOW',
                    loading: true
                }
            });
            const loomTenantProvisionStatus = await $9633e2f0bea217d1$var$getLoomTenantProvisionStatus();
            if (loomTenantProvisionStatus === "not-provisioned") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW'
                    }
                });
                return;
            }
            if (loomTenantProvisionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_JOIN',
                    loading: true
                }
            });
            const loomUserPermissionStatus = await $9633e2f0bea217d1$export$85de6c803181afa9(cloudId, userId, environment);
            if (loomUserPermissionStatus === "not-permitted") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN'
                    }
                });
                return;
            }
            if (loomUserPermissionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CO_USE'
                }
            });
        },
    // No preloader counterpart needed: setCrossJoinSuccess is a runtime-only action
    // triggered after a user completes the interactive cross-join flow (navigates to
    // Loom, gets provisioned, and returns). This cannot occur during SSR. The
    // window.__SSR_LOOM_ENTRY_POINT__ write updates the cached signal so that
    // useLoomEntryPointVariant sees CO_USE on subsequent client-side navigations
    // without re-running the permissions fetch — same pattern as crossFlowSuccessCheck.
    setCrossJoinSuccess: ()=>({ setState: setState })=>{
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CO_USE'
                }
            });
            window.__SSR_LOOM_ENTRY_POINT__ = {
                entryPointVariant: 'CO_USE'
            };
        },
    crossFlowSuccessCheck: ({ cloudId: cloudId, onCrossflowFailure: onCrossflowFailure, createAnalyticsEvent: createAnalyticsEvent, sourceComponent: sourceComponent })=>async ({ setState: setState })=>{
            // refetch license information since TCS doesn't update automatically
            try {
                const { ok: hasLoom, tries: tries } = await (0, $8999o.waitUntil)({
                    fn: ()=>(0, $lnyJf.fetchLicenseInformation)(cloudId),
                    condition: (info)=>info.products['loom']?.state === 'ACTIVE',
                    maxTries: 2,
                    // arbitrarily deciding on just 1 retry until we have more data to understand the eventual consistency here
                    retryWait: 500
                });
                (0, $gXfti.addUFOCustomData)({
                    pollingTries: tries,
                    hasLoom: hasLoom
                });
                if (hasLoom) {
                    // don't bother getLoomUserPermissionStatus here, we assume if the site has loom, the admin will have been given a license during provisioning
                    setState({
                        loomEntryPointVariant: {
                            entryPointVariant: 'CO_USE'
                        }
                    });
                    //This is needed for SSR to work correctly, since we skip logic in useLoomEntryPointVariant.ts if the entry point was SSR-ed
                    window.__SSR_LOOM_ENTRY_POINT__ = {
                        entryPointVariant: 'CO_USE'
                    };
                } else onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'success',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            hasLoom: hasLoom,
                            tries: tries,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            } catch (error) {
                onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'fail',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            error: error.message,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            }
        }
};
const $9633e2f0bea217d1$var$loomEntryPointVariantStore = (0, $8s9DV.createStore)({
    initialState: $9633e2f0bea217d1$var$initialState,
    actions: $9633e2f0bea217d1$export$cbb01c57ec9c933e,
    name: 'loomEntryPointVariantState'
});
const $9633e2f0bea217d1$export$9d93351985de2290 = (0, $kBr4q.createHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
const $9633e2f0bea217d1$export$fd0650c7a15c6ef2 = (0, $kBr4q.createActionsHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
module.exports["LoomTenantProvisionStatus"] = $9633e2f0bea217d1$export$ebe749be4eb13ac4;
module.exports["LoomUserPermissionStatus"] = $9633e2f0bea217d1$export$7909e54672d1c423;
module.exports["getLoomUserLegacyPermissionStatus"] = $9633e2f0bea217d1$export$4fb5a1b2348fe5c4;
module.exports["useLoomEntryPointVariantState"] = $9633e2f0bea217d1$export$9d93351985de2290;
module.exports["useLoomEntryPointVariantActions"] = $9633e2f0bea217d1$export$fd0650c7a15c6ef2;

});

parcelRegister("8999o", function(module, exports) {
const $887bf6ed89c38788$export$4e57ed416e50788e = async ({ fn: fn, condition: condition, retryWait: retryWait, maxTries: maxTries })=>{
    let tries = 0;
    while(true){
        tries++;
        const result = await fn();
        const ok = condition(result);
        if (tries === maxTries || ok) return {
            ok: ok,
            result: result,
            tries: tries
        };
        await new Promise((resolve)=>setTimeout(resolve, retryWait));
    }
};
module.exports["waitUntil"] = $887bf6ed89c38788$export$4e57ed416e50788e;

});

parcelRegister("lnyJf", function(module, exports) {

var $8J8QJ = parcelRequire("8J8QJ");

const $1f2e3e69723febb9$export$a573b79a27d213cc = (cloudId)=>(0, $8J8QJ.fetchJSON)(`/gateway/api/xflow/${cloudId}/license-information`);
module.exports["fetchLicenseInformation"] = $1f2e3e69723febb9$export$a573b79a27d213cc;

});

parcelRegister("8J8QJ", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $d6NtA = parcelRequire("d6NtA");

const $a326082f26863093$export$c776284ef4b1209a = (url, data)=>{
    const fetchOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
const $a326082f26863093$export$81bec6e38e8b706b = (url)=>{
    const fetchOptions = {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ...Boolean(undefined) && Boolean(undefined) && !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': 'identity-platform'
            } : {}
        }
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
module.exports["postJson"] = $a326082f26863093$export$c776284ef4b1209a;
module.exports["fetchJSON"] = $a326082f26863093$export$81bec6e38e8b706b;

});

parcelRegister("3uzFB", function(module, exports) {

var $keH2u = parcelRequire("keH2u");

const $9ee481529bbe8b4d$export$a4bb6b905bc500e2 = (0, $keH2u.default);
const $9ee481529bbe8b4d$export$8d50de945dbf45ca = (cloudId, userId)=>({
        principalId: `ari:cloud:identity::user/${userId}`,
        loomResourceId: `ari:cloud:loom::site/${cloudId}`
    });
const $9ee481529bbe8b4d$export$b048e9c33b8e482 = (data, variables)=>{
    const matchingRows = data?.bulkPermitted?.filter((row)=>row?.principalId === variables.principalId && row?.resourceId === variables.loomResourceId && row?.permissionId === 'write') ?? [];
    if (matchingRows.length < 1) return false;
    return matchingRows.every((row)=>row?.permitted === true);
};
module.exports["LoomUserPermissionQuery"] = $9ee481529bbe8b4d$export$a4bb6b905bc500e2;
module.exports["getLoomUserPermissionQueryVariables"] = $9ee481529bbe8b4d$export$8d50de945dbf45ca;
module.exports["hasExactLoomUserPermission"] = $9ee481529bbe8b4d$export$b048e9c33b8e482;

});

parcelRegister("keH2u", function(module, exports) {
/**
 * @generated SignedSource<<9936c66f475f5b5cae80af06b548f8cb>>
 * @relayHash 1246767ea7fb9149278e67c3ec09752c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b59faaba67fb092ef603e9f684b1d3e070c6185add127d90ea41320066a6b1e5
const $ebcff904befcd9cb$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "loomResourceId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "principalId"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "permissionIds",
                    "value": [
                        "write"
                    ]
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "principalIds.0",
                            "variableName": "principalId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "principalIds"
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "resourceIds.0",
                            "variableName": "loomResourceId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "resourceIds"
                }
            ],
            "concreteType": "BulkPermittedResponse",
            "kind": "LinkedField",
            "name": "bulkPermitted",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "principalId"
                },
                {
                    "kind": "ScalarField",
                    "name": "resourceId"
                },
                {
                    "kind": "ScalarField",
                    "name": "permissionId"
                },
                {
                    "kind": "ScalarField",
                    "name": "permitted"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "loomUserPermissionQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "loomUserPermissionQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "1246767ea7fb9149278e67c3ec09752c",
            "id": "b59faaba67fb092ef603e9f684b1d3e070c6185add127d90ea41320066a6b1e5",
            "metadata": {},
            "name": "loomUserPermissionQuery",
            "operationKind": "query",
            "text": "query loomUserPermissionQuery($principalId:String!,$loomResourceId:String!){bulkPermitted(principalIds:[$principalId],resourceIds:[$loomResourceId],permissionIds:[\"write\"]){principalId,resourceId,permissionId,permitted}}"
        }
    };
}();
$ebcff904befcd9cb$var$node.hash = "714c5537c580f754bda23bcf99534b30";
var $ebcff904befcd9cb$export$2e2bcd8739ae039 = $ebcff904befcd9cb$var$node;
module.exports["default"] = $ebcff904befcd9cb$export$2e2bcd8739ae039;

});

parcelRegister("2gAEP", function(module, exports) {
/**
 * @generated SignedSource<<7e1563bf12c221b07284eee871d1f539>>
 * @relayHash e7355c15b066e2e1bf0badd5083ad1e0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af
const $936b36fbe81f4fb7$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "e7355c15b066e2e1bf0badd5083ad1e0",
            "id": "828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af",
            "metadata": {},
            "name": "useLoomTenantProvisionStatusQuery",
            "operationKind": "query",
            "text": "query useLoomTenantProvisionStatusQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}"
        }
    };
}();
$936b36fbe81f4fb7$var$node.hash = "21c387cdafea215b61e4183319580a69";
var $936b36fbe81f4fb7$export$2e2bcd8739ae039 = $936b36fbe81f4fb7$var$node;
module.exports["default"] = $936b36fbe81f4fb7$export$2e2bcd8739ae039;

});

parcelRegister("8akfd", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $d9cc5462c799c5c3$var$initialState = {
    messageIdSelectedForPreview: null,
    invocationIdSelectedForPreview: null,
    stagingAreaMode: undefined,
    stagingAreaEntryPoint: '',
    prompt: '',
    promptAppConnectorSources: [],
    isThirdPartyPromptStaged: false,
    dynamicUiType: undefined,
    dynamicUiSubtype: undefined,
    userSelectedDynamicUiSubtype: undefined,
    dynamicUiSource: undefined,
    interactionSource: undefined,
    isRemixUpdating: false,
    forceSkipAutoConversationSelection: false,
    currentDisplayMessageId: undefined,
    closeModalCallback: null
};
const $d9cc5462c799c5c3$var$actions = {
    setMessageIdSelectedForPreview: (messageId)=>({ setState: setState })=>{
            setState({
                messageIdSelectedForPreview: messageId
            });
        },
    getMessageIdSelectedForPreview: ()=>({ getState: getState })=>{
            return getState().messageIdSelectedForPreview;
        },
    setStagingAreaMode: (mode, entryPoint)=>({ setState: setState })=>{
            setState({
                stagingAreaMode: mode,
                stagingAreaEntryPoint: entryPoint ?? ''
            });
        },
    setStagingAreaEntryPoint: (entryPoint)=>({ setState: setState })=>{
            setState({
                stagingAreaEntryPoint: entryPoint ?? ''
            });
        },
    setPrompt: (prompt)=>({ setState: setState })=>{
            setState({
                prompt: prompt
            });
        },
    /**
   * Writes `isThirdPartyPromptStaged` in the same update, so the flag cannot drift from the
   * source list. Omitting `isThirdPartyPrompt` derives it from the list, which is what the
   * one-argument call has always meant: before this experiment a non-empty list was the only way
   * to stage a 3P prompt. Pass it for a 3P tile that carried no connectors — an empty list the
   * reader must still attribute to the experiment (CCINT-8714).
   */ setPromptAppConnectorSources: (promptAppConnectorSources, options)=>({ setState: setState })=>{
            setState({
                promptAppConnectorSources: promptAppConnectorSources,
                isThirdPartyPromptStaged: options?.isThirdPartyPrompt ?? promptAppConnectorSources.length > 0
            });
        },
    setInvocationIdSelectedForPreview: (invocationId)=>({ setState: setState })=>{
            setState({
                invocationIdSelectedForPreview: invocationId
            });
        },
    getInvocationIdSelectedForPreview: ()=>({ getState: getState })=>{
            return getState().invocationIdSelectedForPreview;
        },
    setIsRemixUpdating: (isUpdating)=>({ setState: setState })=>{
            setState({
                isRemixUpdating: isUpdating
            });
        },
    setDynamicUiContext: (dynamicUiType, dynamicUiSubtype, dynamicUiSource)=>({ setState: setState })=>{
            setState({
                dynamicUiType: dynamicUiType,
                dynamicUiSubtype: dynamicUiSubtype,
                dynamicUiSource: dynamicUiSource
            });
        },
    setUserSelectedDynamicUiSubtype: (userSelectedDynamicUiSubtype)=>({ setState: setState })=>{
            setState({
                userSelectedDynamicUiSubtype: userSelectedDynamicUiSubtype
            });
        },
    setInteractionSource: (interactionSource)=>({ setState: setState })=>{
            setState({
                interactionSource: interactionSource
            });
        },
    resetStagingArea: ()=>({ setState: setState })=>{
            setState({
                messageIdSelectedForPreview: null,
                invocationIdSelectedForPreview: null,
                isRemixUpdating: false,
                stagingAreaMode: undefined,
                stagingAreaEntryPoint: '',
                promptAppConnectorSources: [],
                isThirdPartyPromptStaged: false,
                dynamicUiType: undefined,
                dynamicUiSubtype: undefined,
                userSelectedDynamicUiSubtype: undefined,
                dynamicUiSource: undefined,
                interactionSource: undefined,
                forceSkipAutoConversationSelection: false,
                currentDisplayMessageId: undefined
            });
        },
    setForceSkipAutoConversationSelection: (forceSkip)=>({ setState: setState })=>{
            setState({
                forceSkipAutoConversationSelection: forceSkip
            });
        },
    setCurrentDisplayMessageId: (messageId)=>({ setState: setState })=>{
            setState({
                currentDisplayMessageId: messageId
            });
        },
    setCloseModalCallback: (closeModalCallback)=>({ setState: setState })=>{
            setState({
                closeModalCallback: closeModalCallback
            });
        },
    closeStagingAreaModal: ()=>({ getState: getState })=>{
            getState().closeModalCallback?.();
        }
};
const $d9cc5462c799c5c3$var$store = (0, $8s9DV.createStore)({
    initialState: $d9cc5462c799c5c3$var$initialState,
    actions: $d9cc5462c799c5c3$var$actions
});
const $d9cc5462c799c5c3$export$a2795b51ce92008f = (0, $kBr4q.createHook)($d9cc5462c799c5c3$var$store, {
    selector: (state)=>state.messageIdSelectedForPreview
});
const $d9cc5462c799c5c3$export$916334da9df8d04 = (0, $kBr4q.createHook)($d9cc5462c799c5c3$var$store);
const $d9cc5462c799c5c3$export$8f9a13b17bec42d5 = (0, $kBr4q.createActionsHook)($d9cc5462c799c5c3$var$store);
const $d9cc5462c799c5c3$export$5a57f796673aabea = (0, $kBr4q.createStateHook)($d9cc5462c799c5c3$var$store);
module.exports["useMessageIdSelectedForPreview"] = $d9cc5462c799c5c3$export$a2795b51ce92008f;
module.exports["useStagingArea"] = $d9cc5462c799c5c3$export$916334da9df8d04;
module.exports["useStagingAreaActions"] = $d9cc5462c799c5c3$export$8f9a13b17bec42d5;
module.exports["useStagingAreaState"] = $d9cc5462c799c5c3$export$5a57f796673aabea;

});

parcelRegister("9cZ1w", function(module, exports) {

var $epLE5 = parcelRequire("epLE5");


const $486bada329940e5a$export$f6e059b56d9aeb26 = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("cUCD4"))).showCreateWithRovoModalCloseFeedbackFlagThunk);
module.exports["useLazyShowFeedbackFlag"] = $486bada329940e5a$export$f6e059b56d9aeb26;

});

parcelRegister("epLE5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $dfceb6b0f6d6cccb$export$729b27bc0f344ffe = (loader)=>{
    return (...deps)=>(0, $cozmU.useCallback)((...args)=>{
            return loader().then((thunk)=>thunk(...deps)(...args));
        }, // Linter doesn't like spread syntax
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            ...deps
        ]);
};
module.exports["createLazyCallbackHook"] = $dfceb6b0f6d6cccb$export$729b27bc0f344ffe;

});

parcelRegister("cUCD4", function(module, exports) {

let $9668adf351322c9b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9668adf351322c9b$var$load("fEHF5"),
    $9668adf351322c9b$var$load("dQT3c"),
    $9668adf351322c9b$var$load("kHXvF"),
    $9668adf351322c9b$var$load("6wr18"),
    $9668adf351322c9b$var$load("ffEVr"),
    $9668adf351322c9b$var$load("Wowvf"),
    $9668adf351322c9b$var$load("7gL7H"),
    $9668adf351322c9b$var$load("hhss7"),
    $9668adf351322c9b$var$load("k7MRD")
]).then(()=>parcelRequire('hlCkz'));

});

parcelRegister("zCcSI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $kwzZh = parcelRequire("kwzZh");


var $6mKj3 = parcelRequire("6mKj3");


var $32x2E = parcelRequire("32x2E");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $8aF6s = parcelRequire("8aF6s");


var $c96tF = parcelRequire("c96tF");


var $9cZ1w = parcelRequire("9cZ1w");

const $e34c3f63766da5b3$var$CLOSE_MODAL_DELAY = 500;
const $e34c3f63766da5b3$export$a9c99c9d804e8c41 = ({ assistanceServiceConfigHeaders: assistanceServiceConfigHeaders = {}, preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose = false, preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose = false })=>{
    const { cloudId: cloudId, orgId: orgId, userId: userId } = (0, $bQm3c.useSessionData)();
    const emojiProvider = (0, $cozmU.useMemo)(()=>{
        return (0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
            cloudId: cloudId,
            userId: userId
        });
    }, [
        userId,
        cloudId
    ]);
    const assistanceServiceConfig = {
        headers: assistanceServiceConfigHeaders,
        baseUrl: '/gateway/api/assist'
    };
    // Keep the config object identity stable when its semantic inputs are stable.
    const memoizedAssistanceServiceConfig = (0, $cozmU.useMemo)(()=>({
            headers: assistanceServiceConfigHeaders,
            baseUrl: '/gateway/api/assist'
        }), [
        assistanceServiceConfigHeaders
    ]);
    const selectedAssistanceServiceConfig = (0, $6mKj3.expValEquals)('rovo_ttai_segment_render_stabilization', 'isEnabled', true) ? memoizedAssistanceServiceConfig : assistanceServiceConfig;
    const memoizedConfig = (0, $cozmU.useMemo)(()=>({
            displaySubmitFlag: true,
            siteId: cloudId,
            product: 'confluence',
            orgId: orgId,
            assistanceServiceConfig: selectedAssistanceServiceConfig,
            emojiProvider: emojiProvider,
            userId: userId ?? undefined,
            preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose,
            preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose
        }), [
        cloudId,
        emojiProvider,
        orgId,
        preventAbortRequestsOnStagingModalClose,
        preventAbortRequestsOnStandaloneChatClose,
        selectedAssistanceServiceConfig,
        userId
    ]);
    return (0, $6mKj3.expValEquals)('rovo_ttai_segment_render_stabilization', 'isEnabled', true) ? memoizedConfig : {
        displaySubmitFlag: true,
        siteId: cloudId,
        product: 'confluence',
        orgId: orgId,
        assistanceServiceConfig: selectedAssistanceServiceConfig,
        emojiProvider: emojiProvider,
        userId: userId ?? undefined,
        preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose,
        preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose
    };
};
const $e34c3f63766da5b3$export$577864d1e6735f1b = ({ flags: flags, customGreeting: customGreeting, shouldShowGreeting: shouldShowGreeting, shouldHideFeedback: shouldHideFeedback })=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const intl = (0, $kSwu1.useIntl)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const navigateToObject = (0, $cozmU.useCallback)(async ({ baseUrl: baseUrlNav, path: path })=>{
        (0, $c96tF.createNavigateToObject)(push)({
            baseUrl: baseUrlNav,
            path: path
        });
        // artifical delay before closing the modal gives the app a moment to transition to the created object while the modal is still open, this creates a smoother transition from modal to new object.
        // For non-SPA transitions, a full page reload will happen so this delay will be ignored
        await new Promise((r)=>setTimeout(r, $e34c3f63766da5b3$var$CLOSE_MODAL_DELAY));
    }, [
        push
    ]);
    const showCreateWithRovoModalCloseFeedbackFlag = (0, $9cZ1w.useLazyShowFeedbackFlag)(flags, intl, showModal, createAnalyticsEvent);
    const handleCloseSmartCreate = (0, $cozmU.useCallback)(({ feedbackVariant: feedbackVariant, currentConversationId: currentConversationId, traceId: traceId, requestId: requestId, remixMetadata: remixMetadata, contentType: contentType, contentMode: contentMode })=>{
        if (shouldHideFeedback) return;
        if (feedbackVariant === undefined) return;
        showCreateWithRovoModalCloseFeedbackFlag({
            feedbackVariant: feedbackVariant,
            contentType: contentType,
            contentMode: contentMode,
            cloudId: cloudId,
            currentConversationId: currentConversationId ?? undefined,
            traceId: traceId,
            requestId: requestId,
            remixMetadata: remixMetadata
        });
    }, [
        showCreateWithRovoModalCloseFeedbackFlag,
        shouldHideFeedback,
        cloudId
    ]);
    // Keep uiConfig identity stable when handler/greeting inputs are stable.
    const memoizedUiConfig = (0, $cozmU.useMemo)(()=>({
            customHandlers: {
                handleSubmitSmartCreate: navigateToObject,
                handleCloseSmartCreate: handleCloseSmartCreate
            },
            elements: {
                voiceDictationButton: true,
                shouldShowGreeting: shouldShowGreeting ?? undefined
            },
            customGreeting: customGreeting ?? undefined
        }), [
        customGreeting,
        handleCloseSmartCreate,
        navigateToObject,
        shouldShowGreeting
    ]);
    return (0, $6mKj3.expValEquals)('rovo_ttai_segment_render_stabilization', 'isEnabled', true) ? memoizedUiConfig : {
        customHandlers: {
            handleSubmitSmartCreate: navigateToObject,
            handleCloseSmartCreate: handleCloseSmartCreate
        },
        elements: {
            voiceDictationButton: true,
            shouldShowGreeting: shouldShowGreeting ?? undefined
        },
        customGreeting: customGreeting ?? undefined
    };
};
module.exports["useConversationAssistantConfig"] = $e34c3f63766da5b3$export$a9c99c9d804e8c41;
module.exports["useConversationAssistantUiConfig"] = $e34c3f63766da5b3$export$577864d1e6735f1b;

});

parcelRegister("c96tF", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $8f856ee350559225$export$b2e60ce4b3907e57 = (baseUrl)=>{
    const host = window.location.host;
    return baseUrl.includes(host) && baseUrl.includes((0, $jlIaF.CONTEXT_PATH));
};
// database need flow query param for special case handling
const $8f856ee350559225$var$addFlowParam = (baseUrl, path)=>{
    const url = new URL(path, baseUrl);
    url.searchParams.set('flow', 'aiCreate');
    return url.pathname + url.search;
};
const $8f856ee350559225$export$38454a8d1321e65a = (push)=>({ baseUrl: baseUrl, path: path })=>{
        const isDatabase = Boolean((0, $1NBp8.DATABASE_VIEW).match(`${baseUrl}${path}`));
        let finalPath = path;
        if (isDatabase) finalPath = $8f856ee350559225$var$addFlowParam(baseUrl, path);
        if ($8f856ee350559225$export$b2e60ce4b3907e57(baseUrl)) push((0, $jlIaF.CONTEXT_PATH) + finalPath);
        else window.location.href = `${baseUrl}${finalPath}`;
    };
module.exports["createNavigateToObject"] = $8f856ee350559225$export$38454a8d1321e65a;

});

parcelRegister("6Mfv2", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ef33fad4d0e8632$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $4ef33fad4d0e8632$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var dateToCompare = (0, $dkBOe.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("5SS4O", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $kBr4q = parcelRequire("kBr4q");

var $fjHkB = parcelRequire("fjHkB");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");


var $8A2GO = parcelRequire("8A2GO");

const $65e219e9f9df9520$var$store = (0, $8s9DV.createStore)({
    initialState: {
        cache: {},
        epoch: 0
    },
    actions: {
        updateCacheEntry: (key, value)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const currentCacheEntry = state.cache[key] ?? {
                    data: null,
                    error: null,
                    isFetching: false
                };
                const newCacheEntry = {
                    ...currentCacheEntry,
                    ...value
                };
                setState({
                    cache: {
                        ...state.cache,
                        [key]: newCacheEntry
                    }
                });
            },
        getCacheEntry: (key)=>({ getState: getState })=>{
                const state = getState();
                return state.cache[key];
            },
        deleteCacheEntry: (key)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const cache = {
                    ...state.cache
                };
                delete cache[key];
                setState({
                    cache: cache
                });
            },
        clearCache: ()=>({ setState: setState, getState: getState })=>{
                setState({
                    cache: {},
                    epoch: getState().epoch + 1
                });
            }
    }
});
const $65e219e9f9df9520$var$getCacheEpoch = ()=>(0, $c6StJ.defaultRegistry).getStore($65e219e9f9df9520$var$store).storeState.getState().epoch;
const $65e219e9f9df9520$export$467f2e03eb04239a = ()=>{
    const storeApi = (0, $c6StJ.defaultRegistry).getStore($65e219e9f9df9520$var$store);
    storeApi.actions.clearCache();
};
const $65e219e9f9df9520$var$selector = (0, $fjHkB.createSelector)((state)=>state.cache, (state)=>state.epoch, (_, props)=>props.key, (_, props)=>props.initialQueryEnabled, /**
 * Based on testing, the result of this selector will be compared with previous result using `shallowEqual`
 * and it will determine whether to rerender the component
 * and also after looking at docs in https://github.com/atlassian/react-sweet-state/blob/master/src/utils/memoize.js#L38
 *
 * e.g. for `enabled` true condition:
 * -> 1st call -> cache[key] === undefined; so it will return { data: null, error: null, isFetching: true }
 * -> 2nd call -> cache[key] !== undefined; so it will return cache[key]; however shallowEqual(cache[key], previousResult) will return true -> so no rerender
 *
 * To test this, run the unit test, and then force this function to return new stuff on every call
 * e.g. `return { ...result, random: Math.random() };`
 * it will result in increase renderCount in the unit test
 */ (cache, epoch, key, initialQueryEnabled)=>({
        ...cache[key] ?? {
            data: null,
            error: null,
            isFetching: initialQueryEnabled
        },
        epoch: epoch
    }));
const $65e219e9f9df9520$var$useCacheEntry = (0, $kBr4q.createHook)($65e219e9f9df9520$var$store, {
    selector: $65e219e9f9df9520$var$selector
});
const $65e219e9f9df9520$export$96097db97bddd5cd = ({ queryKey: queryKeyParts, queryFn: queryFn, onStart: onStart, onSuccess: onSuccess, onError: onError })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const storeApi = (0, $c6StJ.defaultRegistry).getStore($65e219e9f9df9520$var$store);
    const actions = storeApi.actions;
    if (actions.getCacheEntry(queryKey) !== undefined) return;
    onStart?.();
    const epochAtRequestStart = $65e219e9f9df9520$var$getCacheEpoch();
    actions.updateCacheEntry(queryKey, {
        isFetching: true,
        data: null,
        error: null
    });
    queryFn().then((response)=>{
        if ($65e219e9f9df9520$var$getCacheEpoch() !== epochAtRequestStart) return;
        actions.updateCacheEntry(queryKey, {
            data: response,
            error: null,
            isFetching: false
        });
        onSuccess?.(response);
    }).catch((error)=>{
        // Cache-side errors are intentionally swallowed: a downstream `useQuery`
        // observer (if any) must refetch and surface the error via its normal
        // path. Remove the warm entry so the failed prefetch does not poison the
        // shared cache for the cold path — unless the key has since been cleared
        // and refilled, in which case the entry is another request's to remove.
        if ($65e219e9f9df9520$var$getCacheEpoch() === epochAtRequestStart) actions.deleteCacheEntry(queryKey);
        onError?.(error);
    });
};
const $65e219e9f9df9520$export$dd0a697e1782aedd = ({ queryKey: queryKeyParts, queryFn: queryFn, onSuccess: onSuccess, onError: onError, enabled: enabled = true, refetchOnWindowFocus: refetchOnWindowFocus = false })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const queryFnRef = (0, $cozmU.useRef)(queryFn);
    queryFnRef.current = queryFn;
    const onSuccessRef = (0, $cozmU.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $cozmU.useRef)(onError);
    onErrorRef.current = onError;
    const [cache, { updateCacheEntry: updateCacheEntry, getCacheEntry: getCacheEntry }] = $65e219e9f9df9520$var$useCacheEntry({
        key: queryKey,
        initialQueryEnabled: enabled
    });
    const fetchData = (0, $cozmU.useCallback)(async ()=>{
        const epochAtRequestStart = $65e219e9f9df9520$var$getCacheEpoch();
        updateCacheEntry(queryKey, {
            isFetching: true
        });
        try {
            const response = await queryFnRef.current();
            // The clear already dropped this request's entry, and whatever is under the key now
            // belongs to a later request — so write nothing at all, including `isFetching: false`.
            if ($65e219e9f9df9520$var$getCacheEpoch() !== epochAtRequestStart) return null;
            updateCacheEntry(queryKey, {
                data: response,
                error: null
            });
            onSuccessRef.current?.(response);
            return response;
        } catch (error) {
            const apiError = (0, $8A2GO.mapErrorToApiError)(error);
            if ($65e219e9f9df9520$var$getCacheEpoch() !== epochAtRequestStart) return null;
            updateCacheEntry(queryKey, {
                error: apiError
            });
            onErrorRef.current?.(apiError);
        } finally{
            if ($65e219e9f9df9520$var$getCacheEpoch() === epochAtRequestStart) updateCacheEntry(queryKey, {
                isFetching: false
            });
        }
        return null;
    }, [
        updateCacheEntry,
        queryKey
    ]);
    const updateCache = (0, $cozmU.useCallback)((data)=>{
        updateCacheEntry(queryKey, {
            data: data
        });
    }, [
        updateCacheEntry,
        queryKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (enabled && refetchOnWindowFocus) {
            const unbind = (0, $cbY7C.bind)(window, {
                // We use visibilitychange instead of focus to prevent triggering refetch when moving between iframes such as agent embed
                type: 'visibilitychange',
                listener: ()=>{
                    if (enabled && refetchOnWindowFocus && !getCacheEntry(queryKey)?.isFetching) {
                        if (document.visibilityState === 'visible') fetchData();
                    }
                }
            });
            return unbind;
        }
    }, [
        enabled,
        fetchData,
        getCacheEntry,
        queryKey,
        refetchOnWindowFocus
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!getCacheEntry(queryKey) && enabled) fetchData();
    }, [
        queryKey,
        fetchData,
        enabled,
        getCacheEntry,
        cache.epoch
    ]);
    return {
        data: cache.data,
        error: cache.error,
        isFetching: cache.isFetching,
        refetch: fetchData,
        updateCache: updateCache
    };
};
module.exports["clearQueryCache"] = $65e219e9f9df9520$export$467f2e03eb04239a;
module.exports["prefetchQuery"] = $65e219e9f9df9520$export$96097db97bddd5cd;
module.exports["useQuery"] = $65e219e9f9df9520$export$dd0a697e1782aedd;

});

parcelRegister("mW7G5", function(module, exports) {
$parcel$export(module.exports, "expVal", () => (parcelRequire("7aoyv")).expVal);
$parcel$export(module.exports, "expValNoExposure", () => (parcelRequire("2vg8D")).expValNoExposure);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /* eslint-disable @atlaskit/editor/no-re-export -- deprecated shims re-exporting the split `expVal`/`expValNoExposure` modules for backwards compatibility (VOLTC-139). */ 
var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $7OZjB = parcelRequire("7OZjB");


var $htnjC = parcelRequire("htnjC");


var $72aLq = parcelRequire("72aLq");


var $7aoyv = parcelRequire("7aoyv");


var $2vg8D = parcelRequire("2vg8D");

function $b932e71e6f49f771$export$48708229abf6ab93({ experimentName: experimentName, experimentParam: experimentParam, defaultValue: defaultValue, fireExperimentExposure: fireExperimentExposure }) {
    const experimentConfig = (0, $htnjC.editorExperimentsConfig)[experimentName];
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error(`Editor experiment configuration is not defined ${experimentName}. Likely the experiment does not exist or editor package versions are misaligned`);
    if ((0, $72aLq._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    // @ts-ignore need to loosen the type here to allow for any experiment name
    return (0, $72aLq._overrides)[experimentName];
    // Check for parameter overrides
    const paramOverride = (0, $72aLq._paramOverrides)[experimentName]?.[experimentParam];
    if (paramOverride !== undefined) return paramOverride;
    // If client is not initialized, we return the default value
    if (!(0, $cXtTj.default).initializeCompleted()) return defaultValue;
    if (!(0, $72aLq._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return defaultValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig?.productKeys?.[0, $72aLq._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return defaultValue;
    const resolvedExperimentKey = !(0, $htnjC.disallowsProductKeys).includes(experimentName) && (0, $iDrrr.fg)('platform_editor_experiments_use_product_keys') ? experimentKey : experimentName;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $cXtTj.default).getExperimentValue(resolvedExperimentKey, experimentParam, defaultValue, {
        fireExperimentExposure: fireExperimentExposure
    });
    // Duplicated from /confluence/next/packages/feature-experiments/src/index.ts
    (0, $7OZjB.addFeatureFlagAccessed)(`${resolvedExperimentKey}:${experimentParam}`, experimentValue);
    return experimentValue;
}
module.exports["expValInternal"] = $b932e71e6f49f771$export$48708229abf6ab93;

});

parcelRegister("7aoyv", function(module, exports) {

var $mW7G5 = parcelRequire("mW7G5");

function $49077a760efbbc32$export$9db1624a8af791a4(experimentName, experimentParam, defaultValue) {
    return (0, $mW7G5.expValInternal)({
        experimentName: experimentName,
        experimentParam: experimentParam,
        defaultValue: defaultValue,
        fireExperimentExposure: true
    });
}
module.exports["expVal"] = $49077a760efbbc32$export$9db1624a8af791a4;

});

parcelRegister("2vg8D", function(module, exports) {

var $mW7G5 = parcelRequire("mW7G5");

function $77b1b44f5a6ee78c$export$94f132839aec533f(experimentName, experimentParam, defaultValue) {
    return (0, $mW7G5.expValInternal)({
        experimentName: experimentName,
        experimentParam: experimentParam,
        defaultValue: defaultValue,
        fireExperimentExposure: false
    });
}
module.exports["expValNoExposure"] = $77b1b44f5a6ee78c$export$94f132839aec533f;

});

parcelRegister("8lt5O", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $464fa95e1d18f18e$var$rovoEntitlementStore = (0, $8s9DV.createStore)({
    initialState: {
        isRovoEnabled: false
    },
    name: 'RovoEntitlementStore',
    actions: {
        setIsRovoEnabled: (isRovoEnabled, reason)=>({ setState: setState })=>{
                setState({
                    isRovoEnabled: isRovoEnabled,
                    reason: reason
                });
            }
    }
});
const $464fa95e1d18f18e$var$useStateHook = (0, $kBr4q.createStateHook)($464fa95e1d18f18e$var$rovoEntitlementStore);
const $464fa95e1d18f18e$export$66d5dd4be64dea43 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const result = $464fa95e1d18f18e$var$useStateHook();
    let t0;
    if ($[0] !== result) {
        t0 = {
            ...result,
            isRovoEnabled: result.isRovoEnabled
        };
        $[0] = result;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const result = $464fa95e1d18f18e$var$useStateHook();
    return {
        ...result,
        isRovoEnabled: result.isRovoEnabled
    };
};
const $464fa95e1d18f18e$export$8004893135276275 = (0, $kBr4q.createActionsHook)($464fa95e1d18f18e$var$rovoEntitlementStore);
const $464fa95e1d18f18e$export$d03a05ad8547472c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const { isRovoEnabled: isRovoEnabled } = t0;
    const { setIsRovoEnabled: setIsRovoEnabled } = $464fa95e1d18f18e$export$8004893135276275();
    setIsRovoEnabled(isRovoEnabled);
    return null;
} : ({ isRovoEnabled: isRovoEnabled })=>{
    const { setIsRovoEnabled: setIsRovoEnabled } = $464fa95e1d18f18e$export$8004893135276275();
    (0, $cozmU.useMemo)(()=>{
        setIsRovoEnabled(isRovoEnabled);
    }, [
        isRovoEnabled,
        setIsRovoEnabled
    ]);
    return null;
};
module.exports["useRovoEntitlement"] = $464fa95e1d18f18e$export$66d5dd4be64dea43;
module.exports["useRovoEntitlementActions"] = $464fa95e1d18f18e$export$8004893135276275;
module.exports["RovoEntitlementSetter"] = $464fa95e1d18f18e$export$d03a05ad8547472c;

});

parcelRegister("dSCNl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $blKf8 = parcelRequire("blKf8");

const $78dfed354051ab06$export$e83755c3ab7a4493 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $blKf8.uiConfig));
} : ()=>(0, $cozmU.useContext)((0, $blKf8.uiConfig));
module.exports["useUIConfig"] = $78dfed354051ab06$export$e83755c3ab7a4493;

});

parcelRegister("blKf8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2zlSy = parcelRequire("2zlSy");

const $25b69de57535dd1e$export$c85ba824665b708f = (0, $cozmU.createContext)((0, $2zlSy.initialState));
module.exports["uiConfig"] = $25b69de57535dd1e$export$c85ba824665b708f;

});

parcelRegister("2zlSy", function(module, exports) {
const $25fc89fcc6d2e62b$export$d4c72bab9d6cc13a = {
    fullScreen: false,
    externalEmbed: false,
    isContextPanelEnabled: false,
    customHandlers: {
        handleDeepLinkClick: undefined,
        handleSubmitSmartCreate: ()=>{}
    },
    isBitbucketBetaEnabled: false,
    customFeedbackCategories: undefined,
    stagingAreaRef: undefined,
    promptInputDroppableUrls: undefined,
    enableBrowserContextBanner: false,
    disableSettingsModal: false,
    enableSkills: true,
    enableAutoSuggest: true,
    enableMiniModalResize: true,
    browserContextSanitizer: undefined,
    elements: {
        closeButton: true,
        backButton: true,
        newChatButton: true,
        fullscreenButton: true,
        createAgentButton: true,
        browseAgentsButton: true,
        agentsMenu: true,
        navbar: true,
        mainChatHeader: true,
        stagingAreaEnabled: false,
        voiceDictationButton: false,
        fileUploadButton: true,
        chatModeMenuButton: true,
        maxModeButton: true,
        shouldShowConversationActions: true,
        shouldShowContextBanner: true
    }
};
module.exports["initialState"] = $25fc89fcc6d2e62b$export$d4c72bab9d6cc13a;

});

parcelRegister("lHQAj", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $4WmbV = parcelRequire("4WmbV");

const $5558feba06e8dbf9$export$60332b2344f7fe41 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== children) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children) < 2 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, children);
        $[3] = children;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardSectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
            ...props,
            withTasteAndToneStyling: true,
            buttonGroupAlignment: "right"
        }));
        $[5] = props;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== t1 || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardLayout, null, t1, t2);
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardLayout, null, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children) < 2 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardSectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        ...props,
        withTasteAndToneStyling: true,
        buttonGroupAlignment: "right"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardLayout = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _0hPCNLDIqT _0KLXruoI2d _1mT5xdRAKS",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _0hPCNLDIqT _0KLXruoI2d _1mT5xdRAKS",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardSectionMessageContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4FKVYENHnM _4xdlr0FlnN",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYENHnM _4xdlr0FlnN",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardContentsContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2Xe1MPzUZr",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2Xe1MPzUZr",
            __cmplp.className
        ])
    });
});
$5558feba06e8dbf9$var$CardContentsContainer.displayName = 'CardContentsContainer';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardWithBorderAndBox = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0bjKvDKxmn _30huDKQaTT _2uo31foI2d _4bt5LAnQyn _2WAcuGnQyn _2OUyjtGk8v",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDKxmn _30huDKQaTT _2uo31foI2d _4bt5LAnQyn _2WAcuGnQyn _2OUyjtGk8v",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$export$8a23e74e5cf3ca41 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardWithBorderAndBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardContentsContainer, null, children));
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardWithBorderAndBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardContentsContainer, null, children));
module.exports["Card"] = $5558feba06e8dbf9$export$60332b2344f7fe41;
module.exports["CardContainer"] = $5558feba06e8dbf9$export$8a23e74e5cf3ca41;

});

parcelRegister("2pBiX", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $e5ba90f4b97bd7c1$var$i18n = (0, $kSwu1.defineMessages)({
    errorTitleCannotStart: {
        id: "loom-utils.error-flag.title.cannot-start",
        defaultMessage: "We couldn\u2019t start your recording"
    },
    errorSDKFailedToInitialize: {
        id: "loom-utils.error-flag.description.sdk-failed-to-initialize",
        defaultMessage: "Give it a moment and then refresh to try again."
    }
});
const $e5ba90f4b97bd7c1$export$b8f10a3122c10d73 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { flags: flags } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== flags || $[1] !== intl) {
        t1 = ()=>{
            flags.showInfoFlag({
                title: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorTitleCannotStart),
                description: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorSDKFailedToInitialize)
            });
        };
        $[0] = flags;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ flags: flags })=>{
    const intl = (0, $kSwu1.useIntl)();
    return (0, $cozmU.useCallback)(()=>{
        flags.showInfoFlag({
            title: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorTitleCannotStart),
            description: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorSDKFailedToInitialize)
        });
    }, [
        flags,
        intl
    ]);
};
module.exports["useLoomEntryPointErrorCallback"] = $e5ba90f4b97bd7c1$export$b8f10a3122c10d73;

});

parcelRegister("k1Pvg", function(module, exports) {
const $facdac86f4ba08d8$export$49073de218c0e4d6 = {
    AI_MATE: 'ai-mate',
    AI_MATE_ACTIONS: 'ai-mate-actions',
    AI_MATE_INSERT_URLS: 'ai-mate-chat-inserts',
    AI_MATE_CHAT_INPUT_OVERLAY: 'ai-mate-chat-input-overlay',
    AI_MATE_AIFC: 'ai-mate-aifc',
    ROVO_REMIX_LAUNCH: 'rovo-remix-launch',
    ROVO_REMIX: 'rovo-remix',
    AVP: 'avp'
};
const $facdac86f4ba08d8$export$69d3cd8e04a34bd6 = 'jira-inline-agent-creation-agent-assigned';
const $facdac86f4ba08d8$export$273aa0a3b01f12a3 = 'jira-work-items-creating';
const $facdac86f4ba08d8$export$6c48beaef33b5d07 = 'jira-work-items-created';
const $facdac86f4ba08d8$export$141a1577d8898865 = 'jira-work-items-create-failed';
const $facdac86f4ba08d8$export$5007e3a11d326b89 = 'confluence-content-finalized';
module.exports["Topics"] = $facdac86f4ba08d8$export$49073de218c0e4d6;
module.exports["JIRA_INLINE_AGENT_CREATION_AGENT_ASSIGNED_EVENT"] = $facdac86f4ba08d8$export$69d3cd8e04a34bd6;
module.exports["JIRA_WORK_ITEMS_CREATING_EVENT"] = $facdac86f4ba08d8$export$273aa0a3b01f12a3;
module.exports["JIRA_WORK_ITEMS_CREATED_EVENT"] = $facdac86f4ba08d8$export$6c48beaef33b5d07;
module.exports["JIRA_WORK_ITEMS_CREATE_FAILED_EVENT"] = $facdac86f4ba08d8$export$141a1577d8898865;
module.exports["CONFLUENCE_CONTENT_FINALIZED_EVENT"] = $facdac86f4ba08d8$export$5007e3a11d326b89;

});

parcelRegister("9aRNV", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $09ecffa85d56d9ae$var$store = (0, $8s9DV.createStore)({
    initialState: {
        actionFilter: undefined,
        actions: [],
        jiraIssueViewActions: undefined,
        input: '',
        activeAction: undefined,
        buttonClickedTimestamp: undefined
    },
    actions: {
        setConversationActions: (actions)=>({ setState: setState })=>{
                setState({
                    actions: actions
                });
            },
        /*
     * Jira Issue View does not use the provider pattern yet, so we need to skip the provider action fetching.
     * When Jira Issue View is migrated to set actions using provider pattern, we can remove this setter.
     */ setJiraIssueViewActions: (actions)=>({ setState: setState })=>{
                setState({
                    jiraIssueViewActions: actions
                });
            },
        setInput: (input)=>({ setState: setState })=>{
                setState({
                    input: input
                });
            },
        setActionFilter: (actionFilter)=>({ setState: setState })=>{
                setState({
                    actionFilter: actionFilter
                });
            },
        /*
     * Do not use this setter directly. Use setActiveAction from useActiveAction hook in conversation-assistant instead.
     */ setActiveAction_UNSAFE: (activeAction)=>({ setState: setState })=>{
                setState({
                    activeAction: activeAction
                });
            },
        setActiveActionFollowUpContext: (customFollowUpContext)=>({ getState: getState, setState: setState })=>{
                const activeAction = getState().activeAction;
                if (!activeAction || !('customFollowUpContext' in activeAction)) return;
                setState({
                    activeAction: {
                        ...activeAction,
                        customFollowUpContext: customFollowUpContext
                    }
                });
            },
        setButtonClickedTimestamp: (buttonClickedTimestamp)=>({ setState: setState })=>{
                setState({
                    buttonClickedTimestamp: buttonClickedTimestamp
                });
            },
        getConversationActions: ()=>({ getState: getState })=>{
                return getState().actions;
            },
        getActionFilter: ()=>({ getState: getState })=>{
                return getState().actionFilter;
            },
        getInput: ()=>({ getState: getState })=>{
                return getState().input;
            },
        getActiveAction: ()=>({ getState: getState })=>{
                return getState().activeAction;
            },
        getButtonClickedTimestamp: ()=>({ getState: getState })=>{
                return getState().buttonClickedTimestamp;
            },
        setConvoStarterActionPrompt: (convoStarterActionPrompt)=>({ setState: setState })=>{
                setState({
                    convoStarterActionPrompt: convoStarterActionPrompt
                });
            }
    }
});
const $09ecffa85d56d9ae$export$83a8985e8d377ba1 = (0, $kBr4q.createHook)($09ecffa85d56d9ae$var$store);
const $09ecffa85d56d9ae$export$74d7aed167e24a67 = (0, $kBr4q.createActionsHook)($09ecffa85d56d9ae$var$store);
const $09ecffa85d56d9ae$export$d6ed3fb83640b335 = (0, $kBr4q.createStateHook)($09ecffa85d56d9ae$var$store);
const $09ecffa85d56d9ae$export$4be353558b8b8a37 = (0, $kBr4q.createStateHook)($09ecffa85d56d9ae$var$store, {
    selector: (state)=>state.convoStarterActionPrompt
});
module.exports["useConversationActionsStore"] = $09ecffa85d56d9ae$export$83a8985e8d377ba1;
module.exports["useConversationActionsStoreActions"] = $09ecffa85d56d9ae$export$74d7aed167e24a67;
module.exports["useConversationActionsStoreState"] = $09ecffa85d56d9ae$export$d6ed3fb83640b335;

});

parcelRegister("5BOJB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $4m5jb = parcelRequire("4m5jb");


var $bGNkz = parcelRequire("bGNkz");


var $9aRNV = parcelRequire("9aRNV");


var $6iQ4q = parcelRequire("6iQ4q");


var $3TxKn = parcelRequire("3TxKn");


var $iLyZq = parcelRequire("iLyZq");

const $ebee8f54e12cc0bd$var$dismissActiveAction = (action, clearAction)=>{
    try {
        (0, $iLyZq.getActionOnDismiss)(action)?.();
    } finally{
        clearAction();
    }
};
const $ebee8f54e12cc0bd$export$e60c4e7dea337eb3 = ()=>{
    (0, $6cFsl.di)((0, $3TxKn.useChatStoreActions), (0, $9aRNV.useConversationActionsStoreActions), (0, $9aRNV.useConversationActionsStore), (0, $bGNkz.useUIStoreActions));
    const { setActiveAction_UNSAFE: setActiveAction_UNSAFE } = (0, $9aRNV.useConversationActionsStoreActions)();
    const { setSelectedConversation: setSelectedConversation } = (0, $3TxKn.useChatStoreActions)();
    (0, $bGNkz.useUIStoreSubscription)();
    const { setActiveMenu: setActiveMenu } = (0, $bGNkz.useUIStoreActions)();
    const [{ activeAction: activeAction }] = (0, $9aRNV.useConversationActionsStore)();
    const activeActionRef = (0, $cozmU.useRef)(activeAction);
    // Keep clearActiveAction safe for hook instances that did not set the action.
    (0, $cozmU.useEffect)(()=>{
        activeActionRef.current = activeAction;
    }, [
        activeAction
    ]);
    const setActiveAction = (0, $cozmU.useCallback)((action, options)=>{
        activeActionRef.current = action;
        setActiveAction_UNSAFE(action);
        if (action) {
            if (!options?.preserveSelectedConversation) setSelectedConversation({
                conversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID),
                sourceAgentId: (0, $6iQ4q.DEFAULT_AGENT).id
            });
            setActiveMenu('none');
        }
    }, [
        setActiveAction_UNSAFE,
        setSelectedConversation,
        setActiveMenu
    ]);
    const clearActiveAction = (0, $cozmU.useCallback)(()=>{
        $ebee8f54e12cc0bd$var$dismissActiveAction(activeActionRef.current, ()=>{
            activeActionRef.current = undefined;
            setActiveAction_UNSAFE(undefined);
        });
    }, [
        setActiveAction_UNSAFE
    ]);
    return {
        activeAction: activeAction,
        setActiveAction: setActiveAction,
        clearActiveAction: clearActiveAction
    };
};
module.exports["useActiveAction"] = $ebee8f54e12cc0bd$export$e60c4e7dea337eb3;

});

parcelRegister("iLyZq", function(module, exports) {

var $gR7ri = parcelRequire("gR7ri");

const $3bc7276fe39ce470$export$42c34726e4093ea = (action)=>(0, $gR7ri.getConversationActionWithAssistantMetadata)(action)?.onDismiss;
module.exports["getActionOnDismiss"] = $3bc7276fe39ce470$export$42c34726e4093ea;

});

parcelRegister("gR7ri", function(module, exports) {
const $e7fea99b17cf91ca$export$89c94a468e7458db = (action)=>action;
module.exports["getConversationActionWithAssistantMetadata"] = $e7fea99b17cf91ca$export$89c94a468e7458db;

});

parcelRegister("jz8lo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hdBxM = parcelRequire("hdBxM");


var $k1Pvg = parcelRequire("k1Pvg");


var $5BOJB = parcelRequire("5BOJB");


var $6iWVH = parcelRequire("6iWVH");


var $6mKj3 = parcelRequire("6mKj3");


var $jmjWc = parcelRequire("jmjWc");


var $lpaq2 = parcelRequire("lpaq2");


const $133397c2abdefdc4$var$LazyRovoChatRemixView = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "b2tBI",
    name: "LazyRovoChatRemixView",
    loader: async ()=>(await (parcelRequire("kqjdo"))).RovoChatRemixView
});
const $133397c2abdefdc4$var$isOpenRovoRemixSidebarPayload = (payload)=>payload.type === 'open-rovo-remix-sidebar';
const $133397c2abdefdc4$var$createRovoRemixAction = (session)=>{
    const actionId = `confluence-rovo-remix:${crypto.randomUUID()}`;
    return {
        id: actionId,
        title: 'Remix',
        handleType: (0, $6iWVH.HandleActionType).Base,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null),
        presentation: {
            hideActionHeader: true,
            suppressPromptLibrary: true,
            fillAvailableHeight: true
        },
        viewConfig: {
            render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($133397c2abdefdc4$var$LazyRovoChatRemixView, {
                    key: actionId,
                    renderRovoChatRemixPicker: (0, $lpaq2.renderRovoChatRemixPicker),
                    session: session
                })
        }
    };
};
const $133397c2abdefdc4$export$96c35e5f3a6712f8 = ()=>{
    const { setActiveAction: setActiveAction } = (0, $5BOJB.useActiveAction)();
    const handleEvent = (0, $cozmU.useCallback)((payload)=>{
        if (!$133397c2abdefdc4$var$isOpenRovoRemixSidebarPayload(payload)) return;
        // Single exposure point for all variant2 Remix entry paths.
        (0, $6mKj3.manuallyLogExpExposure)('cc-ce-maui-remix-menu-multivariant');
        setActiveAction($133397c2abdefdc4$var$createRovoRemixAction({
            consumer: payload.data.remixConsumer,
            scope: payload.data.remixPreset
        }), {
            preserveSelectedConversation: true
        });
    }, [
        setActiveAction
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hdBxM.Subscriber), {
        consumeOnceKey: "confluence-rovo-remix-action-launcher",
        onEvent: handleEvent,
        topic: (0, $k1Pvg.Topics).ROVO_REMIX_LAUNCH,
        triggerLatest: true
    });
};
module.exports["RovoRemixActionLauncher"] = $133397c2abdefdc4$export$96c35e5f3a6712f8;

});

parcelRegister("lpaq2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


const $3c479359d4e5ebbf$var$LazyRovoChatRemixPickerAdapter = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "HAlgh",
    name: "LazyRovoChatRemixPickerAdapter",
    loader: async ()=>(await (parcelRequire("8BOmv"))).RovoChatRemixPickerAdapter
});
const $3c479359d4e5ebbf$export$ff3dbf3fd6d623a0 = ({ isDisabled: isDisabled, onSelect: onSelect, preset: preset })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3c479359d4e5ebbf$var$LazyRovoChatRemixPickerAdapter, {
        isDisabled: isDisabled,
        onSelect: onSelect,
        preset: preset
    });
module.exports["renderRovoChatRemixPicker"] = $3c479359d4e5ebbf$export$ff3dbf3fd6d623a0;

});

parcelRegister("8BOmv", function(module, exports) {

let $6448d84a5e685547$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6448d84a5e685547$var$load("ggHb7"),
    $6448d84a5e685547$var$load("6wr18"),
    $6448d84a5e685547$var$load("ffEVr"),
    $6448d84a5e685547$var$load("j1ofJ")
]).then(()=>parcelRequire('fK5VE'));

});

parcelRegister("kqjdo", function(module, exports) {

let $ede524123c144713$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ede524123c144713$var$load("1rjMs"),
    $ede524123c144713$var$load("ggHb7"),
    $ede524123c144713$var$load("l6kfs"),
    $ede524123c144713$var$load("18viy"),
    $ede524123c144713$var$load("6vqGz"),
    $ede524123c144713$var$load("cgKMu"),
    $ede524123c144713$var$load("60QcS"),
    $ede524123c144713$var$load("hUbK8"),
    $ede524123c144713$var$load("aur8o"),
    $ede524123c144713$var$load("eQ2E2"),
    $ede524123c144713$var$load("d5d6N"),
    $ede524123c144713$var$load("3HjyT"),
    $ede524123c144713$var$load("ioRQV"),
    $ede524123c144713$var$load("8aHht"),
    $ede524123c144713$var$load("j5RRe"),
    $ede524123c144713$var$load("16zlP"),
    $ede524123c144713$var$load("e5ukl"),
    $ede524123c144713$var$load("8uAbh"),
    $ede524123c144713$var$load("hLNtE"),
    $ede524123c144713$var$load("crwC4"),
    $ede524123c144713$var$load("iPvQ1"),
    $ede524123c144713$var$load("OiIXL"),
    $ede524123c144713$var$load("lvnY6"),
    $ede524123c144713$var$load("VXbA1"),
    $ede524123c144713$var$load("2PVCX"),
    $ede524123c144713$var$load("59hV4"),
    $ede524123c144713$var$load("8T2wY"),
    $ede524123c144713$var$load("dZYhM"),
    $ede524123c144713$var$load("cKj6g"),
    $ede524123c144713$var$load("6PtAo"),
    $ede524123c144713$var$load("4B1fg"),
    $ede524123c144713$var$load("aMsb0"),
    $ede524123c144713$var$load("2PXrC"),
    $ede524123c144713$var$load("3g5Gh"),
    $ede524123c144713$var$load("eIINb"),
    $ede524123c144713$var$load("eqj21"),
    $ede524123c144713$var$load("3oAU3"),
    $ede524123c144713$var$load("gccdb"),
    $ede524123c144713$var$load("nmfna"),
    $ede524123c144713$var$load("dr883"),
    $ede524123c144713$var$load("bePXd"),
    $ede524123c144713$var$load("4x9Jx"),
    $ede524123c144713$var$load("ea3NB"),
    $ede524123c144713$var$load("by9qp"),
    $ede524123c144713$var$load("i6gwF"),
    $ede524123c144713$var$load("gnalD"),
    $ede524123c144713$var$load("lsgAX"),
    $ede524123c144713$var$load("ieLoM"),
    $ede524123c144713$var$load("g81ly"),
    $ede524123c144713$var$load("e3LAK"),
    $ede524123c144713$var$load("if60r"),
    $ede524123c144713$var$load("abJi5"),
    $ede524123c144713$var$load("6wr18"),
    $ede524123c144713$var$load("Wowvf"),
    $ede524123c144713$var$load("ffEVr"),
    $ede524123c144713$var$load("hhss7"),
    $ede524123c144713$var$load("gnocL"),
    $ede524123c144713$var$load("dOLuJ"),
    $ede524123c144713$var$load("aAWLw"),
    $ede524123c144713$var$load("7EorR"),
    $ede524123c144713$var$load("7XiLa")
]).then(()=>parcelRequire('f7cmi'));

});

parcelRegister("4n04n", function(module, exports) {
/**
 * This file was cloned from https://bitbucket.org/atlassian/pf-adf-service/src/master/src/lib/converters/adf-to-markdownPlus.ts and slightly modified to work in the browser.
 */ 
var $8OOZ2 = parcelRequire("8OOZ2");


var $6OV8L = parcelRequire("6OV8L");


var $4XbfY = parcelRequire("4XbfY");


var $2lPWP = parcelRequire("2lPWP");


var $9DPMp = parcelRequire("9DPMp");

const $41ee172e87bea8b0$var$defaultSerializer = new (0, $2lPWP.JSONTransformer)();
function $41ee172e87bea8b0$export$bd172d9b9473ac80(adf, featureToggles, idMap) {
    // Default to markdownPlus being enabled unless explicitly disabled
    if (featureToggles === undefined) featureToggles = {};
    if (featureToggles?.markdownPlus === undefined) featureToggles.markdownPlus = true;
    if (featureToggles?.markdownPlusAvoidDuplicatedIdCounter === undefined) featureToggles.markdownPlusAvoidDuplicatedIdCounter = true;
    let serializer = $41ee172e87bea8b0$var$defaultSerializer;
    if (featureToggles.markdownPlusUseNextLayoutSection) serializer = new (0, $2lPWP.JSONTransformer)((0, $8OOZ2.createSchema)({
        ...(0, $4XbfY.defaultSchemaConfig),
        customNodeSpecs: {
            layoutSection: (0, $6OV8L.layoutSectionWithSingleColumn)
        }
    }));
    // Convert ADF to ProseMirrorNode
    const proseMirrorNode = serializer.parse(adf);
    // Generate the mentionMap required for correctly returning @mention strings in Markdown+
    const mentionMap = $41ee172e87bea8b0$var$getMentionMap(serializer.encode(proseMirrorNode));
    // Convert ProseMirrorNode to markdown-plus
    const { markdown: markdown, idMap: newIdMap } = (0, $9DPMp.convertProsemirrorNodeToMarkdown)({
        node: proseMirrorNode,
        featureToggles: featureToggles,
        mentionMap: mentionMap,
        idMap: idMap
    });
    return {
        markdown: markdown,
        idMap: newIdMap
    };
}
function $41ee172e87bea8b0$var$getMentionMap(jsonNode) {
    const mentionMap = {};
    function findMentions(node) {
        if (node.type === 'mention') {
            const userValues = $41ee172e87bea8b0$var$getUserMentionValues(node);
            if (userValues) // Stripping '@' from the mention as Markdown+ automatically adds it back for each map value
            mentionMap[userValues.id] = userValues.text.replace('@', '');
        }
        node.content?.forEach((childNode)=>{
            if (childNode) findMentions(childNode);
        });
    }
    findMentions(jsonNode);
    return mentionMap;
}
function $41ee172e87bea8b0$var$getUserMentionValues(node) {
    if (node.attrs && $41ee172e87bea8b0$var$hasTextAndIdFields(node.attrs)) return {
        text: node.attrs.text,
        id: node.attrs.id
    };
    return null;
}
function $41ee172e87bea8b0$var$hasTextAndIdFields(attrs) {
    return 'text' in attrs && 'id' in attrs && typeof attrs.text === 'string' && typeof attrs.id === 'string';
}
module.exports["adfToMarkdownPlus"] = $41ee172e87bea8b0$export$bd172d9b9473ac80;

});

parcelRegister("htTUm", function(module, exports) {
/**
 * This file was cloned from https://bitbucket.org/atlassian/pf-adf-service/src/master/src/lib/converters/markdownPlus-to-adf.ts and slightly modified to work in the browser.
 */ 
var $4XbfY = parcelRequire("4XbfY");


var $2lPWP = parcelRequire("2lPWP");


var $97CWy = parcelRequire("97CWy");

const $ecada00de6215dbb$var$serializer = new (0, $2lPWP.JSONTransformer)();
function $ecada00de6215dbb$export$dfca419434f7e5a8({ markdown: markdown, idMap: idMap = {}, editorSchema: editorSchema, featureToggles: featureToggles = {
    markdownPlus: true
} }) {
    // Default to markdownPlus being enabled unless explicitly disabled
    if (featureToggles === undefined) featureToggles = {};
    if (featureToggles?.markdownPlus === undefined) featureToggles.markdownPlus = true;
    // Convert markdown-plus to ProseMirrorNode
    const proseMirrorNode = (0, $97CWy.backendConvertMarkdownToProsemirrorNode)({
        markdown: markdown,
        schema: editorSchema || (0, $4XbfY.defaultSchema),
        idMap: idMap,
        featureToggles: featureToggles
    });
    // Convert ProseMirrorNode to ADF
    return $ecada00de6215dbb$var$serializer.encode(proseMirrorNode);
}
module.exports["markdownPlusToAdf"] = $ecada00de6215dbb$export$dfca419434f7e5a8;

});

parcelRegister("jXXTm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f29e840576a4895aa674c32027ed06f5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e891fc467a4625b3$var$_react = $e891fc467a4625b3$var$_interopRequireDefault((parcelRequire("cozmU")));

var $e891fc467a4625b3$var$_baseNew = $e891fc467a4625b3$var$_interopRequireDefault((parcelRequire("gElAV")));
function $e891fc467a4625b3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Atom".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/atom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e891fc467a4625b3$var$AtomIcon = (props)=>/*#__PURE__*/ $e891fc467a4625b3$var$_react.default.createElement($e891fc467a4625b3$var$_baseNew.default, Object.assign({
        name: "AtomIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M9.87 1.42c1.566-.567 3.258-.667 4.318.393 1.059 1.059.959 2.75.392 4.317A11 11 0 0 1 13.683 8c.376.635.678 1.265.897 1.87.567 1.566.667 3.258-.393 4.318-1.059 1.059-2.75.959-4.317.392A11 11 0 0 1 8 13.683a11 11 0 0 1-1.87.897c-1.566.567-3.258.667-4.317-.393-1.06-1.059-.96-2.75-.393-4.317.219-.605.52-1.235.896-1.87a11 11 0 0 1-.896-1.87c-.567-1.566-.667-3.258.393-4.317C2.872.753 4.563.853 6.13 1.42c.605.219 1.235.52 1.87.896a11 11 0 0 1 1.87-.896M3.26 9.397a9 9 0 0 0-.43.983c-.521 1.44-.362 2.342.043 2.747s1.306.564 2.747.043a9 9 0 0 0 .983-.43 17 17 0 0 1-1.785-1.558A17 17 0 0 1 3.26 9.397m9.48 0a17.4 17.4 0 0 1-3.343 3.342q.507.258.983.431c1.44.521 2.342.362 2.747-.043s.564-1.306.043-2.747a9 9 0 0 0-.43-.983M8 4.099a15.5 15.5 0 0 0-2.121 1.78A15.5 15.5 0 0 0 4.099 8a15.4 15.4 0 0 0 1.78 2.121A15.5 15.5 0 0 0 8 11.901a15.5 15.5 0 0 0 2.121-1.78A15.5 15.5 0 0 0 11.901 8a15.5 15.5 0 0 0-1.78-2.121A15.5 15.5 0 0 0 8 4.099M5.62 2.83c-1.44-.521-2.342-.362-2.747.043S2.31 4.18 2.83 5.62q.173.475.43.983c.46-.607.981-1.207 1.558-1.785A17 17 0 0 1 6.603 3.26a9 9 0 0 0-.983-.43m7.507.043c-.405-.405-1.306-.564-2.747-.043a9 9 0 0 0-.983.43c.607.46 1.207.981 1.785 1.558a17 17 0 0 1 1.557 1.785 9 9 0 0 0 .431-.983c.521-1.44.362-2.342-.043-2.747"/><path fill="currentcolor" d="M9 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$e891fc467a4625b3$var$AtomIcon.displayName = 'AtomIcon';
var $e891fc467a4625b3$var$_default = module.exports.default = $e891fc467a4625b3$var$AtomIcon;

});

parcelRegister("5n93X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::641dd5d03db662197381257f8f1690c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e96216f98bcdad5$var$_react = $3e96216f98bcdad5$var$_interopRequireDefault((parcelRequire("cozmU")));

var $3e96216f98bcdad5$var$_baseNew = $3e96216f98bcdad5$var$_interopRequireDefault((parcelRequire("gElAV")));
function $3e96216f98bcdad5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/cloud-arrow-up
 * Usage guidance:
 * Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3e96216f98bcdad5$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $3e96216f98bcdad5$var$_react.default.createElement($3e96216f98bcdad5$var$_baseNew.default, Object.assign({
        name: "CloudArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3a4.25 4.25 0 0 0-4.236 3.9.75.75 0 0 1-.565.668A2.251 2.251 0 0 0 3.75 12v1.5a3.75 3.75 0 0 1-1.418-7.222 5.751 5.751 0 0 1 11.239-.458A4 4 0 0 1 12 13.5V12a2.5 2.5 0 0 0 .712-4.897.75.75 0 0 1-.526-.59A4.25 4.25 0 0 0 8 3m0 4a.75.75 0 0 1 .53.22l3 3-1.06 1.06-1.72-1.72V16h-1.5V9.56l-1.72 1.72-1.06-1.06 3-3A.75.75 0 0 1 8 7" clip-rule="evenodd"/>`
    }, props));
$3e96216f98bcdad5$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $3e96216f98bcdad5$var$_default = module.exports.default = $3e96216f98bcdad5$var$CloudArrowUpIcon;

});

parcelRegister("76xix", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $91ZZN = parcelRequire("91ZZN");


const $de0bfd2141159d80$var$LazyRovoLoadingGif = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("d8UlV"))); /**
             * @deprecated please use LazyAnimatedRovoIcon from @atlassian/rovo-platform-ui-components/primitives/rovo-animated-icon/LazyAnimatedRovoIcon instead
             */ 
const $de0bfd2141159d80$export$7ea4e54699cd5224 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { alt: t1, testId: t2, width: t3, height: t4 } = t0;
    const alt = t1 === undefined ? "" : t1;
    const testId = t2 === undefined ? "" : t2;
    const width = t3 === undefined ? "" : t3;
    const height = t4 === undefined ? "" : t4;
    let t5;
    if ($[0] !== alt || $[1] !== height || $[2] !== testId || $[3] !== width) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            interactionName: "rovo-conversation-assistant-animated-icon",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($de0bfd2141159d80$var$LazyRovoLoadingGif, {
            alt: alt,
            testId: testId,
            width: width,
            height: height
        }));
        $[0] = alt;
        $[1] = height;
        $[2] = testId;
        $[3] = width;
        $[4] = t5;
    } else t5 = $[4];
    return t5;
} : ({ alt: alt = '', testId: testId = '', width: width = '', height: height = '' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "rovo-conversation-assistant-animated-icon",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($de0bfd2141159d80$var$LazyRovoLoadingGif, {
        alt: alt,
        testId: testId,
        width: width,
        height: height
    }));
});
module.exports["LazyAnimatedRovoIcon"] = $de0bfd2141159d80$export$7ea4e54699cd5224;

});

parcelRegister("d8UlV", function(module, exports) {

let $9917bc308f190038$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9917bc308f190038$var$load("b7fR4").then(()=>parcelRequire('9r8so'));

});

parcelRegister("gd8AW", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $f4d1b21b30388c2e$export$48bd74b0cdc86564 = ()=>{
    return !!(0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED);
};
const $f4d1b21b30388c2e$export$675fdafde077272f = ()=>{
    return (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED, true);
};
const $f4d1b21b30388c2e$var$initialState = {
    activeMessageId: null,
    entryPointIds: [],
    clickTrackingHandler: null,
    dismissHandler: null,
    wasDismissedByUser: false
};
const $f4d1b21b30388c2e$var$actions = {
    startPulse: (entryPointId, messageId, handlers)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const nextState = state.activeMessageId !== messageId ? {
                activeMessageId: messageId,
                entryPointIds: [
                    entryPointId
                ],
                clickTrackingHandler: handlers?.onClick ?? null,
                dismissHandler: handlers?.onDismiss ?? null,
                wasDismissedByUser: false
            } : {
                activeMessageId: messageId,
                entryPointIds: state.entryPointIds.includes(entryPointId) ? state.entryPointIds : [
                    ...state.entryPointIds,
                    entryPointId
                ],
                clickTrackingHandler: handlers?.onClick ?? state.clickTrackingHandler,
                dismissHandler: handlers?.onDismiss ?? state.dismissHandler,
                wasDismissedByUser: false
            };
            const hasEntryPointListChanged = nextState.entryPointIds !== state.entryPointIds;
            const hasClickHandlerChanged = nextState.clickTrackingHandler !== state.clickTrackingHandler;
            const hasDismissHandlerChanged = nextState.dismissHandler !== state.dismissHandler;
            const hasMessageChanged = nextState.activeMessageId !== state.activeMessageId;
            const hasDismissalReset = state.wasDismissedByUser;
            if (!hasEntryPointListChanged && !hasClickHandlerChanged && !hasDismissHandlerChanged && !hasMessageChanged && !hasDismissalReset) return;
            setState(nextState);
        },
    stopPulse: ()=>({ getState: getState, setState: setState })=>{
            const state = getState();
            state.clickTrackingHandler?.();
            state.dismissHandler?.();
            if (!$f4d1b21b30388c2e$export$48bd74b0cdc86564()) $f4d1b21b30388c2e$export$675fdafde077272f();
            if (state.activeMessageId === null && state.entryPointIds.length === 0 && state.dismissHandler === null && state.clickTrackingHandler === null && state.wasDismissedByUser) return;
            setState({
                activeMessageId: null,
                entryPointIds: [],
                clickTrackingHandler: null,
                dismissHandler: null,
                wasDismissedByUser: true
            });
        }
};
const $f4d1b21b30388c2e$var$Store = (0, $8s9DV.createStore)({
    initialState: $f4d1b21b30388c2e$var$initialState,
    actions: $f4d1b21b30388c2e$var$actions,
    name: 'LoomEntryPointsDiscoverabilityPulse'
});
const $f4d1b21b30388c2e$export$e812389786ffbfd0 = (0, $kBr4q.createStateHook)($f4d1b21b30388c2e$var$Store, {
    selector: (state, entryPointId)=>state.entryPointIds.includes(entryPointId) && !state.wasDismissedByUser
});
const $f4d1b21b30388c2e$export$5628ed37e6d9f626 = (0, $kBr4q.createActionsHook)($f4d1b21b30388c2e$var$Store);
module.exports["havePulsesEnded"] = $f4d1b21b30388c2e$export$48bd74b0cdc86564;
module.exports["endPulses"] = $f4d1b21b30388c2e$export$675fdafde077272f;
module.exports["useIsPulseActive"] = $f4d1b21b30388c2e$export$e812389786ffbfd0;
module.exports["useDiscoverabilityPulseActions"] = $f4d1b21b30388c2e$export$5628ed37e6d9f626;

});

parcelRegister("kfIha", function(module, exports) {
const $3551cf4db632cbd5$var$isClipboardApiSupported = ()=>// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    Boolean(navigator.clipboard && typeof navigator.clipboard.writeText === 'function');
const $3551cf4db632cbd5$export$b2199c37e85de4a7 = ()=>{
    const copyToClipboard = async (value)=>{
        if (value && $3551cf4db632cbd5$var$isClipboardApiSupported()) // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        await navigator.clipboard.writeText(value);
    };
    return {
        copyToClipboard: copyToClipboard
    };
};
module.exports["useCopyToClipboard"] = $3551cf4db632cbd5$export$b2199c37e85de4a7;

});

parcelRegister("JCGnt", function(module, exports) {

var $6vgLy = parcelRequire("6vgLy");


var $f7MuR = parcelRequire("f7MuR");

const $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $affa2edf03b5b535$export$750d18e9348a361a = ({ activeDaysThreshold: activeDaysThreshold = 28, activeUserCutoffDate: activeUserCutoffDate }, skip = false)=>{
    const { data: data, loading: loading, error: error } = (0, $f7MuR.useSiteUserTraits)({
        skipBootstrap: skip
    });
    const confluenceFirstActive = data?.attributes?.find(({ name: name })=>name === $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const firstActiveDate = confluenceFirstActive ? new Date(confluenceFirstActive) : null;
    const { isNewlyCreatedUser: isNewlyCreatedUser } = (0, $6vgLy.useShouldExcludeUser)({
        checkDate: firstActiveDate,
        daysThreshold: activeDaysThreshold,
        cutoffDate: activeUserCutoffDate
    });
    if (loading) return {
        isNewUser: null,
        loading: true
    };
    if (error) return {
        isNewUser: null,
        error: error
    };
    return {
        isNewUser: isNewlyCreatedUser,
        loading: false,
        error: null
    };
};
module.exports["useIsNewUser"] = $affa2edf03b5b535$export$750d18e9348a361a;

});

parcelRegister("6vgLy", function(module, exports) {

var $gkHoc = parcelRequire("gkHoc");

var $6Mfv2 = parcelRequire("6Mfv2");

var $esV19 = parcelRequire("esV19");

const $859f2d1feb92d345$export$30b189c21f25ee23 = ({ checkDate: checkDate, daysThreshold: daysThreshold = 14, cutoffDate: cutoffDate })=>{
    // If there is no check date, we cannot determine if user is new
    if (!checkDate) return {
        shouldExclude: true,
        isNewlyCreatedUser: null,
        isNewUserAfterCutoffDate: false
    };
    const isNewlyCreatedUser = (0, $6Mfv2.default)((0, $gkHoc.default)(checkDate, daysThreshold), new Date());
    // Check if user is a new user (date is AFTER the cutoff date)
    // These users don't need changeboarding since it's all new to them
    const isNewUserAfterCutoffDate = cutoffDate && (0, $esV19.default)(cutoffDate) ? (0, $6Mfv2.default)(checkDate, cutoffDate) : false;
    const shouldExclude = isNewlyCreatedUser || isNewUserAfterCutoffDate;
    return {
        shouldExclude: shouldExclude,
        isNewlyCreatedUser: isNewlyCreatedUser,
        isNewUserAfterCutoffDate: isNewUserAfterCutoffDate
    };
};
module.exports["useShouldExcludeUser"] = $859f2d1feb92d345$export$30b189c21f25ee23;

});

parcelRegister("ai7NK", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $30dd91193859fc54$export$4f97fa3245bb0e31 = {
    isSidePanelOpen: false
};
const $30dd91193859fc54$export$e324594224ef24da = {
    showSidePanel: ()=>({ setState: setState })=>{
            setState({
                isSidePanelOpen: true
            });
        },
    hideSidePanel: ()=>({ setState: setState })=>{
            setState({
                isSidePanelOpen: false
            });
        }
};
const $30dd91193859fc54$var$Store = (0, $8s9DV.createStore)({
    initialState: $30dd91193859fc54$export$4f97fa3245bb0e31,
    actions: $30dd91193859fc54$export$e324594224ef24da,
    name: 'SidePanelState'
});
const $30dd91193859fc54$export$d4bcf572fecd48f5 = (0, $kBr4q.createActionsHook)($30dd91193859fc54$var$Store);
const $30dd91193859fc54$export$f3f6191f6fee6235 = (0, $kBr4q.createStateHook)($30dd91193859fc54$var$Store, {
    selector: (state)=>state.isSidePanelOpen
});
module.exports["useSidePanelStateActions"] = $30dd91193859fc54$export$d4bcf572fecd48f5;
module.exports["useIsSidePanelOpen"] = $30dd91193859fc54$export$f3f6191f6fee6235;

});

parcelRegister("4GDP8", function(module, exports) {
function $d27310b4a47ce627$var$keepTrying(fn, times, interval) {
    if (!fn() && times) setTimeout(()=>$d27310b4a47ce627$var$keepTrying(fn, times - 1, interval), interval);
}
function $d27310b4a47ce627$var$waitForDom(itemId) {
    return new Promise((resolve)=>{
        function lookForItem() {
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const targetItem = document.querySelector(itemId);
            if (targetItem) {
                clearInterval(checkInterval);
                resolve(true);
            }
        }
        // Start an interval to check for the item every 10ms
        const checkInterval = setInterval(lookForItem, 10);
        // Fail silently if the item isn't found after 5000ms
        setTimeout(()=>{
            clearInterval(checkInterval);
            resolve(false);
        }, 5000);
    });
}
function $d27310b4a47ce627$var$isForgeModule(itemId) {
    return itemId.startsWith('ari:cloud:ecosystem::extension');
}
function $d27310b4a47ce627$var$escapeForgeModuleKey(itemId) {
    return itemId.replace(/\//g, '\\/').replace(/:/g, '\\:');
}
function $d27310b4a47ce627$var$getItemSelector(itemId) {
    if (!itemId || !itemId.length) return;
    let itemSelector = itemId[0] === '#' ? itemId : `#${itemId}`;
    if ($d27310b4a47ce627$var$isForgeModule(itemId)) itemSelector = $d27310b4a47ce627$var$escapeForgeModuleKey(itemSelector);
    return itemSelector;
}
async function $d27310b4a47ce627$export$6bd4cdcdf3940391({ parentmenuId: parentmenuId, submenuId: submenuId, forgeItemId: forgeItemId }) {
    // Make sure the forge item has a valid id
    const forgeItemSelector = $d27310b4a47ce627$var$getItemSelector(forgeItemId);
    if (!forgeItemSelector) return;
    $d27310b4a47ce627$var$openMenu(parentmenuId);
    const foundSubmenu = await $d27310b4a47ce627$var$waitForDom(submenuId);
    if (!foundSubmenu) return;
    $d27310b4a47ce627$var$openMenu(submenuId);
    const foundForgeItem = await $d27310b4a47ce627$var$waitForDom(forgeItemSelector);
    if (!foundForgeItem) return;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const forgeItem = document.querySelector(forgeItemSelector);
    forgeItem?.click();
}
function $d27310b4a47ce627$var$openMenu(menuId) {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const triggerButton = document.querySelector(menuId);
    if (!triggerButton) return;
    const isOpen = triggerButton.getAttribute('aria-expanded') === 'true';
    //only care about closed case, otherwise let legacy event listener handle
    if (!isOpen) triggerButton.click();
}
function $d27310b4a47ce627$export$73ebde48694f32cd(itemId) {
    const itemSelector = $d27310b4a47ce627$var$getItemSelector(itemId);
    if (!itemSelector) return;
    $d27310b4a47ce627$var$keepTrying(()=>{
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const item = document.querySelector(itemSelector);
        if (item) {
            item.click();
            return true;
        }
    }, 100, 5);
}
function $d27310b4a47ce627$export$96aa6f6c7286ecb4(itemId) {
    const itemSelector = $d27310b4a47ce627$var$getItemSelector(itemId);
    if (!itemSelector) return;
    const event = new MouseEvent('mouseup', {
        bubbles: true,
        cancelable: true
    });
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector(itemSelector)?.dispatchEvent(event);
}
function $d27310b4a47ce627$export$1d6f959e29b7f60d() {
    $d27310b4a47ce627$var$openMenu('#tools-menu-trigger');
}
function $d27310b4a47ce627$export$3d4ff948da3c7dd3() {
    $d27310b4a47ce627$var$openMenu('#context-menu-other-apps');
}
function $d27310b4a47ce627$export$94323a98da3bb62c() {
    $d27310b4a47ce627$var$openMenu('#more-actions-trigger');
}
module.exports["openForgeAppFromSubmenu"] = $d27310b4a47ce627$export$6bd4cdcdf3940391;
module.exports["simulateItemClick"] = $d27310b4a47ce627$export$73ebde48694f32cd;
module.exports["simulateItemMouseOver"] = $d27310b4a47ce627$export$96aa6f6c7286ecb4;
module.exports["openMenuClick"] = $d27310b4a47ce627$export$1d6f959e29b7f60d;
module.exports["openContextMenuClick"] = $d27310b4a47ce627$export$3d4ff948da3c7dd3;
module.exports["openMoreActionsMenuClick"] = $d27310b4a47ce627$export$94323a98da3bb62c;

});

parcelRegister("kmWRd", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $iODl6 = parcelRequire("iODl6");


var $j72ee = parcelRequire("j72ee");

const $7a88b175622d580e$var$sidePanelContentStyling = (0, $buxP3.xcss)({
    position: 'absolute',
    width: '100%',
    backgroundColor: 'elevation.surface',
    height: '100%',
    top: '0',
    right: '0',
    left: '0',
    bottom: '0',
    display: 'flex',
    flexDirection: 'column'
});
const $7a88b175622d580e$export$8689d3888980b1f3 = (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { headerHeight: t1, isFixed: isFixed, children: children, displayTopBorder: displayTopBorder, panelTop: t2, isOpen: t3, width: t4 } = t0;
    const headerHeight = t1 === undefined ? 0 : t1;
    const panelTop = t2 === undefined ? 0 : t2;
    const isOpen = t3 === undefined ? true : t3;
    const width = t4 === undefined ? 320 : t4;
    let t5;
    if ($[0] !== children || $[1] !== displayTopBorder || $[2] !== headerHeight || $[3] !== isFixed || $[4] !== isOpen || $[5] !== panelTop || $[6] !== width) {
        t5 = isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j72ee.default), {
            enterFrom: "right",
            fade: "inout"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                ...props,
                style: {
                    backgroundColor: "elevation.surface",
                    position: isFixed ? "fixed" : "absolute",
                    right: "0",
                    top: `${panelTop}px`,
                    width: `${width}px`,
                    padding: "space.300",
                    borderLeft: "var(--ds-border-width, 1px) solid var(--ds-border, #0B120E24)",
                    height: `calc(100vh - ${headerHeight}px)`,
                    borderTop: displayTopBorder ? "var(--ds-border-width, 1px) solid var(--ds-border, #0B120E24)" : "none"
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: $7a88b175622d580e$var$sidePanelContentStyling
            }, children)));
        $[0] = children;
        $[1] = displayTopBorder;
        $[2] = headerHeight;
        $[3] = isFixed;
        $[4] = isOpen;
        $[5] = panelTop;
        $[6] = width;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
            appear: true
        }, t5);
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    return t6;
};
module.exports["SidePanel"] = $7a88b175622d580e$export$8689d3888980b1f3;

});

parcelRegister("4WZFP", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $72d7920b18bf3596$export$70e0922268f2e08b = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            paddingBlock: "space.100",
            paddingInlineStart: "space.300",
            paddingInlineEnd: "space.150"
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
module.exports["SidePanelHeader"] = $72d7920b18bf3596$export$70e0922268f2e08b;

});

parcelRegister("1I9Gw", function(module, exports) {
const $f0a04d35c062874d$export$1598149f6f3f7d46 = (spaceKey)=>{
    return spaceKey?.[0] === '~';
};
module.exports["isPersonalSpace"] = $f0a04d35c062874d$export$1598149f6f3f7d46;

});

parcelRegister("9Ke0t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cf56f05ebdb57c1dbc90961a7379283b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7183465f1a1868e6$var$_react = $7183465f1a1868e6$var$_interopRequireDefault((parcelRequire("cozmU")));

var $7183465f1a1868e6$var$_baseNew = $7183465f1a1868e6$var$_interopRequireDefault((parcelRequire("gElAV")));
function $7183465f1a1868e6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "GenerativeIndicator".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/generative-indicator
 * Usage guidance:
 * Reserved for indicating generative and suggested content.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7183465f1a1868e6$var$GenerativeIndicatorIcon = (props)=>/*#__PURE__*/ $7183465f1a1868e6$var$_react.default.createElement($7183465f1a1868e6$var$_baseNew.default, Object.assign({
        name: "GenerativeIndicatorIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M8.117 1.009a.75.75 0 0 1 .588.484l1.55 4.251 4.252 1.55A.75.75 0 0 1 15 8v.002a.75.75 0 0 1-.493.704l-4.252 1.55-1.55 4.252a.75.75 0 0 1-.704.493h-.002a.75.75 0 0 1-.704-.493l-1.55-4.252-4.252-1.55A.75.75 0 0 1 1 8.001v-.002a.75.75 0 0 1 .493-.704l4.251-1.55 1.55-4.252.049-.106A.75.75 0 0 1 7.999 1h.002z"/>`
    }, props));
$7183465f1a1868e6$var$GenerativeIndicatorIcon.displayName = 'GenerativeIndicatorIcon';
var $7183465f1a1868e6$var$_default = module.exports.default = $7183465f1a1868e6$var$GenerativeIndicatorIcon;

});

parcelRegister("3Am3T", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dDqLo = parcelRequire("dDqLo");

const $7428cb96b7623c11$export$cf1f48e05bf093f2 = /*#__PURE__*/ (0, $cozmU.createContext)({
    footerCommentsCount: 0,
    unresolvedInlineCommentsCount: 0
});
const $7428cb96b7623c11$export$c2f6e8ee3b0be174 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { contentId: contentId, children: children } = t0;
    const commentCounts = (0, $dDqLo.useCommentCounts)(contentId);
    let t1;
    if ($[0] !== children || $[1] !== commentCounts) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7428cb96b7623c11$export$cf1f48e05bf093f2.Provider, {
            value: commentCounts
        }, children);
        $[0] = children;
        $[1] = commentCounts;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ contentId: contentId, children: children })=>{
    const commentCounts = (0, $dDqLo.useCommentCounts)(contentId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7428cb96b7623c11$export$cf1f48e05bf093f2.Provider, {
        value: commentCounts
    }, children);
};
module.exports["CommentCountsContext"] = $7428cb96b7623c11$export$cf1f48e05bf093f2;
module.exports["CommentCountsProvider"] = $7428cb96b7623c11$export$c2f6e8ee3b0be174;

});

parcelRegister("dDqLo", function(module, exports) {
/**
 * @graphql cc
 */ 
var $cozmU = parcelRequire("cozmU");


var $4L9ve = parcelRequire("4L9ve");

const $c085ac79a8833850$export$453b7c79178856e5 = (_contentId)=>{
    // Get processed comment data from the Comments Data Manager store
    const { isDataProcessed: isDataProcessed, openInlineComments: openInlineComments, openFooterComments: openFooterComments } = (0, $4L9ve.useProcessedCommentsDataState)();
    return (0, $cozmU.useMemo)(()=>{
        if (isDataProcessed) return {
            unresolvedInlineCommentsCount: openInlineComments.length,
            footerCommentsCount: openFooterComments.length
        };
        // Fallback when data hasn't loaded yet
        return {
            unresolvedInlineCommentsCount: 0,
            footerCommentsCount: 0
        };
    }, [
        isDataProcessed,
        openInlineComments.length,
        openFooterComments.length
    ]);
};
module.exports["useCommentCounts"] = $c085ac79a8833850$export$453b7c79178856e5;

});


//# sourceMappingURL=ObjectSidebarControl.2ed29173.js.map
